// src/api-definition-paths/billing-cycles-paths/billing-cycles-id-path.ts
import { oz as oz2 } from "@vy/utils";
import { PATH_ACCESS_LEVELS } from "@vy/zapi-types";

// src/api-definition-paths/api-tags.ts
import { oz } from "@vy/utils";
var API_TAGS = Object.freeze({
  AUTH: "auth",
  EVENTS: "events",
  CUSTOMERS: "customers",
  CUSTOMER: "customer",
  METERS: "meters",
  PLANS: "plans",
  CONTRACTS: "contracts",
  CONTRACT: "contract",
  INVOICES: "invoices",
  INVOICE: "invoice",
  BILLING_CYCLES: "billing-cycles",
  REPORTS: "reports",
  REPORT: "report",
  DATA_DASHBOARD: "data-dashboard",
  INTEGRATIONS: "integrations",
  PAGES: "pages",
  CREDIT_LEDGER: "credit-ledger",
  EVENT_FIELDS: "event-fields",
  LINE_ITEM: "line-item",
  REVISIONED_LINE_ITEM: "revisioned-line-item",
  MEASUREMENTS: "measurements",
  MEASUREMENT: "measurement",
  NOTIFICATION_ALERTS: "notification-alerts",
  PAYMENTS: "payments",
  PHASE_LABELS: "phase-labels",
  ACCOUNTS: "accounts",
  CONTACT_US: "contact-us",
  USERS: "users",
  EMAIL: "email",
  SUBSIDIARIES: "subsidiaries",
  CUSTOMER_PORTAL: "customer-portal",
  REVENUE: "revenue",
  PRODUCTS: "products",
  PRICING: "pricing",
  CATALOG_PRODUCTS: "catalog-products",
  EXCHANGE_RATES: "exchange-rates",
  JOBS: "jobs",
  LABELS: "labels",
  CUSTOMER_NOTE: "customer-note",
  CUSTOMER_NOTES: "customer-notes",
  PUBLIC_API_KEYS: "public-api-keys",
  WEBHOOK_SUBSCRIPTIONS: "webhook-subscriptions",
  STEP_TYPES: "step-types",
  WORKFLOW_EXECUTIONS: "workflow-executions",
  WORKFLOW_STARTERS: "workflow-starters",
  WORKFLOWS: "workflows"
});
var NestApiTagSchema = oz.nativeEnum(API_TAGS);
var API_TAG_VALUES = Object.values(API_TAGS);

// src/api-definition-paths/billing-cycles-paths/billing-cycles-id-path.ts
var BILLING_CYCLE_ID_PATH_PARAM = {
  name: "billingCycleId",
  location: "path",
  schema: oz2.string(),
  required: true
};
var UPDATE_BILLING_CYCLE_PATH_PARAMS = {
  [BILLING_CYCLE_ID_PATH_PARAM.name]: BILLING_CYCLE_ID_PATH_PARAM
};
var BILLING_CYCLES_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS.PRIVATE,
  route: "/billing-cycle/{billingCycleId}",
  pathParams: UPDATE_BILLING_CYCLE_PATH_PARAMS,
  tags: API_TAGS.BILLING_CYCLES
};

// src/api-definition-paths/billing-cycles-paths/create-billing-cycle-path/create-billing-cycle-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS2 } from "@vy/zapi-types";
var CREATE_BILLING_CYCLE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS2.PRIVATE,
  route: "/billing-cycles",
  tags: API_TAGS.BILLING_CYCLES
};

// src/api-definition-paths/billing-cycles-paths/create-billing-cycle-path/create-billing-cycle-request-schema.ts
import { NewBillingCycleSchema } from "@vy/types";
import { oz as oz3 } from "@vy/utils";
var CreateBillingCycleRequestSchema = oz3.object({
  newBillingCycle: NewBillingCycleSchema
}).openapi("createBillingCycleRequest");

// src/api-definition-paths/billing-cycles-paths/create-billing-cycle-path/create-billing-cycle-response-schema.ts
import { BillingCycleSchema } from "@vy/types";
import { oz as oz4 } from "@vy/utils";
var CreateBillingCycleResponseSchema = oz4.object({
  billingCycle: BillingCycleSchema
}).openapi("CreateBillingCycleResponse");

// src/api-definition-paths/billing-cycles-paths/create-billing-cycle-path/create-billing-cycle-action.ts
var CREATE_BILLING_CYCLE_ACTION = {
  method: "post",
  request: {
    name: "CreateBillingCycleRequest",
    schema: CreateBillingCycleRequestSchema
  },
  codeGenerationSettings: {
    actionText: "create-billing-cycle"
  },
  response: {
    name: "CreateBillingCycleResponse",
    schema: CreateBillingCycleResponseSchema
  },
  path: CREATE_BILLING_CYCLE_PATH
};

// src/api-definition-paths/billing-cycles-paths/get-billing-cycles-overviews-path/get-billing-cycles-overviews-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS3 } from "@vy/zapi-types";
var GET_BILLING_CYCLES_OVERVIEWS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS3.PRIVATE,
  route: "/billing-cycles/overviews",
  pathParams: void 0,
  tags: API_TAGS.BILLING_CYCLES
};

// src/api-definition-params/pagination-query-params.ts
import { PageNumberSchema, PageSizeSchema } from "@vy/types";
var PAGE_NUMBER_QUERY_PARAMETER = {
  name: "page",
  location: "query",
  schema: PageNumberSchema
};
var PAGE_SIZE_QUERY_PARAMETER = {
  name: "pageSize",
  location: "query",
  schema: PageSizeSchema
};
var PAGINATION_QUERY_PARAMETERS = {
  [PAGE_NUMBER_QUERY_PARAMETER.name]: PAGE_NUMBER_QUERY_PARAMETER,
  [PAGE_SIZE_QUERY_PARAMETER.name]: PAGE_SIZE_QUERY_PARAMETER
};

// src/api-definition-params/search-query-param.ts
import { oz as oz5 } from "@vy/utils";
var SEARCH_QUERY_PARAMETER = {
  name: "search",
  location: "query",
  schema: oz5.string().nonempty().optional(),
  required: false
};

// src/api-definition-params/customer-id-query-param.ts
import { oz as oz6 } from "@vy/utils";
var CUSTOMER_ID_QUERY_PARAM = {
  name: "customerId",
  location: "query",
  schema: oz6.string().nonempty().optional(),
  required: false
};

// src/shared-schemas/home-page/home-page-top-grossing-schema.ts
import { CurrencySchema, ObjectIdSchema } from "@vy/types";
import { oz as oz7 } from "@vy/utils";
var HomePageTopGrossingSchema = oz7.object({
  id: ObjectIdSchema,
  name: oz7.string().nonempty(),
  currentRevenue: oz7.number(),
  previousRevenue: oz7.number(),
  currency: CurrencySchema.optional()
}).openapi("HomePageTopGrossing");

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-measurement-chart-meter-schema.ts
import { oz as oz10 } from "@vy/utils";

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-measurement-chart-meter-usage-schema.ts
import { oz as oz9 } from "@vy/utils";

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-meter-usage-schema.ts
import { oz as oz8 } from "@vy/utils";
var DynamicInvoiceMeterUsageSchema = oz8.object({
  totalUnits: oz8.number(),
  totalPrice: oz8.number()
});

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-measurement-chart-meter-usage-schema.ts
var DynamicInvoiceMeasurementChartMeterUsageSchema = oz9.record(
  oz9.string(),
  DynamicInvoiceMeterUsageSchema
);

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-measurement-chart-meter-schema.ts
var DynamicInvoiceMeasurementChartMeterSchema = oz10.record(
  DynamicInvoiceMeasurementChartMeterUsageSchema
);

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-page-data-contact-schema.ts
import { ContractSchema, CustomerRelationTypeSchema, CustomerSchema } from "@vy/types";
import { oz as oz11 } from "@vy/utils";
var DynamicInvoicePageCustomerSchema = CustomerSchema.pick({
  id: true,
  name: true,
  settings: true,
  revenueBreakdown: true,
  address: true,
  contacts: true,
  createdAt: true
}).extend({
  parentCustomer: oz11.object({
    name: oz11.string(),
    relationType: CustomerRelationTypeSchema
  }).optional()
});
var DynamicInvoicePageContractSchema = ContractSchema.pick({
  id: true
}).extend({
  customer: DynamicInvoicePageCustomerSchema
});

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-page-data-invoice-schema.ts
import { CurrencySchema as CurrencySchema3, InvoiceSchema, InvoiceTypeSchema, ObjectIdSchema as ObjectIdSchema3 } from "@vy/types";
import { oz as oz13 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/get-invoices-overviews/invoice-payment-schema.ts
import { ApiDateSchema, CurrencySchema as CurrencySchema2, ObjectIdSchema as ObjectIdSchema2 } from "@vy/types";
import { oz as oz12 } from "@vy/utils";
var InvoicePaymentSchema = oz12.object({
  id: ObjectIdSchema2,
  amount: oz12.number(),
  currency: CurrencySchema2,
  createdAt: ApiDateSchema,
  updatedAt: ApiDateSchema,
  paymentMethod: oz12.string().optional(),
  status: oz12.string().optional()
}).openapi("InvoicePayment");

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-page-data-invoice-schema.ts
var DynamicInvoicePageInvoiceSchema = InvoiceSchema.pick({
  id: true,
  name: true,
  reviewStatus: true,
  issuedAt: true,
  billingStatus: true,
  billingCycle: true,
  lineItems: true,
  purchaseOrder: true,
  notes: true,
  approvedAt: true,
  revenueBreakdown: true,
  taxRate: true,
  syncStatus: true,
  invoicingDate: true,
  invoiceNumber: true,
  ref: true,
  exchangeRateSnapshotTimestamp: true,
  refundsInvoiceId: true
}).extend({
  invoiceType: InvoiceTypeSchema.optional(),
  dynamicLineItems: oz13.array(oz13.unknown()),
  contractId: ObjectIdSchema3.optional(),
  contractName: oz13.string().optional(),
  currency: CurrencySchema3,
  modifiedCurrency: CurrencySchema3.nullable().optional(),
  baseCurrency: CurrencySchema3.nullable().optional(),
  exchangeRateSnapshot: oz13.record(CurrencySchema3, oz13.number()).nullish(),
  modifiedExchangeRate: oz13.number().nullish(),
  payments: InvoicePaymentSchema.array().optional()
});

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-page-data-schema.ts
import { oz as oz18 } from "@vy/utils";

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-page-data-contract-schema.ts
import { ContractSchema as ContractSchema2 } from "@vy/types";
var DynamicContractPageContractSchema = ContractSchema2.pick({
  id: true,
  contractType: true,
  currencyOverride: true,
  isTrial: true
});

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-page-measured-price-breakdown-map-schema.ts
import { MeasuredPriceBreakdownSchema } from "@vy/types";
import { oz as oz14 } from "@vy/utils";
var DynamicInvoicePageMeasuredPriceBreakdownMapSchema = oz14.record(oz14.record(MeasuredPriceBreakdownSchema)).openapi("DynamicInvoicePageMeasuredPriceBreakdownMap");

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-page-measurement-chart-schema.ts
import { oz as oz15 } from "@vy/utils";
var DynamicInvoiceMeasurementChartDataSchema = oz15.record(DynamicInvoiceMeasurementChartMeterSchema).openapi("DynamicInvoiceMeasurementChartData");

// src/shared-schemas/dynamic-invoice-page/credit-pools-projection-map-schema.ts
import { oz as oz17 } from "@vy/utils";

// src/shared-schemas/dynamic-invoice-page/credit-pool-projection-schema.ts
import { oz as oz16 } from "@vy/utils";
var CreditPoolProjectionSchema = oz16.object({
  projectedDeduction: oz16.number(),
  projectedBalance: oz16.number()
});

// src/shared-schemas/dynamic-invoice-page/credit-pools-projection-map-schema.ts
var CreditPoolsProjectionMapSchema = oz17.record(oz17.string(), CreditPoolProjectionSchema).optional();

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-page-data-schema.ts
var DynamicInvoiceDataSchema = oz18.object({
  invoice: DynamicInvoicePageInvoiceSchema,
  customer: DynamicInvoicePageCustomerSchema,
  contract: DynamicContractPageContractSchema.optional(),
  measurementChartData: DynamicInvoiceMeasurementChartDataSchema,
  measuredPriceBreakdownMap: DynamicInvoicePageMeasuredPriceBreakdownMapSchema.optional(),
  creditPoolsProjectionMap: CreditPoolsProjectionMapSchema
}).openapi("DynamicInvoiceData");

// src/shared-schemas/dynamic-invoice-page/dynamic-invoice-page-id-type-schema.ts
import { oz as oz19 } from "@vy/utils";
var DYNAMIC_INVOICE_ID_TYPES = Object.freeze({
  Customer: "Customer",
  Invoice: "Invoice"
});
var DynamicInvoiceIdTypeSchema = oz19.nativeEnum(DYNAMIC_INVOICE_ID_TYPES).openapi("DynamicInvoiceIdType");

// src/shared-schemas/string-array-param-schema.ts
import { parseJson, oz as oz20 } from "@vy/utils";
var StringArrayParamSchema = oz20.string().transform((s) => parseJson(s)).pipe(oz20.string().array());

// src/shared-schemas/boolean-query-param-schema.ts
import { oz as oz21 } from "@vy/utils";
var BooleanQueryParamSchema = oz21.union([oz21.literal("true"), oz21.literal("false")]).transform((value) => value === "true").optional();

// src/shared-schemas/contract-page/contract-page-data-schema.ts
import { ContractSchema as ContractSchema3, CustomerSchema as CustomerSchema2 } from "@vy/types";
import { oz as oz23 } from "@vy/utils";

// src/shared-schemas/contract-page/contract-page-version-schema.ts
import { ApiDateSchema as ApiDateSchema2, PhaseTypeSchema } from "@vy/types";
import { oz as oz22 } from "@vy/utils";
var ContractPageVersionSchema = oz22.object({
  revisionId: oz22.string().optional(),
  label: PhaseTypeSchema,
  effectiveAt: ApiDateSchema2,
  name: oz22.string().optional(),
  isNonDeletable: oz22.boolean().nullish(),
  createdAt: ApiDateSchema2
});

// src/shared-schemas/contract-page/contract-page-data-schema.ts
var ContractPageDataSchema = oz23.object({
  contract: ContractSchema3.extend({
    isEditable: oz23.boolean(),
    hasSourcePdf: oz23.boolean(),
    customer: CustomerSchema2,
    revenue: oz23.number(),
    totalAmountToPay: oz23.number(),
    wasRenewed: oz23.boolean()
  }),
  versions: oz23.array(ContractPageVersionSchema)
}).openapi("ContractPageData");

// src/shared-schemas/contract-page/contract-product-overview-schema.ts
import { ObjectIdSchema as ObjectIdSchema4, ProductIntegrationEntitySchema, withNullAsOptional } from "@vy/types";
import { oz as oz24 } from "@vy/utils";
var ContractProductOverviewSchema = oz24.object({
  id: ObjectIdSchema4,
  catalogProductId: withNullAsOptional(ObjectIdSchema4),
  name: oz24.string(),
  description: oz24.string(),
  totalPrice: oz24.number(),
  integrationEntities: withNullAsOptional(oz24.array(ProductIntegrationEntitySchema))
}).openapi("ContractProductOverview");

// src/shared-schemas/products-page/products-page-schema.ts
import { oz as oz27 } from "@vy/utils";

// src/shared-schemas/products-page/meters-for-products-page-schema.ts
import { MeterSchema } from "@vy/types";
import { oz as oz25 } from "@vy/utils";
var MeterForProductPageResponseSchema = MeterSchema.openapi("MeterForProjectPageResponse");
var MetersForProductPageResponseSchema = oz25.array(MeterForProductPageResponseSchema).openapi("MetersForProjectPageResponse");

// src/shared-schemas/products-page/total-revenue-schema.ts
import { oz as oz26 } from "@vy/utils";
var TotalRevenueSchema = oz26.number().openapi("TotalRevenueData");

// src/shared-schemas/products-page/products-page-schema.ts
var ProductsPageSchema = oz27.object({
  totalRevenue: TotalRevenueSchema,
  meters: MetersForProductPageResponseSchema,
  countedTotalMeters: oz27.number().nonnegative(),
  countedFilteredMeters: oz27.number().nonnegative()
}).openapi("ProductsPageData");

// src/shared-schemas/products-page/meters-with-total-measurements.ts
import { oz as oz28 } from "@vy/utils";
var RawTotalMeasurementResultSchema = oz28.object({
  total: oz28.number(),
  meterId: oz28.string()
});
var MeterWithTotalMeasurementsResultSchema = oz28.object({
  meterName: oz28.string(),
  eventName: oz28.string(),
  total: oz28.number()
});

// src/shared-schemas/cache/cache-signature-schema.ts
import { ApiDateSchema as ApiDateSchema3 } from "@vy/types";
import { oz as oz29 } from "@vy/utils";
var CacheSignatureSchema = oz29.object({
  totalCount: oz29.number().nonnegative(),
  lastModified: ApiDateSchema3
}).openapi("CacheSignature");

// src/api-definition-params/customers-ids-query-param.ts
var CUSTOMERS_IDS_QUERY_PARAM = {
  name: "customersIds",
  location: "query",
  schema: StringArrayParamSchema.optional(),
  required: false
};

// src/api-definition-params/meters-ids-query-param.ts
var METERS_IDS_QUERY_PARAM = {
  name: "metersIds",
  location: "query",
  schema: StringArrayParamSchema.optional(),
  required: false
};

// src/api-definition-params/start-time-query-param.ts
import { ApiDateSchema as ApiDateSchema4 } from "@vy/types";
var START_TIME_QUERY_PARAM = {
  name: "startTime",
  location: "query",
  schema: ApiDateSchema4,
  required: true
};
var OPTIONAL_START_TIME_QUERY_PARAM = {
  name: "startTime",
  location: "query",
  schema: ApiDateSchema4.optional(),
  required: false
};

// src/api-definition-params/end-time-query-param.ts
import { ApiDateSchema as ApiDateSchema5 } from "@vy/types";
var END_TIME_QUERY_PARAM = {
  name: "endTime",
  location: "query",
  schema: ApiDateSchema5,
  required: true
};
var OPTIONAL_END_TIME_QUERY_PARAM = {
  name: "endTime",
  location: "query",
  schema: ApiDateSchema5.optional(),
  required: false
};

// src/api-definition-params/event-names-query-param.ts
var OPTIONAL_EVENT_NAMES_QUERY_PARAM = {
  name: "eventNames",
  location: "query",
  schema: StringArrayParamSchema.optional(),
  required: false
};

// src/api-definition-params/event-ref-query-param.ts
import { SanitizedStringSchema } from "@vy/types";
var EVENT_REF_QUERY_PARAM = {
  name: "eventRef",
  location: "query",
  schema: SanitizedStringSchema,
  required: true
};
var OPTIONAL_EVENT_REF_QUERY_PARAM = {
  name: "ref",
  location: "query",
  schema: SanitizedStringSchema.optional(),
  required: false
};

// src/api-definition-params/customer-alias-query-param.ts
import { SanitizedStringSchema as SanitizedStringSchema2 } from "@vy/types";
var OPTIONAL_CUSTOMER_ALIAS_QUERY_PARAM = {
  name: "customerAlias",
  location: "query",
  schema: SanitizedStringSchema2.optional(),
  required: false
};

// src/api-definition-params/token-query-param.ts
import { oz as oz30 } from "@vy/utils";
var TOKEN_QUERY_PARAMETER = {
  name: "token",
  location: "query",
  schema: oz30.string().nonempty(),
  required: true
};

// src/api-definition-params/search-term-query-param.ts
import { oz as oz31 } from "@vy/utils";
var SEARCH_TERM_QUERY_PARAMETER = {
  name: "searchTerm",
  location: "query",
  schema: oz31.string().nonempty().optional(),
  required: false
};

// src/api-definition-params/invoice-id-query-param.ts
import { oz as oz32 } from "@vy/utils";
var INVOICE_ID_QUERY_PARAMETER = {
  name: "invoiceId",
  location: "query",
  schema: oz32.string().nonempty(),
  required: false
};

// src/api-definition-paths/billing-cycles-paths/get-billing-cycles-overviews-path/get-billing-cycles-response-schema.ts
import { BillingCycleSchema as BillingCycleSchema2 } from "@vy/types";
import { oz as oz33 } from "@vy/utils";
var GetBillingCyclesResponseSchema = oz33.object({
  billingCycles: oz33.array(BillingCycleSchema2)
}).openapi("GetBillingCyclesResponse");

// src/api-definition-paths/billing-cycles-paths/get-billing-cycles-overviews-path/get-billing-cycles-overviews-action.ts
var GET_BILLING_CYCLES_OVERVIEWS_ACTION = {
  method: "get",
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS
  },
  codeGenerationSettings: {
    actionText: "get-billing-cycle-overviews"
  },
  response: {
    name: "GetBillingCyclesResponse",
    schema: GetBillingCyclesResponseSchema
  },
  path: GET_BILLING_CYCLES_OVERVIEWS_PATH
};

// src/api-definition-paths/billing-cycles-paths/billing-cycles-paths.ts
var BILLING_CYCLES_PATHS = [
  BILLING_CYCLES_ID_PATH,
  GET_BILLING_CYCLES_OVERVIEWS_PATH,
  CREATE_BILLING_CYCLE_PATH
];

// src/api-definition-paths/billing-cycles-paths/update-billing-cycle-path/update-billing-cycle-request-schema.ts
import { BillingCycleInputSchema } from "@vy/types";
var UpdateBillingCycleRequestSchema = BillingCycleInputSchema.openapi("UpdateBillingCycleRequest");

// src/api-definition-paths/billing-cycles-paths/update-billing-cycle-path/update-billing-cycle-response-schema.ts
import { BillingCycleSchema as BillingCycleSchema3 } from "@vy/types";
import { oz as oz34 } from "@vy/utils";
var UpdateBillingCycleResponseSchema = oz34.object({
  billingCycle: BillingCycleSchema3
}).openapi("UpdateBillingCycleResponse");

// src/api-definition-paths/billing-cycles-paths/update-billing-cycle-path/update-billing-cycle-action.ts
var UPDATE_BILLING_CYCLE_ACTION = {
  method: "put",
  request: {
    name: "UpdateBillingCycleRequest",
    schema: UpdateBillingCycleRequestSchema
  },
  codeGenerationSettings: {
    actionText: "update-billing-cycle"
  },
  response: {
    name: "UpdateBillingCycleResponse",
    schema: UpdateBillingCycleResponseSchema
  },
  path: BILLING_CYCLES_ID_PATH
};

// src/api-definition-paths/billing-cycles-paths/billing-cycles-actions.ts
var BILLING_CYCLES_ACTIONS = [
  CREATE_BILLING_CYCLE_ACTION,
  GET_BILLING_CYCLES_OVERVIEWS_ACTION,
  UPDATE_BILLING_CYCLE_ACTION
];

// src/api-definition-paths/plan-paths/create-plan/create-plan-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS4 } from "@vy/zapi-types";
var CREATE_PLAN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS4.PRIVATE,
  route: "/plan",
  tags: API_TAGS.PLANS
};

// src/api-definition-paths/plan-paths/create-plan/create-plan-request-schema.ts
import { NewPlanSchema } from "@vy/types";
var CreatePlanRequestSchema = NewPlanSchema.openapi("newPlan");

// src/api-definition-paths/plan-paths/create-plan/create-plan-response-schema.ts
import { PlanSchema } from "@vy/types";
import { oz as oz35 } from "@vy/utils";
var CreatePlanResponseSchema = oz35.object({
  plan: PlanSchema
}).openapi("CreatePlanResponse");

// src/api-definition-paths/plan-paths/create-plan/create-plan-action.ts
var CREATE_PLAN_ACTION = {
  method: "post",
  request: {
    name: "CreatePlanRequest",
    schema: CreatePlanRequestSchema
  },
  codeGenerationSettings: {
    actionText: "create-plan"
  },
  response: {
    name: "CreatePlanResponse",
    schema: CreatePlanResponseSchema
  },
  path: CREATE_PLAN_PATH
};

// src/api-definition-paths/plan-paths/disable-plan/disable-plan-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS6 } from "@vy/zapi-types";

// src/api-definition-paths/plan-paths/plan-id-path.ts
import { oz as oz36 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS5 } from "@vy/zapi-types";
var PLANS_ID_PATH_PARAM = {
  name: "planId",
  location: "path",
  schema: oz36.string(),
  required: true
};
var PLAN_ID_PATH_PARAMS = {
  [PLANS_ID_PATH_PARAM.name]: PLANS_ID_PATH_PARAM
};
var PLAN_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS5.PRIVATE,
  route: "/plan/{planId}",
  pathParams: PLAN_ID_PATH_PARAMS,
  tags: API_TAGS.PLANS
};

// src/api-definition-paths/plan-paths/disable-plan/disable-plan-path.ts
var DISABLE_PLAN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS6.PRIVATE,
  route: "/plan/disable/{planId}",
  pathParams: PLAN_ID_PATH_PARAMS,
  tags: API_TAGS.PLANS
};

// src/api-definition-paths/plan-paths/disable-plan/disable-plan-response-schema.ts
import { PlanSchema as PlanSchema2 } from "@vy/types";
import { oz as oz37 } from "@vy/utils";
var DisablePlanResponseSchema = oz37.object({
  plan: PlanSchema2
}).openapi("DisablePlanResponse");

// src/api-definition-paths/plan-paths/disable-plan/disable-plan-action.ts
var DISABLE_PLAN_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "disable-plan"
  },
  response: {
    name: "DisablePlanResponse",
    schema: DisablePlanResponseSchema
  },
  path: DISABLE_PLAN_PATH
};

// src/api-definition-paths/plan-paths/extract-plan/extract-plan-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS7 } from "@vy/zapi-types";
var EXTRACT_PLAN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS7.PRIVATE,
  route: "/plan/extract",
  tags: API_TAGS.PLANS
};

// src/api-definition-paths/plan-paths/extract-plan/extract-plan-response-schema.ts
import { ExtractedPlanSchema } from "@vy/types";
var ExtractPlanResponseSchema = ExtractedPlanSchema.openapi("ExtractPlanResponse");

// src/api-definition-paths/plan-paths/extract-plan/extract-plan-action.ts
var EXTRACT_PLAN_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "extract-plan"
  },
  response: {
    name: "ExtractPlanResponse",
    schema: ExtractPlanResponseSchema
  },
  path: EXTRACT_PLAN_PATH
};

// src/api-definition-paths/plan-paths/get-plan-overview/get-plan-overview-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS8 } from "@vy/zapi-types";
var GET_PLAN_OVERVIEW_PATH = {
  accessLevel: PATH_ACCESS_LEVELS8.PRIVATE,
  route: "/plan/{planId}/overview",
  pathParams: PLAN_ID_PATH_PARAMS,
  tags: API_TAGS.PLANS
};

// src/api-definition-paths/plan-paths/get-plan-overview/get-plan-overview-response-schema.ts
import { oz as oz39 } from "@vy/utils";

// src/api-definition-paths/plan-paths/get-plan-overview/plan-overview-schema.ts
import {
  ApiDateSchema as ApiDateSchema6,
  BillingIntervalSchema,
  PaymentTermSchema,
  PlanDurationSchema,
  PlanStatusSchema
} from "@vy/types";
import { ObjectIdSchema as ObjectIdSchema5 } from "@vy/types";
import { oz as oz38 } from "@vy/utils";
var PlanOverviewSchema = oz38.object({
  id: ObjectIdSchema5,
  name: oz38.string().nonempty(),
  revenue: oz38.number().nonnegative(),
  accrued: oz38.number().nonnegative(),
  paymentTerm: PaymentTermSchema,
  status: PlanStatusSchema,
  customersCount: oz38.number().nonnegative(),
  basedFromPlanId: ObjectIdSchema5.optional(),
  billingInterval: BillingIntervalSchema,
  planDuration: PlanDurationSchema,
  updatedAt: ApiDateSchema6
}).openapi("PlanOverview");

// src/api-definition-paths/plan-paths/get-plan-overview/get-plan-overview-response-schema.ts
var GetPlanOverviewResponseSchema = oz39.object({
  plan: PlanOverviewSchema
}).openapi("GetPlanOverviewResponse");

// src/api-definition-paths/plan-paths/get-plan-overview/get-plan-overview-action.ts
var GET_PLAN_OVERVIEW_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-plan-overview"
  },
  response: {
    name: "GetPlanOverviewResponse",
    schema: GetPlanOverviewResponseSchema
  },
  path: GET_PLAN_OVERVIEW_PATH
};

// src/api-definition-paths/plan-paths/soft-update-plan-path/soft-update-plan-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS9 } from "@vy/zapi-types";
var SOFT_UPDATE_PLAN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS9.PRIVATE,
  route: "/plan/soft/{planId}",
  pathParams: PLAN_ID_PATH_PARAMS,
  tags: API_TAGS.PLANS
};

// src/api-definition-paths/plan-paths/plans-paths.ts
var PLAN_PATHS = [
  PLAN_ID_PATH,
  SOFT_UPDATE_PLAN_PATH,
  DISABLE_PLAN_PATH,
  CREATE_PLAN_PATH,
  GET_PLAN_OVERVIEW_PATH,
  EXTRACT_PLAN_PATH
];

// src/api-definition-paths/plan-paths/update-plan-path/update-plan-request-schema.ts
import { PlanInputSchema } from "@vy/types";
var UpdatePlanRequestSchema = PlanInputSchema.openapi("UpdatePlanRequest");

// src/api-definition-paths/plan-paths/update-plan-path/update-plan-response-schema.ts
import { PlanSchema as PlanSchema3 } from "@vy/types";
import { oz as oz40 } from "@vy/utils";
var UpdatePlanResponseSchema = oz40.object({
  plan: PlanSchema3
}).openapi("updatePlanResponse");

// src/api-definition-paths/plan-paths/update-plan-path/update-plan-action.ts
var UPDATE_PLAN_ACTION = {
  method: "put",
  request: {
    name: "UpdatePlanRequest",
    schema: UpdatePlanRequestSchema
  },
  codeGenerationSettings: {
    actionText: "update-plan"
  },
  response: {
    name: "UpdatePlanResponse",
    schema: UpdatePlanResponseSchema
  },
  path: PLAN_ID_PATH
};

// src/api-definition-paths/plan-paths/soft-update-plan-path/soft-update-plan-request-schema.ts
import { PlanInputSchema as PlanInputSchema2 } from "@vy/types";
var SoftUpdatePlanRequestSchema = PlanInputSchema2.pick({
  name: true,
  billingData: true,
  purchaseOrder: true
}).openapi("SoftUpdatePlanRequest");

// src/api-definition-paths/plan-paths/soft-update-plan-path/soft-update-plan-response-schema.ts
import { oz as oz41 } from "@vy/utils";
var SoftUpdatePlanResponseSchema = oz41.object({
  planId: oz41.string()
});

// src/api-definition-paths/plan-paths/soft-update-plan-path/soft-update-plan-action.ts
var SOFT_UPDATE_PLAN_ACTION = {
  method: "put",
  request: {
    name: "SoftUpdatePlanRequest",
    schema: SoftUpdatePlanRequestSchema
  },
  codeGenerationSettings: {
    actionText: "soft-update-plan"
  },
  response: {
    name: "SoftUpdatePlanResponse",
    schema: SoftUpdatePlanResponseSchema
  },
  path: SOFT_UPDATE_PLAN_PATH
};

// src/api-definition-paths/plan-paths/get-plans-overviews-path/get-plans-overviews-action.ts
import { PlanStatusesSchema } from "@vy/types";

// src/shared-schemas/get-query-sorting-item-parameter-schemas.ts
import { SortingItemSchema } from "@vy/types";
import { oz as oz42 } from "@vy/utils";
function getQuerySortingItemParameterSchemas(entity, openapiName) {
  const keys = Object.keys(entity.shape);
  const SortSchema = SortingItemSchema.extend({
    field: oz42.enum(keys.map(String)).optional()
  }).optional().openapi(openapiName);
  const schema = oz42.custom().optional().openapi(openapiName);
  const param = {
    name: "sort",
    location: "query",
    schema: oz42.string().optional()
  };
  return {
    schema,
    param
  };
}

// src/api-definition-paths/plan-paths/get-plans-overviews-path/get-plans-overviews-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS10 } from "@vy/zapi-types";
var GET_PLANS_OVERVIEWS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS10.PRIVATE,
  route: "/plans/overviews",
  pathParams: void 0,
  tags: API_TAGS.PLANS
};

// src/api-definition-paths/plan-paths/get-plans-overviews-path/get-plans-overviews-response-schema.ts
import { oz as oz43 } from "@vy/utils";
var GetPlansOverviewsResponseSchema = oz43.object({
  countedActivePlansOverviews: oz43.number().nonnegative(),
  countedTotalPlansOverviews: oz43.number().nonnegative(),
  countedFilteredPlansOverviews: oz43.number().nonnegative(),
  plansOverviews: oz43.array(PlanOverviewSchema)
}).openapi("GetPlansOverviewsResponse");

// src/api-definition-paths/plan-paths/get-plans-overviews-path/get-plans-overviews-action.ts
var { schema: GetPlansOverviewsSortingSchema, param: GET_PLANS_OVERVIEWS_SORTING_PARAMETER } = getQuerySortingItemParameterSchemas(PlanOverviewSchema, "GetPlansOverviewsSorting");
var PLAN_STATUSES_QUERY_PARAMETER = {
  name: "planStatuses",
  location: "query",
  schema: PlanStatusesSchema
};
var GET_PLANS_OVERVIEWS_ACTION = {
  method: "get",
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [PLAN_STATUSES_QUERY_PARAMETER.name]: PLAN_STATUSES_QUERY_PARAMETER,
    [GET_PLANS_OVERVIEWS_SORTING_PARAMETER.name]: GET_PLANS_OVERVIEWS_SORTING_PARAMETER
  },
  codeGenerationSettings: {
    actionText: "get-plan-overviews"
  },
  response: {
    name: "GetPlanOverviewsResponse",
    schema: GetPlansOverviewsResponseSchema
  },
  path: GET_PLANS_OVERVIEWS_PATH
};

// src/api-definition-paths/plan-paths/get-plan-path/get-plan-response-schema.ts
import { PlanSchema as PlanSchema4 } from "@vy/types";
import { oz as oz44 } from "@vy/utils";
var GetPlanResponseSchema = oz44.object({
  plan: PlanSchema4
}).openapi("GetPlanResponse");

// src/api-definition-paths/plan-paths/get-plan-path/get-plan-action.ts
var GET_PLAN_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-plan"
  },
  response: {
    name: "GetPlanResponse",
    schema: GetPlanResponseSchema
  },
  path: PLAN_ID_PATH
};

// src/api-definition-paths/plan-paths/delete-plan/delete-plan-action.ts
var DELETE_PLAN_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-plan"
  },
  path: PLAN_ID_PATH
};

// src/api-definition-paths/plan-paths/plans-actions.ts
var PLANS_ACTIONS = [
  CREATE_PLAN_ACTION,
  DELETE_PLAN_ACTION,
  DISABLE_PLAN_ACTION,
  GET_PLAN_ACTION,
  GET_PLANS_OVERVIEWS_ACTION,
  SOFT_UPDATE_PLAN_ACTION,
  UPDATE_PLAN_ACTION,
  GET_PLAN_OVERVIEW_ACTION,
  EXTRACT_PLAN_ACTION
];

// src/api-definition-paths/auth-paths/signup-path/signup-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS11 } from "@vy/zapi-types";
var SIGNUP_PATH = {
  accessLevel: PATH_ACCESS_LEVELS11.PUBLIC,
  route: "/auth/signup",
  tags: API_TAGS.AUTH
};

// src/api-definition-paths/auth-paths/signup-path/signup-request-schema.ts
import { JwtSchema, PasswordSchema } from "@vy/types";
import { oz as oz45 } from "@vy/utils";
var SignupRequestSchema = oz45.object({
  token: JwtSchema,
  password: PasswordSchema
}).openapi("SignupRequest");

// src/api-definition-paths/auth-paths/signup-path/signup-response-schema.ts
import { oz as oz46 } from "@vy/utils";
var SignupResponseSchema = oz46.object({
  accountId: oz46.string(),
  requiresConfirmation: oz46.boolean()
}).openapi("SignupResponse");

// src/api-definition-paths/auth-paths/signup-path/signup-action.ts
var SIGNUP_ACTION = {
  method: "post",
  request: {
    name: "SignupRequest",
    schema: SignupRequestSchema
  },
  codeGenerationSettings: {
    actionText: "signup"
  },
  response: {
    name: "SignupResponse",
    schema: SignupResponseSchema
  },
  path: SIGNUP_PATH
};

// src/api-definition-paths/auth-paths/login-path/login-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS12 } from "@vy/zapi-types";
var LOGIN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS12.PUBLIC,
  route: "/auth/login",
  tags: API_TAGS.AUTH
};

// src/api-definition-paths/auth-paths/login-path/login-request-schema.ts
import { PasswordSchema as PasswordSchema2, UsernameSchema } from "@vy/types";
import { oz as oz47 } from "@vy/utils";
var LoginRequestSchema = oz47.object({
  username: UsernameSchema,
  password: PasswordSchema2
}).openapi("LoginRequest");

// src/api-definition-paths/auth-paths/login-path/login-response-schema.ts
import { UserSchema } from "@vy/types";
import { JwtSchema as JwtSchema2 } from "@vy/types";
import { oz as oz48 } from "@vy/utils";
var LoginResponseSchema = oz48.object({
  token: JwtSchema2,
  user: UserSchema
}).openapi("LoginResponse");

// src/api-definition-paths/auth-paths/login-path/login-action.ts
var LOGIN_ACTION = {
  method: "post",
  request: {
    name: "LoginRequest",
    schema: LoginRequestSchema
  },
  codeGenerationSettings: {
    actionText: "login"
  },
  response: {
    name: "LoginResponse",
    schema: LoginResponseSchema
  },
  path: LOGIN_PATH
};

// src/api-definition-paths/auth-paths/refresh-token-path/refresh-token-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS13 } from "@vy/zapi-types";
var REFRESH_TOKEN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS13.PUBLIC,
  route: "/auth/refresh-token",
  tags: API_TAGS.AUTH
};

// src/api-definition-paths/auth-paths/refresh-token-path/refresh-token-response-schema.ts
import { JwtSchema as JwtSchema3 } from "@vy/types";
import { oz as oz49 } from "@vy/utils";
var RefreshTokenResponseSchema = oz49.object({
  token: JwtSchema3
}).openapi("RefreshTokenResponse");

// src/api-definition-paths/auth-paths/refresh-token-path/refresh-token-action.ts
var REFRESH_TOKEN_ACTION = {
  method: "post",
  request: {
    name: "RefreshTokenRequest",
    schema: void 0
  },
  codeGenerationSettings: {
    actionText: "refreshToken"
  },
  response: {
    name: "RefreshTokenResponse",
    schema: RefreshTokenResponseSchema
  },
  path: REFRESH_TOKEN_PATH
};

// src/api-definition-paths/auth-paths/confirm-password-reset-path/confirm-password-reset-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS14 } from "@vy/zapi-types";
var CONFIRM_PASSWORD_RESET_PATH = {
  accessLevel: PATH_ACCESS_LEVELS14.PUBLIC,
  route: "/auth/confirm-password-reset",
  tags: API_TAGS.AUTH
};

// src/api-definition-paths/auth-paths/confirm-password-reset-path/confirm-password-reset-request-schema.ts
import { ConfirmationCodeSchema, PasswordSchema as PasswordSchema3, UsernameSchema as UsernameSchema2 } from "@vy/types";
import { oz as oz50 } from "@vy/utils";
var ConfirmPasswordResetRequestSchema = oz50.object({
  email: UsernameSchema2,
  newPassword: PasswordSchema3,
  verificationCode: ConfirmationCodeSchema
}).openapi("ConfirmPasswordResetRequest");

// src/api-definition-paths/auth-paths/confirm-password-reset-path/confirm-password-reset-response-schema.ts
import { oz as oz51 } from "@vy/utils";
var ConfirmPasswordResetResponseSchema = oz51.object({
  message: oz51.string()
}).openapi("ConfirmPasswordResetResponse");

// src/api-definition-paths/auth-paths/confirm-password-reset-path/confirm-password-reset-action.ts
var CONFIRM_PASSWORD_RESET_ACTION = {
  method: "post",
  request: {
    name: "ConfirmPasswordResetRequest",
    schema: ConfirmPasswordResetRequestSchema
  },
  codeGenerationSettings: {
    actionText: "confirm password reset"
  },
  response: {
    name: "ConfirmPasswordResetResponse",
    schema: ConfirmPasswordResetResponseSchema
  },
  path: CONFIRM_PASSWORD_RESET_PATH
};

// src/api-definition-paths/auth-paths/confirm-path/confirm-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS15 } from "@vy/zapi-types";
var CONFIRM_PATH = {
  accessLevel: PATH_ACCESS_LEVELS15.PUBLIC,
  route: "/auth/confirm",
  tags: API_TAGS.AUTH
};

// src/api-definition-paths/auth-paths/confirm-path/confirm-request-schema.ts
import { ConfirmationCodeSchema as ConfirmationCodeSchema2, JwtSchema as JwtSchema4 } from "@vy/types";
import { oz as oz52 } from "@vy/utils";
var ConfirmRequestSchema = oz52.object({
  token: JwtSchema4,
  confirmationCode: ConfirmationCodeSchema2
}).openapi("ConfirmRequest");

// src/api-definition-paths/auth-paths/confirm-path/confirm-action.ts
var CONFIRM_ACTION = {
  method: "post",
  request: {
    name: "ConfirmRequest",
    schema: ConfirmRequestSchema
  },
  codeGenerationSettings: {
    actionText: "confirmUser"
  },
  path: CONFIRM_PATH
};

// src/api-definition-paths/auth-paths/get-external-api-token/get-external-api-token-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS16 } from "@vy/zapi-types";
var GET_EXTERNAL_API_TOKEN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS16.PRIVATE,
  route: "/auth/external-api-token",
  tags: API_TAGS.AUTH
};

// src/api-definition-paths/auth-paths/get-external-api-token/get-external-api-token-response-schema.ts
import { oz as oz53 } from "@vy/utils";
var GetExternalApiTokenResponseSchema = oz53.object({
  refreshToken: oz53.string()
});

// src/api-definition-paths/auth-paths/get-external-api-token/get-external-api-token-action.ts
var GET_EXTERNAL_API_TOKEN_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "getExternalApiToken"
  },
  response: {
    name: "GetExternalApiTokenResponse",
    schema: GetExternalApiTokenResponseSchema
  },
  path: GET_EXTERNAL_API_TOKEN_PATH
};

// src/api-definition-paths/auth-paths/get-sandbox-user-path/get-sandbox-user-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS17 } from "@vy/zapi-types";
var GET_SANDBOX_USER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS17.PUBLIC,
  route: "/users/sandbox",
  tags: API_TAGS.AUTH
};

// src/api-definition-paths/auth-paths/get-sandbox-user-path/sandbox-environment-query-parameter.ts
import { SandboxEnvironmentSchema } from "@vy/types";
var SANDBOX_ENVIRONMENT_QUERY_PARAMETER = {
  name: "environment",
  location: "query",
  schema: SandboxEnvironmentSchema,
  required: true
};

// src/api-definition-paths/auth-paths/get-sandbox-user-path/get-sandbox-user-action.ts
var GET_SANDBOX_USER_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "getSandboxUser"
  },
  queryParams: {
    [SANDBOX_ENVIRONMENT_QUERY_PARAMETER.name]: SANDBOX_ENVIRONMENT_QUERY_PARAMETER
  },
  response: {
    name: "SandboxUserResponse",
    schema: LoginResponseSchema
  },
  path: GET_SANDBOX_USER_PATH
};

// src/api-definition-paths/auth-paths/invalidate-external-api-token/invalidate-external-api-token-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS18 } from "@vy/zapi-types";
var INVALIDATE_EXTERNAL_API_TOKEN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS18.PRIVATE,
  route: "/auth/external-api-token/invalidate",
  tags: API_TAGS.AUTH
};

// src/api-definition-paths/auth-paths/invalidate-external-api-token/invalidate-external-api-token-action.ts
var INVALIDATE_EXTERNAL_API_TOKEN_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "invalidateExternalApiToken"
  },
  path: INVALIDATE_EXTERNAL_API_TOKEN_PATH
};

// src/api-definition-paths/auth-paths/reset-password-path/reset-password-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS19 } from "@vy/zapi-types";
var RESET_PASSWORD_PATH = {
  accessLevel: PATH_ACCESS_LEVELS19.PUBLIC,
  route: "/auth/reset-password",
  tags: API_TAGS.AUTH
};

// src/api-definition-paths/auth-paths/reset-password-path/reset-password-request-schema.ts
import { UsernameSchema as UsernameSchema3 } from "@vy/types";
import { oz as oz54 } from "@vy/utils";
var ResetPasswordRequestSchema = oz54.object({
  email: UsernameSchema3
}).openapi("ResetPasswordRequest");

// src/api-definition-paths/auth-paths/reset-password-path/reset-password-response-schema.ts
import { oz as oz55 } from "@vy/utils";
var ResetPasswordResponseSchema = oz55.object({
  message: oz55.string()
}).openapi("ResetPasswordResponse");

// src/api-definition-paths/auth-paths/reset-password-path/reset-password-action.ts
var RESET_PASSWORD_ACTION = {
  method: "post",
  request: {
    name: "ResetPasswordRequest",
    schema: ResetPasswordRequestSchema
  },
  codeGenerationSettings: {
    actionText: "reset password"
  },
  response: {
    name: "ResetPasswordResponse",
    schema: ResetPasswordResponseSchema
  },
  path: RESET_PASSWORD_PATH
};

// src/api-definition-paths/auth-paths/signup-raw-path/signup-raw-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS20 } from "@vy/zapi-types";
var SIGNUP_RAW_PATH = {
  accessLevel: PATH_ACCESS_LEVELS20.PUBLIC,
  route: "/auth/signup/raw",
  tags: API_TAGS.AUTH
};

// src/api-definition-paths/auth-paths/signup-raw-path/signup-raw-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema6, PasswordSchema as PasswordSchema4, UsernameSchema as UsernameSchema4 } from "@vy/types";
import { oz as oz56 } from "@vy/utils";
var SignupRawRequestSchema = oz56.object({
  accountId: ObjectIdSchema6,
  username: UsernameSchema4,
  password: PasswordSchema4,
  userInvitationId: ObjectIdSchema6
}).openapi("SignupRawRequest");

// src/api-definition-paths/auth-paths/signup-raw-path/signup-raw-response-schema.ts
import { JwtSchema as JwtSchema5 } from "@vy/types";
import { oz as oz57 } from "@vy/utils";
var SignupRawResponseSchema = oz57.object({
  token: JwtSchema5
}).openapi("SignupRawResponse");

// src/api-definition-paths/auth-paths/signup-raw-path/signup-raw-action.ts
var SIGNUP_RAW_ACTION = {
  method: "post",
  request: {
    name: "SignupRawRequest",
    schema: SignupRawRequestSchema
  },
  codeGenerationSettings: {
    actionText: "rawSignup"
  },
  response: {
    name: "SignupRawResponse",
    schema: SignupRawResponseSchema
  },
  path: SIGNUP_RAW_PATH
};

// src/api-definition-paths/auth-paths/nest-auth-actions.ts
var AUTH_ACTIONS = [
  LOGIN_ACTION,
  REFRESH_TOKEN_ACTION,
  SIGNUP_ACTION,
  SIGNUP_RAW_ACTION,
  GET_SANDBOX_USER_ACTION,
  CONFIRM_ACTION,
  RESET_PASSWORD_ACTION,
  CONFIRM_PASSWORD_RESET_ACTION,
  GET_EXTERNAL_API_TOKEN_ACTION,
  INVALIDATE_EXTERNAL_API_TOKEN_ACTION
];

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS21 } from "@vy/zapi-types";
var TRIGGER_REPORT_JOB_PATH = {
  accessLevel: PATH_ACCESS_LEVELS21.PRIVATE,
  route: "/report/trigger",
  tags: API_TAGS.REPORTS
};

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-action.ts
import { ReportDataSchema } from "@vy/types";

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-request-schema.ts
import { oz as oz67 } from "@vy/utils";

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-parameters/commitment-usage-report.ts
import { ApiDateSchema as ApiDateSchema7, REPORT_JOB_TYPES } from "@vy/types";
import { oz as oz58 } from "@vy/utils";
var TriggerCommitmentUsageReportJobParametersSchema = oz58.object({
  reportJobType: oz58.literal(REPORT_JOB_TYPES.CommitmentUsage),
  reportName: oz58.string().optional(),
  upToDate: ApiDateSchema7,
  startDate: ApiDateSchema7.optional()
});

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-parameters/uncharged-usage-report.ts
import { PeriodSchema, REPORT_JOB_TYPES as REPORT_JOB_TYPES2 } from "@vy/types";
import { oz as oz59 } from "@vy/utils";
var TriggerUnchargedUsageReportJobParametersSchema = oz59.object({
  reportJobType: oz59.literal(REPORT_JOB_TYPES2.UnchargedUsage),
  reportName: oz59.string().optional(),
  period: PeriodSchema
});

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-parameters/products-usage-report.ts
import { PeriodSchema as PeriodSchema2, REPORT_JOB_TYPES as REPORT_JOB_TYPES3 } from "@vy/types";
import { oz as oz60 } from "@vy/utils";
var TriggerProductsUsageReportJobParametersSchema = oz60.object({
  reportJobType: oz60.literal(REPORT_JOB_TYPES3.ProductsUsage),
  reportName: oz60.string().optional(),
  period: PeriodSchema2
});

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-parameters/contracts-report.ts
import { REPORT_JOB_TYPES as REPORT_JOB_TYPES4 } from "@vy/types";
import { oz as oz61 } from "@vy/utils";
var TriggerContractsReportJobParametersSchema = oz61.object({
  reportJobType: oz61.literal(REPORT_JOB_TYPES4.Contracts),
  reportName: oz61.string().optional()
});

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-parameters/anonymous-customers-report.ts
import { REPORT_JOB_TYPES as REPORT_JOB_TYPES5 } from "@vy/types";
import { oz as oz62 } from "@vy/utils";
var TriggerAnonymousCustomersReportJobParametersSchema = oz62.object({
  reportJobType: oz62.literal(REPORT_JOB_TYPES5.AnonymousCustomers),
  reportName: oz62.string().optional()
});

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-parameters/montly-clouser-report.ts
import { PeriodSchema as PeriodSchema3, REPORT_JOB_TYPES as REPORT_JOB_TYPES6 } from "@vy/types";
import { oz as oz63 } from "@vy/utils";
var TriggerMonthlyClosureReportJobParametersSchema = oz63.object({
  reportJobType: oz63.literal(REPORT_JOB_TYPES6.MonthlyClosure),
  reportName: oz63.string().optional(),
  period: PeriodSchema3
});

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-parameters/customers-report.ts
import { REPORT_JOB_TYPES as REPORT_JOB_TYPES7 } from "@vy/types";
import { oz as oz64 } from "@vy/utils";
var TriggerCustomersReportJobParametersSchema = oz64.object({
  reportJobType: oz64.literal(REPORT_JOB_TYPES7.Customers),
  reportName: oz64.string().optional()
});

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-parameters/failed-invoice-deliveries-report.ts
import { REPORT_JOB_TYPES as REPORT_JOB_TYPES8 } from "@vy/types";
import { oz as oz65 } from "@vy/utils";
var TriggerFailedInvoiceDeliveriesReportJobParametersSchema = oz65.object({
  reportJobType: oz65.literal(REPORT_JOB_TYPES8.FailedInvoiceDeliveries),
  reportName: oz65.string().optional()
});

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-parameters/recurring-revenue-report.ts
import { REPORT_JOB_TYPES as REPORT_JOB_TYPES9 } from "@vy/types";
import { oz as oz66 } from "@vy/utils";
var TriggerRecurringRevenueReportJobParametersSchema = oz66.object({
  reportJobType: oz66.literal(REPORT_JOB_TYPES9.RecurringRevenue),
  reportName: oz66.string().optional()
});

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-request-schema.ts
var TriggerReportJobRequestSchema = oz67.discriminatedUnion("reportJobType", [
  TriggerCommitmentUsageReportJobParametersSchema,
  TriggerUnchargedUsageReportJobParametersSchema,
  TriggerProductsUsageReportJobParametersSchema,
  TriggerContractsReportJobParametersSchema,
  TriggerAnonymousCustomersReportJobParametersSchema,
  TriggerMonthlyClosureReportJobParametersSchema,
  TriggerCustomersReportJobParametersSchema,
  TriggerFailedInvoiceDeliveriesReportJobParametersSchema,
  TriggerRecurringRevenueReportJobParametersSchema
]);

// src/api-definition-paths/reports-paths/trigger-report-job-path/trigger-report-job-action.ts
var TRIGGER_REPORT_JOB_ACTION = {
  method: "post",
  request: {
    name: "TriggerReportJobRequest",
    schema: TriggerReportJobRequestSchema
  },
  codeGenerationSettings: {
    actionText: "trigger-report-job"
  },
  response: {
    name: "TriggerReportJobResponse",
    schema: ReportDataSchema
  },
  path: TRIGGER_REPORT_JOB_PATH
};

// src/api-definition-paths/reports-paths/reports-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS22 } from "@vy/zapi-types";
var REPORTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS22.PRIVATE,
  route: "/reports",
  tags: API_TAGS.REPORTS
};

// src/api-definition-paths/reports-paths/get-reports/get-reports-response-schema.ts
import { ReportDataSchema as ReportDataSchema2 } from "@vy/types";
import { oz as oz68 } from "@vy/utils";
var GetReportsResponseSchema = oz68.array(ReportDataSchema2).openapi("GetReportsResponseSchema");

// src/api-definition-paths/reports-paths/get-reports/get-reports-action.ts
var GET_REPORTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-reports"
  },
  response: {
    name: "GetReportsResponse",
    schema: GetReportsResponseSchema
  },
  path: REPORTS_PATH
};

// src/api-definition-paths/reports-paths/report-id-path.ts
import { oz as oz69 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS23 } from "@vy/zapi-types";
var REPORT_ID_PATH_PARAM = {
  name: "reportId",
  location: "path",
  schema: oz69.string(),
  required: true
};
var REPORT_ID_PATH_PARAMS = {
  [REPORT_ID_PATH_PARAM.name]: REPORT_ID_PATH_PARAM
};
var REPORT_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS23.PRIVATE,
  route: "/report/{reportId}",
  pathParams: REPORT_ID_PATH_PARAMS,
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/delete-report/delete-report-response-schema.ts
import { ReportDataSchema as ReportDataSchema3 } from "@vy/types";
var DeleteReportResponseSchema = ReportDataSchema3.openapi("DeleteReportResponseSchema");

// src/api-definition-paths/reports-paths/delete-report/delete-report-action.ts
var DELETE_REPORT_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-report"
  },
  response: {
    name: "DeleteReportResponse",
    schema: DeleteReportResponseSchema
  },
  path: REPORT_ID_PATH
};

// src/api-definition-paths/reports-paths/get-ar-aging-report-path/get-ar-aging-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS24 } from "@vy/zapi-types";
var GET_AR_AGING_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS24.PRIVATE,
  route: "/report/ar-aging",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/optional-report-id-param.ts
import { oz as oz70 } from "@vy/utils";
var OPTIONAL_REPORT_ID_QUERY_PARAM = {
  name: "reportId",
  location: "query",
  schema: oz70.string().optional(),
  required: false
};

// src/api-definition-paths/reports-paths/get-customers-report-path/get-customers-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS25 } from "@vy/zapi-types";
var GET_CUSTOMERS_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS25.PRIVATE,
  route: "/report/customers",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-customers-report-path/get-customers-report-response-schema.ts
import { ApiDateSchema as ApiDateSchema8, CustomersReportSchema } from "@vy/types";
import { oz as oz71 } from "@vy/utils";
var GetCustomersReportResponseSchema = oz71.object({
  report: CustomersReportSchema,
  creationDate: ApiDateSchema8,
  startDate: ApiDateSchema8.optional(),
  endDate: ApiDateSchema8.optional()
}).openapi("GetCustomerReportResponseSchema");

// src/api-definition-paths/reports-paths/get-customers-report-path/get-customers-report-action.ts
var GET_CUSTOMERS_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customers-report"
  },
  response: {
    name: "GetCustomersReportResponse",
    schema: GetCustomersReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_CUSTOMERS_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-failed-invoice-deliveries-report-path/get-failed-invoice-deliveries-report-response-schema.ts
import { ApiDateSchema as ApiDateSchema9, FailedInvoiceDeliveriesReportSchema } from "@vy/types";
import { oz as oz72 } from "@vy/utils";
var GetFailedInvoiceDeliveriesReportResponseSchema = oz72.object({
  report: FailedInvoiceDeliveriesReportSchema,
  creationDate: ApiDateSchema9
}).openapi("GetFailedInvoiceDeliveriesReportResponseSchema");

// src/api-definition-paths/reports-paths/get-failed-invoice-deliveries-report-path/get-failed-invoice-deliveries-report-path.ts
var GET_FAILED_INVOICE_DELIVERIES_REPORT_PATH = {
  accessLevel: "private",
  route: "/report/failed-invoice-deliveries",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-failed-invoice-deliveries-report-path/get-failed-invoice-deliveries-report-action.ts
var GET_FAILED_INVOICE_DELIVERIES_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-failed-invoice-deliveries-report"
  },
  response: {
    name: "GetFailedInvoiceDeliveriesReportResponse",
    schema: GetFailedInvoiceDeliveriesReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_FAILED_INVOICE_DELIVERIES_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-monthly-clouser-report-path/get-monthly-clouser-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS26 } from "@vy/zapi-types";
var GET_MONTHLY_CLOUSER_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS26.PRIVATE,
  route: "/report/monthly-closure",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-monthly-clouser-report-path/get-monthly-clouser-report-response-schema.ts
import { ApiDateSchema as ApiDateSchema10, MonthlyClosureReportSchema } from "@vy/types";
import { oz as oz73 } from "@vy/utils";
var GetMonthlyClouserReportResponseSchema = oz73.object({
  report: MonthlyClosureReportSchema,
  creationDate: ApiDateSchema10,
  startDate: ApiDateSchema10.optional(),
  endDate: ApiDateSchema10.optional()
}).openapi("GetMonthlyClouserReportResponseSchema");

// src/api-definition-paths/reports-paths/get-monthly-clouser-report-path/get-monthly-clouser-report-action.ts
var GET_MONTHLY_CLOUSER_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-monthly-clouser-report"
  },
  response: {
    name: "GetMonthlyClouserReportResponse",
    schema: GetMonthlyClouserReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_MONTHLY_CLOUSER_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-unapproved-invoices-report-path/get-unapproved-invoices-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS27 } from "@vy/zapi-types";
var GET_UNAPPROVED_INVOICES_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS27.PRIVATE,
  route: "/report/unapproved-invoices",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-unapproved-invoices-report-path/get-unapproved-invoices-report-response.ts
import { oz as oz74 } from "@vy/utils";
var GetUnapprovedInvoicesReportResponseSchema = oz74.object({}).openapi("GetUnapprovedInvoicesReportResponseSchema", {
  description: "Excel file containing the unapproved invoices report",
  format: "binary",
  type: "string"
});

// src/api-definition-paths/reports-paths/get-unapproved-invoices-report-path/get-unapproved-invoices-report-action.ts
var GET_UNAPPROVED_INVOICES_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-unapproved-invoices-report"
  },
  response: {
    name: "GetUnapprovedInvoicesReportResponse",
    schema: GetUnapprovedInvoicesReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_UNAPPROVED_INVOICES_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-upcoming-invoices-report-path/get-upcoming-invoices-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS28 } from "@vy/zapi-types";
var GET_UPCOMING_INVOICES_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS28.PRIVATE,
  route: "/report/upcoming-invoices",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-upcoming-invoices-report-path/get-upcoming-invoices-report-response.ts
import { UpcomingInvoicesReportSchema } from "@vy/types";
var GetUpcomingInvoicesReportResponseSchema = UpcomingInvoicesReportSchema.openapi(
  "GetUpcomingInvoicesReportResponseSchema"
);

// src/api-definition-paths/reports-paths/get-upcoming-invoices-report-path/get-upcoming-invoices-report-action.ts
var GET_UPCOMING_INVOICES_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-upcoming-invoices-report"
  },
  response: {
    name: "GetUpcomingInvoicesReportResponse",
    schema: GetUpcomingInvoicesReportResponseSchema
  },
  path: GET_UPCOMING_INVOICES_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-usage-report-path/get-usage-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS29 } from "@vy/zapi-types";
var GET_USAGE_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS29.PRIVATE,
  route: "/report/usage",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-usage-report-path/get-usage-report-response.ts
import { oz as oz75 } from "@vy/utils";
var GetUsageReportResponseSchema = oz75.object({}).openapi("GetUsageReportResponseSchema", {
  description: "Excel file containing the usage report",
  format: "binary",
  type: "string"
});

// src/api-definition-paths/reports-paths/get-usage-report-path/get-usage-report-action.ts
var GET_USAGE_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-usage-report"
  },
  response: {
    name: "GetUsageReportResponse",
    schema: GetUsageReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_USAGE_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-invoices-summary-report-path/get-invoices-summary-report-path.ts
var GET_INVOICES_SUMMARY_REPORT_PATH = {
  accessLevel: "private",
  route: "/report/invoices-summary",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-invoices-summary-report-path/get-invoices-summary-report-response-schema.ts
import { oz as oz80 } from "@vy/utils";

// src/api-definition-paths/reports-paths/get-invoices-summary-report-path/report-invoices-summary-schema.ts
import { oz as oz79 } from "@vy/utils";

// src/api-definition-paths/reports-paths/get-invoices-summary-report-path/report-invoice-summary-comparisons-schema.ts
import { oz as oz76 } from "@vy/utils";
var ReportInvoiceSummaryComparisonsSchema = oz76.object({
  totalInvoicesSum: oz76.number(),
  lastMonthInvoicesSum: oz76.number(),
  totalActiveCustomers: oz76.number(),
  lastMonthActiveCustomers: oz76.number(),
  totalActiveContracts: oz76.number(),
  lastMonthActiveContracts: oz76.number()
}).openapi("ReportInvoiceSummaryComparisons");

// src/api-definition-paths/reports-paths/get-invoices-summary-report-path/report-revenue-by-billing-status-schema.ts
import { InvoiceBillingStatusSchema } from "@vy/types";
import { oz as oz77 } from "@vy/utils";
var ReportRevenueByBillingStatusSchema = oz77.record(InvoiceBillingStatusSchema, oz77.number()).openapi("ReportRevenueByBillingStatus");

// src/api-definition-paths/reports-paths/get-invoices-summary-report-path/report-counts-by-billing-status-schema.ts
import { InvoiceBillingStatusSchema as InvoiceBillingStatusSchema2 } from "@vy/types";
import { oz as oz78 } from "@vy/utils";
var ReportCountsByBillingStatusSchema = oz78.record(InvoiceBillingStatusSchema2, oz78.number()).openapi("ReportCountsByBillingStatus");

// src/api-definition-paths/reports-paths/get-invoices-summary-report-path/report-invoices-summary-schema.ts
var ReportInvoicesSummarySchema = oz79.object({
  revenueByBillingStatus: ReportRevenueByBillingStatusSchema,
  countsByBillingStatus: ReportCountsByBillingStatusSchema,
  comparisons: ReportInvoiceSummaryComparisonsSchema
}).openapi("ReportInvoicesSummary");

// src/api-definition-paths/reports-paths/get-invoices-summary-report-path/get-invoices-summary-report-response-schema.ts
var GetInvoicesSummaryReportResponseSchema = oz80.object({
  invoicesSummary: ReportInvoicesSummarySchema
}).openapi("GetInvoicesSummaryReportResponse");

// src/api-definition-paths/reports-paths/get-invoices-summary-report-path/get-invoices-summary-report-action.ts
var GET_INVOICES_SUMMARY_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoices-summary-report"
  },
  path: GET_INVOICES_SUMMARY_REPORT_PATH,
  response: {
    name: "GetInvoicesSummaryReportResponse",
    schema: GetInvoicesSummaryReportResponseSchema
  }
};

// src/api-definition-paths/reports-paths/get-usage-report-v2-path/get-usage-report-v2-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS30 } from "@vy/zapi-types";
var GET_USAGE_REPORT_V2_PATH = {
  accessLevel: PATH_ACCESS_LEVELS30.PRIVATE,
  route: "/report/usage-report-v2",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-commitment-vs-usage-path/get-commitment-vs-usage-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS31 } from "@vy/zapi-types";
var GET_COMMITMENT_VS_USAGE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS31.PRIVATE,
  route: "/report/commitment-vs-usage",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-unmetered-events-report-path/get-unmetered-events-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS32 } from "@vy/zapi-types";
var GET_UNMETERED_EVENTS_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS32.PRIVATE,
  route: "/report/unmetered-events",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/reports-paths.ts
var REPORTS_PATHS = [
  TRIGGER_REPORT_JOB_PATH,
  REPORT_ID_PATH,
  REPORTS_PATH,
  GET_AR_AGING_REPORT_PATH,
  GET_MONTHLY_CLOUSER_REPORT_PATH,
  GET_CUSTOMERS_REPORT_PATH,
  GET_UPCOMING_INVOICES_REPORT_PATH,
  GET_UNAPPROVED_INVOICES_REPORT_PATH,
  GET_FAILED_INVOICE_DELIVERIES_REPORT_PATH,
  GET_USAGE_REPORT_PATH,
  GET_INVOICES_SUMMARY_REPORT_PATH,
  GET_USAGE_REPORT_V2_PATH,
  GET_COMMITMENT_VS_USAGE_PATH,
  GET_UNMETERED_EVENTS_REPORT_PATH
];

// src/api-definition-paths/reports-paths/get-uncharged-usage-report-path/get-uncharged-usage-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS33 } from "@vy/zapi-types";
var GET_UNCHARGED_USAGE_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS33.PRIVATE,
  route: "/report/uncharged-usage",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-uncharged-usage-report-path/get-uncharged-usage-report-response-schema.ts
import { ApiDateSchema as ApiDateSchema11, UnchargedUsageReportSchema } from "@vy/types";
import { oz as oz81 } from "@vy/utils";
var GetUnchargedUsageReportResponseSchema = oz81.object({
  report: UnchargedUsageReportSchema,
  creationDate: ApiDateSchema11,
  startDate: ApiDateSchema11.optional(),
  endDate: ApiDateSchema11.optional()
}).openapi("GetUnchargedUsageReportResponseSchema");

// src/api-definition-paths/reports-paths/get-uncharged-usage-report-path/get-uncharged-usage-report-action.ts
var GET_UNCHARGED_USAGE_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-uncharged-usage-report"
  },
  response: {
    name: "GetUnchargedUsageReportResponse",
    schema: GetUnchargedUsageReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_UNCHARGED_USAGE_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-products-usage-report-path/get-products-usage-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS34 } from "@vy/zapi-types";
var GET_PRODUCTS_USAGE_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS34.PRIVATE,
  route: "/report/products-usage",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-products-usage-report-path/get-products-usage-report-response-schema.ts
import { ApiDateSchema as ApiDateSchema12, ProductsUsageReportSchema } from "@vy/types";
import { oz as oz82 } from "@vy/utils";
var GetProductsUsageReportResponseSchema = oz82.object({
  report: ProductsUsageReportSchema,
  creationDate: ApiDateSchema12,
  startDate: ApiDateSchema12.optional(),
  endDate: ApiDateSchema12.optional()
}).openapi("GetProductsUsageReportResponseSchema");

// src/api-definition-paths/reports-paths/get-products-usage-report-path/get-products-usage-report-action.ts
var GET_PRODUCTS_USAGE_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-products-usage-report"
  },
  response: {
    name: "GetProductsUsageReportResponse",
    schema: GetProductsUsageReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_PRODUCTS_USAGE_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-customer-revenue-report-path/get-customer-revenue-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS35 } from "@vy/zapi-types";
var GET_CUSTOMER_REVENUE_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS35.PRIVATE,
  route: "/report/customer-revenue",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-customer-revenue-report-path/get-customer-revenue-report-response-schema.ts
import { CustomerRevenueReportSchema } from "@vy/types";
var GetCustomerRevenueReportResponseSchema = CustomerRevenueReportSchema.openapi(
  "GetCustomerRevenueReportResponseSchema"
);

// src/api-definition-paths/reports-paths/get-customer-revenue-report-path/get-customer-revenue-report-action.ts
var GET_CUSTOMER_REVENUE_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customer-revenue-report"
  },
  response: {
    name: "GetCustomerRevenueReportResponse",
    schema: GetCustomerRevenueReportResponseSchema
  },
  path: GET_CUSTOMER_REVENUE_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-journal-entries-report-path/get-journal-entries-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS36 } from "@vy/zapi-types";
var GET_JOURNAL_ENTRIES_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS36.PRIVATE,
  route: "/report/journal-entries",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-journal-entries-report-path/get-journal-entries-report-response-schema.ts
import { JournalEntriesReportSchema } from "@vy/types";
var GetJournalEntriesReportResponseSchema = JournalEntriesReportSchema.openapi(
  "GetJournalEntriesReportResponseSchema"
);

// src/api-definition-paths/reports-paths/get-journal-entries-report-path/get-journal-entries-report-action.ts
var GET_JOURNAL_ENTRIES_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-journal-entries-report"
  },
  response: {
    name: "GetJournalEntriesReportResponse",
    schema: GetJournalEntriesReportResponseSchema
  },
  path: GET_JOURNAL_ENTRIES_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-contracts-report-path/get-contracts-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS37 } from "@vy/zapi-types";
var GET_CONTRACTS_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS37.PRIVATE,
  route: "/report/contracts",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-contracts-report-path/get-contracts-report-response-schema.ts
import { ApiDateSchema as ApiDateSchema13, ContractsReportSchema } from "@vy/types";
import { oz as oz83 } from "@vy/utils";
var GetContractsReportResponseSchema = oz83.object({
  report: ContractsReportSchema,
  creationDate: ApiDateSchema13,
  startDate: ApiDateSchema13.optional(),
  endDate: ApiDateSchema13.optional()
}).openapi("GetContractsReportResponseSchema");

// src/api-definition-paths/reports-paths/get-contracts-report-path/get-contracts-report-action.ts
var GET_CONTRACTS_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contracts-report"
  },
  response: {
    name: "GetContractsReportResponse",
    schema: GetContractsReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_CONTRACTS_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-commitment-report-path/get-commitment-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS38 } from "@vy/zapi-types";
var GET_COMMITMENT_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS38.PRIVATE,
  route: "/report/commitment",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-commitment-report-path/get-commitment-report-response-schema.ts
import { ApiDateSchema as ApiDateSchema14, CommitmentUsageReportSchema } from "@vy/types";
import { oz as oz84 } from "@vy/utils";
var GetCommitmentReportResponseSchema = oz84.object({
  report: CommitmentUsageReportSchema,
  creationDate: ApiDateSchema14,
  startDate: ApiDateSchema14.optional(),
  endDate: ApiDateSchema14.optional()
}).openapi("GetCommitmentReportResponseSchema");

// src/api-definition-paths/reports-paths/get-commitment-report-path/get-commitment-report-action.ts
var GET_COMMITMENT_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-commitment-report"
  },
  response: {
    name: "GetCommitmentReportResponse",
    schema: GetCommitmentReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_COMMITMENT_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-anonymous-customers-report-path/get-anonymous-customers-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS39 } from "@vy/zapi-types";
var GET_ANONYMOUS_CUSTOMERS_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS39.PRIVATE,
  route: "/report/anonymous-customers",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-anonymous-customers-report-path/get-anonymous-customers-report-response-schema.ts
import { AnonymousCustomersReportSchema, ApiDateSchema as ApiDateSchema15 } from "@vy/types";
import { oz as oz85 } from "@vy/utils";
var GetAnonymousCustomersReportResponseSchema = oz85.object({
  report: AnonymousCustomersReportSchema,
  creationDate: ApiDateSchema15,
  startDate: ApiDateSchema15.optional(),
  endDate: ApiDateSchema15.optional()
}).openapi("GetAnonymousCustomersReportResponseSchema");

// src/api-definition-paths/reports-paths/get-anonymous-customers-report-path/get-anonymous-customers-report-action.ts
var GET_ANONYMOUS_CUSTOMERS_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-anonymous-customers-report"
  },
  response: {
    name: "GetAnonymousCustomersReportResponse",
    schema: GetAnonymousCustomersReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_ANONYMOUS_CUSTOMERS_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-ar-aging-report-path/get-ar-aging-report-response-schema.ts
import { ContractStatusSchema, CurrencySchema as CurrencySchema4, CustomerSchema as CustomerSchema3, InvoiceSchema as InvoiceSchema2 } from "@vy/types";
import { oz as oz86 } from "@vy/utils";

// src/api-definition-paths/reports-paths/get-ar-aging-report-path/outstanding-breakdown-options.ts
var OUTSTANDING_BREAKDOWN_OPTIONS = Object.freeze({
  UP_TO_ONE_MONTH: "upToOneMonth",
  ONE_TO_TWO_MONTHS: "oneToTwoMonths",
  TWO_TO_THREE_MONTHS: "twoToThreeMonths",
  MORE_THAN_THREE_MONTHS: "moreThanThreeMonths"
});

// src/api-definition-paths/reports-paths/get-ar-aging-report-path/get-ar-aging-report-response-schema.ts
var ArAgingLabelSchema = oz86.object({
  id: oz86.string(),
  name: oz86.string(),
  color: oz86.string(),
  backgroundColor: oz86.string()
});
var GetArAgingReportResponseSchema = oz86.object({
  settings: oz86.object({
    currency: CurrencySchema4
  }),
  summary: oz86.array(
    oz86.object({
      customer: CustomerSchema3.pick({
        id: true,
        name: true
      }),
      outstandingBreakdown: oz86.record(
        oz86.nativeEnum(OUTSTANDING_BREAKDOWN_OPTIONS),
        oz86.object({
          grossAmount: oz86.number(),
          invoicesCount: oz86.number()
        })
      )
    })
  ),
  summaryBreakdown: oz86.array(
    oz86.object({
      invoice: InvoiceSchema2.pick({
        id: true,
        invoiceNumber: true,
        revenueBreakdown: true,
        paymentDueDays: true,
        issuedAt: true,
        dueDate: true,
        billingCycle: true,
        billingStatus: true,
        paymentTerm: true
      }),
      customer: CustomerSchema3.pick({
        id: true,
        name: true,
        accountId: true
      }),
      daysOutstanding: oz86.number(),
      remainingAmount: oz86.number(),
      contractStatus: ContractStatusSchema.nullish(),
      labels: oz86.array(ArAgingLabelSchema).optional(),
      subsidiaryName: oz86.string().nullish()
    })
  )
});

// src/api-definition-paths/reports-paths/get-ar-aging-report-path/get-ar-aging-report-action.ts
var GET_AR_AGING_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-ar-aging-report"
  },
  response: {
    name: "GetArAgingReportResponse",
    schema: GetArAgingReportResponseSchema
  },
  path: GET_AR_AGING_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-contract-revenue-schedule-report-path/get-contract-revenue-schedule-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS41 } from "@vy/zapi-types";

// src/api-definition-paths/contract-paths/contract-id-path.ts
import { oz as oz87 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS40 } from "@vy/zapi-types";
var CONTRACT_ID_PATH_PARAM = {
  name: "contractId",
  location: "path",
  schema: oz87.string(),
  required: true
};
var UPDATE_CONTRACT_PATH_PARAMS = {
  [CONTRACT_ID_PATH_PARAM.name]: CONTRACT_ID_PATH_PARAM
};
var CONTRACT_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS40.PRIVATE,
  route: "/contract/{contractId}",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/reports-paths/get-contract-revenue-schedule-report-path/get-contract-revenue-schedule-report-path.ts
var GET_CONTRACT_REVENUE_SCHEDULE_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS41.PRIVATE,
  route: "/report/contract-revenue-schedule/{contractId}",
  pathParams: {
    [CONTRACT_ID_PATH_PARAM.name]: CONTRACT_ID_PATH_PARAM
  },
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-contract-revenue-schedule-report-path/get-contract-revenue-schedule-report-response-schema.ts
import { CustomerRevenueReportItemSchema } from "@vy/types";
import { oz as oz88 } from "@vy/utils";
var GetContractRevenueScheduleReportResponseSchema = oz88.object({
  contractId: oz88.string(),
  reportItems: oz88.array(CustomerRevenueReportItemSchema)
}).openapi("GetContractRevenueScheduleReportResponse");

// src/api-definition-paths/reports-paths/get-contract-revenue-schedule-report-path/get-contract-revenue-schedule-report-action.ts
var GET_CONTRACT_REVENUE_SCHEDULE_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contract-revenue-schedule-report"
  },
  response: {
    name: "GetContractRevenueScheduleReportResponse",
    schema: GetContractRevenueScheduleReportResponseSchema
  },
  path: GET_CONTRACT_REVENUE_SCHEDULE_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-recurring-revenue-report-path/get-recurring-revenue-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS42 } from "@vy/zapi-types";
var GET_RECURRING_REVENUE_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS42.PRIVATE,
  route: "/report/recurring-revenue",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-recurring-revenue-report-path/get-recurring-revenue-report-response-schema.ts
import { ApiDateSchema as ApiDateSchema16, RecurringRevenueReportSchema } from "@vy/types";
import { oz as oz89 } from "@vy/utils";
var GetRecurringRevenueReportResponseSchema = oz89.object({
  report: RecurringRevenueReportSchema,
  creationDate: ApiDateSchema16,
  startDate: ApiDateSchema16.optional(),
  endDate: ApiDateSchema16.optional()
}).openapi("GetRecurringRevenueReportResponseSchema");

// src/api-definition-paths/reports-paths/get-recurring-revenue-report-path/get-recurring-revenue-report-action.ts
var GET_RECURRING_REVENUE_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-recurring-revenue-report"
  },
  response: {
    name: "GetRecurringRevenueReportResponse",
    schema: GetRecurringRevenueReportResponseSchema
  },
  queryParams: {
    [OPTIONAL_REPORT_ID_QUERY_PARAM.name]: OPTIONAL_REPORT_ID_QUERY_PARAM
  },
  path: GET_RECURRING_REVENUE_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-usage-report-v2-path/get-usage-report-v2-response-schema.ts
import { UsageReportV2Schema } from "@vy/types";
var GetUsageReportV2ResponseSchema = UsageReportV2Schema.openapi(
  "GetUsageReportV2ResponseSchema"
);

// src/api-definition-paths/reports-paths/get-usage-report-v2-path/get-usage-report-v2-action.ts
var GET_USAGE_REPORT_V2_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-usage-report-v2"
  },
  queryParams: {
    [OPTIONAL_START_TIME_QUERY_PARAM.name]: OPTIONAL_START_TIME_QUERY_PARAM,
    [OPTIONAL_END_TIME_QUERY_PARAM.name]: OPTIONAL_END_TIME_QUERY_PARAM
  },
  response: {
    name: "GetUsageReportV2Response",
    schema: GetUsageReportV2ResponseSchema
  },
  path: GET_USAGE_REPORT_V2_PATH
};

// src/api-definition-paths/reports-paths/get-commitment-vs-usage-path/get-commitment-vs-usage-response-schema.ts
import { CommitmentVsUsageSchema } from "@vy/types";
var GetCommitmentVsUsageResponseSchema = CommitmentVsUsageSchema.openapi(
  "GetCommitmentVsUsageResponseSchema"
);

// src/api-definition-paths/reports-paths/get-commitment-vs-usage-path/get-commitment-vs-usage-action.ts
var GET_COMMITMENT_VS_USAGE_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-commitment-vs-usage"
  },
  queryParams: {
    [OPTIONAL_START_TIME_QUERY_PARAM.name]: OPTIONAL_START_TIME_QUERY_PARAM,
    [OPTIONAL_END_TIME_QUERY_PARAM.name]: OPTIONAL_END_TIME_QUERY_PARAM
  },
  response: {
    name: "GetCommitmentVsUsageResponse",
    schema: GetCommitmentVsUsageResponseSchema
  },
  path: GET_COMMITMENT_VS_USAGE_PATH
};

// src/api-definition-paths/reports-paths/get-customer-master-report-path/get-customer-master-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS43 } from "@vy/zapi-types";
var GET_CUSTOMER_MASTER_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS43.PRIVATE,
  route: "/report/customer-master",
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/get-customer-master-report-path/get-customer-master-report-response-schema.ts
import { ApiDateSchema as ApiDateSchema17, CustomerMasterReportSchema } from "@vy/types";
import { oz as oz90 } from "@vy/utils";
var GetCustomerMasterReportResponseSchema = oz90.object({
  report: CustomerMasterReportSchema,
  creationDate: ApiDateSchema17
}).openapi("GetCustomerMasterReportResponseSchema");

// src/api-definition-paths/reports-paths/get-customer-master-report-path/get-customer-master-report-action.ts
var GET_CUSTOMER_MASTER_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customer-master-report"
  },
  response: {
    name: "GetCustomerMasterReportResponse",
    schema: GetCustomerMasterReportResponseSchema
  },
  path: GET_CUSTOMER_MASTER_REPORT_PATH
};

// src/api-definition-paths/reports-paths/get-unmetered-events-report-path/get-unmetered-events-report-response-schema.ts
import { UnmeteredEventsReportSchema } from "@vy/types";
var GetUnmeteredEventsReportResponseSchema = UnmeteredEventsReportSchema.openapi(
  "GetUnmeteredEventsReportResponseSchema"
);

// src/api-definition-paths/reports-paths/get-unmetered-events-report-path/get-unmetered-events-report-action.ts
var GET_UNMETERED_EVENTS_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-unmetered-events-report"
  },
  queryParams: {
    [START_TIME_QUERY_PARAM.name]: START_TIME_QUERY_PARAM,
    [END_TIME_QUERY_PARAM.name]: END_TIME_QUERY_PARAM
  },
  response: {
    name: "GetUnmeteredEventsReportResponse",
    schema: GetUnmeteredEventsReportResponseSchema
  },
  path: GET_UNMETERED_EVENTS_REPORT_PATH
};

// src/api-definition-paths/reports-paths/revenue-recognition-override-path/revenue-recognition-record-schema.ts
import { oz as oz91 } from "@vy/utils";
var RevenueRecognitionRecordSchema = oz91.object({
  date: oz91.string(),
  value: oz91.number()
});

// src/api-definition-paths/reports-paths/revenue-recognition-override-path/revenue-recognition-override-variant-id-path.ts
import { oz as oz92 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS44 } from "@vy/zapi-types";
var REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PARAM = {
  name: "variantId",
  location: "path",
  schema: oz92.string(),
  required: true
};
var REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PARAMS = {
  [REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PARAM.name]: REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PARAM
};
var REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS44.PRIVATE,
  route: "/report/revenue-recognition-override/{variantId}",
  pathParams: REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PARAMS,
  tags: API_TAGS.REPORT
};

// src/api-definition-paths/reports-paths/revenue-recognition-override-path/upsert-revenue-recognition-override-request-schema.ts
import { REVENUE_RECOGNITION_TYPE } from "@vy/types";
import { oz as oz93 } from "@vy/utils";
var UpsertRevenueRecognitionOverrideRequestSchema = oz93.object({
  billedOverride: oz93.array(RevenueRecognitionRecordSchema).optional(),
  revenueOverride: oz93.array(RevenueRecognitionRecordSchema).optional(),
  recognitionTypeOverride: oz93.enum([
    REVENUE_RECOGNITION_TYPE.PointInTime,
    REVENUE_RECOGNITION_TYPE.Milestones,
    REVENUE_RECOGNITION_TYPE.StraightLine
  ]).optional()
});

// src/api-definition-paths/reports-paths/revenue-recognition-override-path/upsert-revenue-recognition-override-response-schema.ts
import { oz as oz94 } from "@vy/utils";
var UpsertRevenueRecognitionOverrideResponseSchema = oz94.object({
  success: oz94.boolean()
});

// src/api-definition-paths/reports-paths/revenue-recognition-override-path/upsert-revenue-recognition-override-action.ts
var UPSERT_REVENUE_RECOGNITION_OVERRIDE_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "upsert-revenue-recognition-override"
  },
  request: {
    name: "UpsertRevenueRecognitionOverrideRequest",
    schema: UpsertRevenueRecognitionOverrideRequestSchema
  },
  response: {
    name: "UpsertRevenueRecognitionOverrideResponse",
    schema: UpsertRevenueRecognitionOverrideResponseSchema
  },
  path: REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PATH
};

// src/api-definition-paths/reports-paths/revenue-recognition-override-path/delete-revenue-recognition-override-response-schema.ts
import { oz as oz95 } from "@vy/utils";
var DeleteRevenueRecognitionOverrideResponseSchema = oz95.object({
  success: oz95.boolean()
});

// src/api-definition-paths/reports-paths/revenue-recognition-override-path/delete-revenue-recognition-override-action.ts
var DELETE_REVENUE_RECOGNITION_OVERRIDE_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-revenue-recognition-override"
  },
  response: {
    name: "DeleteRevenueRecognitionOverrideResponse",
    schema: DeleteRevenueRecognitionOverrideResponseSchema
  },
  path: REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PATH
};

// src/api-definition-paths/reports-paths/reports-actions.ts
var REPORTS_ACTIONS = [
  DELETE_REPORT_ACTION,
  UPSERT_REVENUE_RECOGNITION_OVERRIDE_ACTION,
  DELETE_REVENUE_RECOGNITION_OVERRIDE_ACTION,
  GET_ANONYMOUS_CUSTOMERS_REPORT_ACTION,
  GET_COMMITMENT_REPORT_ACTION,
  GET_CONTRACTS_REPORT_ACTION,
  GET_CUSTOMER_REVENUE_REPORT_ACTION,
  GET_PRODUCTS_USAGE_REPORT_ACTION,
  GET_REPORTS_ACTION,
  GET_UNCHARGED_USAGE_REPORT_ACTION,
  GET_AR_AGING_REPORT_ACTION,
  TRIGGER_REPORT_JOB_ACTION,
  GET_CONTRACT_REVENUE_SCHEDULE_REPORT_ACTION,
  GET_MONTHLY_CLOUSER_REPORT_ACTION,
  GET_CUSTOMERS_REPORT_ACTION,
  GET_UPCOMING_INVOICES_REPORT_ACTION,
  GET_UNAPPROVED_INVOICES_REPORT_ACTION,
  GET_FAILED_INVOICE_DELIVERIES_REPORT_ACTION,
  GET_USAGE_REPORT_ACTION,
  GET_INVOICES_SUMMARY_REPORT_ACTION,
  GET_RECURRING_REVENUE_REPORT_ACTION,
  GET_USAGE_REPORT_V2_ACTION,
  GET_COMMITMENT_VS_USAGE_ACTION,
  GET_CUSTOMER_MASTER_REPORT_ACTION,
  GET_JOURNAL_ENTRIES_REPORT_ACTION,
  GET_UNMETERED_EVENTS_REPORT_ACTION
];

// src/api-definition-paths/contract-paths/delete-contract/contract-delete-response-schema.ts
import { oz as oz96 } from "@vy/utils";
var ContractDeleteResponseSchema = oz96.object({
  contractId: oz96.string()
});

// src/api-definition-paths/contract-paths/delete-contract/delete-contract-action.ts
var DELETE_CONTRACT_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-contract"
  },
  response: {
    name: "DeleteContractResponse",
    schema: ContractDeleteResponseSchema
  },
  path: CONTRACT_ID_PATH
};

// src/api-definition-paths/contract-paths/contract-schemas/get-contract-response-schema.ts
import { ContractSchema as ContractSchema4 } from "@vy/types";
import { oz as oz97 } from "@vy/utils";
var GetContractResponseSchema = oz97.object({
  contract: ContractSchema4
}).openapi("GetContractResponse");

// src/api-definition-paths/contract-paths/get-contract/get-contract-action.ts
var GET_CONTRACT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contract"
  },
  response: {
    name: "GetContractResponse",
    schema: GetContractResponseSchema
  },
  path: CONTRACT_ID_PATH
};

// src/api-definition-paths/contract-paths/get-contract-custom-fields/get-contract-custom-fields-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS45 } from "@vy/zapi-types";
var GET_CONTRACT_CUSTOM_FIELDS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS45.PRIVATE,
  route: "/contract/{contractId}/custom-fields",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/get-contract-custom-fields/get-contract-custom-fields-response-schema.ts
import { CustomFieldValueWithDefinitionSchema } from "@vy/custom-fields-types";
import { oz as oz98 } from "@vy/utils";
var GetContractCustomFieldsResponseSchema = oz98.object({
  customFields: CustomFieldValueWithDefinitionSchema.array()
}).openapi("GetContractCustomFieldsResponse");

// src/api-definition-paths/contract-paths/get-contract-custom-fields/get-contract-custom-fields-action.ts
var GET_CONTRACT_CUSTOM_FIELDS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contract-custom-fields"
  },
  response: {
    name: "GetContractCustomFieldsResponse",
    schema: GetContractCustomFieldsResponseSchema
  },
  path: GET_CONTRACT_CUSTOM_FIELDS_PATH
};

// src/api-definition-paths/contract-paths/get-contract-pdf/get-contract-pdf-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS46 } from "@vy/zapi-types";
var GET_CONTRACT_PDF_PATH = {
  accessLevel: PATH_ACCESS_LEVELS46.PRIVATE,
  route: "/contract/pdf/{contractId}",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/get-contract-pdf/get-contract-pdf-response-schema.ts
import { Base64Schema, ObjectIdSchema as ObjectIdSchema7 } from "@vy/types";
import { oz as oz99 } from "@vy/utils";
var GetContractPdfResponseSchema = oz99.object({
  contractId: ObjectIdSchema7,
  encodedPdf: Base64Schema,
  fileName: oz99.string().optional()
}).openapi("GetContractPdfResponse");

// src/api-definition-paths/contract-paths/get-contract-pdf/get-contract-pdf-action.ts
var GET_CONTRACT_PDF_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contract-pdf"
  },
  response: {
    name: "GetContractPdfResponse",
    schema: GetContractPdfResponseSchema
  },
  path: GET_CONTRACT_PDF_PATH
};

// src/api-definition-paths/contract-paths/get-contract-products-consumption/get-contract-products-consumption-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS47 } from "@vy/zapi-types";
var GET_CONTRACT_PRODUCTS_CONSUMPTION_PATH = {
  accessLevel: PATH_ACCESS_LEVELS47.PRIVATE,
  route: "/contract/{contractId}/products-consumption/",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/get-contract-products-consumption/get-contract-products-consumption-response-schema.ts
import { oz as oz100 } from "@vy/utils";
var ProductConsumptionBreakdownSchema = oz100.object({
  productId: oz100.string(),
  productName: oz100.string().optional(),
  currentConsumption: oz100.number(),
  totalConsumption: oz100.number()
});
var GetContractProductsConsumptionResponseSchema = oz100.object({
  products: ProductConsumptionBreakdownSchema.array()
}).openapi("GetContractProductsConsumptionResponseSchema");

// src/api-definition-paths/contract-paths/get-contract-products-consumption/get-contract-products-consumption-action.ts
var GET_CONTRACT_PRODUCTS_CONSUMPTION_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contract-products-consumption"
  },
  response: {
    name: "GetContractProductsConsumptionResponse",
    schema: GetContractProductsConsumptionResponseSchema
  },
  path: GET_CONTRACT_PRODUCTS_CONSUMPTION_PATH
};

// src/api-definition-paths/contract-paths/get-contract-products-overviews-path/get-contract-products-overviews-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS48 } from "@vy/zapi-types";
var GET_CONTRACT_PRODUCTS_OVERVIEWS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS48.PRIVATE,
  route: "/contract/products-overviews/{contractId}/",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/get-contract-products-overviews-path/get-contract-products-overviews-response-schema.ts
import { oz as oz101 } from "@vy/utils";
var GetContractProductsOverviewsResponseSchema = oz101.object({
  productsOverviews: oz101.array(ContractProductOverviewSchema)
}).openapi("GetContractProductsOverviewsResponse");

// src/api-definition-paths/contract-paths/get-contract-products-overviews-path/get-contract-products-overviews-action.ts
var GET_CONTRACT_PRODUCTS_OVERVIEWS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contract-products-overviews"
  },
  response: {
    name: "GetContractProductsOverviewsResponse",
    schema: GetContractProductsOverviewsResponseSchema
  },
  path: GET_CONTRACT_PRODUCTS_OVERVIEWS_PATH
};

// src/api-definition-paths/contract-paths/get-contract-usage-breakdown/get-contract-usage-breakdown-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS49 } from "@vy/zapi-types";
var GET_CONTRACT_USAGE_BREAKDOWN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS49.PRIVATE,
  route: "/contract/{contractId}/usage-breakdown",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/get-contract-usage-breakdown/get-contract-usage-breakdown-response.ts
import { oz as oz102 } from "@vy/utils";
import { ApiDateSchema as ApiDateSchema18 } from "@vy/types";
var ProductUsageBreakdownItemSchema = oz102.object({
  productId: oz102.string(),
  productName: oz102.string(),
  units: oz102.number()
});
var ContractUsageByDateBreakdownSchema = oz102.object({
  date: ApiDateSchema18,
  units: oz102.number(),
  productUsage: ProductUsageBreakdownItemSchema.array()
});
var GetContractUsageBreakdownResponseSchema = oz102.object({
  usageByDateBreakdown: ContractUsageByDateBreakdownSchema.array()
}).openapi("GetContractUsageBreakdownResponse");

// src/api-definition-paths/contract-paths/get-contract-usage-breakdown/get-contract-usage-breakdown-action.ts
var GET_CONTRACT_USAGE_BREAKDOWN_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contract-usage-breakdown"
  },
  response: {
    name: "GetContractUsageBreakdownResponse",
    schema: GetContractUsageBreakdownResponseSchema
  },
  path: GET_CONTRACT_USAGE_BREAKDOWN_PATH
};

// src/api-definition-paths/contract-paths/list-contract-credit-pools/list-contract-credit-pools-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS50 } from "@vy/zapi-types";
var LIST_CONTRACT_CREDIT_POOLS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS50.PRIVATE,
  route: "/contract/{contractId}/credit-pools",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/list-contract-credit-pools/list-contract-credit-pools-response.ts
import { oz as oz107 } from "@vy/utils";

// src/api-definition-paths/credit-pools-paths/credit-pool-with-units-schema.ts
import { oz as oz106 } from "@vy/utils";

// src/api-definition-paths/credit-pools-paths/credit-pool-schema.ts
import { ApiDateSchema as ApiDateSchema20, CreditKindSchema, CreditScheduleSchema } from "@vy/types";

// src/api-definition-paths/credit-pools-paths/credit-pool-entry-schema.ts
import { ApiDateSchema as ApiDateSchema19 } from "@vy/types";

// src/api-definition-paths/credit-pools-paths/credit-pool-entry-type-schema.ts
import { oz as oz103 } from "@vy/utils";
var CREDIT_POOL_ENTRY_TYPES = Object.freeze({
  GRANT: "Grant",
  DEBIT: "Debit"
});
var CreditPoolEntryTypeSchema = oz103.nativeEnum(CREDIT_POOL_ENTRY_TYPES);

// src/api-definition-paths/credit-pools-paths/credit-pool-entry-schema.ts
import { oz as oz104 } from "@vy/utils";
var CreditPoolEntrySchema = oz104.object({
  id: oz104.string(),
  creditPoolId: oz104.string(),
  lineItemId: oz104.string(),
  type: CreditPoolEntryTypeSchema,
  amount: oz104.number(),
  balanceAfter: oz104.number(),
  expiryDate: ApiDateSchema19.optional(),
  createdAt: ApiDateSchema19
}).openapi("CreditPoolEntry");

// src/api-definition-paths/credit-pools-paths/credit-pool-schema.ts
import { oz as oz105 } from "@vy/utils";
var CreditPoolSchema = oz105.object({
  id: oz105.string(),
  createdAt: ApiDateSchema20,
  updatedAt: ApiDateSchema20,
  customerId: oz105.string(),
  creditTypeId: oz105.string(),
  creditKind: CreditKindSchema,
  accountId: oz105.string(),
  balance: oz105.number(),
  projectedBalance: oz105.number(),
  initialGrantSchedule: CreditScheduleSchema,
  closestEntryExpiryDate: ApiDateSchema20.optional(),
  entries: CreditPoolEntrySchema.array().min(1)
}).openapi("CreditPool");

// src/api-definition-paths/credit-pools-paths/credit-pool-with-units-schema.ts
var CreditPoolWithUnitsSchema = CreditPoolSchema.extend({
  units: oz106.string().optional()
}).openapi("CreditPoolWithUnits");

// src/api-definition-paths/contract-paths/list-contract-credit-pools/list-contract-credit-pools-response.ts
var ListContractCreditPoolsResponseSchema = oz107.object({
  creditPools: oz107.array(CreditPoolWithUnitsSchema)
}).openapi("ListContractCreditPoolsResponse");

// src/api-definition-paths/contract-paths/list-contract-credit-pools/list-contract-credit-pools-action.ts
var LIST_CONTRACT_CREDIT_POOLS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "list-contract-credit-pools"
  },
  response: {
    name: "ListContractCreditPoolsResponse",
    schema: ListContractCreditPoolsResponseSchema
  },
  path: LIST_CONTRACT_CREDIT_POOLS_PATH
};

// src/api-definition-paths/contract-paths/renew-contract-path/contract-renewal-request-schema.ts
import { ApiDateSchema as ApiDateSchema21 } from "@vy/types";
import { oz as oz108 } from "@vy/utils";
var ContractRenewalRequestSchema = oz108.object({
  startDate: ApiDateSchema21
}).openapi("ContractRenewalRequest");

// src/api-definition-paths/contract-paths/renew-contract-path/contract-renewal-response-schema.ts
import { oz as oz109 } from "@vy/utils";
var ContractRenewalResponseSchema = oz109.object({
  contractId: oz109.string()
}).openapi("ContractRenewalRequest");

// src/api-definition-paths/contract-paths/renew-contract-path/renew-contract-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS51 } from "@vy/zapi-types";
var RENEW_CONTRACT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS51.PRIVATE,
  route: "/contract/renew/{contractId}",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/renew-contract-path/renew-contract-action.ts
var RENEW_CONTRACT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "renew-contract"
  },
  response: {
    name: "RenewContractResponse",
    schema: ContractRenewalResponseSchema
  },
  request: {
    name: "RenewContractRequest",
    schema: ContractRenewalRequestSchema
  },
  path: RENEW_CONTRACT_PATH
};

// src/api-definition-paths/contract-paths/revise-contract-path/revise-contract-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS52 } from "@vy/zapi-types";
var REVISE_CONTRACT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS52.PRIVATE,
  route: "/contract/revise/{contractId}",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/revise-contract-path/revise-contract-request-schema.ts
import { ApiDateSchema as ApiDateSchema22, NewPlanSchema as NewPlanSchema2, PhaseTypeSchema as PhaseTypeSchema2 } from "@vy/types";
import { oz as oz110 } from "@vy/utils";
var ReviseContractRequestSchema = oz110.object({
  plan: NewPlanSchema2,
  startDate: ApiDateSchema22,
  newContractEndDate: ApiDateSchema22.optional(),
  phaseMetadata: oz110.object({
    label: PhaseTypeSchema2,
    name: oz110.string().optional()
  }).optional()
}).openapi("ReviseContractRequest");

// src/api-definition-paths/contract-paths/revise-contract-path/revise-contract-action.ts
var REVISE_CONTRACT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "revise-contract"
  },
  request: {
    name: "ReviseContractRequest",
    schema: ReviseContractRequestSchema
  },
  path: REVISE_CONTRACT_PATH
};

// src/api-definition-paths/contract-paths/terminate-contract-path/contract-termination-request-schema.ts
import { ApiDateSchema as ApiDateSchema23 } from "@vy/types";
import { oz as oz111 } from "@vy/utils";
var CONTRACT_TERMINATION_OPTIONS = Object.freeze({
  Immediate: "immediate",
  Custom: "custom"
});
var ContractTerminationRequestSchema = oz111.object({
  terminationOption: oz111.nativeEnum(CONTRACT_TERMINATION_OPTIONS),
  terminationDate: oz111.optional(ApiDateSchema23)
}).openapi("ContractTerminationRequest");

// src/api-definition-paths/contract-paths/terminate-contract-path/terminate-contract-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS53 } from "@vy/zapi-types";
var TERMINATE_CONTRACT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS53.PRIVATE,
  route: "/contract/terminate/{contractId}",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/terminate-contract-path/terminate-contract-action.ts
var TERMINATE_CONTRACT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "terminate-contract"
  },
  request: {
    name: "TerminateContractRequest",
    schema: ContractTerminationRequestSchema
  },
  path: TERMINATE_CONTRACT_PATH
};

// src/api-definition-paths/contract-paths/update-contract/update-contract-request-schema.ts
import {
  NewPlanSchema as NewPlanSchema3,
  ApiDateSchema as ApiDateSchema24,
  CurrencySchema as CurrencySchema5,
  ParentAgreementSettingsSchema,
  TrialDurationSchema,
  CreditPurchaseConfigSchema
} from "@vy/types";
import { oz as oz112 } from "@vy/utils";
var MINIMUM_MULTI_YEAR_DURATION_MONTHS = 13;
var UpdatePlanSchema = NewPlanSchema3.extend({
  trial: TrialDurationSchema.nullable().optional()
});
var UpdateContractRequestSchema = oz112.object({
  plan: UpdatePlanSchema,
  startDate: ApiDateSchema24,
  currencyOverride: CurrencySchema5.optional(),
  signatureDate: ApiDateSchema24.optional(),
  parentAgreementSettings: ParentAgreementSettingsSchema.optional(),
  credits: CreditPurchaseConfigSchema.array().optional()
}).superRefine((data, ctx) => {
  const hasProductLevelUplift = data.plan.products.some(
    (product) => product.upliftConfiguration?.inflationaryUpliftEnabled || product.upliftConfiguration?.seatUpliftEnabled || product.upliftConfiguration?.commitmentUpliftEnabled
  );
  if (hasProductLevelUplift && data.plan.billingData.duration < MINIMUM_MULTI_YEAR_DURATION_MONTHS) {
    ctx.addIssue({
      code: oz112.ZodIssueCode.custom,
      message: "Uplift can only be enabled on multi-year contracts (duration > 12 months)",
      path: ["plan", "products"]
    });
  }
}).openapi("UpdateContractRequest");

// src/api-definition-paths/contract-paths/update-contract/update-contract-response-schema.ts
import { ContractSchema as ContractSchema5 } from "@vy/types";
import { oz as oz113 } from "@vy/utils";
var UpdateContractResponseSchema = oz113.object({
  contract: ContractSchema5
}).openapi("UpdateContractResponse");

// src/api-definition-paths/contract-paths/update-contract/update-contract-action.ts
var UPDATE_CONTRACT_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-contract"
  },
  response: {
    name: "UpdateContractResponse",
    schema: UpdateContractResponseSchema
  },
  request: {
    name: "UpdateContractRequest",
    schema: UpdateContractRequestSchema
  },
  path: CONTRACT_ID_PATH
};

// src/api-definition-paths/contract-paths/update-contract-status-path/update-contract-status-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS54 } from "@vy/zapi-types";
var UPDATE_CONTRACT_STATUS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS54.PRIVATE,
  route: "/contract/status/{contractId}",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/update-contract-status-path/update-contract-status-request-schema.ts
import { CONTRACT_STATUSES } from "@vy/types";
import { oz as oz114 } from "@vy/utils";
var UpdateContractStatusRequestSchema = oz114.object({
  status: oz114.enum([CONTRACT_STATUSES.Active, CONTRACT_STATUSES.Inactive])
}).openapi("UpdateContractStatusRequest");

// src/api-definition-paths/contract-paths/update-contract-status-path/update-contract-status-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema8 } from "@vy/types";
import { oz as oz115 } from "@vy/utils";
var UpdateContractStatusResponseSchema = oz115.object({
  contractId: ObjectIdSchema8
}).openapi("UpdateContractStatusResponse");

// src/api-definition-paths/contract-paths/update-contract-status-path/update-contract-status-action.ts
var UPDATE_CONTRACT_STATUS_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-contract-status"
  },
  response: {
    name: "UpdateContractStatusResponse",
    schema: UpdateContractStatusResponseSchema
  },
  request: {
    name: "UpdateContractStatusRequest",
    schema: UpdateContractStatusRequestSchema
  },
  path: UPDATE_CONTRACT_STATUS_PATH
};

// src/api-definition-paths/contract-paths/get-contract-billing-schedule/get-contract-billing-schedule-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS55 } from "@vy/zapi-types";
var GET_CONTRACT_BILLING_SCHEDULE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS55.PRIVATE,
  route: "/contract/{contractId}/billing-schedule/",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/get-contract-billing-schedule/get-contract-billing-schedule-response-schema.ts
import { ApiDateSchema as ApiDateSchema25, InvoiceReviewStatusSchema, PeriodSchema as PeriodSchema4, RevenueBreakdownSchema } from "@vy/types";
import { oz as oz116 } from "@vy/utils";
var GetContractBillingScheduleResponseSchema = oz116.object({
  invoices: oz116.object({
    invoiceId: oz116.string(),
    name: oz116.string(),
    reviewStatus: InvoiceReviewStatusSchema,
    lineItemsGroupingKey: oz116.string(),
    invoicingDate: ApiDateSchema25,
    period: PeriodSchema4,
    revenueBreakdown: RevenueBreakdownSchema,
    products: oz116.object({
      productId: oz116.string(),
      name: oz116.string(),
      period: PeriodSchema4,
      revenueBreakdown: RevenueBreakdownSchema
    }).array()
  }).array()
});

// src/api-definition-paths/contract-paths/get-contract-billing-schedule/get-contract-billing-schedule-action.ts
var GET_CONTRACT_BILLING_SCHEDULE_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contract-billing-schedule"
  },
  response: {
    name: "GetContractBillingScheduleResponse",
    schema: GetContractBillingScheduleResponseSchema
  },
  path: GET_CONTRACT_BILLING_SCHEDULE_PATH
};

// src/api-definition-paths/contract-paths/get-contract-version/get-contract-version-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS56 } from "@vy/zapi-types";
import { oz as oz117 } from "@vy/utils";
var CONTRACT_ID_PATH_PARAM2 = {
  name: "contractId",
  location: "path",
  schema: oz117.string(),
  required: true
};
var GET_CONTRACT_VERSION_PATH_PARAMS = {
  [CONTRACT_ID_PATH_PARAM2.name]: CONTRACT_ID_PATH_PARAM2
};
var GET_CONTRACT_VERSION_PATH = {
  accessLevel: PATH_ACCESS_LEVELS56.PRIVATE,
  route: "/contract/{contractId}/version",
  pathParams: GET_CONTRACT_VERSION_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/get-contract-version/get-contract-version-response-schema.ts
import { ProductSchema } from "@vy/types";
import { oz as oz118 } from "@vy/utils";
var GetContractVersionResponseSchema = oz118.object({
  products: oz118.array(ProductSchema)
});

// src/api-definition-paths/contract-paths/get-contract-version/get-contract-version-action.ts
import { oz as oz119 } from "@vy/utils";
var VERSION_ID_QUERY_PARAM = {
  name: "versionId",
  location: "query",
  schema: oz119.string().optional(),
  required: false
};
var GET_CONTRACT_VERSION_ACTION = {
  method: "get",
  response: {
    name: "GetContractVersionResponse",
    schema: GetContractVersionResponseSchema
  },
  queryParams: {
    [VERSION_ID_QUERY_PARAM.name]: VERSION_ID_QUERY_PARAM
  },
  codeGenerationSettings: {
    actionText: "get-contract-version"
  },
  path: GET_CONTRACT_VERSION_PATH
};

// src/api-definition-paths/contract-paths/set-contract-auto-renewal-path/set-contract-auto-renewal-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS57 } from "@vy/zapi-types";
var SET_CONTRACT_AUTO_RENEWAL_PATH = {
  accessLevel: PATH_ACCESS_LEVELS57.PRIVATE,
  route: "/contract/auto-renewal/{contractId}",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/set-contract-auto-renewal-path/set-contract-auto-renewal-request-schema.ts
import { oz as oz120 } from "@vy/utils";
var SetContractAutoRenewalRequestSchema = oz120.object({
  autoRenewal: oz120.boolean()
}).openapi("SetContractAutoRenewalRequest");

// src/api-definition-paths/contract-paths/set-contract-auto-renewal-path/set-contract-auto-renewal-action.ts
var SET_CONTRACT_AUTO_RENEWAL_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "set-contract-auto-renewal"
  },
  request: {
    name: "SetContractAutoRenewalRequest",
    schema: SetContractAutoRenewalRequestSchema
  },
  path: SET_CONTRACT_AUTO_RENEWAL_PATH
};

// src/api-definition-paths/contract-paths/get-latest-contract-renewal/get-latest-contract-renewal-response-schema.ts
import { ContractRenewalSchema } from "@vy/types";
import { oz as oz121 } from "@vy/utils";
var GetLatestContractRenewalResponseSchema = oz121.object({
  contractRenewal: ContractRenewalSchema.optional()
}).openapi("GetLatestContractRenewalResponse");

// src/api-definition-paths/contract-paths/get-latest-contract-renewal/get-latest-contract-renewal-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS58 } from "@vy/zapi-types";
var GET_LATEST_CONTRACT_RENEWAL_PATH = {
  accessLevel: PATH_ACCESS_LEVELS58.PRIVATE,
  route: "/contract/{contractId}/renewals/latest",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/get-latest-contract-renewal/get-latest-contract-renewal-action.ts
var GET_LATEST_CONTRACT_RENEWAL_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-latest-contract-renewal"
  },
  response: {
    name: "GetLatestContractRenewalResponse",
    schema: GetLatestContractRenewalResponseSchema
  },
  path: GET_LATEST_CONTRACT_RENEWAL_PATH
};

// src/api-definition-paths/contract-paths/update-contract-end-date-path/update-contract-end-date-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS59 } from "@vy/zapi-types";
var UPDATE_CONTRACT_END_DATE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS59.PRIVATE,
  route: "/contract/end-date/{contractId}",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/update-contract-end-date-path/update-contract-end-date-request-schema.ts
import { ApiDateSchema as ApiDateSchema26 } from "@vy/types";
import { oz as oz122 } from "@vy/utils";
var UpdateContractEndDateRequestSchema = oz122.object({
  endDate: ApiDateSchema26
}).openapi("UpdateContractEndDateRequest");

// src/api-definition-paths/contract-paths/update-contract-end-date-path/update-contract-end-date-action.ts
var UPDATE_CONTRACT_END_DATE_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-contract-end-date"
  },
  request: {
    name: "UpdateContractEndDateRequest",
    schema: UpdateContractEndDateRequestSchema
  },
  path: UPDATE_CONTRACT_END_DATE_PATH
};

// src/api-definition-paths/contract-paths/update-contract-labels/update-contract-labels-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS60 } from "@vy/zapi-types";
var UPDATE_CONTRACT_LABELS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS60.PRIVATE,
  route: "/contract/{contractId}/labels",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/update-contract-labels/update-contract-labels-request-schema.ts
import { oz as oz123 } from "@vy/utils";
var UpdateContractLabelsRequestSchema = oz123.object({ labelIds: oz123.array(oz123.string()) }).openapi("UpdateContractLabelsRequest");

// src/api-definition-paths/contract-paths/update-contract-labels/update-contract-labels-response-schema.ts
import { oz as oz124 } from "@vy/utils";
var UpdateContractLabelsResponseSchema = oz124.object({
  contract: oz124.object({
    id: oz124.string(),
    labelIds: oz124.array(oz124.string())
  })
}).openapi("UpdateContractLabelsResponse");

// src/api-definition-paths/contract-paths/update-contract-labels/update-contract-labels-action.ts
var UPDATE_CONTRACT_LABELS_ACTION = {
  method: "patch",
  codeGenerationSettings: { actionText: "update-contract-labels" },
  response: { name: "UpdateContractLabelsResponse", schema: UpdateContractLabelsResponseSchema },
  request: { name: "UpdateContractLabelsRequest", schema: UpdateContractLabelsRequestSchema },
  path: UPDATE_CONTRACT_LABELS_PATH
};

// src/api-definition-paths/contract-paths/delete-revision/delete-revision-path.ts
import { oz as oz125 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS61 } from "@vy/zapi-types";
var DELETE_REVISION_ID_PATH_PARAM = {
  name: "revisionId",
  location: "path",
  schema: oz125.string(),
  required: true
};
var DELETE_REVISION_PATH_PARAMS = {
  [CONTRACT_ID_PATH_PARAM.name]: CONTRACT_ID_PATH_PARAM,
  [DELETE_REVISION_ID_PATH_PARAM.name]: DELETE_REVISION_ID_PATH_PARAM
};
var DELETE_REVISION_PATH = {
  accessLevel: PATH_ACCESS_LEVELS61.PRIVATE,
  route: "/contract/{contractId}/revision/{revisionId}",
  pathParams: DELETE_REVISION_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/delete-revision/delete-revision-response.ts
import { oz as oz126 } from "@vy/utils";
var DeleteRevisionResponseSchema = oz126.object({
  contractId: oz126.string(),
  revisionId: oz126.string()
}).openapi("DeleteRevisionResponse");

// src/api-definition-paths/contract-paths/delete-revision/delete-revision-action.ts
var DELETE_REVISION_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-revision"
  },
  response: {
    name: "DeleteRevisionResponse",
    schema: DeleteRevisionResponseSchema
  },
  path: DELETE_REVISION_PATH
};

// src/api-definition-paths/contract-paths/update-contract-memo/update-contract-memo-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS62 } from "@vy/zapi-types";
var UPDATE_CONTRACT_MEMO_PATH = {
  accessLevel: PATH_ACCESS_LEVELS62.PRIVATE,
  route: "/contract/memo/{contractId}",
  pathParams: UPDATE_CONTRACT_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/update-contract-memo/update-contract-memo-request-schema.ts
import { oz as oz127 } from "@vy/utils";
var UpdateContractMemoRequestSchema = oz127.object({
  notes: oz127.string().max(500).optional()
}).openapi("UpdateContractMemoRequest");

// src/api-definition-paths/contract-paths/update-contract-memo/update-contract-memo-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema9 } from "@vy/types";
import { oz as oz128 } from "@vy/utils";
var UpdateContractMemoResponseSchema = oz128.object({
  contractId: ObjectIdSchema9,
  notes: oz128.string().optional()
}).openapi("UpdateContractMemoResponse");

// src/api-definition-paths/contract-paths/update-contract-memo/update-contract-memo-action.ts
var UPDATE_CONTRACT_MEMO_ACTION = {
  method: "patch",
  codeGenerationSettings: {
    actionText: "update-contract-memo"
  },
  request: {
    name: "UpdateContractMemoRequest",
    schema: UpdateContractMemoRequestSchema
  },
  response: {
    name: "UpdateContractMemoResponse",
    schema: UpdateContractMemoResponseSchema
  },
  path: UPDATE_CONTRACT_MEMO_PATH
};

// src/api-definition-paths/contract-paths/update-contract-custom-field-value/update-contract-custom-field-value-path.ts
import { oz as oz129 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS63 } from "@vy/zapi-types";
var CUSTOM_FIELD_DEFINITION_ID_PATH_PARAM = {
  name: "customFieldDefinitionId",
  location: "path",
  schema: oz129.string(),
  required: true
};
var UPDATE_CONTRACT_CUSTOM_FIELD_VALUE_PATH_PARAMS = {
  [CONTRACT_ID_PATH_PARAM.name]: CONTRACT_ID_PATH_PARAM,
  [CUSTOM_FIELD_DEFINITION_ID_PATH_PARAM.name]: CUSTOM_FIELD_DEFINITION_ID_PATH_PARAM
};
var UPDATE_CONTRACT_CUSTOM_FIELD_VALUE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS63.PRIVATE,
  route: "/contract/{contractId}/custom-fields/{customFieldDefinitionId}",
  pathParams: UPDATE_CONTRACT_CUSTOM_FIELD_VALUE_PATH_PARAMS,
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/update-contract-custom-field-value/update-contract-custom-field-value-request-schema.ts
import { CustomFieldScalarValueSchema } from "@vy/custom-fields-types";
import { oz as oz130 } from "@vy/utils";
var UpdateContractCustomFieldValueRequestSchema = oz130.object({
  value: CustomFieldScalarValueSchema.nullable()
}).openapi("UpdateContractCustomFieldValueRequest");

// src/api-definition-paths/contract-paths/update-contract-custom-field-value/update-contract-custom-field-value-response-schema.ts
import { CustomFieldValueSchema } from "@vy/custom-fields-types";
import { oz as oz131 } from "@vy/utils";
var UpdateContractCustomFieldValueResponseSchema = oz131.object({
  customFieldValues: CustomFieldValueSchema.array()
}).openapi("UpdateContractCustomFieldValueResponse");

// src/api-definition-paths/contract-paths/update-contract-custom-field-value/update-contract-custom-field-value-action.ts
var UPDATE_CONTRACT_CUSTOM_FIELD_VALUE_ACTION = {
  method: "patch",
  codeGenerationSettings: { actionText: "update-contract-custom-field-value" },
  response: {
    name: "UpdateContractCustomFieldValueResponse",
    schema: UpdateContractCustomFieldValueResponseSchema
  },
  request: {
    name: "UpdateContractCustomFieldValueRequest",
    schema: UpdateContractCustomFieldValueRequestSchema
  },
  path: UPDATE_CONTRACT_CUSTOM_FIELD_VALUE_PATH
};

// src/api-definition-paths/contract-paths/contract-actions.ts
var CONTRACT_ACTIONS = [
  DELETE_CONTRACT_ACTION,
  GET_CONTRACT_ACTION,
  GET_CONTRACT_CUSTOM_FIELDS_ACTION,
  GET_CONTRACT_PDF_ACTION,
  GET_CONTRACT_PRODUCTS_OVERVIEWS_ACTION,
  GET_CONTRACT_USAGE_BREAKDOWN_ACTION,
  LIST_CONTRACT_CREDIT_POOLS_ACTION,
  RENEW_CONTRACT_ACTION,
  REVISE_CONTRACT_ACTION,
  TERMINATE_CONTRACT_ACTION,
  UPDATE_CONTRACT_ACTION,
  UPDATE_CONTRACT_STATUS_ACTION,
  UPDATE_CONTRACT_END_DATE_ACTION,
  GET_CONTRACT_PRODUCTS_CONSUMPTION_ACTION,
  GET_CONTRACT_BILLING_SCHEDULE_ACTION,
  GET_CONTRACT_VERSION_ACTION,
  SET_CONTRACT_AUTO_RENEWAL_ACTION,
  GET_LATEST_CONTRACT_RENEWAL_ACTION,
  UPDATE_CONTRACT_LABELS_ACTION,
  DELETE_REVISION_ACTION,
  UPDATE_CONTRACT_MEMO_ACTION,
  UPDATE_CONTRACT_CUSTOM_FIELD_VALUE_ACTION
];

// src/api-definition-paths/contract-paths/contract-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS64 } from "@vy/zapi-types";
var CONTRACT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS64.PRIVATE,
  route: "/contract",
  tags: API_TAGS.CONTRACT
};

// src/api-definition-paths/contract-paths/contract-paths.ts
var CONTRACT_PATHS = [
  CONTRACT_ID_PATH_PARAM,
  CONTRACT_PATH,
  GET_CONTRACT_PDF_PATH,
  GET_CONTRACT_PRODUCTS_OVERVIEWS_PATH,
  RENEW_CONTRACT_PATH,
  REVISE_CONTRACT_PATH,
  TERMINATE_CONTRACT_PATH,
  UPDATE_CONTRACT_STATUS_PATH,
  GET_CONTRACT_PRODUCTS_CONSUMPTION_PATH,
  GET_CONTRACT_BILLING_SCHEDULE_PATH,
  GET_CONTRACT_VERSION_PATH,
  SET_CONTRACT_AUTO_RENEWAL_PATH,
  GET_LATEST_CONTRACT_RENEWAL_PATH
];

// src/api-definition-paths/contracts-paths/contracts-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS65 } from "@vy/zapi-types";
var CONTRACTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS65.PRIVATE,
  route: "/contracts",
  tags: API_TAGS.CONTRACTS
};

// src/api-definition-paths/contracts-paths/get-contracts-overviews-path/get-contracts-overviews-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS66 } from "@vy/zapi-types";
var GET_CONTRACTS_OVERVIEWS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS66.PRIVATE,
  route: "/contracts/overviews",
  tags: API_TAGS.CONTRACTS
};

// src/api-definition-paths/contracts-paths/get-contracts-overviews-path/get-contracts-overviews-action.ts
import { ContractOverviewSchema as ContractOverviewSchema2, ContractStatusesSchema } from "@vy/types";

// src/api-definition-paths/contracts-paths/get-contracts-overviews-path/get-contracts-overviews-response-schema.ts
import { ContractOverviewSchema } from "@vy/types";
import { oz as oz132 } from "@vy/utils";
var GetContractsOverviewsResponseSchema = oz132.object({
  countedTotalActiveContractsOverviews: oz132.number().nonnegative(),
  countedTotalContractsOverviews: oz132.number().nonnegative(),
  countedFilteredContractsOverviews: oz132.number().nonnegative(),
  contracts: ContractOverviewSchema.array()
}).openapi("GetContractsOverviewsResponse");

// src/api-definition-paths/contracts-paths/get-contracts-overviews-path/get-contracts-overviews-action.ts
var { schema: GetContractsOverviewsSortingSchema, param: GET_CONTRACTS_OVERVIEWS_SORTING_PARAMETER } = getQuerySortingItemParameterSchemas(ContractOverviewSchema2, "GetContractsOverviewsSorting");
var CONTRACT_STATUSES_QUERY_PARAMETER = {
  name: "contractStatuses",
  location: "query",
  schema: ContractStatusesSchema
};
var GET_CONTRACTS_OVERVIEWS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contracts-overviews"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [CONTRACT_STATUSES_QUERY_PARAMETER.name]: CONTRACT_STATUSES_QUERY_PARAMETER,
    [GET_CONTRACTS_OVERVIEWS_SORTING_PARAMETER.name]: GET_CONTRACTS_OVERVIEWS_SORTING_PARAMETER
  },
  response: {
    name: "GetContractsOverviewsResponse",
    schema: GetContractsOverviewsResponseSchema
  },
  path: GET_CONTRACTS_OVERVIEWS_PATH
};

// src/api-definition-paths/contracts-paths/contracts-paths.ts
var CONTRACTS_PATHS = [CONTRACTS_PATH, GET_CONTRACTS_OVERVIEWS_PATH];

// src/api-definition-paths/contracts-paths/create-contracts/create-contracts-request-schema.ts
import { NewContractSchemaWithPlanBase, NewContractSchemaWithoutPlan } from "@vy/types";
import { oz as oz133 } from "@vy/utils";
var MINIMUM_MULTI_YEAR_DURATION_MONTHS2 = 13;
var CreateContractsRequestSchema = oz133.discriminatedUnion("creationType", [NewContractSchemaWithPlanBase, NewContractSchemaWithoutPlan]).superRefine((data, ctx) => {
  if (data.creationType !== "CreateContractWithPlan") return;
  data.contracts.forEach((contract, contractIndex) => {
    const hasProductLevelUplift = contract.plan.products.some(
      (product) => product.upliftConfiguration?.inflationaryUpliftEnabled || product.upliftConfiguration?.seatUpliftEnabled || product.upliftConfiguration?.commitmentUpliftEnabled
    );
    if (hasProductLevelUplift && contract.plan.billingData.duration < MINIMUM_MULTI_YEAR_DURATION_MONTHS2) {
      ctx.addIssue({
        code: oz133.ZodIssueCode.custom,
        message: "Uplift can only be enabled on multi-year contracts (duration > 12 months)",
        path: ["contracts", contractIndex, "plan", "products"]
      });
    }
  });
}).openapi("CreateContractsRequest");

// src/api-definition-paths/contracts-paths/create-contracts/create-contracts-response-schema.ts
import { ContractSchema as ContractSchema6 } from "@vy/types";
import { oz as oz134 } from "@vy/utils";
var CreateContractsResponseSchema = oz134.object({
  contracts: oz134.array(ContractSchema6)
}).openapi("CreateContractsResponse");

// src/api-definition-paths/contracts-paths/create-contracts/create-contracts-action.ts
var CREATE_CONTRACTS_ACTION = {
  method: "post",
  request: {
    name: "CreateContractsRequest",
    schema: CreateContractsRequestSchema
  },
  codeGenerationSettings: {
    actionText: "create-contracts"
  },
  response: {
    name: "CreateContractsResponse",
    schema: CreateContractsResponseSchema
  },
  path: CONTRACTS_PATH
};

// src/api-definition-paths/contracts-paths/extract-contract/extract-contract-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS67 } from "@vy/zapi-types";
var EXTRACT_CONTRACT_PATH = {
  route: "/contracts/extract",
  tags: [API_TAGS.CONTRACTS],
  accessLevel: PATH_ACCESS_LEVELS67.PRIVATE
};

// src/api-definition-paths/contracts-paths/extract-contract/extract-contract-response-schema.ts
import { oz as oz135 } from "@vy/utils";
var ExtractContractResponseSchema = oz135.object({
  jobId: oz135.string()
}).openapi("ExtractContractResponse");

// src/api-definition-paths/contracts-paths/extract-contract/extract-contract-action.ts
var EXTRACT_CONTRACT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "extract-contract"
  },
  response: {
    name: "ExtractContractResponse",
    schema: ExtractContractResponseSchema
  },
  path: EXTRACT_CONTRACT_PATH
};

// src/api-definition-paths/contracts-paths/get-contracts/get-contracts-action.ts
import {
  ContractAdditionalFiltersSchema,
  ContractSchema as ContractSchema7,
  ContractStatusesSchema as ContractStatusesSchema2,
  SyncStatusesSchema
} from "@vy/types";
import { oz as oz137, parseJson as parseJson2 } from "@vy/utils";

// src/api-definition-paths/contracts-paths/get-contracts/get-contracts-response-schema.ts
import { ContractOverviewSchema as ContractOverviewSchema3 } from "@vy/types";
import { oz as oz136 } from "@vy/utils";
var GetContractsResponseSchema = oz136.object({
  countedActiveContracts: oz136.number().nonnegative(),
  countedInReviewContracts: oz136.number().nonnegative(),
  countedInactiveContracts: oz136.number().nonnegative(),
  countedExpiredContracts: oz136.number().nonnegative(),
  countedInactiveImportedContracts: oz136.number().nonnegative(),
  countedUpcomingRenewalContracts: oz136.number().nonnegative(),
  countedTotalContracts: oz136.number().nonnegative(),
  countedFilteredContracts: oz136.number().nonnegative(),
  contracts: oz136.array(ContractOverviewSchema3)
}).openapi("GetContractsResponse");

// src/api-definition-paths/contracts-paths/get-contracts/get-contracts-action.ts
import { ContractFilterSchema } from "@vy/contracts-types";
var { schema: GetContractsSortingSchema, param: GET_CONTRACTS_SORTING_PARAMETER } = getQuerySortingItemParameterSchemas(ContractSchema7, "GetContractsSorting");
var CUSTOMER_ID_QUERY_PARAMETER = {
  name: "customerId",
  location: "query",
  schema: oz137.string().optional(),
  required: false
};
var CONTRACT_STATUSES_QUERY_PARAMETER2 = {
  name: "contractStatuses",
  location: "query",
  schema: ContractStatusesSchema2.optional(),
  required: false
};
var CONTRACT_SYNC_STATUSES_QUERY_PARAMETER = {
  name: "syncStatuses",
  location: "query",
  schema: SyncStatusesSchema.optional(),
  required: false
};
var CONTRACT_ADDITIONAL_FILTERS_QUERY_PARAMETER = {
  name: "additionalFilters",
  location: "query",
  schema: ContractAdditionalFiltersSchema.optional(),
  required: false
};
var CONTRACT_FILTERS_QUERY_PARAMETER = {
  name: "contractFilters",
  location: "query",
  schema: oz137.string().transform(parseJson2).pipe(ContractFilterSchema.array()).optional(),
  required: false
};
var INCLUDE_CONTRACTS_QUERY_PARAMETER = {
  name: "includeContracts",
  location: "query",
  schema: BooleanQueryParamSchema,
  required: false
};
var GET_CONTRACTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contracts"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [CUSTOMER_ID_QUERY_PARAMETER.name]: CUSTOMER_ID_QUERY_PARAMETER,
    [CONTRACT_STATUSES_QUERY_PARAMETER2.name]: CONTRACT_STATUSES_QUERY_PARAMETER2,
    [CONTRACT_SYNC_STATUSES_QUERY_PARAMETER.name]: CONTRACT_SYNC_STATUSES_QUERY_PARAMETER,
    [GET_CONTRACTS_SORTING_PARAMETER.name]: GET_CONTRACTS_SORTING_PARAMETER,
    [CONTRACT_ADDITIONAL_FILTERS_QUERY_PARAMETER.name]: CONTRACT_ADDITIONAL_FILTERS_QUERY_PARAMETER,
    [CONTRACT_FILTERS_QUERY_PARAMETER.name]: CONTRACT_FILTERS_QUERY_PARAMETER,
    [INCLUDE_CONTRACTS_QUERY_PARAMETER.name]: INCLUDE_CONTRACTS_QUERY_PARAMETER
  },
  response: {
    name: "GetContractsResponse",
    schema: GetContractsResponseSchema
  },
  path: CONTRACTS_PATH
};

// src/api-definition-paths/contracts-paths/contracts-actions.ts
var CONTRACTS_ACTIONS = [
  CREATE_CONTRACTS_ACTION,
  EXTRACT_CONTRACT_ACTION,
  GET_CONTRACTS_ACTION,
  GET_CONTRACTS_OVERVIEWS_ACTION
];

// src/api-definition-paths/customer-paths/customer-id-path.ts
import { oz as oz138 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS68 } from "@vy/zapi-types";
var CUSTOMER_ID_PATH_PARAM = {
  name: "customerId",
  location: "path",
  schema: oz138.string(),
  required: true
};
var CUSTOMER_ID_PATH_PARAMS = {
  [CUSTOMER_ID_PATH_PARAM.name]: CUSTOMER_ID_PATH_PARAM
};
var CUSTOMER_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS68.PRIVATE,
  route: "/customer/{customerId}",
  pathParams: CUSTOMER_ID_PATH_PARAMS,
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/customer-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS69 } from "@vy/zapi-types";
var CUSTOMER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS69.PRIVATE,
  route: "/customer",
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/delete-customer/delete-customer-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS70 } from "@vy/zapi-types";
var DELETE_CUSTOMER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS70.PRIVATE,
  route: "/customer/{customerId}",
  pathParams: CUSTOMER_ID_PATH_PARAMS,
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/get-customers/get-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS71 } from "@vy/zapi-types";
var GET_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS71.PRIVATE,
  route: "/customers",
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/get-customers/get-customers-response-schema.ts
import { CustomerSchema as CustomerSchema4, ObjectIdSchema as ObjectIdSchema10 } from "@vy/types";
import { oz as oz139 } from "@vy/utils";
var GetCustomersResponseSchema = oz139.object({
  customers: oz139.array(
    CustomerSchema4.extend({
      childCustomersIds: ObjectIdSchema10.array().optional()
    })
  )
}).openapi("GetCustomersResponse");

// src/api-definition-paths/customer-paths/get-customers/get-customers-action.ts
var GET_CUSTOMERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customers"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS
  },
  response: {
    name: "GetCustomersResponse",
    schema: GetCustomersResponseSchema
  },
  path: GET_CUSTOMERS_PATH
};

// src/api-definition-paths/customer-paths/get-customers-names/get-customers-names-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS72 } from "@vy/zapi-types";
var GET_CUSTOMERS_NAMES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS72.PRIVATE,
  route: "/customers/names",
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/get-customers-names/get-customers-names-response-schema.ts
import { CustomerSchema as CustomerSchema5, ObjectIdSchema as ObjectIdSchema11 } from "@vy/types";
import { oz as oz140 } from "@vy/utils";
var GetCustomersNamesResponseSchema = oz140.object({
  customers: oz140.array(
    CustomerSchema5.pick({
      name: true,
      id: true
    }).extend({
      childCustomersIds: ObjectIdSchema11.array().optional()
    })
  )
}).openapi("GetCustomersNamesResponse");

// src/api-definition-paths/customer-paths/get-customers-names/get-customers-names-action.ts
var GET_CUSTOMERS_NAMES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customers-names"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS
  },
  response: {
    name: "GetCustomersNamesResponse",
    schema: GetCustomersNamesResponseSchema
  },
  path: GET_CUSTOMERS_NAMES_PATH
};

// src/api-definition-paths/customer-paths/get-customers-overviews/get-customers-overviews-action.ts
import { CustomerFiltersSchema } from "@vy/types";

// src/api-definition-paths/customer-paths/get-customers-overviews/customer-overview-schema.ts
import { CustomerStatusSchema, CurrencySchema as CurrencySchema6, ApiDateSchema as ApiDateSchema27, LabelSchema } from "@vy/types";
import { ObjectIdSchema as ObjectIdSchema12 } from "@vy/types";
import { oz as oz141 } from "@vy/utils";
import { CustomFieldValueSchema as CustomFieldValueSchema2 } from "@vy/custom-fields-types";
var CustomerOverviewSchema = oz141.object({
  id: ObjectIdSchema12,
  createdAt: ApiDateSchema27,
  updatedAt: ApiDateSchema27,
  externalId: oz141.string().optional(),
  name: oz141.string().min(1),
  revenue: oz141.number(),
  status: CustomerStatusSchema,
  currency: CurrencySchema6.optional(),
  contractsCount: oz141.number().nonnegative(),
  activeContractsCount: oz141.number().nonnegative(),
  isChildCustomer: oz141.boolean(),
  parentCustomer: oz141.string().optional(),
  subsidiary: oz141.string().optional(),
  address: oz141.string().optional(),
  country: oz141.string().optional(),
  state: oz141.string().optional(),
  city: oz141.string().optional(),
  postalCode: oz141.string().optional(),
  paymentDueDays: oz141.number().optional(),
  manualReview: oz141.boolean().optional(),
  legalName: oz141.string().optional(),
  crmId: oz141.string().optional(),
  erpId: oz141.string().optional(),
  taxIds: oz141.array(oz141.string()).optional(),
  aliases: oz141.array(oz141.string()).optional(),
  wallet: oz141.string().optional(),
  taxRate: oz141.number().nullish(),
  customFieldValues: oz141.array(CustomFieldValueSchema2).optional(),
  labels: LabelSchema.pick({ id: true, name: true, color: true, backgroundColor: true }).array().optional()
}).openapi("CustomerOverview");

// src/api-definition-paths/customer-paths/get-customers-overviews/get-customers-overviews-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS73 } from "@vy/zapi-types";
var GET_CUSTOMER_OVERVIEWS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS73.PRIVATE,
  route: "/customers/overviews",
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/get-customers-overviews/get-customers-overviews-response-schema.ts
import { oz as oz142 } from "@vy/utils";
var GetCustomersOverviewsResponseSchema = oz142.object({
  customers: oz142.array(CustomerOverviewSchema),
  countedFilteredCustomers: oz142.number().nonnegative(),
  countedTotalCustomers: oz142.number().nonnegative(),
  countedActiveCustomers: oz142.number().nonnegative()
}).openapi("GetCustomersOverviewsResponse");

// src/api-definition-paths/customer-paths/get-customers-overviews/get-customers-overviews-action.ts
var { schema: GetCustomersOverviewsSortingSchema, param: GET_CUSTOMERS_OVERVIEWS_SORTING_PARAMETER } = getQuerySortingItemParameterSchemas(CustomerOverviewSchema, "GetCustomersOverviewsSorting");
var CUSTOMER_FILTERS_QUERY_PARAMETER = {
  name: "filters",
  location: "query",
  schema: CustomerFiltersSchema
};
var GET_CUSTOMERS_OVERVIEWS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customers-overviews"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [CUSTOMER_FILTERS_QUERY_PARAMETER.name]: CUSTOMER_FILTERS_QUERY_PARAMETER,
    [GET_CUSTOMERS_OVERVIEWS_SORTING_PARAMETER.name]: GET_CUSTOMERS_OVERVIEWS_SORTING_PARAMETER
  },
  response: {
    name: "GetCustomersOverviewsResponse",
    schema: GetCustomersOverviewsResponseSchema
  },
  path: GET_CUSTOMER_OVERVIEWS_PATH
};

// src/api-definition-paths/customer-paths/get-customers-overviews-new/get-customers-overviews-new-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS74 } from "@vy/zapi-types";
var GET_CUSTOMERS_OVERVIEWS_NEW_PATH = {
  accessLevel: PATH_ACCESS_LEVELS74.PRIVATE,
  route: "/customers/overviews-new",
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/get-customers-overviews-new/get-customers-overviews-new-response-schema.ts
import { oz as oz143 } from "@vy/utils";
var GetCustomersOverviewsNewResponseSchema = oz143.object({
  items: oz143.array(CustomerOverviewSchema),
  count: oz143.number()
}).openapi("GetCustomersOverviewsNewResponse");

// src/api-definition-paths/customer-paths/get-customers-overviews-new/get-customers-overviews-new-action.ts
import { parseJson as parseJson3, oz as oz144 } from "@vy/utils";
import { CustomerFilterSchema } from "@vy/customers-types";
var { param: GET_CUSTOMERS_OVERVIEWS_SORTING_PARAMETER2 } = getQuerySortingItemParameterSchemas(
  CustomerOverviewSchema,
  "GetCustomersOverviewsSorting"
);
var CUSTOMER_FILTERS_QUERY_PARAMETER2 = {
  name: "customerFilters",
  location: "query",
  schema: oz144.string().transform(parseJson3).pipe(CustomerFilterSchema.array()).optional(),
  required: false
};
var GET_CUSTOMERS_OVERVIEWS_NEW_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customers-overviews-new"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [CUSTOMER_FILTERS_QUERY_PARAMETER2.name]: CUSTOMER_FILTERS_QUERY_PARAMETER2,
    [GET_CUSTOMERS_OVERVIEWS_SORTING_PARAMETER2.name]: GET_CUSTOMERS_OVERVIEWS_SORTING_PARAMETER2
  },
  response: {
    name: "GetCustomersOverviewsNewResponse",
    schema: GetCustomersOverviewsNewResponseSchema
  },
  path: GET_CUSTOMERS_OVERVIEWS_NEW_PATH
};

// src/api-definition-paths/customer-paths/get-potential-child-customers/get-potential-child-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS75 } from "@vy/zapi-types";
var GET_POTENTIAL_CHILD_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS75.PRIVATE,
  route: "/customers/potential-children",
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/get-potential-child-customers/get-potential-child-customers-response-schema.ts
import { ChildCustomerOverviewSchema } from "@vy/types";
import { oz as oz145 } from "@vy/utils";
var PotentialChildCustomersResponseSchema = oz145.object({
  potentialChildCustomers: oz145.array(ChildCustomerOverviewSchema)
}).openapi("GetPotentialChildCustomersResponse");

// src/api-definition-paths/customer-paths/get-potential-child-customers/get-potential-child-customers-action.ts
var GET_POTENTIAL_CHILD_CUSTOMERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-potential-child-customers"
  },
  response: {
    name: "GetPotentialChildCustomersResponse",
    schema: PotentialChildCustomersResponseSchema
  },
  path: GET_POTENTIAL_CHILD_CUSTOMERS_PATH
};

// src/api-definition-paths/customer-paths/get-top-overdue-customers/get-top-overdue-customers-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema13 } from "@vy/types";
import { oz as oz146 } from "@vy/utils";
var GetTopOverdueCustomersResponseSchema = oz146.object({
  customers: oz146.array(
    oz146.object({
      id: ObjectIdSchema13,
      name: oz146.string(),
      currentRevenue: oz146.number(),
      previousRevenue: oz146.number()
    })
  )
}).openapi("GetTopOverdueCustomersResponse");

// src/api-definition-paths/customer-paths/get-top-overdue-customers/get-top-overdue-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS76 } from "@vy/zapi-types";
var GET_TOP_OVERDUE_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS76.PRIVATE,
  route: "/customers/top-overdue-customers",
  tags: API_TAGS.CUSTOMERS
};

// src/api-definition-paths/customer-paths/get-top-overdue-customers/get-top-overdue-customers-action.ts
var GET_TOP_OVERDUE_CUSTOMERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-top-overdue-customers"
  },
  response: {
    name: "GetTopOverdueCustomersResponse",
    schema: GetTopOverdueCustomersResponseSchema
  },
  path: GET_TOP_OVERDUE_CUSTOMERS_PATH
};

// src/api-definition-paths/customer-paths/migrate-to-automatic-tax/migrate-to-automatic-tax-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS77 } from "@vy/zapi-types";
var MIGRATE_TO_AUTOMATIC_TAX_PATH = {
  accessLevel: PATH_ACCESS_LEVELS77.PRIVATE,
  route: "/customers/migrate-to-automatic-tax",
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/migrate-to-automatic-tax/migrate-to-automatic-tax-request-schema.ts
import { MIGRATE_AUTO_SCOPE_OPTIONS } from "@vy/types";
import { oz as oz147 } from "@vy/utils";
var MigrateToAutomaticTaxRequestSchema = oz147.object({
  scope: oz147.enum([MIGRATE_AUTO_SCOPE_OPTIONS.ALL, MIGRATE_AUTO_SCOPE_OPTIONS.ZERO_TAX_RATE])
}).openapi("MigrateToAutomaticTaxRequest");

// src/api-definition-paths/customer-paths/migrate-to-automatic-tax/migrate-to-automatic-tax-response-schema.ts
import { oz as oz148 } from "@vy/utils";
var MigrateToAutomaticTaxResponseSchema = oz148.object({
  migratedCount: oz148.number()
}).openapi("MigrateToAutomaticTaxResponse");

// src/api-definition-paths/customer-paths/migrate-to-automatic-tax/migrate-to-automatic-tax-action.ts
var MIGRATE_TO_AUTOMATIC_TAX_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "migrate-to-automatic-tax"
  },
  request: {
    name: "MigrateToAutomaticTaxRequest",
    schema: MigrateToAutomaticTaxRequestSchema
  },
  response: {
    name: "MigrateToAutomaticTaxResponse",
    schema: MigrateToAutomaticTaxResponseSchema
  },
  path: MIGRATE_TO_AUTOMATIC_TAX_PATH
};

// src/api-definition-paths/customer-paths/customers-paths.ts
var CUSTOMER_PATHS = [
  CUSTOMER_PATH,
  CUSTOMER_ID_PATH,
  GET_CUSTOMERS_PATH,
  GET_CUSTOMER_OVERVIEWS_PATH,
  GET_CUSTOMERS_OVERVIEWS_NEW_PATH,
  GET_POTENTIAL_CHILD_CUSTOMERS_PATH,
  DELETE_CUSTOMER_PATH,
  GET_CUSTOMERS_NAMES_PATH,
  GET_TOP_OVERDUE_CUSTOMERS_PATH,
  MIGRATE_TO_AUTOMATIC_TAX_PATH
];

// src/api-definition-paths/customer-paths/create-customer/create-customer-request-schema.ts
import { NewCustomerSchema } from "@vy/types";
var CreateCustomerRequestSchema = NewCustomerSchema.openapi("CreateCustomerRequest");

// src/api-definition-paths/customer-paths/create-customer/create-customer-response-schema.ts
import { CustomerSchema as CustomerSchema6 } from "@vy/types";
import { oz as oz149 } from "@vy/utils";
var CreateCustomerResponseSchema = oz149.object({
  customer: CustomerSchema6
}).openapi("CreateCustomerResponse");

// src/api-definition-paths/customer-paths/create-customer/create-customer-action.ts
var CREATE_CUSTOMER_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "create-customer"
  },
  response: {
    name: "CreateCustomerResponse",
    schema: CreateCustomerResponseSchema
  },
  request: {
    name: "CreateCustomerRequest",
    schema: CreateCustomerRequestSchema
  },
  path: CUSTOMER_PATH
};

// src/api-definition-paths/customer-paths/get-customer/get-customer-response-schema.ts
import { CustomerRelationTypeSchema as CustomerRelationTypeSchema2, CustomerSchema as CustomerSchema7, ObjectIdSchema as ObjectIdSchema14 } from "@vy/types";
import { CustomFieldDefinitionSchema, CustomFieldValueWithDefinitionSchema as CustomFieldValueWithDefinitionSchema2 } from "@vy/custom-fields-types";
import { oz as oz150 } from "@vy/utils";
var GetCustomerResponseSchema = oz150.object({
  customer: CustomerSchema7,
  children: oz150.array(CustomerSchema7),
  childrenRelations: oz150.array(
    oz150.object({
      childId: ObjectIdSchema14,
      relationType: CustomerRelationTypeSchema2
    })
  ).optional(),
  customFieldsWithDefinitions: CustomFieldValueWithDefinitionSchema2.array().optional(),
  customFieldDefinitions: CustomFieldDefinitionSchema.array().optional()
}).openapi("GetCustomerResponse");

// src/api-definition-paths/customer-paths/get-customer/get-customer-action.ts
var GET_CUSTOMER_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customer"
  },
  response: {
    name: "GetCustomerResponse",
    schema: GetCustomerResponseSchema
  },
  path: CUSTOMER_ID_PATH
};

// src/api-definition-paths/customer-paths/update-customer/update-customer-request-schema.ts
import { CustomerChildrenRelationsSchema, CustomerInputSchema } from "@vy/types";
var UpdateCustomerRequestSchema = CustomerInputSchema.extend({
  childrenRelations: CustomerChildrenRelationsSchema
}).openapi("UpdateCustomerRequest");

// src/api-definition-paths/customer-paths/update-customer/update-customer-response-schema.ts
import { CustomerSchema as CustomerSchema8 } from "@vy/types";
import { oz as oz151 } from "@vy/utils";
var UpdateCustomerResponseSchema = oz151.object({
  customer: CustomerSchema8
}).openapi("UpdateCustomerResponse");

// src/api-definition-paths/customer-paths/update-customer/update-customer-action.ts
var UPDATE_CUSTOMER_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-customer"
  },
  response: {
    name: "UpdateCustomerResponse",
    schema: UpdateCustomerResponseSchema
  },
  request: {
    name: "UpdateCustomerRequest",
    schema: UpdateCustomerRequestSchema
  },
  path: CUSTOMER_ID_PATH
};

// src/api-definition-paths/customer-paths/delete-customer/delete-customer-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema15 } from "@vy/types";
import { oz as oz152 } from "@vy/utils";
var DeleteCustomerResponseSchema = oz152.object({
  customerId: ObjectIdSchema15
}).openapi("DeleteCustomerResponse");

// src/api-definition-paths/customer-paths/delete-customer/delete-customer-action.ts
var DELETE_CUSTOMER_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-customer"
  },
  response: {
    name: "DeleteCustomerResponse",
    schema: DeleteCustomerResponseSchema
  },
  path: DELETE_CUSTOMER_PATH
};

// src/api-definition-paths/customer-paths/update-customer-labels/update-customer-labels-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS78 } from "@vy/zapi-types";
var UPDATE_CUSTOMER_LABELS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS78.PRIVATE,
  route: "/customer/{customerId}/labels",
  pathParams: CUSTOMER_ID_PATH_PARAMS,
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/update-customer-labels/update-customer-labels-request-schema.ts
import { oz as oz153 } from "@vy/utils";
var UpdateCustomerLabelsRequestSchema = oz153.object({ labelIds: oz153.array(oz153.string()) }).openapi("UpdateCustomerLabelsRequest");

// src/api-definition-paths/customer-paths/update-customer-labels/update-customer-labels-response-schema.ts
import { oz as oz154 } from "@vy/utils";
var UpdateCustomerLabelsResponseSchema = oz154.object({
  customer: oz154.object({
    id: oz154.string(),
    labelIds: oz154.array(oz154.string())
  })
}).openapi("UpdateCustomerLabelsResponse");

// src/api-definition-paths/customer-paths/update-customer-labels/update-customer-labels-action.ts
var UPDATE_CUSTOMER_LABELS_ACTION = {
  method: "patch",
  codeGenerationSettings: { actionText: "update-customer-labels" },
  response: { name: "UpdateCustomerLabelsResponse", schema: UpdateCustomerLabelsResponseSchema },
  request: { name: "UpdateCustomerLabelsRequest", schema: UpdateCustomerLabelsRequestSchema },
  path: UPDATE_CUSTOMER_LABELS_PATH
};

// src/api-definition-paths/customer-paths/get-customer-status-count/get-customer-status-count-response-schema.ts
import { CustomerStatusSchema as CustomerStatusSchema2 } from "@vy/types";
import { oz as oz155 } from "@vy/utils";
var GetCustomerStatusCountsResponseSchema = oz155.array(
  oz155.object({
    status: CustomerStatusSchema2,
    count: oz155.number()
  })
).openapi("GetCustomerStatusCountsResponse");

// src/api-definition-paths/customer-paths/get-customer-status-count/get-customer-status-count-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS79 } from "@vy/zapi-types";
var GET_CUSTOMER_STATUS_COUNTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS79.PRIVATE,
  route: "/customers/status-counts",
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/customer-paths/get-customer-status-count/get-customer-status-count-action.ts
var GET_CUSTOMER_STATUS_COUNTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customer-status-counts"
  },
  response: {
    name: "GetCustomerStatusCountsResponse",
    schema: GetCustomerStatusCountsResponseSchema
  },
  path: GET_CUSTOMER_STATUS_COUNTS_PATH
};

// src/api-definition-paths/customer-paths/customers-actions.ts
var CUSTOMERS_ACTIONS = [
  CREATE_CUSTOMER_ACTION,
  GET_CUSTOMER_ACTION,
  GET_CUSTOMERS_ACTION,
  GET_CUSTOMERS_OVERVIEWS_ACTION,
  GET_CUSTOMERS_OVERVIEWS_NEW_ACTION,
  GET_POTENTIAL_CHILD_CUSTOMERS_ACTION,
  UPDATE_CUSTOMER_ACTION,
  UPDATE_CUSTOMER_LABELS_ACTION,
  DELETE_CUSTOMER_ACTION,
  GET_CUSTOMERS_NAMES_ACTION,
  GET_TOP_OVERDUE_CUSTOMERS_ACTION,
  GET_CUSTOMER_STATUS_COUNTS_ACTION,
  MIGRATE_TO_AUTOMATIC_TAX_ACTION
];

// src/api-definition-paths/invoices-paths/apply-credits/apply-credits-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS80 } from "@vy/zapi-types";
var APPLY_CREDITS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS80.PRIVATE,
  route: "/invoices/apply-credits",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/apply-credits/apply-credits-request-schema.ts
import { oz as oz156 } from "@vy/utils";
var ApplyCreditsRequestSchema = oz156.object({
  invoiceId: oz156.string(),
  creditAmount: oz156.number().positive()
}).openapi("ApplyCreditsRequest");

// src/api-definition-paths/invoices-paths/apply-credits/apply-credits-action.ts
var APPLY_CREDITS_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "apply-credits"
  },
  request: {
    name: "ApplyCreditsRequest",
    schema: ApplyCreditsRequestSchema
  },
  path: APPLY_CREDITS_PATH
};

// src/api-definition-paths/invoices-paths/invoice-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS81 } from "@vy/zapi-types";
var INVOICE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS81.PRIVATE,
  route: "/invoice",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/create-invoice/create-invoice-request-schema.ts
import { CreditPurchaseConfigSchema as CreditPurchaseConfigSchema2, NewFixedProductSchema, ObjectIdSchema as ObjectIdSchema16 } from "@vy/types";
import { oz as oz158 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/create-invoice/create-invoice-settings-schema.ts
import { CurrencySchema as CurrencySchema7 } from "@vy/types";
import { oz as oz157 } from "@vy/utils";
var CreateInvoiceSettingsSchema = oz157.object({
  customerId: oz157.string({
    ["required_error"]: "Customer is required"
  }),
  contractId: oz157.string().optional(),
  currency: CurrencySchema7,
  startDate: oz157.string({
    ["required_error"]: "Start date is required"
  }),
  endDate: oz157.string({
    ["required_error"]: "End date is required"
  }),
  issueDate: oz157.string().optional(),
  paymentDueDays: oz157.number().nullable(),
  purchaseOrder: oz157.string().optional(),
  refundsInvoiceId: oz157.string().optional()
}).openapi("CreateInvoiceSettings");
var CreateInvoiceSettingsWithValidationSchema = CreateInvoiceSettingsSchema.refine(
  (data) => {
    if (data.startDate && data.endDate) {
      const startDate = new Date(data.startDate);
      const endDate = new Date(data.endDate);
      return endDate >= startDate;
    }
    return true;
  },
  {
    message: "End date cannot be earlier than start date",
    path: ["endDate"]
  }
);

// src/api-definition-paths/invoices-paths/create-invoice/create-invoice-request-schema.ts
var CreateInvoiceRequestSchema = oz158.object({
  fixedProducts: oz158.array(NewFixedProductSchema),
  settings: CreateInvoiceSettingsWithValidationSchema,
  contractId: ObjectIdSchema16.optional(),
  credits: oz158.array(CreditPurchaseConfigSchema2).optional()
}).openapi("CreateInvoiceRequest");

// src/api-definition-paths/invoices-paths/create-invoice/create-invoice-response-schema.ts
import { oz as oz159 } from "@vy/utils";
var CreateInvoiceResponseSchema = oz159.object({
  invoiceId: oz159.string(),
  customerId: oz159.string()
}).openapi("CreateInvoiceResponse");

// src/api-definition-paths/invoices-paths/create-invoice/create-invoice-action.ts
var CREATE_INVOICE_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "create-invoice"
  },
  response: {
    name: "CreateInvoiceResponse",
    schema: CreateInvoiceResponseSchema
  },
  request: {
    name: "CreateInvoiceRequest",
    schema: CreateInvoiceRequestSchema
  },
  path: INVOICE_PATH
};

// src/api-definition-paths/invoices-paths/delete-invoice/delete-invoice-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS83 } from "@vy/zapi-types";

// src/api-definition-paths/invoices-paths/invoice-id-path.ts
import { oz as oz160 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS82 } from "@vy/zapi-types";
var INVOICE_ID_PATH_PARAM = {
  name: "invoiceId",
  location: "path",
  schema: oz160.string(),
  required: true
};
var INVOICE_ID_PATH_PARAMS = {
  [INVOICE_ID_PATH_PARAM.name]: INVOICE_ID_PATH_PARAM
};
var INVOICE_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS82.PRIVATE,
  route: "/invoice/{invoiceId}",
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/delete-invoice/delete-invoice-path.ts
var DELETE_INVOICE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS83.PRIVATE,
  route: "/invoice/{invoiceId}",
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/delete-invoice/delete-invoice-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema17 } from "@vy/types";
import { oz as oz161 } from "@vy/utils";
var DeleteInvoiceResponseSchema = oz161.object({
  invoiceId: ObjectIdSchema17
}).openapi("DeleteInvoiceResponse");

// src/api-definition-paths/invoices-paths/delete-invoice/delete-invoice-action.ts
var DELETE_INVOICE_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-invoice"
  },
  response: {
    name: "DeleteInvoiceResponse",
    schema: DeleteInvoiceResponseSchema
  },
  path: DELETE_INVOICE_PATH
};

// src/api-definition-paths/invoices-paths/get-approval-flow-invoices-list/approval-flow-invoice-types-query-params.ts
import { parseJson as parseJson4, oz as oz162 } from "@vy/utils";
var APPROVAL_FLOW_INVOICE_TYPES = Object.freeze({
  PREVIOUS_CYCLE: "previousCycle",
  OLD_CYCLES: "oldCycles",
  OVERAGES: "overages"
});
var ApprovalFlowInvoiceTypesParamSchema = oz162.string().transform((s) => parseJson4(s)).pipe(oz162.nativeEnum(APPROVAL_FLOW_INVOICE_TYPES).array()).openapi("ApprovalFlowInvoiceType");

// src/api-definition-paths/invoices-paths/get-approval-flow-invoices-list/get-approval-flow-invoices-list-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS84 } from "@vy/zapi-types";
var GET_APPROVAL_FLOW_INVOICES_LIST_PATH = {
  accessLevel: PATH_ACCESS_LEVELS84.PRIVATE,
  route: "/invoices/approval-flow",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/get-approval-flow-invoices-list/get-approval-flow-invoices-list-response-schema.ts
import { CurrencySchema as CurrencySchema8, InvoiceReviewStatusSchema as InvoiceReviewStatusSchema2, PeriodSchema as PeriodSchema5, RevenueBreakdownSchema as RevenueBreakdownSchema2 } from "@vy/types";
import { oz as oz163 } from "@vy/utils";
var GetApprovalFlowInvoicesListResponseSchema = oz163.object({
  invoiceId: oz163.string(),
  invoiceName: oz163.string(),
  invoicePeriod: PeriodSchema5,
  invoiceTags: oz163.nativeEnum(APPROVAL_FLOW_INVOICE_TYPES).array(),
  reviewStatus: InvoiceReviewStatusSchema2,
  customerName: oz163.string(),
  currency: CurrencySchema8,
  contractName: oz163.string().optional(),
  revenueBreakdown: RevenueBreakdownSchema2
}).array().openapi("GetApprovalFlowInvoicesListResponseSchema");

// src/api-definition-paths/invoices-paths/get-approval-flow-invoices-list/get-approval-flow-invoices-list-action.ts
var APPROVAL_FLOW_INVOICE_TYPES_QUERY_PARAM = {
  name: "invoiceTypes",
  location: "query",
  schema: ApprovalFlowInvoiceTypesParamSchema
};
var GET_APPROVAL_FLOW_INVOICES_LIST_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-approval-flow-invoices-list"
  },
  queryParams: {
    [APPROVAL_FLOW_INVOICE_TYPES_QUERY_PARAM.name]: APPROVAL_FLOW_INVOICE_TYPES_QUERY_PARAM
  },
  response: {
    name: "GetApprovalFlowInvoicesListResponse",
    schema: GetApprovalFlowInvoicesListResponseSchema
  },
  path: GET_APPROVAL_FLOW_INVOICES_LIST_PATH
};

// src/api-definition-paths/invoices-paths/get-billing-cycle-invoices/billing-cycle-invoice-type-query-parameter.ts
import { oz as oz164 } from "@vy/utils";
var BILLING_CYCLE_INVOICE_TYPES = Object.freeze({
  REGULAR: "regular",
  INSPECTION: "inspection",
  OLD: "old"
});
var BillingCycleInvoiceTypeSchema = oz164.nativeEnum(BILLING_CYCLE_INVOICE_TYPES).openapi("BillingCycleInvoiceType");

// src/api-definition-paths/invoices-paths/get-billing-cycle-invoices/get-billing-cycle-invoices-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS85 } from "@vy/zapi-types";
var GET_BILLING_CYCLE_INVOICES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS85.PRIVATE,
  route: "/invoices/billing-cycle",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/get-billing-cycle-invoices/get-billing-cycle-invoices-response-schema.ts
import { oz as oz166 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/get-billing-cycle-invoices/billing-cycle-invoice-schema.ts
import { CurrencySchema as CurrencySchema9, InvoiceSchema as InvoiceSchema3, PAYMENT_TERMS } from "@vy/types";
import { oz as oz165 } from "@vy/utils";
var BillingCycleInvoiceSchema = InvoiceSchema3.pick({
  id: true,
  name: true,
  revenueBreakdown: true,
  reviewStatus: true,
  billingStatus: true,
  billingCycle: true
}).extend({
  invoiceNumber: oz165.string().min(1),
  ref: oz165.string(),
  previousInvoiceAmount: oz165.number().optional(),
  customerName: oz165.string().min(1),
  customerId: oz165.string().min(1),
  erpDisplayId: oz165.string().optional(),
  overcharges: oz165.number().nonnegative(),
  currency: CurrencySchema9,
  erpId: oz165.string().nullish(),
  customerExternalId: oz165.string().min(1).optional(),
  paymentTerm: oz165.nativeEnum(PAYMENT_TERMS),
  contractName: oz165.string().optional()
}).openapi("BillingCycleInvoice");

// src/api-definition-paths/invoices-paths/get-billing-cycle-invoices/get-billing-cycle-invoices-response-schema.ts
var GetBillingCycleInvoicesResponseSchema = oz166.object({
  invoices: oz166.array(BillingCycleInvoiceSchema)
}).openapi("GetBillingCycleInvoicesResponse");

// src/api-definition-paths/invoices-paths/get-billing-cycle-invoices/get-billing-cycle-invoices-action.ts
var BILLING_CYCLE_INVOICE_TYPE_QUERY_PARAMETER = {
  name: "billingCycleInvoiceType",
  location: "query",
  schema: BillingCycleInvoiceTypeSchema.optional()
};
var GET_BILLING_CYCLE_INVOICES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-billing-cycle-invoices"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [BILLING_CYCLE_INVOICE_TYPE_QUERY_PARAMETER.name]: BILLING_CYCLE_INVOICE_TYPE_QUERY_PARAMETER,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER
  },
  response: {
    name: "GetBillingCycleInvoicesResponse",
    schema: GetBillingCycleInvoicesResponseSchema
  },
  path: GET_BILLING_CYCLE_INVOICES_PATH
};

// src/api-definition-paths/invoices-paths/get-dynamic-invoice/get-dynamic-invoice-data-response-schema.ts
import { oz as oz167 } from "@vy/utils";
var GetDynamicInvoiceDataResponseSchema = oz167.object({
  dynamicInvoiceData: DynamicInvoiceDataSchema
}).openapi("GetDynamicInvoiceDataResponse");

// src/api-definition-paths/invoices-paths/get-dynamic-invoice/get-dynamic-invoice-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS86 } from "@vy/zapi-types";
var GET_DYNAMIC_INVOICE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS86.PRIVATE,
  route: "/invoice/dynamic/{invoiceId}",
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/get-dynamic-invoice/get-dynamic-invoice-action.ts
var GET_DYNAMIC_INVOICE_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-dynamic-invoice"
  },
  response: {
    name: "GetDynamicInvoiceResponse",
    schema: GetDynamicInvoiceDataResponseSchema
  },
  path: GET_DYNAMIC_INVOICE_PATH
};

// src/api-definition-paths/invoices-paths/get-exported-integrations/get-exported-integrations-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS87 } from "@vy/zapi-types";
var GET_EXPORTED_INTEGRATIONS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS87.PRIVATE,
  route: "/invoices/exported-integrations/{invoiceId}",
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: [API_TAGS.INVOICES]
};

// src/api-definition-paths/invoices-paths/get-exported-integrations/get-exported-integrations-response-schema.ts
import { INTEGRATION_TYPES, SYNC_JOB_STATUSES } from "@vy/integrations-types";
import { ApiDateSchema as ApiDateSchema28, SyncJobAttemptSchema } from "@vy/types";
import { oz as oz168 } from "@vy/utils";
var ExportedIntegrationSchema = oz168.object({
  integration: oz168.nativeEnum(INTEGRATION_TYPES),
  integrationExternalId: oz168.string().nullable(),
  entityName: oz168.string().nullish(),
  status: oz168.nativeEnum(SYNC_JOB_STATUSES),
  createdAt: ApiDateSchema28,
  updatedAt: ApiDateSchema28,
  attempts: oz168.array(SyncJobAttemptSchema)
});
var GetExportedIntegrationsResponseSchema = oz168.array(ExportedIntegrationSchema).openapi("GetExportedIntegrationsResponse");

// src/api-definition-paths/invoices-paths/get-exported-integrations/get-exported-integrations-action.ts
var GET_EXPORTED_INTEGRATIONS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-exported-integrations"
  },
  response: {
    name: "GetExportedIntegrationsResponse",
    schema: GetExportedIntegrationsResponseSchema
  },
  path: GET_EXPORTED_INTEGRATIONS_PATH
};

// src/api-definition-paths/invoices-paths/get-invoice/get-invoice-response-schema.ts
import { InvoiceSchema as InvoiceSchema4 } from "@vy/types";
import { oz as oz169 } from "@vy/utils";
var GetInvoiceResponseSchema = oz169.object({
  invoice: InvoiceSchema4
}).openapi("GetInvoiceResponse");

// src/api-definition-paths/invoices-paths/get-invoice/get-invoice-action.ts
var GET_INVOICE_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoice"
  },
  response: {
    name: "GetInvoiceResponse",
    schema: GetInvoiceResponseSchema
  },
  path: INVOICE_ID_PATH
};

// src/api-definition-paths/invoices-paths/get-invoice-by-discriminator/get-invoice-by-discriminator-path.ts
import { oz as oz170 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS88 } from "@vy/zapi-types";
var DISCRIMINATOR_PATH_PARAM = {
  name: "discriminator",
  location: "path",
  schema: DynamicInvoiceIdTypeSchema,
  required: true
};
var DISCRIMINATION_ID_PATH_PARAM = {
  name: "id",
  location: "path",
  schema: oz170.string(),
  required: true
};
var GET_DYNAMIC_INVOICE_BY_DISCRIMINATOR_PATH = {
  accessLevel: PATH_ACCESS_LEVELS88.PRIVATE,
  route: `/invoice/dynamic/{${DISCRIMINATOR_PATH_PARAM.name}}/{${DISCRIMINATION_ID_PATH_PARAM.name}}`,
  pathParams: {
    [DISCRIMINATOR_PATH_PARAM.name]: DISCRIMINATOR_PATH_PARAM,
    [DISCRIMINATION_ID_PATH_PARAM.name]: DISCRIMINATION_ID_PATH_PARAM
  },
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/get-invoice-by-discriminator/get-invoice-by-discriminator-action.ts
var GET_DYNAMIC_INVOICE_BY_DISCRIMINATOR_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-dynamic-invoice-by-discriminator"
  },
  response: {
    name: "GetDynamicInvoiceResponse",
    schema: GetDynamicInvoiceDataResponseSchema
  },
  path: GET_DYNAMIC_INVOICE_BY_DISCRIMINATOR_PATH
};

// src/api-definition-paths/invoices-paths/get-invoice-pdf/get-invoice-pdf-action.ts
import { InvoicePdfTypeSchema } from "@vy/types";

// src/api-definition-paths/invoices-paths/get-invoice-pdf/get-invoice-pdf-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS89 } from "@vy/zapi-types";
var GET_INVOICE_PDF_PATH = {
  accessLevel: PATH_ACCESS_LEVELS89.PRIVATE,
  route: "/invoice/pdf/{invoiceId}",
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/get-invoice-pdf/get-invoice-pdf-response-schema.ts
import { Base64Schema as Base64Schema2, ObjectIdSchema as ObjectIdSchema18 } from "@vy/types";
import { oz as oz171 } from "@vy/utils";
var GetInvoicePdfResponseSchema = oz171.object({
  invoiceId: ObjectIdSchema18,
  encodedPdf: Base64Schema2
}).openapi("GetInvoicePdfResponse");

// src/api-definition-paths/invoices-paths/get-invoice-pdf/get-invoice-pdf-action.ts
var INVOICE_TYPE_QUERY_PARAMETER = {
  name: "type",
  location: "query",
  schema: InvoicePdfTypeSchema.optional(),
  required: false
};
var GET_INVOICE_PDF_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoice-pdf"
  },
  response: {
    name: "GetInvoicePdfResponse",
    schema: GetInvoicePdfResponseSchema
  },
  queryParams: {
    [INVOICE_TYPE_QUERY_PARAMETER.name]: INVOICE_TYPE_QUERY_PARAMETER
  },
  path: GET_INVOICE_PDF_PATH
};

// src/api-definition-paths/invoices-paths/get-invoice-usage-events-report/get-invoice-usage-events-report-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS90 } from "@vy/zapi-types";
var GET_INVOICE_USAGE_EVENTS_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS90.PRIVATE,
  route: "/invoice/{invoiceId}/usage-events-report",
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/get-invoice-usage-events-report/get-invoice-usage-events-report-action.ts
var GET_INVOICE_USAGE_EVENTS_REPORT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoice-usage-events-report"
  },
  path: GET_INVOICE_USAGE_EVENTS_REPORT_PATH
};

// src/api-definition-paths/invoices-paths/get-invoice-products-integration-entities/get-invoice-products-integration-entities-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS91 } from "@vy/zapi-types";
var GET_INVOICE_PRODUCTS_INTEGRATION_ENTITIES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS91.PRIVATE,
  route: "/invoice/{invoiceId}/products-integration-entities",
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: [API_TAGS.INVOICES]
};
var GetInvoiceProductsIntegrationEntitiesPath = typeof GET_INVOICE_PRODUCTS_INTEGRATION_ENTITIES_PATH;

// src/api-definition-paths/invoices-paths/get-invoice-products-integration-entities/get-invoice-products-integration-entities-response-schema.ts
import { oz as oz172 } from "@vy/utils";
import { BaseIntegrationEntitySchema, withNullAsOptional as withNullAsOptional2 } from "@vy/types";
var GetInvoiceProductsIntegrationEntitiesResponseSchema = oz172.object({
  products: oz172.array(
    oz172.object({
      lineItemId: oz172.string(),
      name: oz172.string(),
      integrationEntities: withNullAsOptional2(oz172.array(BaseIntegrationEntitySchema))
    })
  )
}).openapi("GetInvoiceProductsIntegrationEntitiesResponse");

// src/api-definition-paths/invoices-paths/get-invoice-products-integration-entities/get-invoice-products-integration-entities-actions.ts
var GET_INVOICE_PRODUCTS_INTEGRATION_ENTITIES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoice-products-integration-entities"
  },
  response: {
    name: "GetInvoiceProductsIntegrationEntitiesResponse",
    schema: GetInvoiceProductsIntegrationEntitiesResponseSchema
  },
  path: GET_INVOICE_PRODUCTS_INTEGRATION_ENTITIES_PATH
};

// src/api-definition-paths/invoices-paths/get-invoices-ar-health/get-invoices-ar-health-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS92 } from "@vy/zapi-types";
var GET_INVOICES_AR_HEALTH_PATH = {
  accessLevel: PATH_ACCESS_LEVELS92.PRIVATE,
  route: "/invoices/ar-health",
  tags: API_TAGS.INVOICES
};

// src/api-definition-paths/invoices-paths/get-invoices-ar-health/get-invoices-ar-health-response-schema.ts
import { oz as oz173 } from "@vy/utils";
var OverdueBucketDataSchema = oz173.object({
  sum: oz173.number(),
  count: oz173.number()
});
var OverdueBucketRange = /* @__PURE__ */ ((OverdueBucketRange2) => {
  OverdueBucketRange2["0-30"] = "0-30";
  OverdueBucketRange2["30-60"] = "30-60";
  OverdueBucketRange2["60-90"] = "60-90";
  OverdueBucketRange2["90+"] = "90+";
  return OverdueBucketRange2;
})(OverdueBucketRange || {});
var OverdueBucketRangeSchema = oz173.nativeEnum(OverdueBucketRange);
var defaultOverdueBuckets = [
  { range: "0-30" /* 0-30 */, sum: 0, count: 0 },
  { range: "30-60" /* 30-60 */, sum: 0, count: 0 },
  { range: "60-90" /* 60-90 */, sum: 0, count: 0 },
  { range: "90+" /* 90+ */, sum: 0, count: 0 }
];
var OverdueBucketsSchema = oz173.array(
  oz173.object({
    range: OverdueBucketRangeSchema,
    sum: oz173.number(),
    count: oz173.number()
  })
).openapi("OverdueBuckets");
var GetInvoicesArHealthResponseSchema = oz173.object({
  overdueInvoicesSumThan90Days: oz173.number(),
  overdueInvoicesPercentage: oz173.number(),
  overdueBuckets: OverdueBucketsSchema.nullish().default(defaultOverdueBuckets),
  avgDso: oz173.number()
});

// src/api-definition-paths/invoices-paths/get-invoices-ar-health/get-invoices-ar-health-action.ts
var GET_INVOICES_AR_HEALTH_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoices-ar-health"
  },
  response: {
    name: "GetInvoicesArHealthResponse",
    schema: GetInvoicesArHealthResponseSchema
  },
  path: GET_INVOICES_AR_HEALTH_PATH
};

// src/api-definition-paths/invoices-paths/get-invoices-breakdown-stats/get-invoices-breakdown-stats-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS93 } from "@vy/zapi-types";
var GET_INVOICES_BREAKDOWN_STATS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS93.PRIVATE,
  route: "/invoices/breakdown-stats",
  tags: API_TAGS.INVOICES
};

// src/api-definition-paths/invoices-paths/get-invoices-breakdown-stats/get-invoices-breakdown-stats-response-schema.ts
import { oz as oz174 } from "@vy/utils";
var GetInvoicesBreakdownStatsResponseSchema = oz174.object({
  total: oz174.object({
    sum: oz174.number(),
    count: oz174.number()
  }),
  inReview: oz174.object({
    sum: oz174.number(),
    count: oz174.number()
  }),
  inOverage: oz174.object({
    sum: oz174.number(),
    count: oz174.number()
  })
});

// src/api-definition-paths/invoices-paths/get-invoices-breakdown-stats/get-invoices-breakdown-stats-action.ts
import { ApiDateSchema as ApiDateSchema29 } from "@vy/types";
var GET_INVOICES_BREAKDOWN_STATS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoices-breakdown-stats"
  },
  queryParams: {
    startTime: {
      name: "startTime",
      location: "query",
      schema: ApiDateSchema29.optional(),
      required: false
    },
    endTime: {
      name: "endTime",
      location: "query",
      schema: ApiDateSchema29.optional(),
      required: false
    }
  },
  response: {
    name: "GetInvoicesBreakdownStatsResponse",
    schema: GetInvoicesBreakdownStatsResponseSchema
  },
  path: GET_INVOICES_BREAKDOWN_STATS_PATH
};

// src/api-definition-paths/invoices-paths/get-invoices-highlights-statistics/get-invoices-highlights-statistics-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS94 } from "@vy/zapi-types";
var GET_INVOICES_HIGHLIGHTS_STATISTICS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS94.PRIVATE,
  route: "/invoices/highlights-statistics",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/get-invoices-highlights-statistics/get-invoices-highlights-statistics-response-schema.ts
import { oz as oz176 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/get-invoices-highlights-statistics/invoices-highlights-summary-schema.ts
import { oz as oz175 } from "@vy/utils";
var InvoicesHighlightsSummarySchema = oz175.object({
  totalCount: oz175.number(),
  totalAmount: oz175.number(),
  inReview: oz175.object({
    count: oz175.number(),
    amount: oz175.number()
  }),
  overdue: oz175.object({
    count: oz175.number(),
    amount: oz175.number()
  }),
  pendingPayment: oz175.object({
    count: oz175.number(),
    amount: oz175.number()
  })
}).openapi("InvoicesHighlightsSummary");

// src/api-definition-paths/invoices-paths/get-invoices-highlights-statistics/get-invoices-highlights-statistics-response-schema.ts
var GetInvoicesHighlightsStatisticsResponseSchema = oz176.object({
  summary: InvoicesHighlightsSummarySchema
}).openapi("GetInvoicesHighlightsStatisticsResponse");

// src/api-definition-paths/invoices-paths/get-invoices-highlights-statistics/get-invoices-highlights-statistics-action.ts
import { InvoiceDateSchema, InvoiceFilterSchema } from "@vy/types";
import { parseJson as parseJson5, oz as oz177 } from "@vy/utils";
var CUSTOMER_ID_QUERY_PARAMETER2 = {
  name: "customerId",
  location: "query",
  schema: oz177.string().optional(),
  required: false
};
var INVOICE_FILTERS_QUERY_PARAMETER = {
  name: "filters",
  location: "query",
  schema: oz177.string().transform((jsonString) => parseJson5(jsonString)).pipe(InvoiceFilterSchema.array()).optional(),
  required: false
};
var DATE_QUERY_PARAMETER = {
  name: "issuedDates",
  location: "query",
  schema: oz177.string().transform((jsonString) => parseJson5(jsonString)).pipe(InvoiceDateSchema.array()).optional(),
  required: false
};
var GET_INVOICES_HIGHLIGHTS_STATISTICS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoices-highlights-statistics"
  },
  queryParams: {
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [CUSTOMER_ID_QUERY_PARAMETER2.name]: CUSTOMER_ID_QUERY_PARAMETER2,
    [DATE_QUERY_PARAMETER.name]: DATE_QUERY_PARAMETER,
    [INVOICE_FILTERS_QUERY_PARAMETER.name]: INVOICE_FILTERS_QUERY_PARAMETER
  },
  response: {
    name: "GetInvoicesHighlightsStatisticsResponse",
    schema: GetInvoicesHighlightsStatisticsResponseSchema
  },
  path: GET_INVOICES_HIGHLIGHTS_STATISTICS_PATH
};

// src/api-definition-paths/invoices-paths/get-invoices-overviews/get-invoices-overviews-action.ts
import {
  InvoiceBillingStatusesSchema,
  InvoiceDateSchema as InvoiceDateSchema2,
  InvoiceReviewStatusesSchema,
  InvoicesOverviewsAdditionalFiltersSchema
} from "@vy/types";
import { parseJson as parseJson6, oz as oz181 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/get-invoices-overviews/get-invoices-overviews-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS95 } from "@vy/zapi-types";
var GET_INVOICES_OVERVIEWS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS95.PRIVATE,
  route: "/invoices/overviews",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/get-invoices-overviews/get-invoices-overviews-response-schema.ts
import { oz as oz180 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/get-invoices-overviews/invoice-overview-schema.ts
import {
  ApiDateSchema as ApiDateSchema31,
  ContractSchema as ContractSchema8,
  ContractStatusSchema as ContractStatusSchema2,
  CurrencySchema as CurrencySchema10,
  CustomerRelationTypeSchema as CustomerRelationTypeSchema3,
  CustomerSchema as CustomerSchema9,
  IntegrationExportSchema,
  InvoiceSchema as InvoiceSchema5,
  ObjectIdSchema as ObjectIdSchema19,
  PaymentProviderSchema
} from "@vy/types";
import { CustomFieldValueSchema as CustomFieldValueSchema3 } from "@vy/custom-fields-types";
import { oz as oz179 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/get-invoices-overviews/marketplace-sync-status-schema.ts
import { JOB_TASK_STATUSES } from "@vy/jobs-types";
import { ApiDateSchema as ApiDateSchema30 } from "@vy/types";
import { oz as oz178 } from "@vy/utils";
var MarketplaceSyncStatusSchema = oz178.object({
  status: oz178.nativeEnum(JOB_TASK_STATUSES),
  message: oz178.string().optional(),
  updatedAt: ApiDateSchema30.optional(),
  rawResponse: oz178.string().optional()
});

// src/api-definition-paths/invoices-paths/get-invoices-overviews/invoice-overview-schema.ts
var InvoiceOverviewCustomerSchema = CustomerSchema9.extend({
  parentCustomer: oz179.object({
    name: oz179.string(),
    relationType: CustomerRelationTypeSchema3
  }).optional()
});
var InvoiceOverviewContractSchema = ContractSchema8.extend({
  contractName: oz179.string().optional()
}).nullable();
var MarketplaceDimensionUnitsSchema = oz179.object({
  dimension: oz179.string(),
  quantity: oz179.number()
});
var MarketplaceUnitsSchema = oz179.object({
  total: oz179.number(),
  dimensions: oz179.array(MarketplaceDimensionUnitsSchema)
});
var InvoiceOverviewSchema = InvoiceSchema5.pick({
  name: true,
  id: true,
  revenueBreakdown: true,
  billingStatus: true,
  reviewStatus: true,
  billingCycle: true,
  syncStatus: true,
  invoicingDate: true,
  syncStatusUpdatedAt: true,
  stripeSyncStatus: true,
  stripeSyncStatusUpdatedAt: true,
  stripeIntegrationExternalId: true,
  paymentInfo: true,
  dueDate: true,
  invoiceType: true,
  invoiceNumber: true,
  ref: true,
  refundsInvoiceId: true
}).extend({
  id: ObjectIdSchema19,
  customer: InvoiceOverviewCustomerSchema,
  contractId: ObjectIdSchema19.optional(),
  contractName: oz179.string().optional(),
  contractStatus: ContractStatusSchema2.optional(),
  contractEndDate: ApiDateSchema31.optional(),
  isTrial: oz179.boolean().optional(),
  issuedAt: ApiDateSchema31.nullable(),
  currency: CurrencySchema10,
  isStripeSyncMissing: oz179.boolean(),
  paymentProvider: PaymentProviderSchema.optional(),
  wasInvoiceEmailSent: oz179.boolean().optional().default(false),
  lastSentAt: ApiDateSchema31.nullable().optional(),
  integrationExports: IntegrationExportSchema.array().optional(),
  marketplaceSyncStatus: MarketplaceSyncStatusSchema.optional(),
  purchaseOrder: oz179.string().optional(),
  notes: oz179.string().optional(),
  payments: InvoicePaymentSchema.array().optional(),
  marketplaceUnits: MarketplaceUnitsSchema.optional(),
  customFieldValues: oz179.array(CustomFieldValueSchema3).optional()
}).openapi("InvoiceOverview");

// src/api-definition-paths/invoices-paths/get-invoices-overviews/get-invoices-overviews-response-schema.ts
var GetInvoicesOverviewsResponseSchema = oz180.object({
  invoicesOverviews: oz180.array(InvoiceOverviewSchema),
  count: oz180.number()
}).openapi("GetInvoicesOverviewsResponse");

// src/api-definition-paths/invoices-paths/get-invoices-overviews/get-invoices-overviews-action.ts
var CUSTOMER_ID_QUERY_PARAMETER3 = {
  name: "customerId",
  location: "query",
  schema: oz181.string().optional(),
  required: false
};
var DATE_QUERY_PARAMETER2 = {
  name: "dates",
  location: "query",
  schema: oz181.string().transform((s) => parseJson6(s)).pipe(InvoiceDateSchema2.array()).optional(),
  required: false
};
var INVOICES_REVIEWS_STATUSES_QUERY_PARAMETER = {
  name: "reviewStatuses",
  location: "query",
  schema: InvoiceReviewStatusesSchema.optional(),
  required: false
};
var INVOICES_BILLING_STATUSES_QUERY_PARAMETER = {
  name: "billingStatuses",
  location: "query",
  schema: InvoiceBillingStatusesSchema.optional(),
  required: false
};
var ADDITIONAL_FILTERS_PARAMETER = {
  name: "additionalFilters",
  location: "query",
  schema: InvoicesOverviewsAdditionalFiltersSchema,
  required: false
};
var CONTRACT_ID_QUERY_PARAMETER = {
  name: "contractId",
  location: "query",
  schema: oz181.string().optional(),
  required: false
};
var { schema: GetInvoicesOverviewsSortingSchema, param: GET_INVOICES_OVERVIEWS_SORTING_PARAMETER } = getQuerySortingItemParameterSchemas(InvoiceOverviewSchema, "GetInvoicesOverviewsSorting");
var GET_INVOICES_OVERVIEWS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoices-overviews"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [CUSTOMER_ID_QUERY_PARAMETER3.name]: CUSTOMER_ID_QUERY_PARAMETER3,
    [DATE_QUERY_PARAMETER2.name]: DATE_QUERY_PARAMETER2,
    [INVOICES_REVIEWS_STATUSES_QUERY_PARAMETER.name]: INVOICES_REVIEWS_STATUSES_QUERY_PARAMETER,
    [INVOICES_BILLING_STATUSES_QUERY_PARAMETER.name]: INVOICES_BILLING_STATUSES_QUERY_PARAMETER,
    [ADDITIONAL_FILTERS_PARAMETER.name]: ADDITIONAL_FILTERS_PARAMETER,
    [GET_INVOICES_OVERVIEWS_SORTING_PARAMETER.name]: GET_INVOICES_OVERVIEWS_SORTING_PARAMETER,
    [CONTRACT_ID_QUERY_PARAMETER.name]: CONTRACT_ID_QUERY_PARAMETER
  },
  response: {
    name: "GetInvoicesOverviewsResponse",
    schema: GetInvoicesOverviewsResponseSchema
  },
  path: GET_INVOICES_OVERVIEWS_PATH
};

// src/api-definition-paths/invoices-paths/get-invoices-overviews-new/get-invoices-overviews-new-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS96 } from "@vy/zapi-types";
var GET_INVOICES_OVERVIEWS_NEW_PATH = {
  accessLevel: PATH_ACCESS_LEVELS96.PRIVATE,
  route: "/invoices/overviews-new",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/get-invoices-overviews-new/get-invoices-overviews-new-response-schema.ts
import { oz as oz182 } from "@vy/utils";
var GetInvoicesOverviewsNewResponseSchema = oz182.object({
  invoicesOverviews: oz182.array(InvoiceOverviewSchema),
  count: oz182.number(),
  availableCustomFieldNames: oz182.array(oz182.string()).optional()
}).openapi("GetInvoicesOverviewsNewResponse");

// src/api-definition-paths/invoices-paths/get-invoices-overviews-new/get-invoices-overviews-new-action.ts
import { InvoiceDateSchema as InvoiceDateSchema3, InvoiceFilterSchema as InvoiceFilterSchema2 } from "@vy/types";
import { parseJson as parseJson7, oz as oz183 } from "@vy/utils";
var CUSTOMER_ID_QUERY_PARAMETER4 = {
  name: "customerId",
  location: "query",
  schema: oz183.string().optional(),
  required: false
};
var { param: GET_INVOICES_OVERVIEWS_SORTING_PARAMETER2 } = getQuerySortingItemParameterSchemas(InvoiceOverviewSchema, "GetInvoicesOverviewsSorting");
var INVOICE_FILTERS_QUERY_PARAMETER2 = {
  name: "filters",
  location: "query",
  schema: oz183.string().transform((jsonString) => parseJson7(jsonString)).pipe(InvoiceFilterSchema2.array()).optional(),
  required: false
};
var DATE_QUERY_PARAMETER3 = {
  name: "issuedDates",
  location: "query",
  schema: oz183.string().transform((jsonString) => parseJson7(jsonString)).pipe(InvoiceDateSchema3.array()).optional(),
  required: false
};
var GET_INVOICES_OVERVIEWS_NEW_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoices-overviews-new"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [CUSTOMER_ID_QUERY_PARAMETER4.name]: CUSTOMER_ID_QUERY_PARAMETER4,
    [DATE_QUERY_PARAMETER3.name]: DATE_QUERY_PARAMETER3,
    [GET_INVOICES_OVERVIEWS_SORTING_PARAMETER2.name]: GET_INVOICES_OVERVIEWS_SORTING_PARAMETER2,
    [INVOICE_FILTERS_QUERY_PARAMETER2.name]: INVOICE_FILTERS_QUERY_PARAMETER2
  },
  response: {
    name: "GetInvoicesOverviewsNewResponse",
    schema: GetInvoicesOverviewsNewResponseSchema
  },
  path: GET_INVOICES_OVERVIEWS_NEW_PATH
};

// src/api-definition-paths/invoices-paths/get-invoices-statistics/get-invoices-statistics-action.ts
import { oz as oz186 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/get-invoices-statistics/get-invoice-statistics-response-schema.ts
import { oz as oz185 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/get-invoices-statistics/invoices-overviews-summary-schema.ts
import { oz as oz184 } from "@vy/utils";
var InvoicesOverviewsSummarySchema = oz184.object({
  totalAmount: oz184.number(),
  openAmount: oz184.number(),
  overdueAmount: oz184.number(),
  pendingPaymentAmount: oz184.number(),
  paidAmount: oz184.number()
}).openapi("InvoicesOverviewsSummary");

// src/api-definition-paths/invoices-paths/get-invoices-statistics/get-invoice-statistics-response-schema.ts
var GetInvoicesStatisticsResponseSchema = oz185.object({
  summary: InvoicesOverviewsSummarySchema
}).openapi("GetInvoicesStatisticsResponse");

// src/api-definition-paths/invoices-paths/get-invoices-statistics/get-invoices-statistics-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS97 } from "@vy/zapi-types";
var GET_INVOICES_STATISTICS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS97.PRIVATE,
  route: "/invoices/statistics",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/get-invoices-statistics/get-invoices-statistics-action.ts
var CUSTOMER_ID_PATH_PARAM2 = {
  name: "customerId",
  location: "query",
  schema: oz186.string().optional(),
  required: false
};
var GET_INVOICES_STATISTICS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoices-statistics"
  },
  queryParams: {
    [CUSTOMER_ID_PATH_PARAM2.name]: CUSTOMER_ID_PATH_PARAM2
  },
  response: {
    name: "GetInvoicesStatisticsResponse",
    schema: GetInvoicesStatisticsResponseSchema
  },
  path: GET_INVOICES_STATISTICS_PATH
};

// src/api-definition-paths/invoices-paths/get-invoices-summary/get-invoices-summary-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS98 } from "@vy/zapi-types";
var GET_INVOICES_SUMMARY_PATH = {
  accessLevel: PATH_ACCESS_LEVELS98.PRIVATE,
  route: "/invoices/summary",
  tags: API_TAGS.INVOICES
};

// src/api-definition-paths/invoices-paths/get-invoices-summary/get-invoices-summary-action.ts
import { oz as oz188 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/get-invoices-summary/get-invoices-summary-response-schema.ts
import { INVOICE_BILLING_STATUSES } from "@vy/types";
import { oz as oz187 } from "@vy/utils";
var GetInvoicesSummaryResponseSchema = oz187.record(
  oz187.nativeEnum(INVOICE_BILLING_STATUSES),
  oz187.number()
);

// src/api-definition-paths/invoices-paths/get-invoices-summary/get-invoices-summary-action.ts
var GET_INVOICES_SUMMARY_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoices-summary"
  },
  queryParams: {
    ["customerId"]: {
      name: "customerId",
      location: "query",
      schema: oz188.string().optional(),
      required: true
    }
  },
  response: {
    name: "GetInvoicesSummaryResponse",
    schema: GetInvoicesSummaryResponseSchema
  },
  path: GET_INVOICES_SUMMARY_PATH
};

// src/api-definition-paths/invoices-paths/get-light-invoices/get-light-invoices-action.ts
import { parseJson as parseJson8, oz as oz193 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/get-light-invoices/get-light-invoice-response-schema/get-light-invoice-commitment-line-item-schema.ts
import { CommitmentLineItemSchema, PerUnitProductVariantSchema, TiersProductVariantSchema } from "@vy/types";
import { oz as oz189 } from "@vy/utils";
var LightInvoiceCommitmentLineItemSchema = CommitmentLineItemSchema.pick({
  revenueBreakdown: true,
  commitmentTiersUsageMap: true
}).extend({
  productDescription: oz189.string().optional(),
  productTitle: oz189.string(),
  tiersProductVariants: oz189.array(
    TiersProductVariantSchema.pick({
      id: true,
      name: true,
      pricing: true
    })
  ),
  perUnitProductVariants: oz189.array(
    PerUnitProductVariantSchema.pick({
      id: true,
      pricing: true
    }).extend({
      meterName: oz189.string()
    })
  )
});

// src/api-definition-paths/invoices-paths/get-light-invoices/get-light-invoice-response-schema/get-light-invoice-fixed-line-item-schema.ts
import { FixedLineItemSchema, FixedPricingSchema } from "@vy/types";
import { oz as oz190 } from "@vy/utils";
var LightInvoiceFixedLineItemSchema = FixedLineItemSchema.pick({
  id: true,
  revenueBreakdown: true,
  modifiedName: true
}).extend({
  pricing: FixedPricingSchema,
  productName: oz190.string(),
  productId: oz190.string().optional(),
  description: oz190.string().optional()
});

// src/api-definition-paths/invoices-paths/get-light-invoices/get-light-invoice-response-schema/get-light-invoice-usage-line-item-schema.ts
import { PerUnitProductVariantSchema as PerUnitProductVariantSchema2, TiersProductVariantSchema as TiersProductVariantSchema2, UsageLineItemSchema } from "@vy/types";
import { oz as oz191 } from "@vy/utils";
var LightInvoiceUsageLineItemSchema = UsageLineItemSchema.pick({
  revenueBreakdown: true,
  tiersUsageMap: true
}).extend({
  productDescription: oz191.string().optional(),
  productTitle: oz191.string(),
  tiersProductVariants: oz191.array(
    TiersProductVariantSchema2.pick({
      id: true,
      name: true,
      pricing: true
    })
  ),
  perUnitProductVariants: oz191.array(
    PerUnitProductVariantSchema2.pick({
      id: true,
      pricing: true
    }).extend({
      meterName: oz191.string()
    })
  )
});

// src/api-definition-paths/invoices-paths/get-light-invoices/get-light-invoice-response-schema/get-light-invoices-response-schema.ts
import {
  ApiDateSchema as ApiDateSchema32,
  BaseIntegrationEntitySchema as BaseIntegrationEntitySchema2,
  CurrencySchema as CurrencySchema11,
  CustomerRelationSchema,
  CustomerSchema as CustomerSchema10,
  EmailMessageSchema,
  InvoiceBillingStatusSchema as InvoiceBillingStatusSchema3,
  InvoiceCalculationStatusSchema,
  InvoicePaymentProviderInformationSchema,
  InvoiceReviewStatusSchema as InvoiceReviewStatusSchema3,
  PAYMENT_TERMS as PAYMENT_TERMS2,
  PaymentInfoSchema,
  PeriodSchema as PeriodSchema6,
  RevenueBreakdownSchema as RevenueBreakdownSchema3,
  SYNC_STATUSES,
  SyncStatusSchema,
  SystemEventSchema
} from "@vy/types";
import { oz as oz192 } from "@vy/utils";
var LightInvoicesCustomerSchema = CustomerSchema10.extend({
  parentCustomer: CustomerRelationSchema.optional()
});
var GetLightInvoicesResponseSchema = oz192.object({
  invoices: oz192.array(
    oz192.object({
      id: oz192.string(),
      name: oz192.string(),
      customer: LightInvoicesCustomerSchema,
      currency: CurrencySchema11,
      notes: oz192.string().optional(),
      totalCommitment: oz192.number(),
      taxRate: oz192.number().min(0).max(100).nullable(),
      issuedAt: ApiDateSchema32.nullable(),
      emailMessages: EmailMessageSchema.array().optional(),
      contract: oz192.object({
        contractName: oz192.string(),
        contractStartDate: ApiDateSchema32,
        contractId: oz192.string()
      }).optional(),
      invoicingDate: ApiDateSchema32.optional(),
      dueDate: ApiDateSchema32.nullable(),
      isStripeSyncMissing: oz192.boolean(),
      revenueBreakdown: RevenueBreakdownSchema3,
      billingCycle: PeriodSchema6,
      purchaseOrder: oz192.string().optional(),
      syncStatus: SyncStatusSchema.default(SYNC_STATUSES.None),
      fixedLineItems: oz192.array(LightInvoiceFixedLineItemSchema),
      usageLineItems: oz192.array(LightInvoiceUsageLineItemSchema),
      commitmentLineItems: oz192.array(LightInvoiceCommitmentLineItemSchema),
      promotionLineItems: oz192.array(LightInvoiceFixedLineItemSchema),
      paymentInfo: PaymentInfoSchema.optional(),
      paymentDueDays: oz192.number(),
      paymentProviderInformation: InvoicePaymentProviderInformationSchema.optional(),
      paymentTerm: oz192.nativeEnum(PAYMENT_TERMS2),
      reviewStatus: InvoiceReviewStatusSchema3,
      billingStatus: InvoiceBillingStatusSchema3,
      calculationStatus: InvoiceCalculationStatusSchema,
      integrationEntities: oz192.array(BaseIntegrationEntitySchema2),
      invoiceNumber: oz192.string(),
      ref: oz192.string(),
      marketplaceSyncStatus: MarketplaceSyncStatusSchema.optional()
    })
  ),
  invoicesSystemEvents: oz192.array(SystemEventSchema)
}).openapi("GetLightInvoicesResponse");

// src/api-definition-paths/invoices-paths/get-light-invoices/get-light-invoices-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS99 } from "@vy/zapi-types";
var GET_LIGHT_INVOICES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS99.PRIVATE,
  route: "/invoices/light",
  tags: API_TAGS.INVOICES
};

// src/api-definition-paths/invoices-paths/get-light-invoices/get-light-invoices-action.ts
var GET_LIGHT_INVOICES_QUERY_PARAM = {
  name: "invoicesIds",
  location: "query",
  schema: oz193.string().transform((s) => parseJson8(s)).pipe(oz193.string().array()),
  required: true
};
var GET_LIGHT_INVOICES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-light-invoices"
  },
  queryParams: {
    [GET_LIGHT_INVOICES_QUERY_PARAM.name]: GET_LIGHT_INVOICES_QUERY_PARAM
  },
  response: {
    name: "GetLightInvoicesResponse",
    schema: GetLightInvoicesResponseSchema
  },
  path: GET_LIGHT_INVOICES_PATH
};

// src/api-definition-paths/invoices-paths/receive-payment/receive-payment-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS100 } from "@vy/zapi-types";
var RECEIVE_PAYMENT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS100.PRIVATE,
  route: "/invoices/receive-payment",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/receive-payment/receive-payment-request-schema.ts
import { PaymentInfoSchema as PaymentInfoSchema2 } from "@vy/types";
import { oz as oz194 } from "@vy/utils";
var ReceivePaymentRequestSchema = PaymentInfoSchema2.extend({
  invoiceId: oz194.string()
}).openapi("ReceivePaymentRequest");

// src/api-definition-paths/invoices-paths/receive-payment/receive-payment-actions.ts
var RECEIVE_PAYMENT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "receive-payment"
  },
  request: {
    name: "ReceivePaymentRequest",
    schema: ReceivePaymentRequestSchema
  },
  path: RECEIVE_PAYMENT_PATH
};

// src/api-definition-paths/invoices-paths/refund-invoice/refund-invoice-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS101 } from "@vy/zapi-types";
var REFUND_INVOICE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS101.PRIVATE,
  route: "/invoice/refund/{invoiceId}",
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/refund-invoice/refund-invoice-response-schema.ts
import { InvoiceSchema as InvoiceSchema6 } from "@vy/types";
import { oz as oz195 } from "@vy/utils";
var RefundInvoiceResponseSchema = oz195.object({
  invoice: InvoiceSchema6
}).openapi("RefundInvoiceResponse");

// src/api-definition-paths/invoices-paths/refund-invoice/refund-invoice-action.ts
var REFUND_INVOICE_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "refund-invoice"
  },
  response: {
    name: "RefundInvoiceResponse",
    schema: RefundInvoiceResponseSchema
  },
  path: REFUND_INVOICE_PATH
};

// src/api-definition-paths/invoices-paths/share-invoices/share-invoices-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS102 } from "@vy/zapi-types";
var SHARE_INVOICES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS102.PRIVATE,
  route: "/invoices/share",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/share-invoices/share-invoices-request-schema.ts
import { oz as oz196 } from "@vy/utils";
var ShareInvoicesRequestSchema = oz196.array(
  oz196.object({
    emailOverride: oz196.string().email().optional(),
    invoiceId: oz196.string()
  }).openapi("shareInvoicesRequest")
);

// src/api-definition-paths/invoices-paths/share-invoices/share-invoices-action.ts
var SHARE_INVOICES_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "share-invoices"
  },
  request: {
    name: "ShareInvoicesRequest",
    schema: ShareInvoicesRequestSchema
  },
  path: SHARE_INVOICES_PATH
};

// src/api-definition-paths/invoices-paths/update-invoice-additional-details/update-invoice-additional-details-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS103 } from "@vy/zapi-types";
var UPDATE_INVOICES_ADDITIONAL_DETAILS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS103.PRIVATE,
  route: "/invoice/additional-details",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/update-invoice-additional-details/update-invoice-additional-details-request-schema.ts
import { InvoiceSchema as InvoiceSchema7 } from "@vy/types";
import { oz as oz197 } from "@vy/utils";
var UpdateInvoiceAdditionalDetailsRequestSchema = InvoiceSchema7.pick({
  id: true,
  purchaseOrder: true,
  notes: true
}).extend({
  invoiceNumber: oz197.string().optional()
}).openapi("UpdateInvoiceAdditionalDetailsRequest");

// src/api-definition-paths/invoices-paths/update-invoice-additional-details/update-invoice-additional-details-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema20 } from "@vy/types";
import { oz as oz198 } from "@vy/utils";
var updateInvoiceAdditionalDetailsResponseSchema = oz198.object({
  invoiceId: ObjectIdSchema20
}).openapi("UpdateInvoiceAdditionalDetailsResponse");

// src/api-definition-paths/invoices-paths/update-invoice-additional-details/update-invoice-additional-details-action.ts
var UPDATE_INVOICE_ADDITIONAL_DETAILS_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-invoice-additional-details"
  },
  request: {
    name: "UpdateInvoiceAdditionalDetailsRequest",
    schema: UpdateInvoiceAdditionalDetailsRequestSchema
  },
  response: {
    name: "UpdateInvoiceAdditionalDetailsResponse",
    schema: updateInvoiceAdditionalDetailsResponseSchema
  },
  path: UPDATE_INVOICES_ADDITIONAL_DETAILS_PATH
};

// src/api-definition-paths/invoices-paths/update-invoices-additional-details/update-invoices-additional-details-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS104 } from "@vy/zapi-types";
var UPDATE_INVOICES_ADDITIONAL_DETAILS_BULK_PATH = {
  accessLevel: PATH_ACCESS_LEVELS104.PRIVATE,
  route: "/invoices/additional-details",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/update-invoices-additional-details/update-invoices-additional-details-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema21 } from "@vy/types";
import { isNotNullOrUndefined, oz as oz199 } from "@vy/utils";
var UpdateInvoicesAdditionalDetailsRequestSchema = oz199.object({
  invoiceIds: oz199.array(ObjectIdSchema21),
  purchaseOrder: oz199.string().optional(),
  notes: oz199.string().optional()
}).refine((data) => isNotNullOrUndefined(data.purchaseOrder) || isNotNullOrUndefined(data.notes), {
  message: "At least one of purchaseOrder or notes must be provided"
}).openapi("UpdateInvoicesAdditionalDetailsRequest");

// src/api-definition-paths/invoices-paths/update-invoices-additional-details/update-invoices-additional-details-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema22 } from "@vy/types";
import { oz as oz200 } from "@vy/utils";
var updateInvoicesAdditionalDetailsResponseSchema = oz200.object({
  invoiceIds: oz200.array(ObjectIdSchema22)
}).openapi("UpdateInvoicesAdditionalDetailsResponse");

// src/api-definition-paths/invoices-paths/update-invoices-additional-details/update-invoices-additional-details-action.ts
var UPDATE_INVOICES_ADDITIONAL_DETAILS_ACTION = {
  method: "patch",
  codeGenerationSettings: {
    actionText: "update-invoices-additional-details"
  },
  request: {
    name: "UpdateInvoicesAdditionalDetailsRequest",
    schema: UpdateInvoicesAdditionalDetailsRequestSchema
  },
  response: {
    name: "UpdateInvoicesAdditionalDetailsResponse",
    schema: updateInvoicesAdditionalDetailsResponseSchema
  },
  path: UPDATE_INVOICES_ADDITIONAL_DETAILS_BULK_PATH
};

// src/api-definition-paths/invoices-paths/update-invoice-currency/update-invoice-currency-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS105 } from "@vy/zapi-types";
var UPDATE_INVOICE_CURRENCY_PATH = {
  accessLevel: PATH_ACCESS_LEVELS105.PRIVATE,
  route: `/invoice/{invoiceId}/currency`,
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/update-invoice-currency/update-invoice-currency-request-schema.ts
import { CurrencySchema as CurrencySchema12 } from "@vy/types";
import { oz as oz201 } from "@vy/utils";
var UpdateInvoiceCurrencyRequestSchema = oz201.object({
  modifiedCurrency: CurrencySchema12.nullable(),
  modifiedExchangeRate: oz201.number().positive().nullable()
}).openapi("UpdateInvoiceCurrencyRequest");

// src/api-definition-paths/invoices-paths/update-invoice-currency/update-invoice-currency-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema23 } from "@vy/types";
import { oz as oz202 } from "@vy/utils";
var updateInvoiceCurrencyResponseSchema = oz202.object({
  invoiceId: ObjectIdSchema23
}).openapi("UpdateInvoiceCurrencyResponse");

// src/api-definition-paths/invoices-paths/update-invoice-currency/update-invoice-currency-action.ts
var UPDATE_INVOICE_CURRENCY_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-invoice-currency"
  },
  request: {
    name: "UpdateInvoiceCurrencyRequest",
    schema: UpdateInvoiceCurrencyRequestSchema
  },
  response: {
    name: "UpdateInvoiceCurrencyResponse",
    schema: updateInvoiceCurrencyResponseSchema
  },
  path: UPDATE_INVOICE_CURRENCY_PATH
};

// src/api-definition-paths/invoices-paths/update-invoice-issue-date/update-invoice-issue-date-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS106 } from "@vy/zapi-types";
var UPDATE_INVOICE_ISSUE_DATE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS106.PRIVATE,
  route: `/invoice/{invoiceId}/issue-date`,
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/update-invoice-issue-date/update-invoice-issue-date-request-schema.ts
import { InvoiceSchema as InvoiceSchema8 } from "@vy/types";
var UpdateInvoiceIssueDateRequestSchema = InvoiceSchema8.pick({
  issuedAt: true
}).openapi("UpdateInvoiceIssueDateRequest");

// src/api-definition-paths/invoices-paths/update-invoice-issue-date/update-invoice-issue-date-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema24 } from "@vy/types";
import { oz as oz203 } from "@vy/utils";
var updateInvoiceIssueDateResponseSchema = oz203.object({
  invoiceId: ObjectIdSchema24
}).openapi("UpdateInvoiceIssueDateResponse");

// src/api-definition-paths/invoices-paths/update-invoice-issue-date/update-invoice-issue-date-action.ts
var UPDATE_INVOICE_ISSUE_DATE_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-invoice-issue-date"
  },
  request: {
    name: "UpdateInvoiceIssueDateRequest",
    schema: UpdateInvoiceIssueDateRequestSchema
  },
  response: {
    name: "UpdateInvoiceIssueDateResponse",
    schema: updateInvoiceIssueDateResponseSchema
  },
  path: UPDATE_INVOICE_ISSUE_DATE_PATH
};

// src/api-definition-paths/invoices-paths/update-invoices-billing-statuses/update-invoice-billing-status-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema25 } from "@vy/types";
import { oz as oz204 } from "@vy/utils";
var UpdateInvoicesBillingStatusResponseSchema = oz204.object({
  invoicesIds: oz204.array(ObjectIdSchema25)
}).openapi("UpdateInvoicesBillingStatusResponse");

// src/api-definition-paths/invoices-paths/update-invoices-billing-statuses/update-invoices-billing-status-request-schema.ts
import { oz as oz206 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/update-invoices-billing-statuses/invoice-by-billing-status-schema.ts
import { InvoiceBillingStatusSchema as InvoiceBillingStatusSchema4, ObjectIdSchema as ObjectIdSchema26 } from "@vy/types";
import { oz as oz205 } from "@vy/utils";
var invoicesByBillingStatusSchema = oz205.record(InvoiceBillingStatusSchema4, oz205.array(ObjectIdSchema26)).openapi("InvoicesByBillingStatus");

// src/api-definition-paths/invoices-paths/update-invoices-billing-statuses/update-invoices-billing-status-request-schema.ts
var UpdateInvoicesBillingStatusRequestSchema = oz206.object({
  invoicesByNewStatus: invoicesByBillingStatusSchema
}).openapi("UpdateInvoicesBillingStatusRequest");

// src/api-definition-paths/invoices-paths/update-invoices-billing-statuses/update-invoices-billing-statuses-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS107 } from "@vy/zapi-types";
var UPDATE_INVOICES_BILLING_STATUSES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS107.PRIVATE,
  route: "/invoices/billing-statuses",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/update-invoices-billing-statuses/update-invoices-billing-statuses-action.ts
var UPDATE_INVOICES_BILLING_STATUSES_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-invoices-billing-statuses"
  },
  request: {
    name: "UpdateInvoicesBillingStatusesRequest",
    schema: UpdateInvoicesBillingStatusRequestSchema
  },
  response: {
    name: "UpdateInvoicesBillingStatusesResponse",
    schema: UpdateInvoicesBillingStatusResponseSchema
  },
  path: UPDATE_INVOICES_BILLING_STATUSES_PATH
};

// src/api-definition-paths/invoices-paths/update-invoices-review-statuses/update-invoice-review-status-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema27 } from "@vy/types";
import { oz as oz207 } from "@vy/utils";
var UpdateInvoicesReviewStatusResponseSchema = oz207.object({
  invoicesIds: oz207.array(ObjectIdSchema27)
}).openapi("UpdateInvoicesReviewStatusResponse");

// src/api-definition-paths/invoices-paths/update-invoices-review-statuses/update-invoices-review-status-request-schema.ts
import { oz as oz209 } from "@vy/utils";

// src/api-definition-paths/invoices-paths/update-invoices-review-statuses/invoice-by-review-status-schema.ts
import { InvoiceReviewStatusSchema as InvoiceReviewStatusSchema4, ObjectIdSchema as ObjectIdSchema28 } from "@vy/types";
import { oz as oz208 } from "@vy/utils";
var invoicesByReviewStatusSchema = oz208.record(InvoiceReviewStatusSchema4, oz208.array(ObjectIdSchema28)).openapi("InvoicesByReviewStatus");

// src/api-definition-paths/invoices-paths/update-invoices-review-statuses/update-invoices-review-status-request-schema.ts
var UpdateInvoicesReviewStatusRequestSchema = oz209.object({
  invoicesByNewStatus: invoicesByReviewStatusSchema
}).openapi("UpdateInvoicesReviewStatusRequest");

// src/api-definition-paths/invoices-paths/update-invoices-review-statuses/update-invoices-review-statuses-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS108 } from "@vy/zapi-types";
var UPDATE_INVOICES_REVIEW_STATUSES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS108.PRIVATE,
  route: "/invoices/review-statuses",
  tags: API_TAGS.INVOICE
};

// src/api-definition-paths/invoices-paths/update-invoices-review-statuses/update-invoices-review-statuses-action.ts
var UPDATE_INVOICES_REVIEW_STATUSES_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-invoices-review-statuses"
  },
  request: {
    name: "UpdateInvoicesReviewStatusesRequest",
    schema: UpdateInvoicesReviewStatusRequestSchema
  },
  response: {
    name: "UpdateInvoicesReviewStatusesResponse",
    schema: UpdateInvoicesReviewStatusResponseSchema
  },
  path: UPDATE_INVOICES_REVIEW_STATUSES_PATH
};

// src/api-definition-paths/invoices-paths/invoices-actions.ts
var INVOICES_ACTIONS = [
  APPLY_CREDITS_ACTION,
  CREATE_INVOICE_ACTION,
  DELETE_INVOICE_ACTION,
  GET_INVOICE_ACTION,
  REFUND_INVOICE_ACTION,
  GET_APPROVAL_FLOW_INVOICES_LIST_ACTION,
  GET_BILLING_CYCLE_INVOICES_ACTION,
  GET_DYNAMIC_INVOICE_ACTION,
  GET_INVOICES_OVERVIEWS_ACTION,
  GET_INVOICES_OVERVIEWS_NEW_ACTION,
  GET_INVOICES_STATISTICS_ACTION,
  GET_LIGHT_INVOICES_ACTION,
  GET_INVOICE_PDF_ACTION,
  GET_INVOICE_USAGE_EVENTS_REPORT_ACTION,
  UPDATE_INVOICE_ADDITIONAL_DETAILS_ACTION,
  UPDATE_INVOICES_ADDITIONAL_DETAILS_ACTION,
  UPDATE_INVOICE_CURRENCY_ACTION,
  UPDATE_INVOICE_ISSUE_DATE_ACTION,
  UPDATE_INVOICES_BILLING_STATUSES_ACTION,
  UPDATE_INVOICES_REVIEW_STATUSES_ACTION,
  SHARE_INVOICES_ACTION,
  RECEIVE_PAYMENT_ACTION,
  GET_DYNAMIC_INVOICE_BY_DISCRIMINATOR_ACTION,
  GET_INVOICES_SUMMARY_ACTION,
  GET_INVOICE_PRODUCTS_INTEGRATION_ENTITIES_ACTION,
  GET_EXPORTED_INTEGRATIONS_ACTION,
  GET_INVOICES_AR_HEALTH_ACTION,
  GET_INVOICES_BREAKDOWN_STATS_ACTION,
  GET_INVOICES_HIGHLIGHTS_STATISTICS_ACTION
];

// src/api-definition-paths/invoices-paths/invoices-paths.ts
var INVOICES_PATHS = [
  APPLY_CREDITS_PATH,
  INVOICE_PATH,
  DELETE_INVOICE_PATH,
  GET_APPROVAL_FLOW_INVOICES_LIST_PATH,
  REFUND_INVOICE_PATH,
  GET_BILLING_CYCLE_INVOICES_PATH,
  GET_DYNAMIC_INVOICE_PATH,
  GET_INVOICES_OVERVIEWS_PATH,
  GET_INVOICES_OVERVIEWS_NEW_PATH,
  GET_DYNAMIC_INVOICE_BY_DISCRIMINATOR_PATH,
  GET_INVOICES_STATISTICS_PATH,
  GET_INVOICES_HIGHLIGHTS_STATISTICS_PATH,
  GET_LIGHT_INVOICES_PATH,
  GET_INVOICE_PDF_PATH,
  GET_INVOICE_USAGE_EVENTS_REPORT_PATH,
  UPDATE_INVOICES_ADDITIONAL_DETAILS_PATH,
  UPDATE_INVOICES_ADDITIONAL_DETAILS_BULK_PATH,
  UPDATE_INVOICES_BILLING_STATUSES_PATH,
  UPDATE_INVOICES_REVIEW_STATUSES_PATH,
  SHARE_INVOICES_PATH,
  RECEIVE_PAYMENT_PATH,
  GET_INVOICE_PRODUCTS_INTEGRATION_ENTITIES_PATH,
  GET_INVOICES_AR_HEALTH_PATH,
  GET_INVOICES_BREAKDOWN_STATS_PATH
];

// src/api-definition-paths/data-dashboard-paths/get-customer-commitment-usage/get-customer-commitment-usage-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS109 } from "@vy/zapi-types";
var GET_CUSTOMER_COMMITMENT_USAGE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS109.PRIVATE,
  route: "/data-dashboard/customer-commitment-usage",
  tags: API_TAGS.DATA_DASHBOARD
};

// src/api-definition-paths/data-dashboard-paths/get-customer-commitment-usage/get-customer-commitment-usage-response-schema.ts
import { oz as oz210 } from "@vy/utils";
var GetCustomerCommitmentUsageResponseSchema = oz210.object({
  customerCommitmentUsage: oz210.array(
    oz210.object({
      customerName: oz210.string(),
      customerId: oz210.string(),
      commitmentUnits: oz210.number(),
      usageUnits: oz210.number()
    })
  )
});

// src/api-definition-paths/data-dashboard-paths/get-customer-commitment-usage/get-customer-commitment-usage-action.ts
var GET_CUSTOMER_COMMITMENT_USAGE_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customer-commitment-usage"
  },
  response: {
    name: "GetCustomerCommitmentUsageResponse",
    schema: GetCustomerCommitmentUsageResponseSchema
  },
  path: GET_CUSTOMER_COMMITMENT_USAGE_PATH
};

// src/api-definition-paths/data-dashboard-paths/get-daily-events-digested/get-daily-events-digested-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS110 } from "@vy/zapi-types";
var GET_DAILY_EVENTS_DIGESTED_PATH = {
  accessLevel: PATH_ACCESS_LEVELS110.PRIVATE,
  route: "/data-dashboard/daily-events-digested",
  tags: API_TAGS.DATA_DASHBOARD
};

// src/api-definition-paths/data-dashboard-paths/get-daily-events-digested/get-daily-events-digested-response-schema.ts
import { ApiDateSchema as ApiDateSchema33 } from "@vy/types";
import { oz as oz211 } from "@vy/utils";
var GetDailyEventsDigestedResponseSchema = oz211.object({
  dailyEventsDigested: oz211.object({
    date: ApiDateSchema33,
    count: oz211.number()
  }).array()
});

// src/api-definition-paths/data-dashboard-paths/get-daily-events-digested/get-daily-events-digested-action.ts
var GET_DAILY_EVENTS_DIGESTED_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-daily-events-digested"
  },
  response: {
    name: "GetDailyEventsDigestedResponse",
    schema: GetDailyEventsDigestedResponseSchema
  },
  path: GET_DAILY_EVENTS_DIGESTED_PATH
};

// src/api-definition-paths/data-dashboard-paths/get-revenue-by-currency/get-revenue-by-currency-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS111 } from "@vy/zapi-types";
var GET_REVENUE_BY_CURRENCY_PATH = {
  accessLevel: PATH_ACCESS_LEVELS111.PRIVATE,
  route: "/data-dashboard/revenue-by-currency",
  tags: API_TAGS.DATA_DASHBOARD
};

// src/api-definition-paths/data-dashboard-paths/get-revenue-by-currency/get-revenue-by-currency-response-schema.ts
import { CurrencySchema as CurrencySchema13 } from "@vy/types";
import { oz as oz212 } from "@vy/utils";
var GetRevenueByCurrencyResponseSchema = oz212.object({
  amountByCurrency: oz212.record(CurrencySchema13, oz212.number())
}).openapi("GetRevenueByCurrencyResponseSchema");

// src/api-definition-paths/data-dashboard-paths/get-revenue-by-currency/get-revenue-by-currency-action.ts
var GET_REVENUE_BY_CURRENCY_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-revenue-by-currency"
  },
  response: {
    name: "GetRevenueByCurrencyResponse",
    schema: GetRevenueByCurrencyResponseSchema
  },
  path: GET_REVENUE_BY_CURRENCY_PATH
};

// src/api-definition-paths/data-dashboard-paths/get-usage-by-meter/get-usage-by-meter-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS112 } from "@vy/zapi-types";
var GET_USAGE_BY_METER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS112.PRIVATE,
  route: "/data-dashboard/usage-by-meter",
  tags: API_TAGS.DATA_DASHBOARD
};

// src/api-definition-paths/data-dashboard-paths/get-usage-by-meter/get-usage-by-meter-response-schema.ts
import { oz as oz214 } from "@vy/utils";

// src/api-definition-paths/data-dashboard-paths/get-usage-by-meter/usage-by-meter-schema.ts
import { oz as oz213 } from "@vy/utils";
var UsageByMeterSchema = oz213.object({
  usageAmount: oz213.number(),
  meterName: oz213.string(),
  meterId: oz213.string()
}).openapi("UsageByProductSchema");

// src/api-definition-paths/data-dashboard-paths/get-usage-by-meter/get-usage-by-meter-response-schema.ts
var GetUsageByMeterResponseSchema = oz214.object({
  usageByMeter: oz214.array(UsageByMeterSchema)
}).openapi("GetRevenueByCurrencyResponseSchema");

// src/api-definition-paths/data-dashboard-paths/get-usage-by-meter/get-usage-by-meter-action.ts
var GET_USAGE_BY_METER_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-usage-by-meter"
  },
  response: {
    name: "GetUsageByMeterResponse",
    schema: GetUsageByMeterResponseSchema
  },
  path: GET_USAGE_BY_METER_PATH
};

// src/api-definition-paths/data-dashboard-paths/data-dashboard-paths.ts
var DATA_DASHBOARDS_PATHS = [
  GET_USAGE_BY_METER_PATH,
  GET_REVENUE_BY_CURRENCY_PATH,
  GET_DAILY_EVENTS_DIGESTED_PATH,
  GET_CUSTOMER_COMMITMENT_USAGE_PATH
];

// src/api-definition-paths/data-dashboard-paths/data-dashboard-actions.ts
var DATA_DASHBOARDS_ACTIONS = [
  GET_USAGE_BY_METER_ACTION,
  GET_REVENUE_BY_CURRENCY_ACTION,
  GET_DAILY_EVENTS_DIGESTED_ACTION,
  GET_CUSTOMER_COMMITMENT_USAGE_ACTION
];

// src/api-definition-paths/integrations-paths/anrok/anrok-connect/anrok-auth-connect-request-schema.ts
import { oz as oz215 } from "@vy/utils";
var AnrokAuthConnectRequestSchema = oz215.object({
  apiKey: oz215.string().nonempty(),
  defaultExternalProductId: oz215.string().nonempty()
}).openapi("AnrokAuthConnectRequest");

// src/api-definition-paths/integrations-paths/anrok/anrok-connect/anrok-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS113 } from "@vy/zapi-types";
var ANROK_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS113.PRIVATE,
  route: "/integrations/anrok/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/anrok/anrok-connect/anrok-connect-action.ts
var ANROK_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "anrok-connect"
  },
  request: {
    name: "AnrokConnectRequest",
    schema: AnrokAuthConnectRequestSchema
  },
  path: ANROK_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/anrok/anrok-backfill-transactions/anrok-backfill-transactions-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS114 } from "@vy/zapi-types";
var ANROK_BACKFILL_TRANSACTIONS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS114.PRIVATE,
  route: "/integrations/anrok/backfill-transactions",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/anrok/anrok-backfill-transactions/anrok-backfill-transactions-request-schema.ts
import { BACKFILL_QUERY_SCOPE_OPTIONS } from "@vy/types";
import { oz as oz216 } from "@vy/utils";
var AnrokBackfillTransactionsRequestSchema = oz216.object({
  scope: oz216.enum([BACKFILL_QUERY_SCOPE_OPTIONS.ALL, BACKFILL_QUERY_SCOPE_OPTIONS.AUTOMATIC_TAX_ONLY])
}).openapi("AnrokBackfillTransactionsRequest");

// src/api-definition-paths/integrations-paths/anrok/anrok-backfill-transactions/anrok-backfill-transactions-action.ts
var ANROK_BACKFILL_TRANSACTIONS_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "anrok-backfill-transactions"
  },
  request: {
    name: "AnrokBackfillTransactionsRequest",
    schema: AnrokBackfillTransactionsRequestSchema
  },
  path: ANROK_BACKFILL_TRANSACTIONS_PATH
};

// src/api-definition-paths/integrations-paths/aws/s3/connect/s3-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS115 } from "@vy/zapi-types";
var S3_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS115.PRIVATE,
  route: "/integrations/s3/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/aws/s3/connect/s3-connect-request-schema.ts
import { S3AuthDataSchema } from "@vy/types";
var S3ConnectRequestSchema = S3AuthDataSchema.openapi("S3ConnectRequest");

// src/api-definition-paths/integrations-paths/aws/s3/connect/s3-connect-action.ts
var S3_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "s3-connect"
  },
  request: {
    name: "S3ConnectRequest",
    schema: S3ConnectRequestSchema
  },
  path: S3_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/connact/connact-connect/connact-auth-connect-request-schema.ts
import { ConnactAuthDataSchema } from "@vy/connact";
var ConnactAuthConnectRequestSchema = ConnactAuthDataSchema.openapi("ConnactAuthConnectRequest");

// src/api-definition-paths/integrations-paths/connact/connact-connect/connact-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS116 } from "@vy/zapi-types";
var CONNACT_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS116.PRIVATE,
  route: "/integrations/connact/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/connact/connact-connect/connact-connect-action.ts
var CONNACT_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "connact-connect"
  },
  request: {
    name: "ConnactConnectRequest",
    schema: ConnactAuthConnectRequestSchema
  },
  path: CONNACT_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/disconnect-integration/disconnect-integration-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS117 } from "@vy/zapi-types";

// src/api-definition-paths/integrations-paths/disconnect-integration/disconnect-integration-path-params.ts
import { oz as oz217 } from "@vy/utils";
var INTEGRATION_ID_PATH_PARAM = {
  name: "integrationId",
  location: "path",
  schema: oz217.string(),
  required: true
};
var INTEGRATION_ID_PATH_PARAMS = {
  [INTEGRATION_ID_PATH_PARAM.name]: INTEGRATION_ID_PATH_PARAM
};

// src/api-definition-paths/integrations-paths/disconnect-integration/disconnect-integration-path.ts
var DISCONNECT_INTEGRATION_PATH = {
  accessLevel: PATH_ACCESS_LEVELS117.PRIVATE,
  route: "/integrations/{integrationId}/disconnect",
  tags: API_TAGS.INTEGRATIONS,
  pathParams: INTEGRATION_ID_PATH_PARAMS
};

// src/api-definition-paths/integrations-paths/disconnect-integration/disconnect-integration-action.ts
var DISCONNECT_INTEGRATION_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "disconnect-integration"
  },
  path: DISCONNECT_INTEGRATION_PATH
};

// src/api-definition-paths/integrations-paths/get-connected-integrations/get-connected-integrations-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS118 } from "@vy/zapi-types";
var GET_CONNECTED_INTEGRATIONS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS118.PRIVATE,
  route: "/integrations/connected",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/get-connected-integrations/get-connected-integrations-response-schema.ts
import { ConnectedIntegrationsSchema } from "@vy/types";
var GetConnectedIntegrationsResponseSchema = ConnectedIntegrationsSchema.openapi(
  "getConnectedIntegrationsResponseSchema"
);

// src/api-definition-paths/integrations-paths/get-connected-integrations/get-connected-integrations-action.ts
var GET_CONNECTED_INTEGRATIONS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-connected-integrations"
  },
  response: {
    name: "GetConnectedIntegrationsResponse",
    schema: GetConnectedIntegrationsResponseSchema
  },
  path: GET_CONNECTED_INTEGRATIONS_PATH
};

// src/api-definition-paths/integrations-paths/get-external-link/get-external-link-action.ts
import { oz as oz219 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/get-external-link/get-external-link-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS119 } from "@vy/zapi-types";
var GET_EXTERNAL_LINK_PATH = {
  accessLevel: PATH_ACCESS_LEVELS119.PRIVATE,
  route: "/integrations/external-link",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/get-external-link/get-external-link-response-schema.ts
import { oz as oz218 } from "@vy/utils";
var GetExternalLinkResponseSchema = oz218.object({
  url: oz218.string().describe("The URL to the external integration record")
}).openapi("GetExternalLinkResponse");

// src/api-definition-paths/integrations-paths/get-external-link/get-external-link-action.ts
var PROVIDER_PARAM = {
  name: "linkProvider",
  location: "query",
  schema: oz219.enum(["Hubspot", "Salesforce"]).openapi("ExternalLinkProvider"),
  required: true
};
var ENTITY_TYPE_PARAM = {
  name: "entityType",
  location: "query",
  schema: oz219.enum(["contract", "customer"]).openapi("ExternalLinkEntityType"),
  required: true
};
var ENTITY_ID_PARAM = {
  name: "entityId",
  location: "query",
  schema: oz219.string(),
  required: true
};
var GET_EXTERNAL_LINK_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-external-link"
  },
  queryParams: {
    [PROVIDER_PARAM.name]: PROVIDER_PARAM,
    [ENTITY_TYPE_PARAM.name]: ENTITY_TYPE_PARAM,
    [ENTITY_ID_PARAM.name]: ENTITY_ID_PARAM
  },
  response: {
    name: "GetExternalLinkResponse",
    schema: GetExternalLinkResponseSchema
  },
  path: GET_EXTERNAL_LINK_PATH
};

// src/api-definition-paths/integrations-paths/get-invoice-products/get-invoice-products-integrations-response-schema.ts
import { oz as oz221 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/get-invoice-products/product-integration-schema.ts
import { oz as oz220 } from "@vy/utils";
var ProductIntegrationSchema = oz220.object({
  id: oz220.string(),
  name: oz220.string(),
  externalId: oz220.string().optional(),
  externalName: oz220.string().optional()
});

// src/api-definition-paths/integrations-paths/get-invoice-products/get-invoice-products-integrations-response-schema.ts
var GetInvoiceProductsIntegrationsResponseSchema = oz221.object({
  products: oz221.array(ProductIntegrationSchema)
}).openapi("GetInvoiceProductsIntegrationsResponse");

// src/api-definition-paths/integrations-paths/get-invoice-products/get-invoice-products-integrations-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS120 } from "@vy/zapi-types";
var GET_INVOICE_PRODUCTS_INTEGRATIONS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS120.PRIVATE,
  route: "/integrations/invoice/{invoiceId}/products",
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: [API_TAGS.INTEGRATIONS]
};

// src/api-definition-paths/integrations-paths/get-invoice-products/get-invoice-products-integrations-action.ts
import { oz as oz222, omitKey } from "@vy/utils";
import { INTEGRATION_TYPES_V3 } from "@vy/integrations-types";
var QUERYABLE_INTEGRATION_TYPES_V3 = Object.freeze(
  omitKey(INTEGRATION_TYPES_V3, "CONNACT")
);
var QueryableIntegrationTypesV3Schema = oz222.nativeEnum(QUERYABLE_INTEGRATION_TYPES_V3);
var INTEGRATION_QUERY_PARAM = {
  name: "integration",
  location: "query",
  schema: QueryableIntegrationTypesV3Schema,
  required: true
};
var GET_INVOICE_PRODUCTS_INTEGRATIONS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-invoice-products-integrations"
  },
  queryParams: {
    [INTEGRATION_QUERY_PARAM.name]: INTEGRATION_QUERY_PARAM
  },
  response: {
    name: "GetInvoiceProductsIntegrationsResponse",
    schema: GetInvoiceProductsIntegrationsResponseSchema
  },
  path: GET_INVOICE_PRODUCTS_INTEGRATIONS_PATH
};

// src/api-definition-paths/integrations-paths/get-settings/get-settings-action.ts
import { IntegrationProvidersSchema } from "@vy/types";

// src/api-definition-paths/integrations-paths/get-settings/get-settings-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS121 } from "@vy/zapi-types";
var GET_INTEGRATION_SETTINGS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS121.PRIVATE,
  route: "/integrations/settings",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/get-settings/get-settings-response-schema.ts
import { VersionedIntegrationSettingsSchema } from "@vy/types";
import { oz as oz223 } from "@vy/utils";
var GetIntegrationSettingsResponseSchema = oz223.object({
  integrationId: oz223.string(),
  integrationSettings: VersionedIntegrationSettingsSchema
}).openapi("GetIntegrationSettingsResponse");

// src/api-definition-paths/integrations-paths/get-settings/get-settings-action.ts
var GET_INTEGRATION_SETTINGS_QUERY_PARAMETER = {
  name: "provider",
  location: "query",
  schema: IntegrationProvidersSchema,
  required: true
};
var GET_INTEGRATION_SETTINGS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-integrations-settings"
  },
  queryParams: {
    [GET_INTEGRATION_SETTINGS_QUERY_PARAMETER.name]: GET_INTEGRATION_SETTINGS_QUERY_PARAMETER
  },
  response: {
    name: "GetIntegrationsSettingsResponse",
    schema: GetIntegrationSettingsResponseSchema
  },
  path: GET_INTEGRATION_SETTINGS_PATH
};

// src/api-definition-paths/integrations-paths/hubspot/auth-callback/hubspot-auth-callback-action.ts
import { oz as oz224 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/hubspot/auth-callback/hubspot-auth-callback-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS122 } from "@vy/zapi-types";
var HUBSPOT_AUTH_CALLBACK_PATH = {
  accessLevel: PATH_ACCESS_LEVELS122.PUBLIC,
  route: "/integrations/hubspot/auth/callback",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/hubspot/auth-callback/hubspot-auth-callback-action.ts
var HUBSPOT_AUTH_CALLBACK_CODE_QUERY_PARAMETER = {
  name: "code",
  location: "query",
  schema: oz224.string()
};
var HUBSPOT_AUTH_CALLBACK_STATE_QUERY_PARAMETER = {
  name: "state",
  location: "query",
  schema: oz224.string()
};
var HUBSPOT_AUTH_CALLBACK_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "hubspot-auth-callback"
  },
  queryParams: {
    [HUBSPOT_AUTH_CALLBACK_CODE_QUERY_PARAMETER.name]: HUBSPOT_AUTH_CALLBACK_CODE_QUERY_PARAMETER,
    [HUBSPOT_AUTH_CALLBACK_STATE_QUERY_PARAMETER.name]: HUBSPOT_AUTH_CALLBACK_STATE_QUERY_PARAMETER
  },
  path: HUBSPOT_AUTH_CALLBACK_PATH
};

// src/api-definition-paths/integrations-paths/hubspot/auth-connect/hubspot-auth-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS123 } from "@vy/zapi-types";
var HUBSPOT_AUTH_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS123.PRIVATE,
  route: "/integrations/hubspot/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/hubspot/auth-connect/hubspot-auth-connect-response-schema.ts
import { oz as oz225 } from "@vy/utils";
var HubspotAuthConnectRedirectResponseSchema = oz225.object({
  redirectUrl: oz225.string()
});

// src/api-definition-paths/integrations-paths/hubspot/auth-connect/hubspot-auth-connect-action.ts
var HUBSPOT_AUTH_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "hubspot-auth-connect"
  },
  response: {
    name: "HubspotAuthConnectResponse",
    schema: HubspotAuthConnectRedirectResponseSchema
  },
  path: HUBSPOT_AUTH_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/hubspot/sync-customers/hubspot-sync-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS124 } from "@vy/zapi-types";
var HUBSPOT_SYNC_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS124.PRIVATE,
  route: "/integrations/hubspot/sync-customers",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/hubspot/sync-customers/hubspot-sync-customers-action.ts
var HUBSPOT_SYNC_CUSTOMERS_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "hubspot-sync-customers"
  },
  path: HUBSPOT_SYNC_CUSTOMERS_PATH
};

// src/api-definition-paths/integrations-paths/modify-external-product/modify-external-product-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS128 } from "@vy/zapi-types";

// src/api-definition-paths/product-paths/get-product-usage-chart-data/get-product-usage-chart-data-path.ts
import { oz as oz226 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS125 } from "@vy/zapi-types";
var PRODUCT_ID_PATH_PARAM = {
  name: "productId",
  location: "path",
  schema: oz226.string(),
  required: true
};
var PRODUCT_ID_PATH_PARAMS = {
  [PRODUCT_ID_PATH_PARAM.name]: PRODUCT_ID_PATH_PARAM
};
var GET_PRODUCT_USAGE_CHART_DATA_PATH = {
  accessLevel: PATH_ACCESS_LEVELS125.PRIVATE,
  route: "/product/{productId}/usage-chart-data",
  pathParams: PRODUCT_ID_PATH_PARAMS,
  tags: API_TAGS.PRODUCTS
};

// src/api-definition-paths/product-paths/get-product-usage-chart-data/get-product-usage-chart-data-response.ts
import { oz as oz227 } from "@vy/utils";
var GetProductUsageChartDataResponseSchema = oz227.object({
  usageData: DynamicInvoiceMeasurementChartMeterSchema
}).openapi("GetProductUsageChartDataResponse");

// src/api-definition-paths/product-paths/get-product-usage-chart-data/get-product-usage-chart-data-action.ts
var GET_PRODUCT_USAGE_CHART_DATA_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-product-usage-chart-data"
  },
  response: {
    name: "GetProductUsageChartDataResponse",
    schema: GetProductUsageChartDataResponseSchema
  },
  path: GET_PRODUCT_USAGE_CHART_DATA_PATH
};

// src/api-definition-paths/product-paths/get-product-usage-by-date-breakdown/get-product-usage-by-date-breakdown-response.ts
import { oz as oz228 } from "@vy/utils";
import { UsageByDateBreakdownSchema } from "@vy/types";
var GetProductUsageByDateBreakdownResponseSchema = oz228.object({
  usageByDateBreakdown: UsageByDateBreakdownSchema.array()
}).openapi("GetProductUsageByDateBreakdownResponse");

// src/api-definition-paths/product-paths/get-product-usage-by-date-breakdown/get-product-usage-by-date-breakdown-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS126 } from "@vy/zapi-types";
import { oz as oz229 } from "@vy/utils";
var VARIANT_ID_PATH_PARAM = {
  name: "variantId",
  location: "path",
  schema: oz229.string(),
  required: true
};
var VARIANT_ID_PATH_PARAMS = {
  [VARIANT_ID_PATH_PARAM.name]: VARIANT_ID_PATH_PARAM
};
var GET_PRODUCT_USAGE_BY_DATE_BREAKDOWN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS126.PRIVATE,
  route: "/product/variant/{variantId}/usage-by-date-breakdown",
  pathParams: VARIANT_ID_PATH_PARAMS,
  tags: API_TAGS.PRODUCTS
};

// src/api-definition-paths/product-paths/get-product-usage-by-date-breakdown/get-product-usage-by-date-breakdown-action.ts
var GET_PRODUCT_USAGE_BY_DATE_BREAKDOWN_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-product-usage-by-date-breakdown"
  },
  response: {
    name: "GetProductUsageByDateBreakdownResponse",
    schema: GetProductUsageByDateBreakdownResponseSchema
  },
  path: GET_PRODUCT_USAGE_BY_DATE_BREAKDOWN_PATH
};

// src/api-definition-paths/product-paths/update-product-integration-entities/update-product-integration-entities-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS127 } from "@vy/zapi-types";
var UPDATE_PRODUCT_INTEGRATION_ENTITIES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS127.PRIVATE,
  route: "/product/{productId}/integration-entities",
  pathParams: PRODUCT_ID_PATH_PARAMS,
  tags: [API_TAGS.PRODUCTS]
};

// src/api-definition-paths/product-paths/update-product-integration-entities/update-product-integration-entities-request-schema.ts
import { ProductIntegrationEntitySchema as ProductIntegrationEntitySchema2 } from "@vy/types";
import { oz as oz230 } from "@vy/utils";
var UpdateProductIntegrationEntitiesRequestSchema = oz230.object({
  integrationEntities: oz230.array(ProductIntegrationEntitySchema2)
}).openapi("UpdateProductIntegrationEntitiesRequest");

// src/api-definition-paths/product-paths/update-product-integration-entities/update-product-integration-entities-response-schema.ts
import { ProductIntegrationEntitySchema as ProductIntegrationEntitySchema3 } from "@vy/types";
import { oz as oz231 } from "@vy/utils";
var UpdateProductIntegrationEntitiesResponseSchema = oz231.object({
  product: oz231.object({
    id: oz231.string(),
    name: oz231.string(),
    integrationEntities: oz231.array(ProductIntegrationEntitySchema3)
  })
}).openapi("UpdateProductIntegrationEntitiesResponse");

// src/api-definition-paths/product-paths/update-product-integration-entities/update-product-integration-entities-action.ts
var UPDATE_PRODUCT_INTEGRATION_ENTITIES_ACTION = {
  method: "put",
  request: {
    name: "UpdateProductIntegrationEntitiesRequest",
    schema: UpdateProductIntegrationEntitiesRequestSchema
  },
  codeGenerationSettings: {
    actionText: "update-product-integration-entities"
  },
  response: {
    name: "UpdateProductIntegrationEntitiesResponse",
    schema: UpdateProductIntegrationEntitiesResponseSchema
  },
  path: UPDATE_PRODUCT_INTEGRATION_ENTITIES_PATH
};

// src/api-definition-paths/product-paths/product-actions.ts
var PRODUCTS_ACTIONS = [
  GET_PRODUCT_USAGE_CHART_DATA_ACTION,
  GET_PRODUCT_USAGE_BY_DATE_BREAKDOWN_ACTION,
  UPDATE_PRODUCT_INTEGRATION_ENTITIES_ACTION
];

// src/api-definition-paths/product-paths/product-paths.ts
var PRODUCT_PATHS = [GET_PRODUCT_USAGE_CHART_DATA_PATH, GET_PRODUCT_USAGE_BY_DATE_BREAKDOWN_PATH];

// src/api-definition-paths/integrations-paths/modify-external-product/modify-external-product-path.ts
var MODIFY_EXTERNAL_PRODUCT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS128.PRIVATE,
  route: "/integrations/product/{productId}/external-integration",
  tags: API_TAGS.INTEGRATIONS,
  pathParams: PRODUCT_ID_PATH_PARAMS
};

// src/api-definition-paths/integrations-paths/modify-external-product/modify-external-product-query-params.ts
import { IntegrationTypesV3Schema } from "@vy/integrations-types";
import { oz as oz232 } from "@vy/utils";
var INTEGRATION_QUERY_PARAMETER = {
  name: "integration",
  location: "query",
  schema: IntegrationTypesV3Schema,
  required: true
};
var EXTERNAL_ID_QUERY_PARAMETER = {
  name: "externalId",
  location: "query",
  schema: oz232.string().optional(),
  required: false
};
var MODIFY_EXTERNAL_PRODUCT_QUERY_PARAMS = {
  [INTEGRATION_QUERY_PARAMETER.name]: INTEGRATION_QUERY_PARAMETER,
  [EXTERNAL_ID_QUERY_PARAMETER.name]: EXTERNAL_ID_QUERY_PARAMETER
};

// src/api-definition-paths/integrations-paths/modify-external-product/modify-external-product-action.ts
var MODIFY_EXTERNAL_PRODUCT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "modify-external-product"
  },
  path: MODIFY_EXTERNAL_PRODUCT_PATH,
  queryParams: MODIFY_EXTERNAL_PRODUCT_QUERY_PARAMS
};

// src/api-definition-paths/integrations-paths/morning/morning-connect/morning-auth-connect-request-schema.ts
import { oz as oz233 } from "@vy/utils";
var MorningAuthConnectRequestSchema = oz233.object({
  apiKey: oz233.string().min(1, "API key is required"),
  secretId: oz233.string().min(1, "Secret ID is required")
}).openapi("MorningAuthConnectRequest");

// src/api-definition-paths/integrations-paths/morning/morning-connect/morning-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS129 } from "@vy/zapi-types";
var MORNING_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS129.PRIVATE,
  route: "/integrations/morning/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/morning/morning-connect/morning-connect-action.ts
var MORNING_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "morning-connect"
  },
  request: {
    name: "MorningConnectRequest",
    schema: MorningAuthConnectRequestSchema
  },
  path: MORNING_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/morning/morning-get-customers/morning-get-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS130 } from "@vy/zapi-types";
var MORNING_GET_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS130.PRIVATE,
  route: "/integrations/morning/get-customers",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/morning/morning-get-customers/morning-get-customers-response-schema.ts
import { oz as oz234 } from "@vy/utils";
var MorningCustomerPayloadSchema = oz234.object({
  id: oz234.string(),
  name: oz234.string()
});
var MorningGetCustomersResponseSchema = oz234.object({
  customers: oz234.array(MorningCustomerPayloadSchema)
}).openapi("MorningGetCustomersResponse");

// src/api-definition-paths/integrations-paths/morning/morning-get-customers/morning-get-customers-action.ts
var MORNING_GET_CUSTOMERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "morning-get-customers"
  },
  queryParams: {
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER
  },
  response: {
    name: "MorningGetCustomersResponse",
    schema: MorningGetCustomersResponseSchema
  },
  path: MORNING_GET_CUSTOMERS_PATH
};

// src/api-definition-paths/integrations-paths/morning/export-invoices/morning-export-invoices-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS131 } from "@vy/zapi-types";
var MORNING_EXPORT_INVOICES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS131.PRIVATE,
  route: "/integrations/morning/export-invoices",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/morning/export-invoices/morning-export-invoices-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema29 } from "@vy/types";
import { oz as oz235 } from "@vy/utils";
var MorningExportInvoicesRequestSchema = oz235.object({
  invoiceIds: oz235.array(ObjectIdSchema29)
}).openapi("morningExportInvoicesRequest");

// src/api-definition-paths/integrations-paths/morning/export-invoices/morning-export-invoices-action.ts
var MORNING_EXPORT_INVOICES_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "morning-export-invoices"
  },
  request: {
    name: "MorningExportInvoicesRequest",
    schema: MorningExportInvoicesRequestSchema
  },
  path: MORNING_EXPORT_INVOICES_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/connect/net-suite-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS132 } from "@vy/zapi-types";
var NET_SUITE_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS132.PRIVATE,
  route: "/integrations/net-suite/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/connect/net-suite-connect-request-schema.ts
import { NetSuiteRestAuthDataSchema } from "@vy/types";
var NetSuiteConnectRequestSchema = NetSuiteRestAuthDataSchema.openapi("netSuiteConnectRequest");

// src/api-definition-paths/integrations-paths/net-suite/connect/net-suite-connect-action.ts
var NET_SUITE_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "net-suite-connect"
  },
  request: {
    name: "NetSuiteConnectRequest",
    schema: NetSuiteConnectRequestSchema
  },
  path: NET_SUITE_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/export-sales-order/net-suite-export-sales-order-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS133 } from "@vy/zapi-types";
var NET_SUITE_EXPORT_SALES_ORDER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS133.PRIVATE,
  route: "/integrations/net-suite/export-sales-order",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/export-sales-order/net-suite-export-sales-order-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema30 } from "@vy/types";
import { oz as oz236 } from "@vy/utils";
var NetSuiteExportSalesOrderRequestSchema = oz236.object({
  contractId: ObjectIdSchema30,
  productsIds: oz236.array(ObjectIdSchema30),
  subsidiaryId: oz236.string(),
  memo: oz236.string().optional()
}).openapi("netSuiteExportSalesOrderRequest");

// src/api-definition-paths/integrations-paths/net-suite/export-sales-order/net-suite-export-sales-order-action.ts
var EXPORT_NET_SUITE_SALES_ORDER_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "export-net-suite-sales-order"
  },
  request: {
    name: "NetSuiteExportSalesOrderRequest",
    schema: NetSuiteExportSalesOrderRequestSchema
  },
  path: NET_SUITE_EXPORT_SALES_ORDER_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/get-customer/net-suite-get-customer-action.ts
import { oz as oz237 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/net-suite/get-customer/net-suite-get-customer-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS134 } from "@vy/zapi-types";
var NET_SUITE_GET_CUSTOMER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS134.PRIVATE,
  route: "/integrations/net-suite/customer",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/get-customer/net-suite-get-customer-response-schema.ts
import { NetSuiteCustomerSchema } from "@vy/types";
var NetSuiteGetCustomerResponseSchema = NetSuiteCustomerSchema.nullable().openapi(
  "NetSuiteGetCustomerResponse"
);

// src/api-definition-paths/integrations-paths/net-suite/get-customer/net-suite-get-customer-action.ts
var CUSTOMER_ID_QUERY_PARAM2 = {
  name: "customerId",
  location: "query",
  schema: oz237.string(),
  required: true
};
var NET_SUITE_GET_CUSTOMER_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "net-suite-get-customer"
  },
  queryParams: {
    [CUSTOMER_ID_QUERY_PARAM2.name]: CUSTOMER_ID_QUERY_PARAM2
  },
  response: {
    name: "NetSuiteGetCustomerResponse",
    schema: NetSuiteGetCustomerResponseSchema
  },
  path: NET_SUITE_GET_CUSTOMER_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/get-customers/net-suite-get-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS135 } from "@vy/zapi-types";
var NET_SUITE_GET_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS135.PRIVATE,
  route: "/integrations/net-suite/customers",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/get-customers/net-suite-get-customers-response-schema.ts
import { NetSuiteCustomerSchema as NetSuiteCustomerSchema2 } from "@vy/types";
import { oz as oz238 } from "@vy/utils";
var NetSuiteGetCustomersResponseSchema = oz238.object({
  customers: oz238.array(NetSuiteCustomerSchema2)
}).openapi("NetSuiteGetCustomersResponse");

// src/api-definition-paths/integrations-paths/net-suite/get-customers/net-suite-get-customers-action.ts
var NET_SUITE_GET_CUSTOMERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "net-suite-get-customers"
  },
  queryParams: {
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER
  },
  response: {
    name: "NetSuiteGetCustomersResponse",
    schema: NetSuiteGetCustomersResponseSchema
  },
  path: NET_SUITE_GET_CUSTOMERS_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/get-deposit-to-accounts/net-suite-get-deposit-to-accounts-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS136 } from "@vy/zapi-types";
var NET_SUITE_GET_DEPOSIT_TO_ACCOUNTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS136.PRIVATE,
  route: "/integrations/net-suite/deposit-to-accounts",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/get-deposit-to-accounts/net-suite-get-deposit-to-accounts-response-schema.ts
import { oz as oz239 } from "@vy/utils";
var NetSuiteDepositToAccountSchema = oz239.object({
  id: oz239.string(),
  name: oz239.string()
});
var NetSuiteGetDepositToAccountsResponseSchema = oz239.object({
  depositToAccounts: oz239.array(NetSuiteDepositToAccountSchema)
}).openapi("NetSuiteGetDepositToAccountsResponse");

// src/api-definition-paths/integrations-paths/net-suite/get-deposit-to-accounts/net-suite-get-deposit-to-accounts-action.ts
var NET_SUITE_GET_DEPOSIT_TO_ACCOUNTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "net-suite-get-deposit-to-accounts"
  },
  response: {
    name: "NetSuiteGetDepositToAccountsResponse",
    schema: NetSuiteGetDepositToAccountsResponseSchema
  },
  path: NET_SUITE_GET_DEPOSIT_TO_ACCOUNTS_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/get-invoice-dashboard-url/net-suite-get-invoice-dashboard-url-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS137 } from "@vy/zapi-types";
var NET_SUITE_GET_INVOICE_DASHBOARD_URL_PATH = {
  accessLevel: PATH_ACCESS_LEVELS137.PRIVATE,
  route: "/integrations/net-suite/invoice-dashboard-url",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/get-invoice-dashboard-url/net-suite-get-invoice-dashboard-url-action.ts
import { oz as oz241 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/net-suite/get-invoice-dashboard-url/net-suite-get-invoice-dashboard-url-response-schema.ts
import { oz as oz240 } from "@vy/utils";
var NetSuiteGetInvoiceDashboardUrlResponseSchema = oz240.object({
  url: oz240.string().describe("The URL to the NetSuite invoice dashboard")
}).openapi("NetSuiteGetInvoiceDashboardUrlResponse");

// src/api-definition-paths/integrations-paths/net-suite/get-invoice-dashboard-url/net-suite-get-invoice-dashboard-url-action.ts
var VAYU_INVOICE_ID = {
  name: "vayuInvoiceId",
  location: "query",
  schema: oz241.string(),
  required: true
};
var NET_SUITE_GET_INVOICE_DASHBOARD_URL_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "net-suite-get-invoice-dashboard-url"
  },
  queryParams: {
    [VAYU_INVOICE_ID.name]: VAYU_INVOICE_ID
  },
  response: {
    name: "NetSuiteGetInvoiceDashboardUrlResponse",
    schema: NetSuiteGetInvoiceDashboardUrlResponseSchema
  },
  path: NET_SUITE_GET_INVOICE_DASHBOARD_URL_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/get-products/net-suite-get-products-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS138 } from "@vy/zapi-types";
var NET_SUITE_GET_PRODUCTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS138.PRIVATE,
  route: "/integrations/net-suite/products",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/get-products/net-suite-get-products-response-schema.ts
import { NetSuiteProductSchema } from "@vy/types";
import { oz as oz242 } from "@vy/utils";
var NetSuiteGetProductsResponseSchema = oz242.object({
  products: oz242.array(NetSuiteProductSchema)
}).openapi("NetSuiteGetProductsResponse");

// src/api-definition-paths/integrations-paths/net-suite/get-products/net-suite-get-products-action.ts
import { oz as oz243 } from "@vy/utils";
var CUSTOMER_ID_QUERY_PARAM3 = {
  name: "customerId",
  location: "query",
  schema: oz243.string().optional(),
  required: false
};
var NET_SUITE_GET_PRODUCTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "net-suite-get-products"
  },
  queryParams: {
    [CUSTOMER_ID_QUERY_PARAM3.name]: CUSTOMER_ID_QUERY_PARAM3
  },
  response: {
    name: "NetSuiteGetProductsResponse",
    schema: NetSuiteGetProductsResponseSchema
  },
  path: NET_SUITE_GET_PRODUCTS_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/sync-invoices/net-suite-sync-invoices-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS139 } from "@vy/zapi-types";
var NET_SUITE_SYNC_INVOICES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS139.PRIVATE,
  route: "/integrations/net-suite/sync-invoices",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/sync-invoices/net-suite-sync-invoices-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema31 } from "@vy/types";
import { oz as oz244 } from "@vy/utils";
var NetSuiteSyncInvoicesRequestSchema = oz244.object({
  invoicesIds: oz244.array(ObjectIdSchema31)
}).openapi("netSuiteSyncInvoicesRequest");

// src/api-definition-paths/integrations-paths/net-suite/sync-invoices/net-suite-sync-invoices-action.ts
var NET_SUITE_SYNC_INVOICES_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "net-suite-sync-invoices"
  },
  request: {
    name: "NetSuiteSyncInvoicesRequest",
    schema: NetSuiteSyncInvoicesRequestSchema
  },
  path: NET_SUITE_SYNC_INVOICES_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/sync-invoices/invoice-sync-attempt-error-reason.ts
import { oz as oz245 } from "@vy/utils";
var InvoiceSyncAttemptErrorReasonSchema = oz245.object({
  internalReason: oz245.string(),
  providerReasons: oz245.string().array().optional()
}).openapi("invoiceSyncAttemptResult");

// src/api-definition-paths/integrations-paths/net-suite/sync-invoices/invoice-sync-attempt-result.ts
import { ObjectIdSchema as ObjectIdSchema32 } from "@vy/types";
import { oz as oz246 } from "@vy/utils";
var InvoiceSyncAttemptResultSchema = oz246.object({
  vayuInvoiceId: ObjectIdSchema32,
  netsuiteInvoiceId: ObjectIdSchema32.optional(),
  invoiceName: oz246.string(),
  customerId: oz246.string(),
  customerName: oz246.string(),
  errorReason: InvoiceSyncAttemptErrorReasonSchema.optional()
}).openapi("invoiceSyncAttemptResult");

// src/api-definition-paths/integrations-paths/net-suite/sync-invoices-sales-order/net-suite-sync-invoices-sales-order-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS140 } from "@vy/zapi-types";
var NET_SUITE_SYNC_INVOICES_SALES_ORDER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS140.PRIVATE,
  route: "/integrations/net-suite/sync-invoices-sales-order",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/sync-invoices-sales-order/net-suite-sync-invoices-sales-order-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema33 } from "@vy/types";
import { oz as oz247 } from "@vy/utils";
var NetSuiteSyncInvoicesSalesOrderRequestSchema = oz247.object({
  invoicesIds: oz247.array(ObjectIdSchema33)
}).openapi("netSuiteSyncInvoicesSalesOrderRequest");

// src/api-definition-paths/integrations-paths/net-suite/sync-invoices-sales-order/net-suite-sync-invoices-sales-order-action.ts
var NET_SUITE_SYNC_INVOICES_SALES_ORDER_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "net-suite-sync-invoices-sales-order"
  },
  request: {
    name: "NetSuiteSyncInvoicesSalesOrderRequest",
    schema: NetSuiteSyncInvoicesSalesOrderRequestSchema
  },
  path: NET_SUITE_SYNC_INVOICES_SALES_ORDER_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/get-subsidiaries/net-suite-get-subsidiaries-action.ts
import { oz as oz249 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/net-suite/get-subsidiaries/net-suite-get-subsidiaries-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS141 } from "@vy/zapi-types";
var GET_NET_SUITE_SUBSIDIARIES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS141.PRIVATE,
  route: "/integrations/net-suite/subsidiaries",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/get-subsidiaries/net-suite-get-subsidiaries-response-schema.ts
import { NetSuiteSubsidiarySchema } from "@vy/types";
import { oz as oz248 } from "@vy/utils";
var NetSuiteGetSubsidiariesResponseSchema = oz248.object({
  subsidiaries: oz248.array(NetSuiteSubsidiarySchema)
}).openapi("NetSuiteGetSubsidiariesResponse");

// src/api-definition-paths/integrations-paths/net-suite/get-subsidiaries/net-suite-get-subsidiaries-action.ts
var ERP_ID_QUERY_PARAM = {
  name: "erpId",
  location: "query",
  schema: oz249.string().optional(),
  required: false
};
var GET_NET_SUITE_SUBSIDIARIES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-net-suite-subsidiaries"
  },
  queryParams: { [ERP_ID_QUERY_PARAM.name]: ERP_ID_QUERY_PARAM },
  response: {
    name: "GetNetSuiteSubsidiariesResponse",
    schema: NetSuiteGetSubsidiariesResponseSchema
  },
  path: GET_NET_SUITE_SUBSIDIARIES_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/update-sales-order/net-suite-update-sales-order-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS142 } from "@vy/zapi-types";
var NET_SUITE_UPDATE_SALES_ORDER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS142.PRIVATE,
  route: "/integrations/net-suite/update-sales-order",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/update-sales-order/net-suite-update-sales-order-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema34 } from "@vy/types";
import { oz as oz250 } from "@vy/utils";
var NetSuiteUpdateSalesOrderRequestSchema = oz250.object({
  contractId: ObjectIdSchema34,
  productsIds: oz250.array(ObjectIdSchema34),
  subsidiaryId: oz250.string()
}).openapi("netSuiteUpdateSalesOrderRequest");

// src/api-definition-paths/integrations-paths/net-suite/update-sales-order/net-suite-update-sales-order-action.ts
var NET_SUITE_UPDATE_SALES_ORDER_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "net-suite-update-sales-order"
  },
  request: {
    name: "NetSuiteUpdateSalesOrderRequest",
    schema: NetSuiteUpdateSalesOrderRequestSchema
  },
  path: NET_SUITE_UPDATE_SALES_ORDER_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/get-classes/net-suite-get-classes-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS143 } from "@vy/zapi-types";
var NET_SUITE_GET_CLASSES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS143.PRIVATE,
  route: "/integrations/net-suite/classes",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/get-classes/net-suite-get-classes-action.ts
import { oz as oz252 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/net-suite/get-classes/net-suite-get-classes-response-schema.ts
import { NetSuiteClassSchema } from "@vy/types";
import { oz as oz251 } from "@vy/utils";
var NetSuiteGetClassesResponseSchema = oz251.object({
  classes: oz251.array(NetSuiteClassSchema)
}).openapi("NetSuiteGetProductsResponse");

// src/api-definition-paths/integrations-paths/net-suite/get-classes/net-suite-get-classes-action.ts
var SUBSIDIARY_ID_QUERY_PARAM = {
  name: "subsidiaryId",
  location: "query",
  schema: oz252.string().optional(),
  required: false
};
var NET_SUITE_GET_CLASSES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "net-suite-get-classes"
  },
  queryParams: {
    [SUBSIDIARY_ID_QUERY_PARAM.name]: SUBSIDIARY_ID_QUERY_PARAM
  },
  response: {
    name: "NetSuiteGetClassesResponse",
    schema: NetSuiteGetClassesResponseSchema
  },
  path: NET_SUITE_GET_CLASSES_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/get-credit-items/net-suite-get-credit-items-response-schema.ts
import { oz as oz253 } from "@vy/utils";
var NetSuiteGetCreditItemsResponseSchema = oz253.array(
  oz253.object({
    id: oz253.string(),
    name: oz253.string()
  })
).openapi("NetSuiteGetCreditItemsResponse");

// src/api-definition-paths/integrations-paths/net-suite/get-credit-items/net-suite-get-credit-items-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS144 } from "@vy/zapi-types";
var NET_SUITE_GET_CREDIT_ITEMS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS144.PRIVATE,
  route: "/integrations/net-suite/credit-items",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/get-credit-items/net-suite-get-credit-items-action.ts
var NET_SUITE_GET_CREDIT_ITEMS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "net-suite-get-credit-items"
  },
  response: {
    name: "NetSuiteGetCreditItemsResponse",
    schema: NetSuiteGetCreditItemsResponseSchema
  },
  path: NET_SUITE_GET_CREDIT_ITEMS_PATH
};

// src/api-definition-paths/integrations-paths/net-suite/export-credit-memo/export-credit-memo-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS145 } from "@vy/zapi-types";
var NET_SUITE_EXPORT_CREDIT_MEMO_PATH = {
  accessLevel: PATH_ACCESS_LEVELS145.PRIVATE,
  route: "/integrations/net-suite/export-credit-memo",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/net-suite/export-credit-memo/export-credit-memo-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema35 } from "@vy/types";
import { oz as oz254 } from "@vy/utils";
var NetSuiteExportCreditMemoRequestSchema = oz254.object({
  creditLedgerEntryId: ObjectIdSchema35
}).openapi("netSuiteExportCreditMemoRequest");

// src/api-definition-paths/integrations-paths/net-suite/export-credit-memo/export-credit-memo-action.ts
var NET_SUITE_EXPORT_CREDIT_MEMO_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "net-suite-export-credit-memo"
  },
  path: NET_SUITE_EXPORT_CREDIT_MEMO_PATH,
  request: {
    name: "NetSuiteExportCreditMemoRequest",
    schema: NetSuiteExportCreditMemoRequestSchema
  }
};

// src/api-definition-paths/integrations-paths/quickbooks/get-customers/quickbooks-get-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS146 } from "@vy/zapi-types";
var QUICKBOOKS_GET_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS146.PRIVATE,
  route: "/integrations/quickbooks/customers",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/quickbooks/get-customers/quickbooks-get-customers-response-schema.ts
import { QuickBooksCustomerSchema } from "@vy/types";
import { oz as oz255 } from "@vy/utils";
var QuickBooksGetCustomersResponseSchema = oz255.object({
  customers: oz255.array(QuickBooksCustomerSchema)
}).openapi("QuickBooksGetCustomersResponse");

// src/api-definition-paths/integrations-paths/quickbooks/get-customers/quickbooks-get-customers-action.ts
import { SqlSafeStringSchema } from "@vy/types";
var SEARCH_QUERY_PARAMETER2 = {
  name: "search",
  location: "query",
  schema: SqlSafeStringSchema.optional(),
  required: false
};
var QUICKBOOKS_GET_CUSTOMERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "quickbooks-get-customers"
  },
  queryParams: {
    [SEARCH_QUERY_PARAMETER2.name]: SEARCH_QUERY_PARAMETER2
  },
  response: {
    name: "QuickBooksGetCustomersResponse",
    schema: QuickBooksGetCustomersResponseSchema
  },
  path: QUICKBOOKS_GET_CUSTOMERS_PATH
};

// src/api-definition-paths/integrations-paths/quickbooks/connect/quickbooks-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS147 } from "@vy/zapi-types";
var QUICKBOOKS_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS147.PRIVATE,
  route: "/integrations/quickbooks/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/quickbooks/connect/quickbooks-connect-response-schema.ts
import { oz as oz256 } from "@vy/utils";
var QuickBooksConnectResponseSchema = oz256.object({
  redirectUrl: oz256.string()
}).openapi("QuickBooksConnectResponseSchema");

// src/api-definition-paths/integrations-paths/quickbooks/connect/quickbooks-connect-action.ts
var QUICKBOOKS_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "quickbooks-connect"
  },
  response: {
    name: "QuickBooksConnectResponse",
    schema: QuickBooksConnectResponseSchema
  },
  path: QUICKBOOKS_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/quickbooks/auth-callback/quickbooks-auth-callback-action.ts
import { oz as oz257 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/quickbooks/auth-callback/quickbooks-auth-callback-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS148 } from "@vy/zapi-types";
var QUICKBOOKS_AUTH_CALLBACK_PATH = {
  accessLevel: PATH_ACCESS_LEVELS148.PUBLIC,
  route: "/integrations/quickbooks/auth/callback",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/quickbooks/auth-callback/quickbooks-auth-callback-action.ts
var ERROR_QUERY_PARAMETER = {
  name: "error",
  location: "query",
  schema: oz257.string().optional(),
  required: false
};
var REALM_ID_QUERY_PARAMETER = {
  name: "realmId",
  location: "query",
  schema: oz257.string().optional(),
  required: false
};
var CODE_QUERY_PARAMETER = {
  name: "code",
  location: "query",
  schema: oz257.string().optional(),
  required: false
};
var STATE_QUERY_PARAMETER = {
  name: "state",
  location: "query",
  schema: oz257.string().optional(),
  required: false
};
var QUICKBOOKS_AUTH_CALLBACK_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "quickbooks-auth-callback"
  },
  queryParams: {
    [CODE_QUERY_PARAMETER.name]: CODE_QUERY_PARAMETER,
    [STATE_QUERY_PARAMETER.name]: STATE_QUERY_PARAMETER,
    [REALM_ID_QUERY_PARAMETER.name]: REALM_ID_QUERY_PARAMETER,
    [ERROR_QUERY_PARAMETER.name]: ERROR_QUERY_PARAMETER
  },
  path: QUICKBOOKS_AUTH_CALLBACK_PATH
};

// src/api-definition-paths/integrations-paths/quickbooks/get-products/quickbooks-get-products-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS149 } from "@vy/zapi-types";
var QUICKBOOKS_GET_PRODUCTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS149.PRIVATE,
  route: "/integrations/quickbooks/products",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/quickbooks/get-products/quickbooks-get-products-response-schema.ts
import { QuickBooksProductSchema } from "@vy/types";
import { oz as oz258 } from "@vy/utils";
var QuickBooksGetProductsResponseSchema = oz258.object({
  products: oz258.array(QuickBooksProductSchema)
}).openapi("QuickBooksGetProductsResponse");

// src/api-definition-paths/integrations-paths/quickbooks/get-products/quickbooks-get-products-action.ts
import { SqlSafeStringSchema as SqlSafeStringSchema2 } from "@vy/types";
var SEARCH_QUERY_PARAMETER3 = {
  name: "search",
  location: "query",
  schema: SqlSafeStringSchema2.optional(),
  required: false
};
var QUICKBOOKS_GET_PRODUCTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "quickbooks-get-products"
  },
  queryParams: {
    [SEARCH_QUERY_PARAMETER3.name]: SEARCH_QUERY_PARAMETER3
  },
  response: {
    name: "QuickBooksGetProductsResponse",
    schema: QuickBooksGetProductsResponseSchema
  },
  path: QUICKBOOKS_GET_PRODUCTS_PATH
};

// src/api-definition-paths/integrations-paths/quickbooks/export-credit-memo/quickbooks-export-credit-memo-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS150 } from "@vy/zapi-types";
var QUICKBOOKS_EXPORT_CREDIT_MEMO_PATH = {
  accessLevel: PATH_ACCESS_LEVELS150.PRIVATE,
  route: "/integrations/quickbooks/export-credit-memo",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/quickbooks/export-credit-memo/quickbooks-export-credit-memo-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema36 } from "@vy/types";
import { oz as oz259 } from "@vy/utils";
var QuickBooksExportCreditMemoRequestSchema = oz259.object({
  creditLedgerEntryId: ObjectIdSchema36
}).openapi("quickBooksExportCreditMemoRequest");

// src/api-definition-paths/integrations-paths/quickbooks/export-credit-memo/quickbooks-export-credit-memo-action.ts
var QUICKBOOKS_EXPORT_CREDIT_MEMO_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "quickbooks-export-credit-memo"
  },
  request: {
    name: "QuickBooksExportCreditMemoRequest",
    schema: QuickBooksExportCreditMemoRequestSchema
  },
  path: QUICKBOOKS_EXPORT_CREDIT_MEMO_PATH
};

// src/api-definition-paths/integrations-paths/quickbooks/export-invoices/quickbooks-export-invoices-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS151 } from "@vy/zapi-types";
var QUICKBOOKS_EXPORT_INVOICES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS151.PRIVATE,
  route: "/integrations/quickbooks/export-invoices",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/quickbooks/export-invoices/quickbooks-export-invoices-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema37 } from "@vy/types";
import { oz as oz260 } from "@vy/utils";
var QuickBooksExportInvoicesRequestSchema = oz260.object({
  invoiceIds: oz260.array(ObjectIdSchema37)
}).openapi("quickBooksExportInvoicesRequest");

// src/api-definition-paths/integrations-paths/quickbooks/export-invoices/quickbooks-export-invoices-action.ts
var QUICKBOOKS_EXPORT_INVOICES_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "quickbooks-export-invoices"
  },
  request: {
    name: "QuickBooksExportInvoicesRequest",
    schema: QuickBooksExportInvoicesRequestSchema
  },
  path: QUICKBOOKS_EXPORT_INVOICES_PATH
};

// src/api-definition-paths/integrations-paths/quickbooks/get-deposit-to-accounts/quickbooks-get-deposit-to-accounts-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS152 } from "@vy/zapi-types";
var QUICKBOOKS_GET_DEPOSIT_TO_ACCOUNTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS152.PRIVATE,
  route: "/integrations/quickbooks/deposit-to-accounts",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/quickbooks/get-deposit-to-accounts/quickbooks-get-deposit-to-accounts-response-schema.ts
import { oz as oz261 } from "@vy/utils";
var QuickBooksDepositToAccountSchema = oz261.object({
  id: oz261.string(),
  name: oz261.string()
});
var QuickBooksGetDepositToAccountsResponseSchema = oz261.object({
  depositToAccounts: oz261.array(QuickBooksDepositToAccountSchema)
}).openapi("QuickBooksGetDepositToAccountsResponse");

// src/api-definition-paths/integrations-paths/quickbooks/get-deposit-to-accounts/quickbooks-get-deposit-to-accounts-action.ts
var QUICKBOOKS_GET_DEPOSIT_TO_ACCOUNTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "quickbooks-get-deposit-to-accounts"
  },
  response: {
    name: "QuickBooksGetDepositToAccountsResponse",
    schema: QuickBooksGetDepositToAccountsResponseSchema
  },
  path: QUICKBOOKS_GET_DEPOSIT_TO_ACCOUNTS_PATH
};

// src/api-definition-paths/integrations-paths/salesforce/connect/salesforce-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS153 } from "@vy/zapi-types";
var SALESFORCE_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS153.PRIVATE,
  route: "/integrations/salesforce/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/salesforce/connect/salesforce-connect-request-schema.ts
import { SalesforceAuthDataSchema } from "@vy/types";
var SalesforceConnectRequestSchema = SalesforceAuthDataSchema.openapi("salesforceConnectRequest");

// src/api-definition-paths/integrations-paths/salesforce/connect/salesforce-connect-action.ts
var SALESFORCE_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "salesforce-connect"
  },
  request: {
    name: "SalesforceConnectRequest",
    schema: SalesforceConnectRequestSchema
  },
  path: SALESFORCE_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/salesforce/import-customers/salesforce-import-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS154 } from "@vy/zapi-types";
var SALESFORCE_IMPORT_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS154.PRIVATE,
  route: "/integrations/salesforce/import-customers",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/salesforce/import-customers/salesforce-import-customers-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema38 } from "@vy/types";
import { oz as oz262 } from "@vy/utils";
var SalesforceImportCustomersResponseSchema = oz262.array(
  oz262.object({
    crmId: ObjectIdSchema38.optional().nullable(),
    name: oz262.string()
  })
).openapi("salesforceImportCustomersResponseSchema");

// src/api-definition-paths/integrations-paths/salesforce/import-customers/salesforce-import-customers-action.ts
var SALESFORCE_IMPORT_CUSTOMERS_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "salesforce-import-customers"
  },
  response: {
    name: "SalesforceImportCustomersResponse",
    schema: SalesforceImportCustomersResponseSchema
  },
  path: SALESFORCE_IMPORT_CUSTOMERS_PATH
};

// src/api-definition-paths/integrations-paths/salesforce/get-contract-custom-fields/salesforce-get-contract-custom-fields-action.ts
import { oz as oz264 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/salesforce/get-contract-custom-fields/salesforce-get-contract-custom-fields-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS155 } from "@vy/zapi-types";
var SALESFORCE_GET_CONTRACT_CUSTOM_FIELDS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS155.PRIVATE,
  route: "/integrations/salesforce/contract-custom-fields",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/salesforce/get-contract-custom-fields/salesforce-get-contract-custom-fields-response-schema.ts
import { CustomFieldSchema } from "@vy/types";
import { oz as oz263 } from "@vy/utils";
var SalesforceGetContractCustomFieldsResponseSchema = oz263.object({
  fields: CustomFieldSchema.array()
}).openapi("SalesforceGetContractCustomFieldsResponse");

// src/api-definition-paths/integrations-paths/salesforce/get-contract-custom-fields/salesforce-get-contract-custom-fields-action.ts
var CONTRACT_ID_QUERY_PARAM = {
  name: "contractId",
  location: "query",
  schema: oz264.string(),
  required: true
};
var SALESFORCE_GET_CONTRACT_CUSTOM_FIELDS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "salesforce-get-contract-custom-fields"
  },
  queryParams: {
    [CONTRACT_ID_QUERY_PARAM.name]: CONTRACT_ID_QUERY_PARAM
  },
  response: {
    name: "SalesforceGetContractContractCustomFieldsResponse",
    schema: SalesforceGetContractCustomFieldsResponseSchema
  },
  path: SALESFORCE_GET_CONTRACT_CUSTOM_FIELDS_PATH
};

// src/api-definition-paths/integrations-paths/slack/send-invoice-approval-message/send-invoice-approval-message-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS156 } from "@vy/zapi-types";
var SEND_SLACK_INVOICE_APPROVAL_MESSAGE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS156.PRIVATE,
  route: "/integrations/slack/invoice-approval",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/slack/send-invoice-approval-message/slack-send-invoice-approval-message-request-schema.ts
import { oz as oz265 } from "@vy/utils";
var SlackSendInvoiceApprovalMessageRequestSchema = oz265.object({
  userId: oz265.string(),
  invoice: oz265.string()
}).openapi("slackSendMessageRequest");

// src/api-definition-paths/integrations-paths/slack/send-invoice-approval-message/slack-send-invoice-approval-message-response-schema.ts
import { oz as oz266 } from "@vy/utils";
var SlackSendInvoiceApprovalMessageResponseSchema = oz266.object({
  message: oz266.string()
}).openapi("slackSendInvoiceApprovalMessageResponse");

// src/api-definition-paths/integrations-paths/slack/send-invoice-approval-message/send-invoice-approval-message-action.ts
var SEND_SLACK_INVOICE_APPROVAL_MESSAGE_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "send-slack-invoice-approval-message"
  },
  request: {
    name: "SlackSendInvoiceApprovalMessageRequestSchema",
    schema: SlackSendInvoiceApprovalMessageRequestSchema
  },
  response: {
    name: "SlackSendInvoiceApprovalMessageResponseSchema",
    schema: SlackSendInvoiceApprovalMessageResponseSchema
  },
  path: SEND_SLACK_INVOICE_APPROVAL_MESSAGE_PATH
};

// src/api-definition-paths/integrations-paths/slack/send-credit-note-notification/send-credit-note-notification-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS157 } from "@vy/zapi-types";
var SEND_SLACK_CREDIT_NOTE_NOTIFICATION_PATH = {
  accessLevel: PATH_ACCESS_LEVELS157.PRIVATE,
  route: "/integrations/slack/credit-note-notification",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/slack/send-credit-note-notification/send-credit-note-notification-request-schema.ts
import { oz as oz267 } from "@vy/utils";
var SlackSendCreditNoteNotificationRequestSchema = oz267.object({
  userId: oz267.string(),
  creditLedgerEntryId: oz267.string()
}).openapi("slackSendCreditNoteNotificationRequest");

// src/api-definition-paths/integrations-paths/slack/send-credit-note-notification/send-credit-note-notification-response-schema.ts
import { oz as oz268 } from "@vy/utils";
var SlackSendCreditNoteNotificationResponseSchema = oz268.object({
  message: oz268.string()
}).openapi("slackSendCreditNoteNotificationResponse");

// src/api-definition-paths/integrations-paths/slack/send-credit-note-notification/send-credit-note-notification-action.ts
var SEND_SLACK_CREDIT_NOTE_NOTIFICATION_ACTION = {
  method: "post",
  codeGenerationSettings: { actionText: "send-slack-credit-note-notification" },
  request: { name: "SlackSendCreditNoteNotificationRequest", schema: SlackSendCreditNoteNotificationRequestSchema },
  response: { name: "SlackSendCreditNoteNotificationResponse", schema: SlackSendCreditNoteNotificationResponseSchema },
  path: SEND_SLACK_CREDIT_NOTE_NOTIFICATION_PATH
};

// src/api-definition-paths/integrations-paths/slack/get-users/get-users-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS158 } from "@vy/zapi-types";
var GET_SLACK_USERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS158.PRIVATE,
  route: "/integrations/slack/users",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/slack/get-users/slack-get-users-response-schema.ts
import { SlackUserSchema } from "@vy/types";
import { oz as oz269 } from "@vy/utils";
var SlackGetUsersResponseSchema = oz269.object({
  users: oz269.array(SlackUserSchema)
}).openapi("SlackGetUsersResponse");

// src/api-definition-paths/integrations-paths/slack/get-users/get-users-action.ts
var GET_SLACK_USERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-slack-users"
  },
  response: {
    name: "SlackGetUsersResponseSchema",
    schema: SlackGetUsersResponseSchema
  },
  path: GET_SLACK_USERS_PATH
};

// src/api-definition-paths/integrations-paths/slack/get-channels/get-channels-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS159 } from "@vy/zapi-types";
var GET_SLACK_CHANNELS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS159.PRIVATE,
  route: "/integrations/slack/channels",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/slack/get-channels/slack-get-channels-response-schema.ts
import { SlackChannelOptionSchema } from "@vy/types";
import { oz as oz270 } from "@vy/utils";
var SlackGetChannelsResponseSchema = oz270.object({
  channels: oz270.array(SlackChannelOptionSchema)
}).openapi("SlackGetChannelsResponse");

// src/api-definition-paths/integrations-paths/slack/get-channels/get-channels-action.ts
var GET_SLACK_CHANNELS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-slack-channels"
  },
  response: {
    name: "SlackGetChannelsResponseSchema",
    schema: SlackGetChannelsResponseSchema
  },
  path: GET_SLACK_CHANNELS_PATH
};

// src/api-definition-paths/integrations-paths/slack/event-handler/event-handler-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS160 } from "@vy/zapi-types";
var SLACK_EVENT_HANDLER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS160.PUBLIC,
  route: "/integrations/slack/events",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/slack/event-handler/slack-event-handler-request-schema.ts
import { SlackUserPayloadSchema } from "@vy/types";
import { oz as oz272 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/slack/event-handler/slack-event-handler-action-schema.ts
import { oz as oz271 } from "@vy/utils";
var SlackActionSchema = oz271.object({
  type: oz271.string(),
  text: oz271.object({
    type: oz271.string(),
    text: oz271.string()
  }),
  action_id: oz271.string(),
  block_id: oz271.string().optional(),
  value: oz271.string()
}).openapi("SlackAction");

// src/api-definition-paths/integrations-paths/slack/event-handler/slack-event-handler-request-schema.ts
var SlackEventHandlerParsedRequestSchema = oz272.object({
  type: oz272.string(),
  user: SlackUserPayloadSchema,
  container: oz272.object({
    channel_id: oz272.string(),
    message_ts: oz272.string()
  }),
  actions: oz272.array(SlackActionSchema).optional()
});
var SlackEventHandlerRequestSchema = oz272.object({
  payload: oz272.string()
}).transform((body) => JSON.parse(body.payload)).pipe(SlackEventHandlerParsedRequestSchema).openapi("SlackEventHandlerRequest");

// src/api-definition-paths/integrations-paths/slack/event-handler/slack-event-handler-response-schema.ts
import { oz as oz273 } from "@vy/utils";
var SlackEventHandlerResponseSchema = oz273.object({
  response_action: oz273.string(),
  message: oz273.object({
    text: oz273.string()
  })
}).openapi("slackSendMessageResponse");

// src/api-definition-paths/integrations-paths/slack/event-handler/event-handler-action.ts
var SLACK_EVENT_HANDLER_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "event-handler"
  },
  request: {
    name: "SlackEventHandlerRequestSchema",
    schema: SlackEventHandlerRequestSchema
  },
  response: {
    name: "SlackEventHandlerResponse",
    schema: SlackEventHandlerResponseSchema
  },
  path: SLACK_EVENT_HANDLER_PATH
};

// src/api-definition-paths/integrations-paths/slack/connect/connect-action.ts
import { oz as oz275 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/slack/connect/connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS161 } from "@vy/zapi-types";
var SLACK_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS161.PRIVATE,
  route: "/integrations/slack/auth/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/slack/connect/slack-auth-connect-response-schema.ts
import { oz as oz274 } from "@vy/utils";
var SlackAuthConnectRedirectResponseSchema = oz274.object({
  redirectUrl: oz274.string()
});

// src/api-definition-paths/integrations-paths/slack/connect/connect-action.ts
var REDIRECT_URL_QUERY_PARAMETER = {
  name: "redirectUrl",
  location: "query",
  schema: oz275.string(),
  required: true
};
var SLACK_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "slack-connect"
  },
  queryParams: {
    [REDIRECT_URL_QUERY_PARAMETER.name]: REDIRECT_URL_QUERY_PARAMETER
  },
  response: {
    name: "SlackAuthConnectRedirectResponseSchema",
    schema: SlackAuthConnectRedirectResponseSchema
  },
  path: SLACK_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/slack/callback/callback-action.ts
import { oz as oz276 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/slack/callback/callback-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS162 } from "@vy/zapi-types";
var SLACK_CALLBACK_PATH = {
  accessLevel: PATH_ACCESS_LEVELS162.PUBLIC,
  route: "/integrations/slack/auth/callback",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/slack/callback/callback-action.ts
var CODE_QUERY_PARAMETER2 = {
  name: "code",
  location: "query",
  schema: oz276.string(),
  required: true
};
var STATE_QUERY_PARAMETER2 = {
  name: "state",
  location: "query",
  schema: oz276.string(),
  required: true
};
var SLACK_CALLBACK_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "slack-callback"
  },
  queryParams: {
    [CODE_QUERY_PARAMETER2.name]: CODE_QUERY_PARAMETER2,
    [STATE_QUERY_PARAMETER2.name]: STATE_QUERY_PARAMETER2
  },
  path: SLACK_CALLBACK_PATH
};

// src/api-definition-paths/integrations-paths/stripe/stripe-connect/stripe-auth-connect-request-schema.ts
import { oz as oz277 } from "@vy/utils";
var StripeAuthConnectRequestSchema = oz277.object({
  apiToken: oz277.string().nonempty()
}).openapi("StripeAuthConnectRequest");

// src/api-definition-paths/integrations-paths/stripe/stripe-connect/stripe-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS163 } from "@vy/zapi-types";
var STRIPE_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS163.PRIVATE,
  route: "/integrations/stripe/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/stripe/stripe-connect/stripe-connect-action.ts
var STRIPE_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "stripe-connect"
  },
  request: {
    name: "StripeConnectRequest",
    schema: StripeAuthConnectRequestSchema
  },
  path: STRIPE_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/stripe/stripe-create-invoice/stripe-create-invoice-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS164 } from "@vy/zapi-types";
var STRIPE_CREATE_INVOICE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS164.PRIVATE,
  route: "/integrations/stripe/invoice",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/stripe/stripe-create-invoice/stripe-create-invoice-request-schema.ts
import { oz as oz278 } from "@vy/utils";
var StripeCreateInvoiceRequestSchema = oz278.object({
  invoicesIds: oz278.array(oz278.string().nonempty())
}).openapi("stripeCreateInvoiceRequest");

// src/api-definition-paths/integrations-paths/stripe/stripe-create-invoice/stripe-create-invoice-response-schema.ts
import { oz as oz279 } from "@vy/utils";
var StripeCreateInvoiceResponseSchema = oz279.array(
  oz279.object({
    invoiceId: oz279.string().min(1),
    stripeInvoiceId: oz279.string().min(1)
  })
).openapi("stripeCreateInvoiceResponse");

// src/api-definition-paths/integrations-paths/stripe/stripe-create-invoice/stripe-create-invoice-action.ts
var STRIPE_CREATE_INVOICE_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "stripe-create-invoice"
  },
  request: {
    name: "StripeCreateInvoiceRequest",
    schema: StripeCreateInvoiceRequestSchema
  },
  response: {
    name: "StripeCreateInvoiceResponse",
    schema: StripeCreateInvoiceResponseSchema
  },
  path: STRIPE_CREATE_INVOICE_PATH
};

// src/api-definition-paths/integrations-paths/stripe/stripe-event/stripe-event-action.ts
import { oz as oz282 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/stripe/stripe-event/stripe-event-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS165 } from "@vy/zapi-types";
var STRIPE_EVENT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS165.PUBLIC,
  route: "/integrations/stripe/event",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/stripe/stripe-event/stripe-event-request-schema.ts
import { oz as oz280 } from "@vy/utils";
var StripeEventRequestSchema = oz280.custom();

// src/api-definition-paths/integrations-paths/stripe/stripe-event/stripe-event-response-schema.ts
import { oz as oz281 } from "@vy/utils";
var StripeEventResponseSchema = oz281.object({}).openapi("stripeEventResponse");

// src/api-definition-paths/integrations-paths/stripe/stripe-event/stripe-event-action.ts
var ACCOUNT_ID_QUERY_PARAM = {
  name: "stripeEventAccountId",
  location: "query",
  schema: oz282.string(),
  required: true
};
var STRIPE_EVENT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "stripe-event"
  },
  queryParams: {
    [ACCOUNT_ID_QUERY_PARAM.name]: ACCOUNT_ID_QUERY_PARAM
  },
  request: {
    name: "StripeEventRequest",
    schema: StripeEventRequestSchema
  },
  response: {
    name: "StripeEventResponse",
    schema: StripeEventResponseSchema
  },
  path: STRIPE_EVENT_PATH
};

// src/api-definition-paths/integrations-paths/stripe/stripe-get-customers/stripe-get-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS166 } from "@vy/zapi-types";
var STRIPE_GET_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS166.PRIVATE,
  route: "/integrations/stripe/customers",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/stripe/stripe-get-customers/stripe-get-customers-response-schema.ts
import { oz as oz283 } from "@vy/utils";
var StripeGetCustomersResponseSchema = oz283.object({ customers: oz283.array(oz283.custom()) }).openapi("getStripeCustomersResponse");

// src/api-definition-paths/integrations-paths/stripe/stripe-get-customers/stripe-get-customers-action.ts
var STRIPE_GET_CUSTOMERS_ACTION = {
  method: "get",
  queryParams: {
    [SEARCH_TERM_QUERY_PARAMETER.name]: SEARCH_TERM_QUERY_PARAMETER
  },
  codeGenerationSettings: {
    actionText: "stripe-get-customers"
  },
  response: {
    name: "StripeGetCustomersResponse",
    schema: StripeGetCustomersResponseSchema
  },
  path: STRIPE_GET_CUSTOMERS_PATH
};

// src/api-definition-paths/integrations-paths/stripe/stripe-create-customer/stripe-create-customer-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS167 } from "@vy/zapi-types";
var STRIPE_CREATE_CUSTOMER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS167.PRIVATE,
  route: "/integrations/stripe/customer/{customerId}",
  tags: API_TAGS.INTEGRATIONS,
  pathParams: CUSTOMER_ID_PATH_PARAMS
};

// src/api-definition-paths/integrations-paths/stripe/stripe-create-customer/stripe-create-customer-response-schema.ts
import { oz as oz284 } from "@vy/utils";
var StripeCreateCustomerResponseSchema = oz284.object({
  createdStripeCustomerId: oz284.string().min(1)
}).openapi("StripeCreateCustomerResponse");

// src/api-definition-paths/integrations-paths/stripe/stripe-create-customer/stripe-create-customer-action.ts
var STRIPE_CREATE_CUSTOMER_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "stripe-create-customer"
  },
  response: {
    name: "StripeCreateCustomerResponse",
    schema: StripeCreateCustomerResponseSchema
  },
  path: STRIPE_CREATE_CUSTOMER_PATH
};

// src/api-definition-paths/integrations-paths/paddle/export-invoices/paddle-export-invoices-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS168 } from "@vy/zapi-types";
var PADDLE_EXPORT_INVOICES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS168.PRIVATE,
  route: "/integrations/paddle/export-invoices",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/paddle/export-invoices/paddle-export-invoices-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema39 } from "@vy/types";
import { oz as oz285 } from "@vy/utils";
var PaddleExportInvoicesRequestSchema = oz285.object({
  invoiceIds: oz285.array(ObjectIdSchema39)
}).openapi("paddleExportInvoicesRequest");

// src/api-definition-paths/integrations-paths/paddle/export-invoices/paddle-export-invoices-action.ts
var PADDLE_EXPORT_INVOICES_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "paddle-export-invoices"
  },
  request: {
    name: "PaddleExportInvoicesRequest",
    schema: PaddleExportInvoicesRequestSchema
  },
  path: PADDLE_EXPORT_INVOICES_PATH
};

// src/api-definition-paths/integrations-paths/paddle/get-customers/paddle-get-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS169 } from "@vy/zapi-types";
var PADDLE_GET_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS169.PRIVATE,
  route: "/integrations/paddle/customers",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/paddle/get-customers/paddle-get-customers-response-schema.ts
import { oz as oz286 } from "@vy/utils";
var PaddleCustomerPayloadSchema = oz286.object({
  id: oz286.string(),
  name: oz286.string(),
  email: oz286.string().optional()
});
var PaddleGetCustomersResponseSchema = oz286.object({
  customers: oz286.array(PaddleCustomerPayloadSchema)
}).openapi("PaddleGetCustomersResponse");

// src/api-definition-paths/integrations-paths/paddle/get-customers/paddle-get-customers-action.ts
var PADDLE_GET_CUSTOMERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "paddle-get-customers"
  },
  queryParams: {
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER
  },
  response: {
    name: "PaddleGetCustomersResponse",
    schema: PaddleGetCustomersResponseSchema
  },
  path: PADDLE_GET_CUSTOMERS_PATH
};

// src/api-definition-paths/integrations-paths/paddle/get-products/paddle-get-products-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS170 } from "@vy/zapi-types";
var PADDLE_GET_PRODUCTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS170.PRIVATE,
  route: "/integrations/paddle/products",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/paddle/get-products/paddle-get-products-response-schema.ts
import { oz as oz287 } from "@vy/utils";
var PaddleProductPayloadSchema = oz287.object({
  id: oz287.string(),
  name: oz287.string()
});
var PaddleGetProductsResponseSchema = oz287.object({
  products: oz287.array(PaddleProductPayloadSchema)
}).openapi("PaddleGetProductsResponse");

// src/api-definition-paths/integrations-paths/paddle/get-products/paddle-get-products-action.ts
var PADDLE_GET_PRODUCTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "paddle-get-products"
  },
  response: {
    name: "PaddleGetProductsResponse",
    schema: PaddleGetProductsResponseSchema
  },
  path: PADDLE_GET_PRODUCTS_PATH
};

// src/api-definition-paths/integrations-paths/paddle/get-transaction-url/paddle-get-transaction-url-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS171 } from "@vy/zapi-types";
var PADDLE_GET_TRANSACTION_URL_PATH = {
  accessLevel: PATH_ACCESS_LEVELS171.PRIVATE,
  route: "/integrations/paddle/transaction-url",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/paddle/get-transaction-url/paddle-get-transaction-url-action.ts
import { oz as oz289 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/paddle/get-transaction-url/paddle-get-transaction-url-response-schema.ts
import { oz as oz288 } from "@vy/utils";
var PaddleGetTransactionUrlResponseSchema = oz288.object({
  url: oz288.string().describe("The URL to the Paddle transaction")
}).openapi("PaddleGetTransactionUrlResponse");

// src/api-definition-paths/integrations-paths/paddle/get-transaction-url/paddle-get-transaction-url-action.ts
var VAYU_INVOICE_ID2 = {
  name: "vayuInvoiceId",
  location: "query",
  schema: oz289.string(),
  required: true
};
var PADDLE_GET_TRANSACTION_URL_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "paddle-get-transaction-url"
  },
  queryParams: {
    [VAYU_INVOICE_ID2.name]: VAYU_INVOICE_ID2
  },
  response: {
    name: "PaddleGetTransactionUrlResponse",
    schema: PaddleGetTransactionUrlResponseSchema
  },
  path: PADDLE_GET_TRANSACTION_URL_PATH
};

// src/api-definition-paths/integrations-paths/paddle/paddle-connect/paddle-auth-connect-request-schema.ts
import { oz as oz290 } from "@vy/utils";
var PaddleEnvironmentSchema = oz290.enum(["sandbox", "production"]);
var PaddleAuthConnectRequestSchema = oz290.object({
  apiToken: oz290.string().nonempty(),
  environment: PaddleEnvironmentSchema
}).openapi("PaddleAuthConnectRequest");

// src/api-definition-paths/integrations-paths/paddle/paddle-connect/paddle-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS172 } from "@vy/zapi-types";
var PADDLE_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS172.PRIVATE,
  route: "/integrations/paddle/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/paddle/paddle-connect/paddle-connect-action.ts
var PADDLE_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "paddle-connect"
  },
  request: {
    name: "PaddleConnectRequest",
    schema: PaddleAuthConnectRequestSchema
  },
  path: PADDLE_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/paddle/paddle-event/paddle-event-action.ts
import { oz as oz293 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/paddle/paddle-event/paddle-event-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS173 } from "@vy/zapi-types";
var PADDLE_EVENT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS173.PUBLIC,
  route: "/integrations/paddle/event",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/paddle/paddle-event/paddle-event-request-schema.ts
import { oz as oz291 } from "@vy/utils";
var PaddleEventRequestSchema = oz291.custom();

// src/api-definition-paths/integrations-paths/paddle/paddle-event/paddle-event-response-schema.ts
import { oz as oz292 } from "@vy/utils";
var PaddleEventResponseSchema = oz292.object({}).openapi("paddleEventResponse");

// src/api-definition-paths/integrations-paths/paddle/paddle-event/paddle-event-action.ts
var ACCOUNT_ID_QUERY_PARAM2 = {
  name: "paddleEventAccountId",
  location: "query",
  schema: oz293.string(),
  required: true
};
var PADDLE_EVENT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "paddle-event"
  },
  queryParams: {
    [ACCOUNT_ID_QUERY_PARAM2.name]: ACCOUNT_ID_QUERY_PARAM2
  },
  request: {
    name: "PaddleEventRequest",
    schema: PaddleEventRequestSchema
  },
  response: {
    name: "PaddleEventResponse",
    schema: PaddleEventResponseSchema
  },
  path: PADDLE_EVENT_PATH
};

// src/api-definition-paths/integrations-paths/update-configuration/update-configuration-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS174 } from "@vy/zapi-types";
var UPDATE_INTEGRATION_CONFIGURATION_PATH = {
  accessLevel: PATH_ACCESS_LEVELS174.PRIVATE,
  route: "/integrations/configuration",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/update-configuration/update-configuration-request-schema.ts
import { UpdateIntegrationSettingsSchema } from "@vy/types";
import { oz as oz294 } from "@vy/utils";
var UpdateIntegrationConfigurationRequestSchema = oz294.object({
  integrationId: oz294.string(),
  integrationSettings: UpdateIntegrationSettingsSchema
}).openapi("UpdateIntegrationConfigurationRequest");

// src/api-definition-paths/integrations-paths/update-configuration/update-configuration-response-schema.ts
import { VersionedIntegrationSettingsSchema as VersionedIntegrationSettingsSchema2 } from "@vy/types";
import { oz as oz295 } from "@vy/utils";
var UpdateIntegrationConfigurationResponseSchema = oz295.object({
  integrationSettings: VersionedIntegrationSettingsSchema2
}).openapi("UpdateIntegrationConfigurationResponse");

// src/api-definition-paths/integrations-paths/update-configuration/update-configuration-action.ts
var UPDATE_INTEGRATION_CONFIGURATION_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-integration-configuration"
  },
  request: {
    name: "UpdateIntegrationConfigurationRequest",
    schema: UpdateIntegrationConfigurationRequestSchema
  },
  response: {
    name: "UpdateIntegrationConfigurationResponse",
    schema: UpdateIntegrationConfigurationResponseSchema
  },
  path: UPDATE_INTEGRATION_CONFIGURATION_PATH
};

// src/api-definition-paths/integrations-paths/marketplace/export-usage/export-usage-to-marketplace-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS175 } from "@vy/zapi-types";
var EXPORT_USAGE_TO_MARKETPLACE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS175.PRIVATE,
  route: "/integrations/export-usage-to-marketplace",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/marketplace/export-usage/export-usage-to-marketplace-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema40 } from "@vy/types";
import { oz as oz296 } from "@vy/utils";
var ExportUsageToMarketplaceRequestSchema = oz296.object({
  invoicesIds: oz296.array(ObjectIdSchema40)
}).openapi("exportUsageToMarketplaceRequest");

// src/api-definition-paths/integrations-paths/marketplace/export-usage/export-usage-to-marketplace-action.ts
var EXPORT_USAGE_TO_MARKETPLACE_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "export-usage-to-marketplace"
  },
  request: {
    name: "ExportUsageToMarketplaceRequest",
    schema: ExportUsageToMarketplaceRequestSchema
  },
  path: EXPORT_USAGE_TO_MARKETPLACE_PATH
};

// src/api-definition-paths/integrations-paths/xero/auth-callback/xero-auth-callback-action.ts
import { oz as oz297 } from "@vy/utils";

// src/api-definition-paths/integrations-paths/xero/auth-callback/xero-auth-callback-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS176 } from "@vy/zapi-types";
var XERO_AUTH_CALLBACK_PATH = {
  accessLevel: PATH_ACCESS_LEVELS176.PUBLIC,
  route: "/integrations/xero/auth/callback",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/xero/auth-callback/xero-auth-callback-action.ts
var CODE_QUERY_PARAMETER3 = {
  name: "code",
  location: "query",
  schema: oz297.string().optional(),
  required: false
};
var STATE_QUERY_PARAMETER3 = {
  name: "state",
  location: "query",
  schema: oz297.string().optional(),
  required: false
};
var ERROR_QUERY_PARAMETER2 = {
  name: "error",
  location: "query",
  schema: oz297.string().optional(),
  required: false
};
var XERO_AUTH_CALLBACK_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "xero-auth-callback"
  },
  queryParams: {
    [CODE_QUERY_PARAMETER3.name]: CODE_QUERY_PARAMETER3,
    [STATE_QUERY_PARAMETER3.name]: STATE_QUERY_PARAMETER3,
    [ERROR_QUERY_PARAMETER2.name]: ERROR_QUERY_PARAMETER2
  },
  path: XERO_AUTH_CALLBACK_PATH
};

// src/api-definition-paths/integrations-paths/xero/auth-connect/xero-auth-connect-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS177 } from "@vy/zapi-types";
var XERO_AUTH_CONNECT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS177.PRIVATE,
  route: "/integrations/xero/connect",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/xero/auth-connect/xero-auth-connect-response-schema.ts
import { oz as oz298 } from "@vy/utils";
var XeroAuthConnectResponseSchema = oz298.object({
  redirectUrl: oz298.string()
}).openapi("XeroAuthConnectResponseSchema");

// src/api-definition-paths/integrations-paths/xero/auth-connect/xero-auth-connect-request-schema.ts
import { oz as oz299 } from "@vy/utils";
var XeroAuthConnectRequestSchema = oz299.object({
  clientId: oz299.string(),
  clientSecret: oz299.string(),
  environment: oz299.enum(["sandbox", "production"])
});

// src/api-definition-paths/integrations-paths/xero/auth-connect/xero-auth-connect-action.ts
var XERO_AUTH_CONNECT_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "xero-auth-connect"
  },
  request: {
    name: "XeroAuthConnectRequest",
    schema: XeroAuthConnectRequestSchema
  },
  response: {
    name: "XeroAuthConnectResponse",
    schema: XeroAuthConnectResponseSchema
  },
  path: XERO_AUTH_CONNECT_PATH
};

// src/api-definition-paths/integrations-paths/xero/export-credit-memo/xero-export-credit-memo-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS178 } from "@vy/zapi-types";
var XERO_EXPORT_CREDIT_MEMO_PATH = {
  accessLevel: PATH_ACCESS_LEVELS178.PRIVATE,
  route: "/integrations/xero/export-credit-memo",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/xero/export-credit-memo/xero-export-credit-memo-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema41 } from "@vy/types";
import { oz as oz300 } from "@vy/utils";
var XeroExportCreditMemoRequestSchema = oz300.object({
  creditLedgerEntryId: ObjectIdSchema41
}).openapi("xeroExportCreditMemoRequest");

// src/api-definition-paths/integrations-paths/xero/export-credit-memo/xero-export-credit-memo-action.ts
var XERO_EXPORT_CREDIT_MEMO_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "xero-export-credit-memo"
  },
  request: {
    name: "XeroExportCreditMemoRequest",
    schema: XeroExportCreditMemoRequestSchema
  },
  path: XERO_EXPORT_CREDIT_MEMO_PATH
};

// src/api-definition-paths/integrations-paths/xero/export-invoices/xero-export-invoices-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS179 } from "@vy/zapi-types";
var XERO_EXPORT_INVOICES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS179.PRIVATE,
  route: "/integrations/xero/export-invoices",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/xero/export-invoices/xero-export-invoices-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema42 } from "@vy/types";
import { oz as oz301 } from "@vy/utils";
var XeroExportInvoicesRequestSchema = oz301.object({
  invoiceIds: oz301.array(ObjectIdSchema42)
}).openapi("xeroExportInvoicesRequest");

// src/api-definition-paths/integrations-paths/xero/export-invoices/xero-export-invoices-action.ts
var XERO_EXPORT_INVOICES_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "xero-export-invoices"
  },
  request: {
    name: "XeroExportInvoicesRequest",
    schema: XeroExportInvoicesRequestSchema
  },
  path: XERO_EXPORT_INVOICES_PATH
};

// src/api-definition-paths/integrations-paths/xero/get-customers/xero-get-customers-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS180 } from "@vy/zapi-types";
var XERO_GET_CUSTOMERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS180.PRIVATE,
  route: "/integrations/xero/customers",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/xero/get-customers/xero-get-customers-response-schema.ts
import { oz as oz302 } from "@vy/utils";
var XeroCustomerPayloadSchema = oz302.object({
  id: oz302.string(),
  name: oz302.string(),
  email: oz302.string().optional(),
  isActive: oz302.boolean().optional()
});
var XeroGetCustomersResponseSchema = oz302.object({
  customers: oz302.array(XeroCustomerPayloadSchema)
}).openapi("XeroGetCustomersResponse");

// src/api-definition-paths/integrations-paths/xero/get-customers/xero-get-customers-action.ts
var XERO_GET_CUSTOMERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "xero-get-customers"
  },
  queryParams: {
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER
  },
  response: {
    name: "XeroGetCustomersResponse",
    schema: XeroGetCustomersResponseSchema
  },
  path: XERO_GET_CUSTOMERS_PATH
};

// src/api-definition-paths/integrations-paths/xero/get-deposit-to-accounts/xero-get-deposit-to-accounts-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS181 } from "@vy/zapi-types";
var XERO_GET_DEPOSIT_TO_ACCOUNTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS181.PRIVATE,
  route: "/integrations/xero/deposit-to-accounts",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/xero/get-deposit-to-accounts/xero-get-deposit-to-accounts-response-schema.ts
import { oz as oz303 } from "@vy/utils";
var XeroDepositToAccountSchema = oz303.object({
  id: oz303.string(),
  name: oz303.string(),
  code: oz303.string().optional()
});
var XeroGetDepositToAccountsResponseSchema = oz303.object({
  depositToAccounts: oz303.array(XeroDepositToAccountSchema)
}).openapi("XeroGetDepositToAccountsResponse");

// src/api-definition-paths/integrations-paths/xero/get-deposit-to-accounts/xero-get-deposit-to-accounts-action.ts
var XERO_GET_DEPOSIT_TO_ACCOUNTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "xero-get-deposit-to-accounts"
  },
  response: {
    name: "XeroGetDepositToAccountsResponse",
    schema: XeroGetDepositToAccountsResponseSchema
  },
  path: XERO_GET_DEPOSIT_TO_ACCOUNTS_PATH
};

// src/api-definition-paths/integrations-paths/xero/get-products/xero-get-products-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS182 } from "@vy/zapi-types";
var XERO_GET_PRODUCTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS182.PRIVATE,
  route: "/integrations/xero/products",
  tags: API_TAGS.INTEGRATIONS
};

// src/api-definition-paths/integrations-paths/xero/get-products/xero-get-products-response-schema.ts
import { oz as oz304 } from "@vy/utils";
var XeroProductPayloadSchema = oz304.object({
  id: oz304.string(),
  name: oz304.string(),
  code: oz304.string().optional()
});
var XeroGetProductsResponseSchema = oz304.object({
  products: oz304.array(XeroProductPayloadSchema)
}).openapi("XeroGetProductsResponse");

// src/api-definition-paths/integrations-paths/xero/get-products/xero-get-products-action.ts
var XERO_GET_PRODUCTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "xero-get-products"
  },
  queryParams: {
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER
  },
  response: {
    name: "XeroGetProductsResponse",
    schema: XeroGetProductsResponseSchema
  },
  path: XERO_GET_PRODUCTS_PATH
};

// src/api-definition-paths/integrations-paths/integrations-actions.ts
var INTEGRATIONS_ACTIONS = [
  ANROK_CONNECT_ACTION,
  ANROK_BACKFILL_TRANSACTIONS_ACTION,
  HUBSPOT_AUTH_CALLBACK_ACTION,
  HUBSPOT_AUTH_CONNECT_ACTION,
  HUBSPOT_SYNC_CUSTOMERS_ACTION,
  GET_CONNECTED_INTEGRATIONS_ACTION,
  GET_EXTERNAL_LINK_ACTION,
  GET_INTEGRATION_SETTINGS_ACTION,
  GET_INVOICE_PRODUCTS_INTEGRATIONS_ACTION,
  UPDATE_INTEGRATION_CONFIGURATION_ACTION,
  DISCONNECT_INTEGRATION_ACTION,
  SALESFORCE_IMPORT_CUSTOMERS_ACTION,
  STRIPE_CONNECT_ACTION,
  STRIPE_CREATE_INVOICE_ACTION,
  STRIPE_EVENT_ACTION,
  STRIPE_GET_CUSTOMERS_ACTION,
  STRIPE_CREATE_CUSTOMER_ACTION,
  NET_SUITE_CONNECT_ACTION,
  EXPORT_NET_SUITE_SALES_ORDER_ACTION,
  NET_SUITE_GET_CUSTOMERS_ACTION,
  NET_SUITE_GET_CUSTOMER_ACTION,
  NET_SUITE_GET_PRODUCTS_ACTION,
  NET_SUITE_GET_CLASSES_ACTION,
  NET_SUITE_SYNC_INVOICES_ACTION,
  NET_SUITE_SYNC_INVOICES_SALES_ORDER_ACTION,
  NET_SUITE_UPDATE_SALES_ORDER_ACTION,
  GET_NET_SUITE_SUBSIDIARIES_ACTION,
  NET_SUITE_GET_INVOICE_DASHBOARD_URL_ACTION,
  QUICKBOOKS_CONNECT_ACTION,
  QUICKBOOKS_AUTH_CALLBACK_ACTION,
  QUICKBOOKS_GET_CUSTOMERS_ACTION,
  QUICKBOOKS_GET_PRODUCTS_ACTION,
  QUICKBOOKS_GET_DEPOSIT_TO_ACCOUNTS_ACTION,
  QUICKBOOKS_EXPORT_INVOICES_ACTION,
  QUICKBOOKS_EXPORT_CREDIT_MEMO_ACTION,
  GET_SLACK_USERS_ACTION,
  SEND_SLACK_CREDIT_NOTE_NOTIFICATION_ACTION,
  SEND_SLACK_INVOICE_APPROVAL_MESSAGE_ACTION,
  SLACK_EVENT_HANDLER_ACTION,
  SLACK_CONNECT_ACTION,
  SLACK_CALLBACK_ACTION,
  GET_SLACK_CHANNELS_ACTION,
  SALESFORCE_CONNECT_ACTION,
  SALESFORCE_GET_CONTRACT_CUSTOM_FIELDS_ACTION,
  NET_SUITE_GET_CREDIT_ITEMS_ACTION,
  NET_SUITE_GET_DEPOSIT_TO_ACCOUNTS_ACTION,
  NET_SUITE_EXPORT_CREDIT_MEMO_ACTION,
  MODIFY_EXTERNAL_PRODUCT_ACTION,
  MORNING_CONNECT_ACTION,
  MORNING_GET_CUSTOMERS_ACTION,
  MORNING_EXPORT_INVOICES_ACTION,
  CONNACT_CONNECT_ACTION,
  EXPORT_USAGE_TO_MARKETPLACE_ACTION,
  XERO_AUTH_CALLBACK_ACTION,
  XERO_AUTH_CONNECT_ACTION,
  XERO_EXPORT_CREDIT_MEMO_ACTION,
  XERO_EXPORT_INVOICES_ACTION,
  XERO_GET_CUSTOMERS_ACTION,
  XERO_GET_DEPOSIT_TO_ACCOUNTS_ACTION,
  XERO_GET_PRODUCTS_ACTION,
  PADDLE_CONNECT_ACTION,
  PADDLE_EVENT_ACTION,
  PADDLE_EXPORT_INVOICES_ACTION,
  PADDLE_GET_CUSTOMERS_ACTION,
  PADDLE_GET_PRODUCTS_ACTION,
  PADDLE_GET_TRANSACTION_URL_ACTION
];

// src/api-definition-paths/integrations-paths/integrations-paths.ts
var INTEGRATIONS_PATHS = [
  HUBSPOT_AUTH_CALLBACK_PATH,
  HUBSPOT_AUTH_CONNECT_PATH,
  HUBSPOT_SYNC_CUSTOMERS_PATH,
  GET_CONNECTED_INTEGRATIONS_PATH,
  GET_INTEGRATION_SETTINGS_PATH,
  GET_INVOICE_PRODUCTS_INTEGRATIONS_PATH,
  UPDATE_INTEGRATION_CONFIGURATION_PATH,
  DISCONNECT_INTEGRATION_PATH,
  SALESFORCE_IMPORT_CUSTOMERS_PATH,
  STRIPE_CONNECT_PATH,
  STRIPE_CREATE_INVOICE_PATH,
  STRIPE_EVENT_PATH,
  STRIPE_GET_CUSTOMERS_PATH,
  STRIPE_CREATE_CUSTOMER_PATH,
  NET_SUITE_CONNECT_PATH,
  NET_SUITE_EXPORT_SALES_ORDER_PATH,
  NET_SUITE_GET_CUSTOMERS_PATH,
  NET_SUITE_GET_CUSTOMER_PATH,
  NET_SUITE_GET_PRODUCTS_PATH,
  NET_SUITE_GET_CLASSES_PATH,
  NET_SUITE_SYNC_INVOICES_PATH,
  NET_SUITE_UPDATE_SALES_ORDER_PATH,
  GET_NET_SUITE_SUBSIDIARIES_PATH,
  NET_SUITE_GET_INVOICE_DASHBOARD_URL_PATH,
  QUICKBOOKS_GET_CUSTOMERS_PATH,
  QUICKBOOKS_GET_PRODUCTS_PATH,
  QUICKBOOKS_CONNECT_PATH,
  QUICKBOOKS_AUTH_CALLBACK_PATH,
  QUICKBOOKS_EXPORT_INVOICES_PATH,
  GET_SLACK_USERS_PATH,
  SEND_SLACK_CREDIT_NOTE_NOTIFICATION_PATH,
  SEND_SLACK_INVOICE_APPROVAL_MESSAGE_PATH,
  SLACK_EVENT_HANDLER_PATH,
  SLACK_CONNECT_PATH,
  SLACK_CALLBACK_PATH,
  GET_SLACK_CHANNELS_PATH,
  SALESFORCE_CONNECT_PATH,
  SALESFORCE_GET_CONTRACT_CUSTOM_FIELDS_PATH,
  NET_SUITE_EXPORT_CREDIT_MEMO_PATH,
  NET_SUITE_GET_CREDIT_ITEMS_PATH,
  MODIFY_EXTERNAL_PRODUCT_PATH,
  MORNING_CONNECT_PATH,
  MORNING_GET_CUSTOMERS_PATH,
  MORNING_EXPORT_INVOICES_PATH,
  XERO_AUTH_CALLBACK_PATH,
  XERO_AUTH_CONNECT_PATH,
  XERO_EXPORT_CREDIT_MEMO_PATH,
  XERO_EXPORT_INVOICES_PATH,
  XERO_GET_CUSTOMERS_PATH,
  XERO_GET_PRODUCTS_PATH,
  QUICKBOOKS_EXPORT_CREDIT_MEMO_PATH,
  PADDLE_CONNECT_PATH,
  PADDLE_EVENT_PATH,
  PADDLE_EXPORT_INVOICES_PATH,
  PADDLE_GET_CUSTOMERS_PATH,
  PADDLE_GET_PRODUCTS_PATH
];

// src/api-definition-paths/line-items-paths/create-line-item/create-line-item-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS183 } from "@vy/zapi-types";
var CREATE_LINE_ITEM_PATH = {
  accessLevel: PATH_ACCESS_LEVELS183.PRIVATE,
  route: "/line-item",
  tags: API_TAGS.LINE_ITEM
};

// src/api-definition-paths/line-items-paths/create-line-item/create-line-item-revision-request-schema.ts
import { NewLineItemSchema } from "@vy/types";
var CreateLineItemRequestSchema = NewLineItemSchema.openapi("CreateLineItemRequest");

// src/api-definition-paths/line-items-paths/create-line-item/create-line-item-revision-response-schema.ts
import { LineItemSchema } from "@vy/types";
import { oz as oz305 } from "@vy/utils";
var CreateLineItemResponseSchema = oz305.object({
  updatedLineItem: LineItemSchema
}).openapi("CreateLineItemResponse");

// src/api-definition-paths/line-items-paths/create-line-item/create-line-item-action.ts
var CREATE_LINE_ITEM_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "create-line-item"
  },
  response: {
    name: "CreateLineItemResponse",
    schema: CreateLineItemResponseSchema
  },
  request: {
    name: "CreateLineItemRequest",
    schema: CreateLineItemRequestSchema
  },
  path: CREATE_LINE_ITEM_PATH
};

// src/api-definition-paths/line-items-paths/line-item-id-path.ts
import { oz as oz306 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS184 } from "@vy/zapi-types";
var LINE_ITEM_ID_PATH_PARAM = {
  name: "lineItemId",
  location: "path",
  schema: oz306.string(),
  required: true
};
var LINE_ITEM_ID_PATH_PARAMS = {
  [LINE_ITEM_ID_PATH_PARAM.name]: LINE_ITEM_ID_PATH_PARAM
};
var LINE_ITEM_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS184.PRIVATE,
  route: "/line-item/{lineItemId}",
  pathParams: LINE_ITEM_ID_PATH_PARAMS,
  tags: API_TAGS.LINE_ITEM
};

// src/api-definition-paths/line-items-paths/delete-line-item/delete-line-item-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema43 } from "@vy/types";
import { oz as oz307 } from "@vy/utils";
var DeleteLineItemResponseSchema = oz307.object({
  lineItemId: ObjectIdSchema43
}).openapi("DeleteLineItemResponse");

// src/api-definition-paths/line-items-paths/delete-line-item/delete-line-item-action.ts
var DELETE_LINE_ITEM_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-line-item"
  },
  response: {
    name: "DeleteLineItemResponse",
    schema: DeleteLineItemResponseSchema
  },
  path: LINE_ITEM_ID_PATH
};

// src/api-definition-paths/line-items-paths/set-line-item-calculation-state/set-line-item-calculation-state-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS185 } from "@vy/zapi-types";
var SET_LINE_ITEM_CALCULATION_STATE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS185.PRIVATE,
  route: "/line-item/{lineItemId}/calculation-state",
  pathParams: LINE_ITEM_ID_PATH_PARAMS,
  tags: API_TAGS.LINE_ITEM
};

// src/api-definition-paths/line-items-paths/set-line-item-calculation-state/set-line-item-calculation-state-request-schema.ts
import { oz as oz308 } from "@vy/utils";
var SetLineItemCalculationStateRequestSchema = oz308.object({
  disable: oz308.boolean()
}).openapi("SetLineItemCalculationStateRequest");

// src/api-definition-paths/line-items-paths/set-line-item-calculation-state/set-line-item-calculation-state-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema44 } from "@vy/types";
import { oz as oz309 } from "@vy/utils";
var SetLineItemCalculationStateResponseSchema = oz309.object({
  lineItemId: ObjectIdSchema44
}).openapi("SetLineItemCalculationStateResponse");

// src/api-definition-paths/line-items-paths/set-line-item-calculation-state/set-line-item-calculation-state-action.ts
var SET_LINE_ITEM_CALCULATION_STATE_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "set-line-item-calculation-state"
  },
  response: {
    name: "SetLineItemCalculationStateResponse",
    schema: SetLineItemCalculationStateResponseSchema
  },
  request: {
    name: "SetLineItemCalculationStateRequest",
    schema: SetLineItemCalculationStateRequestSchema
  },
  path: SET_LINE_ITEM_CALCULATION_STATE_PATH
};

// src/api-definition-paths/line-items-paths/trigger-line-items-calculator/trigger-line-items-calculator-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS186 } from "@vy/zapi-types";
var TRIGGER_LINE_ITEM_CALCULATOR_PATH = {
  accessLevel: PATH_ACCESS_LEVELS186.PRIVATE,
  route: "/line-items/trigger-calculator",
  tags: API_TAGS.LINE_ITEM
};

// src/api-definition-paths/line-items-paths/trigger-line-items-calculator/trigger-line-items-calculator-action.ts
var TRIGGER_LINE_ITEMS_CALCULATOR_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "trigger-line-items-calculator"
  },
  path: TRIGGER_LINE_ITEM_CALCULATOR_PATH
};

// src/api-definition-paths/line-items-paths/undo-line-item-price-override/undo-line-item-price-override-response-schema.ts
import { LineItemSchema as LineItemSchema2 } from "@vy/types";
import { oz as oz310 } from "@vy/utils";
var UndoLineItemPriceOverrideResponseSchema = oz310.object({
  lineItem: LineItemSchema2
}).openapi("UndoLineItemPriceOverrideResponse");

// src/api-definition-paths/line-items-paths/undo-line-item-price-override/undo-line-item-price-override-action.ts
var UNDO_LINE_ITEM_PRICE_OVERRIDE_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "undo-line-item-price-override"
  },
  response: {
    name: "UndoLineItemPriceOverrideResponse",
    schema: UndoLineItemPriceOverrideResponseSchema
  },
  path: {
    ...LINE_ITEM_ID_PATH,
    route: "/line-item/{lineItemId}/undo-price-override"
  }
};

// src/api-definition-paths/line-items-paths/update-line-item/update-line-item-request-schema.ts
import { LineItemInputSchema } from "@vy/types";
var UpdateLineItemRequestSchema = LineItemInputSchema.openapi("UpdateLineItemRequest");

// src/api-definition-paths/line-items-paths/update-line-item/update-line-item-response-schema.ts
import { LineItemSchema as LineItemSchema3 } from "@vy/types";
import { oz as oz311 } from "@vy/utils";
var UpdateLineItemResponseSchema = oz311.object({
  lineItem: LineItemSchema3
}).openapi("UpdateLineItemResponse");

// src/api-definition-paths/line-items-paths/update-line-item/update-line-item-action.ts
var UPDATE_LINE_ITEM_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-line-item"
  },
  response: {
    name: "UpdateLineItemResponse",
    schema: UpdateLineItemResponseSchema
  },
  request: {
    name: "UpdateLineItemRequest",
    schema: UpdateLineItemRequestSchema
  },
  path: LINE_ITEM_ID_PATH
};

// src/api-definition-paths/line-items-paths/update-line-item-integration-entities/update-line-item-integration-entities-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS187 } from "@vy/zapi-types";
var UPDATE_LINE_ITEM_INTEGRATION_ENTITIES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS187.PRIVATE,
  route: "/line-item/{lineItemId}/integration-entities",
  pathParams: LINE_ITEM_ID_PATH_PARAMS,
  tags: API_TAGS.LINE_ITEM
};

// src/api-definition-paths/line-items-paths/update-line-item-integration-entities/update-line-item-integration-entities-request-schema.ts
import { BaseIntegrationEntitySchema as BaseIntegrationEntitySchema3, withNullAsOptional as withNullAsOptional3 } from "@vy/types";
import { oz as oz312 } from "@vy/utils";
var UpdateLineItemIntegrationEntitiesRequestSchema = oz312.object({
  integrationEntities: withNullAsOptional3(oz312.array(BaseIntegrationEntitySchema3))
}).openapi("UpdateLineItemIntegrationEntitiesRequest");

// src/api-definition-paths/line-items-paths/update-line-item-integration-entities/update-line-item-integration-entities-action.ts
var UPDATE_LINE_ITEM_INTEGRATION_ENTITIES_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-line-item-integration-entities"
  },
  path: UPDATE_LINE_ITEM_INTEGRATION_ENTITIES_PATH,
  request: {
    name: "UpdateLineItemIntegrationEntitiesRequest",
    schema: UpdateLineItemIntegrationEntitiesRequestSchema
  }
};

// src/api-definition-paths/line-items-paths/update-line-items/update-line-items-request-schema.ts
import { LineItemInputSchema as LineItemInputSchema2 } from "@vy/types";
import { oz as oz313 } from "@vy/utils";
var UpdateLineItemsRequestSchema = oz313.object({
  lineItems: oz313.array(LineItemInputSchema2)
}).openapi("UpdateLineItemsRequest");

// src/api-definition-paths/line-items-paths/update-line-items/update-line-items-response-schema.ts
import { LineItemSchema as LineItemSchema4 } from "@vy/types";
import { oz as oz314 } from "@vy/utils";
var UpdateLineItemsResponseSchema = oz314.object({
  lineItems: oz314.array(LineItemSchema4)
}).openapi("UpdateLineItemsResponse");

// src/api-definition-paths/line-items-paths/update-line-items/update-line-items-bulk-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS188 } from "@vy/zapi-types";
var LINE_ITEM_BULK_UPDATE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS188.PRIVATE,
  route: "/line-items/bulk-update",
  tags: API_TAGS.LINE_ITEM
};

// src/api-definition-paths/line-items-paths/update-line-items/update-line-items-action.ts
var UPDATE_LINE_ITEMS_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-line-items"
  },
  response: {
    name: "UpdateLineItemsResponse",
    schema: UpdateLineItemsResponseSchema
  },
  request: {
    name: "UpdateLineItemsRequest",
    schema: UpdateLineItemsRequestSchema
  },
  path: LINE_ITEM_BULK_UPDATE_PATH
};

// src/api-definition-paths/line-items-paths/line-items-actions.ts
var LINE_ITEMS_ACTIONS = [
  TRIGGER_LINE_ITEMS_CALCULATOR_ACTION,
  DELETE_LINE_ITEM_ACTION,
  UPDATE_LINE_ITEM_ACTION,
  UPDATE_LINE_ITEMS_ACTION,
  CREATE_LINE_ITEM_ACTION,
  SET_LINE_ITEM_CALCULATION_STATE_ACTION,
  UPDATE_LINE_ITEM_INTEGRATION_ENTITIES_ACTION,
  UNDO_LINE_ITEM_PRICE_OVERRIDE_ACTION
];

// src/api-definition-paths/line-items-paths/line-items-paths.ts
var LINE_ITEMS_PATHS = [
  TRIGGER_LINE_ITEM_CALCULATOR_PATH,
  LINE_ITEM_ID_PATH,
  CREATE_LINE_ITEM_PATH,
  SET_LINE_ITEM_CALCULATION_STATE_PATH,
  UPDATE_LINE_ITEM_INTEGRATION_ENTITIES_PATH,
  LINE_ITEM_BULK_UPDATE_PATH
];

// src/api-definition-paths/event-fields-paths/get-event-field-values/get-event-field-values-action.ts
import { oz as oz316 } from "@vy/utils";

// src/api-definition-paths/event-fields-paths/get-event-field-values/get-event-field-values-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS189 } from "@vy/zapi-types";
var GET_EVENT_FIELD_VALUES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS189.PRIVATE,
  route: `/${API_TAGS.EVENT_FIELDS}/event-field-values`,
  tags: API_TAGS.EVENT_FIELDS
};

// src/api-definition-paths/event-fields-paths/get-event-field-values/get-event-field-values-response-schema.ts
import { oz as oz315 } from "@vy/utils";
var GetEventFieldValuesResponseSchema = oz315.object({
  eventFieldValues: oz315.array(oz315.string())
}).openapi("GetEventFieldValuesResponse");

// src/api-definition-paths/event-fields-paths/get-event-field-values/get-event-field-values-action.ts
var EVENT_FIELD_VALUES_EVENT_NAME_QUERY_PARAMETER = {
  name: "eventName",
  location: "query",
  schema: oz316.string(),
  required: true
};
var EVENT_FIELD_VALUES_FIELD_NAME_QUERY_PARAMETER = {
  name: "fieldName",
  location: "query",
  schema: oz316.string(),
  required: true
};
var GET_EVENT_FIELD_VALUES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-event-field-values"
  },
  queryParams: {
    [EVENT_FIELD_VALUES_EVENT_NAME_QUERY_PARAMETER.name]: EVENT_FIELD_VALUES_EVENT_NAME_QUERY_PARAMETER,
    [EVENT_FIELD_VALUES_FIELD_NAME_QUERY_PARAMETER.name]: EVENT_FIELD_VALUES_FIELD_NAME_QUERY_PARAMETER
  },
  response: {
    name: "GetEventFieldValuesResponse",
    schema: GetEventFieldValuesResponseSchema
  },
  path: GET_EVENT_FIELD_VALUES_PATH
};

// src/api-definition-paths/event-fields-paths/get-event-fields/get-event-fields-action.ts
import { oz as oz318 } from "@vy/utils";

// src/api-definition-paths/event-fields-paths/get-event-fields/get-event-fields-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS190 } from "@vy/zapi-types";
var GET_EVENT_FIELDS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS190.PRIVATE,
  route: "/event-fields",
  tags: API_TAGS.EVENT_FIELDS
};

// src/api-definition-paths/event-fields-paths/get-event-fields/get-event-fields-response-schema.ts
import { EventFieldSchema } from "@vy/types";
import { oz as oz317 } from "@vy/utils";
var GetEventFieldsResponseSchema = oz317.object({
  eventFields: oz317.array(EventFieldSchema)
}).openapi("GetEventFieldsResponse");

// src/api-definition-paths/event-fields-paths/get-event-fields/get-event-fields-action.ts
var EVENT_FIELDS_QUERY_EVENT_NAME_PARAMETER = {
  name: "eventName",
  location: "query",
  schema: oz318.string(),
  required: true
};
var GET_EVENT_FIELDS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-event-fields"
  },
  queryParams: {
    [EVENT_FIELDS_QUERY_EVENT_NAME_PARAMETER.name]: EVENT_FIELDS_QUERY_EVENT_NAME_PARAMETER
  },
  response: {
    name: "GetEventFieldsResponse",
    schema: GetEventFieldsResponseSchema
  },
  path: GET_EVENT_FIELDS_PATH
};

// src/api-definition-paths/event-fields-paths/get-event-names/get-event-names-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS191 } from "@vy/zapi-types";
var GET_EVENT_NAMES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS191.PRIVATE,
  route: "/event-fields/names",
  tags: API_TAGS.EVENT_FIELDS
};

// src/api-definition-paths/event-fields-paths/get-event-names/get-event-names-response-schema.ts
import { EventNameSchema } from "@vy/types";
import { oz as oz319 } from "@vy/utils";
var GetEventNamesResponseSchema = oz319.object({
  eventNames: oz319.array(EventNameSchema)
}).openapi("GetEventFieldsResponse");

// src/api-definition-paths/event-fields-paths/get-event-names/get-event-names-action.ts
var GET_EVENT_NAMES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-event-names"
  },
  response: {
    name: "GetEventNamesResponse",
    schema: GetEventNamesResponseSchema
  },
  path: GET_EVENT_NAMES_PATH
};

// src/api-definition-paths/event-fields-paths/event-fields-paths.ts
var EVENT_FIELDS_PATHS = [GET_EVENT_FIELDS_PATH, GET_EVENT_NAMES_PATH, GET_EVENT_FIELD_VALUES_PATH];

// src/api-definition-paths/event-fields-paths/event-fields-actions.ts
var EVENT_FIELDS_ACTIONS = [
  GET_EVENT_NAMES_ACTION,
  GET_EVENT_FIELDS_ACTION,
  GET_EVENT_FIELD_VALUES_ACTION
];

// src/api-definition-paths/events-paths/filter-sample-events/filter-sample-events-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS192 } from "@vy/zapi-types";
var FILTER_SAMPLE_EVENTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS192.PRIVATE,
  route: "/events/sample",
  tags: API_TAGS.EVENTS
};

// src/api-definition-paths/events-paths/filter-sample-events/filter-sample-events-request-schema.ts
import { FilterSchema } from "@vy/types";
import { oz as oz320 } from "@vy/utils";
var FilterSampleEventsRequestSchema = oz320.object({
  filter: FilterSchema
}).openapi("FilterSampleEventsRequest");

// src/api-definition-paths/events-paths/filter-sample-events/filter-sample-events-response-schema.ts
import { IngestedEventSampleSchema } from "@vy/types";
import { oz as oz321 } from "@vy/utils";
var FilterSampleEventsResponseSchema = oz321.object({
  events: oz321.array(IngestedEventSampleSchema)
}).openapi("FilterSampleEventsResponse");

// src/api-definition-paths/events-paths/filter-sample-events/filter-sample-events-action.ts
var FILTER_SAMPLE_EVENTS_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "filter-sample-events"
  },
  request: {
    name: "FilterSampleEventsRequest",
    schema: FilterSampleEventsRequestSchema
  },
  response: {
    name: "FilterSampleEventsResponse",
    schema: FilterSampleEventsResponseSchema
  },
  path: FILTER_SAMPLE_EVENTS_PATH
};

// src/api-definition-paths/events-paths/get-affected-metered-events/get-affected-metered-events-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS193 } from "@vy/zapi-types";
var GET_AFFECTED_METERED_EVENTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS193.PRIVATE,
  route: "/events/affected-metered-events",
  tags: API_TAGS.EVENTS
};

// src/api-definition-paths/events-paths/get-affected-metered-events/get-affected-metered-events-response-schema.ts
import { AffectedMeteredEventSampleSchema } from "@vy/types";
import { oz as oz322 } from "@vy/utils";
var GetAffectedMeteredEventsResponseSchema = oz322.object({
  affectedMeteredEvents: oz322.array(AffectedMeteredEventSampleSchema)
}).openapi("GetAffectedMeteredEventsResponse");

// src/api-definition-paths/events-paths/get-affected-metered-events/get-affected-metered-events-action.ts
var GET_AFFECTED_METERED_EVENTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-affected-metered-events"
  },
  queryParams: {
    [EVENT_REF_QUERY_PARAM.name]: EVENT_REF_QUERY_PARAM,
    [OPTIONAL_END_TIME_QUERY_PARAM.name]: OPTIONAL_END_TIME_QUERY_PARAM,
    [OPTIONAL_START_TIME_QUERY_PARAM.name]: OPTIONAL_START_TIME_QUERY_PARAM
  },
  response: {
    name: "GetAffectedMeteredEventsResponse",
    schema: GetAffectedMeteredEventsResponseSchema
  },
  path: GET_AFFECTED_METERED_EVENTS_PATH
};

// src/api-definition-paths/events-paths/get-latest-events/get-latest-events-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS194 } from "@vy/zapi-types";
var GET_LATEST_EVENTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS194.PRIVATE,
  route: "/events/latest",
  tags: API_TAGS.EVENTS
};

// src/api-definition-paths/events-paths/get-latest-events/get-latest-events-response-schema.ts
import { IngestedEventSampleSchema as IngestedEventSampleSchema2 } from "@vy/types";
import { oz as oz323 } from "@vy/utils";
var GetLatestEventsResponseSchema = oz323.object({
  events: oz323.array(IngestedEventSampleSchema2),
  countedFilteredEvents: oz323.number().nonnegative()
}).openapi("GetLatestEventsResponse");

// src/api-definition-paths/events-paths/get-latest-events/get-latest-events-action.ts
var GET_LATEST_EVENTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-latest-events"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [OPTIONAL_END_TIME_QUERY_PARAM.name]: OPTIONAL_END_TIME_QUERY_PARAM,
    [OPTIONAL_START_TIME_QUERY_PARAM.name]: OPTIONAL_START_TIME_QUERY_PARAM,
    [OPTIONAL_EVENT_NAMES_QUERY_PARAM.name]: OPTIONAL_EVENT_NAMES_QUERY_PARAM,
    [OPTIONAL_CUSTOMER_ALIAS_QUERY_PARAM.name]: OPTIONAL_CUSTOMER_ALIAS_QUERY_PARAM,
    [OPTIONAL_EVENT_REF_QUERY_PARAM.name]: OPTIONAL_EVENT_REF_QUERY_PARAM
  },
  response: {
    name: "GetLatestEventsResponse",
    schema: GetLatestEventsResponseSchema
  },
  path: GET_LATEST_EVENTS_PATH
};

// src/api-definition-paths/events-paths/events-paths.ts
var EVENTS_PATHS = [
  GET_LATEST_EVENTS_PATH,
  FILTER_SAMPLE_EVENTS_PATH,
  GET_AFFECTED_METERED_EVENTS_PATH
];

// src/api-definition-paths/events-paths/events-actions.ts
var EVENTS_ACTIONS = [
  GET_LATEST_EVENTS_ACTION,
  FILTER_SAMPLE_EVENTS_ACTION,
  GET_AFFECTED_METERED_EVENTS_ACTION
];

// src/api-definition-paths/credit-ledger-paths/delete-credit-note/delete-credit-note-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS195 } from "@vy/zapi-types";
import { oz as oz324 } from "@vy/utils";
var CREDIT_LEDGER_ENTRY_ID_PATH_PARAM = {
  name: "creditLedgerEntryId",
  location: "path",
  schema: oz324.string(),
  required: true
};
var CREDIT_LEDGER_ENTRY_ID_PATH_PARAMS = {
  [CREDIT_LEDGER_ENTRY_ID_PATH_PARAM.name]: CREDIT_LEDGER_ENTRY_ID_PATH_PARAM
};
var DELETE_CREDIT_NOTE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS195.PRIVATE,
  route: `/credit-ledger/{${CREDIT_LEDGER_ENTRY_ID_PATH_PARAM.name}}`,
  tags: API_TAGS.CREDIT_LEDGER,
  pathParams: CREDIT_LEDGER_ENTRY_ID_PATH_PARAMS
};

// src/api-definition-paths/credit-ledger-paths/delete-credit-note/delete-credit-note-action.ts
var DELETE_CREDIT_NOTE_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-credit-note"
  },
  path: DELETE_CREDIT_NOTE_PATH
};

// src/api-definition-paths/credit-ledger-paths/get-credit-ledger-overview/get-credit-ledger-overview-action.ts
import { oz as oz326 } from "@vy/utils";

// src/api-definition-paths/credit-ledger-paths/get-credit-ledger-overview/get-credit-ledger-overview-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS196 } from "@vy/zapi-types";
var GET_CREDIT_LEDGER_OVERVIEW_PATH = {
  accessLevel: PATH_ACCESS_LEVELS196.PRIVATE,
  route: "/credit-ledger/overview",
  tags: API_TAGS.CREDIT_LEDGER
};

// src/api-definition-paths/credit-ledger-paths/get-credit-ledger-overview/get-credit-ledger-overview-response-schema.ts
import { CreditLedgerEntryOverviewSchema, ObjectIdSchema as ObjectIdSchema45 } from "@vy/types";
import { oz as oz325 } from "@vy/utils";
var GetCreditLedgerOverviewResponseSchema = oz325.object({
  creditLedger: oz325.object({
    id: ObjectIdSchema45,
    balance: oz325.number(),
    entriesOverviews: oz325.array(CreditLedgerEntryOverviewSchema)
  }).optional()
}).openapi("GetCreditLedgerOverviewResponse");

// src/api-definition-paths/credit-ledger-paths/get-credit-ledger-overview/get-credit-ledger-overview-action.ts
var CUSTOMER_ID_PATH_PARAM3 = {
  name: "customerId",
  location: "query",
  schema: oz326.string(),
  required: true
};
var GET_CREDIT_LEDGER_OVERVIEW_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-credit-ledger-overview"
  },
  queryParams: {
    [CUSTOMER_ID_PATH_PARAM3.name]: CUSTOMER_ID_PATH_PARAM3
  },
  response: {
    name: "GetCreditLedgerOverviewResponse",
    schema: GetCreditLedgerOverviewResponseSchema
  },
  path: GET_CREDIT_LEDGER_OVERVIEW_PATH
};

// src/api-definition-paths/credit-ledger-paths/get-credit-ledger-pdf/get-credit-ledger-pdf-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS197 } from "@vy/zapi-types";

// src/api-definition-paths/credit-ledger-paths/credit-ledger-id-path.ts
import { oz as oz327 } from "@vy/utils";
var CREDIT_LEDGER_ID_PATH_PARAM = {
  name: "creditLedgerId",
  location: "path",
  schema: oz327.string(),
  required: true
};
var CREDIT_LEDGER_ID_PATH_PARAMS = {
  [CREDIT_LEDGER_ID_PATH_PARAM.name]: CREDIT_LEDGER_ID_PATH_PARAM
};

// src/api-definition-paths/credit-ledger-paths/get-credit-ledger-pdf/get-credit-ledger-pdf-path.ts
var GET_CREDIT_LEDGER_PDF_PATH = {
  accessLevel: PATH_ACCESS_LEVELS197.PRIVATE,
  route: "/credit-ledger/pdf/{creditLedgerId}",
  pathParams: CREDIT_LEDGER_ID_PATH_PARAMS,
  tags: API_TAGS.CREDIT_LEDGER
};

// src/api-definition-paths/credit-ledger-paths/get-credit-ledger-pdf/get-credit-ledger-pdf-response-schema.ts
import { Base64Schema as Base64Schema3, ObjectIdSchema as ObjectIdSchema46 } from "@vy/types";
import { oz as oz328 } from "@vy/utils";
var GetCreditLedgerPdfResponseSchema = oz328.object({
  creditLedgerId: ObjectIdSchema46,
  encodedPdf: Base64Schema3
}).openapi("GetCreditLedgerEntryPdfResponse");

// src/api-definition-paths/credit-ledger-paths/get-credit-ledger-pdf/get-credit-ledger-pdf-action.ts
var GET_CREDIT_LEDGER_PDF_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-credit-ledge-pdf"
  },
  response: {
    name: "GetCreditLedgerPdfResponse",
    schema: GetCreditLedgerPdfResponseSchema
  },
  path: GET_CREDIT_LEDGER_PDF_PATH
};

// src/api-definition-paths/credit-ledger-paths/get-credit-notes/get-credit-notes-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS198 } from "@vy/zapi-types";
var GET_CREDIT_NOTES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS198.PRIVATE,
  route: `/credit-ledger/{${CUSTOMER_ID_PATH_PARAM.name}}/credit-notes`,
  tags: API_TAGS.CREDIT_LEDGER,
  pathParams: CUSTOMER_ID_PATH_PARAMS
};

// src/api-definition-paths/credit-ledger-paths/get-credit-notes/get-credit-notes-response-schema.ts
import { ApiDateSchema as ApiDateSchema34 } from "@vy/types";
import { oz as oz329 } from "@vy/utils";
var CreditNoteSchema = oz329.object({
  id: oz329.string(),
  date: ApiDateSchema34,
  amount: oz329.number(),
  customerId: oz329.string(),
  customerName: oz329.string(),
  invoiceId: oz329.string().optional(),
  invoiceNumber: oz329.string().optional(),
  contractId: oz329.string().optional(),
  erpId: oz329.string().optional(),
  syncedIntegrations: oz329.array(oz329.string()).optional()
});
var GetCreditNotesResponseSchema = oz329.object({
  creditNotes: oz329.array(CreditNoteSchema)
}).openapi("GetCreditNotesResponse");

// src/api-definition-paths/credit-ledger-paths/get-credit-notes/get-credit-notes-action.ts
var GET_CREDIT_NOTES_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-credit-notes" },
  response: { name: "GetCreditNotesResponse", schema: GetCreditNotesResponseSchema },
  path: GET_CREDIT_NOTES_PATH
};

// src/api-definition-paths/credit-ledger-paths/issue-credit-note/post-credit-note-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS199 } from "@vy/zapi-types";
var POST_CREDIT_NOTE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS199.PRIVATE,
  route: `/credit-ledger/{${CUSTOMER_ID_PATH_PARAM.name}}`,
  tags: API_TAGS.CREDIT_LEDGER,
  pathParams: CUSTOMER_ID_PATH_PARAMS
};

// src/api-definition-paths/credit-ledger-paths/share-credit-notes/share-credit-notes-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS200 } from "@vy/zapi-types";
var SHARE_CREDIT_NOTES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS200.PRIVATE,
  route: "/credit-ledger/share",
  tags: API_TAGS.CREDIT_LEDGER
};

// src/api-definition-paths/credit-ledger-paths/share-credit-notes/share-credit-notes-request-schema.ts
import { oz as oz330 } from "@vy/utils";
var ShareCreditNotesRequestSchema = oz330.array(
  oz330.object({
    emailOverride: oz330.string().email().optional(),
    creditLedgerEntryId: oz330.string()
  }).openapi("shareCreditNotesRequest")
);

// src/api-definition-paths/credit-ledger-paths/share-credit-notes/share-credit-notes-action.ts
var SHARE_CREDIT_NOTES_ACTION = {
  method: "post",
  codeGenerationSettings: { actionText: "share-credit-notes" },
  request: { name: "ShareCreditNotesRequest", schema: ShareCreditNotesRequestSchema },
  path: SHARE_CREDIT_NOTES_PATH
};

// src/api-definition-paths/credit-ledger-paths/credit-ledger-paths.ts
var CREDIT_LEDGER_PATHS = [
  GET_CREDIT_LEDGER_OVERVIEW_PATH,
  POST_CREDIT_NOTE_PATH,
  DELETE_CREDIT_NOTE_PATH,
  GET_CREDIT_LEDGER_PDF_PATH,
  GET_CREDIT_NOTES_PATH,
  SHARE_CREDIT_NOTES_PATH
];

// src/api-definition-paths/credit-ledger-paths/issue-credit-note/create-customer-request-schema.ts
import { ApiDateSchema as ApiDateSchema35, ObjectIdSchema as ObjectIdSchema47 } from "@vy/types";
import { oz as oz331 } from "@vy/utils";
var IssueCreditNoteRequestSchema = oz331.object({
  date: ApiDateSchema35,
  amount: oz331.number().nonnegative(),
  invoiceId: ObjectIdSchema47.optional(),
  erpId: oz331.string().optional(),
  contractId: ObjectIdSchema47.optional()
}).openapi("IssueCreditNoteRequest");

// src/api-definition-paths/credit-ledger-paths/issue-credit-note/create-customer-response-schema.ts
var IssueCreditNoteResponseSchema = GetCreditLedgerOverviewResponseSchema.openapi("IssueCreditNoteResponse");

// src/api-definition-paths/credit-ledger-paths/issue-credit-note/get-credit-ledger-overview-action.ts
var CREATE_CREDIT_NOTE_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "post-credit-note"
  },
  request: {
    name: "IssueCreditNoteRequest",
    schema: IssueCreditNoteRequestSchema
  },
  response: {
    name: "IssueCreditNoteResponse",
    schema: IssueCreditNoteResponseSchema
  },
  path: POST_CREDIT_NOTE_PATH
};

// src/api-definition-paths/credit-ledger-paths/credit-ledger-actions.ts
var CREDIT_LEDGER_ACTIONS = [
  GET_CREDIT_LEDGER_OVERVIEW_ACTION,
  CREATE_CREDIT_NOTE_ACTION,
  DELETE_CREDIT_NOTE_ACTION,
  GET_CREDIT_LEDGER_PDF_ACTION,
  GET_CREDIT_NOTES_ACTION,
  SHARE_CREDIT_NOTES_ACTION
];

// src/api-definition-paths/measurements-paths/_shared/measurement-date-format.ts
import { vyDate } from "@vy/utils";
var SUPPORTED_DELIMITERS = [",", ";", "\\", "/", "-", "."];
var SUPPORTED_YEARS = ["YY", "YYYY"];
var SUPPORTED_MONTHS = ["M", "MM"];
var SUPPORTED_DAYS = ["D", "DD"];
var MONTH_FIRST_FORMATS = SUPPORTED_DELIMITERS.flatMap(
  (delimiter) => SUPPORTED_YEARS.flatMap(
    (year) => SUPPORTED_MONTHS.flatMap(
      (month) => SUPPORTED_DAYS.map((day) => `${month}${delimiter}${day}${delimiter}${year}`)
    )
  )
);
var YEAR_FIRST_FORMATS = SUPPORTED_DELIMITERS.flatMap(
  (delimiter) => SUPPORTED_MONTHS.flatMap(
    (month) => SUPPORTED_DAYS.map((day) => `YYYY${delimiter}${month}${delimiter}${day}`)
  )
);
var DATE_FORMATS = [...MONTH_FIRST_FORMATS, ...YEAR_FIRST_FORMATS];
function isValidMeasurementDate(date) {
  return vyDate(date, { format: DATE_FORMATS, localeOrStrict: true }).isValid();
}
function isStringNumber(value) {
  return !Number.isNaN(Number(value));
}

// src/api-definition-paths/measurements-paths/_shared/measurement-row-schema.ts
import { SanitizedStringSchema as SanitizedStringSchema3 } from "@vy/types";
import { oz as oz332 } from "@vy/utils";
var MeasurementRowSchema = oz332.object({
  date: SanitizedStringSchema3.refine(
    isValidMeasurementDate,
    "please provide a valid date in the MM/DD/YYYY, MM/DD/YY, or YYYY/MM/DD format"
  ),
  customer: SanitizedStringSchema3,
  meter: SanitizedStringSchema3,
  value: SanitizedStringSchema3.refine(isStringNumber, "must be a number")
}).openapi("MeasurementRow");

// src/api-definition-paths/measurements-paths/generate-measurements/generate-measurements-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS201 } from "@vy/zapi-types";
var GENERATE_MEASUREMENTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS201.PRIVATE,
  route: "/measurements/generate",
  tags: API_TAGS.MEASUREMENTS
};

// src/api-definition-paths/measurements-paths/generate-measurements/generate-measurements-data-schema.ts
import { PeriodSchema as PeriodSchema7 } from "@vy/types";
import { oz as oz333 } from "@vy/utils";
var GenerateMeasurementsDataSchema = oz333.object({
  data: oz333.object({
    period: PeriodSchema7,
    customersIds: oz333.array(oz333.string().nonempty()).min(1),
    metersIds: oz333.array(oz333.string().nonempty()).min(1),
    minimumQuantity: oz333.number().default(1),
    maximumQuantity: oz333.number().default(10)
  }).refine((data) => data.maximumQuantity > data.minimumQuantity, {
    message: "minimum quantity must be less than the maximum quantity",
    path: ["quantityMin"]
  })
}).openapi("GenerateMeasurements");

// src/api-definition-paths/measurements-paths/generate-measurements/generate-measurements-request-schema.ts
var GenerateMeasurementsRequestSchema = GenerateMeasurementsDataSchema.openapi(
  "GenerateMeasurementsRequest"
);

// src/api-definition-paths/measurements-paths/generate-measurements/generate-measurements-response-schema.ts
import { oz as oz334 } from "@vy/utils";
var GenerateMeasurementsResponseSchema = oz334.object({
  count: oz334.number()
}).openapi("GenerateMeasurementsResponse");

// src/api-definition-paths/measurements-paths/generate-measurements/generate-measurements-action.ts
var GENERATE_MEASUREMENTS_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "generate-measurements"
  },
  response: {
    name: "GenerateMeasurementsResponse",
    schema: GenerateMeasurementsResponseSchema
  },
  request: {
    name: "GenerateMeasurementsRequest",
    schema: GenerateMeasurementsRequestSchema
  },
  path: GENERATE_MEASUREMENTS_PATH
};

// src/api-definition-paths/measurements-paths/get-measurements-stats/get-measurements-stats-action.ts
import { oz as oz337 } from "@vy/utils";

// src/api-definition-paths/measurements-paths/get-measurements-stats/get-measurements-stats-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS202 } from "@vy/zapi-types";
var GET_MEASUREMENTS_STATS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS202.PRIVATE,
  route: "/measurements/stats",
  tags: API_TAGS.MEASUREMENTS
};

// src/api-definition-paths/measurements-paths/get-measurements-stats/get-measurements-stats-response-schema.ts
import { oz as oz336 } from "@vy/utils";

// src/api-definition-paths/measurements-paths/get-measurements-stats/measurements-stats-schema.ts
import { ApiDateSchema as ApiDateSchema36, CurrencySchema as CurrencySchema14 } from "@vy/types";
import { oz as oz335 } from "@vy/utils";
var MeasurementsStatsSchema = oz335.object({
  id: oz335.string(),
  day: ApiDateSchema36,
  customer: oz335.string().nonempty(),
  customerId: oz335.string().nonempty(),
  customerExternalId: oz335.string().optional(),
  product: oz335.string().nonempty(),
  productVariant: oz335.string().nonempty(),
  meterId: oz335.string().nonempty(),
  quantity: oz335.number(),
  price: oz335.number().optional(),
  currency: CurrencySchema14.optional(),
  instanceKey: oz335.string().optional()
}).openapi("MeasurementsStats");

// src/api-definition-paths/measurements-paths/get-measurements-stats/get-measurements-stats-response-schema.ts
var MEASUREMENTS_STATS_MODES = {
  EXPORT: "export",
  QUERY: "query"
};
var GetMeasurementsStatsQueryResponseSchema = oz336.object({
  items: oz336.array(MeasurementsStatsSchema),
  totalCount: oz336.number(),
  mode: oz336.literal(MEASUREMENTS_STATS_MODES.QUERY),
  totalValue: oz336.number()
}).openapi("GetMeasurementsStatsQueryResponse");
var GetMeasurementsStatsExportResponseSchema = oz336.object({
  items: oz336.array(MeasurementsStatsSchema),
  mode: oz336.literal(MEASUREMENTS_STATS_MODES.EXPORT)
}).openapi("GetMeasurementsStatsExportResponse");
var GetMeasurementsStatsResponseSchema = oz336.discriminatedUnion("mode", [
  GetMeasurementsStatsQueryResponseSchema,
  GetMeasurementsStatsExportResponseSchema
]).openapi("GetMeasurementsStatsResponse");

// src/api-definition-paths/measurements-paths/get-measurements-stats/get-measurements-stats-action.ts
var { schema: GetMeasurementsStatsSortingSchema, param: GET_MEASUREMENTS_STATS_SORTING_PARAM } = getQuerySortingItemParameterSchemas(MeasurementsStatsSchema, "GetMeasurementsStatsSorting");
var METER_EVENT_NAME_QUERY_PARAM = {
  name: "eventNames",
  location: "query",
  schema: StringArrayParamSchema.optional(),
  required: false
};
var MEASUREMENTS_STATS_MODE = {
  name: "mode",
  location: "query",
  schema: oz337.enum([MEASUREMENTS_STATS_MODES.EXPORT, MEASUREMENTS_STATS_MODES.QUERY]).default(MEASUREMENTS_STATS_MODES.EXPORT).optional(),
  required: false
};
var GET_MEASUREMENTS_STATS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-measurements-stats"
  },
  queryParams: {
    [CUSTOMERS_IDS_QUERY_PARAM.name]: CUSTOMERS_IDS_QUERY_PARAM,
    [METERS_IDS_QUERY_PARAM.name]: METERS_IDS_QUERY_PARAM,
    [START_TIME_QUERY_PARAM.name]: START_TIME_QUERY_PARAM,
    [END_TIME_QUERY_PARAM.name]: END_TIME_QUERY_PARAM,
    [METER_EVENT_NAME_QUERY_PARAM.name]: METER_EVENT_NAME_QUERY_PARAM,
    [MEASUREMENTS_STATS_MODE.name]: MEASUREMENTS_STATS_MODE,
    [GET_MEASUREMENTS_STATS_SORTING_PARAM.name]: GET_MEASUREMENTS_STATS_SORTING_PARAM,
    ...PAGINATION_QUERY_PARAMETERS
  },
  response: {
    name: "GetMeasurementsStatsResponse",
    schema: GetMeasurementsStatsResponseSchema
  },
  path: GET_MEASUREMENTS_STATS_PATH
};

// src/api-definition-paths/measurements-paths/measurement-id-path.ts
import { ObjectIdSchema as ObjectIdSchema48 } from "@vy/types";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS203 } from "@vy/zapi-types";
var MEASUREMENT_ID_PATH_PARAM = {
  name: "measurementId",
  location: "path",
  schema: ObjectIdSchema48,
  required: true
};
var MEASUREMENT_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS203.PRIVATE,
  route: "/measurement/{measurementId}",
  pathParams: {
    [MEASUREMENT_ID_PATH_PARAM.name]: MEASUREMENT_ID_PATH_PARAM
  },
  tags: API_TAGS.MEASUREMENT
};

// src/api-definition-paths/measurements-paths/measurements-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS204 } from "@vy/zapi-types";
var MEASUREMENTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS204.PRIVATE,
  route: "/measurements",
  tags: API_TAGS.MEASUREMENTS
};

// src/api-definition-paths/measurements-paths/upload-measurements/upload-measurements-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS205 } from "@vy/zapi-types";
var UPLOAD_MEASUREMENTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS205.PRIVATE,
  route: "/measurements/upload",
  tags: API_TAGS.MEASUREMENTS
};

// src/api-definition-paths/measurements-paths/upload-measurements/upload-measurements-response-schema.ts
import { oz as oz338 } from "@vy/utils";
var UploadMeasurementsResponseSchema = oz338.object({
  message: oz338.string()
}).openapi("UploadMeasurementsResponse");

// src/api-definition-paths/measurements-paths/upload-measurements/upload-measurements-action.ts
var UPLOAD_MEASUREMENTS_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "upload-measurements"
  },
  response: {
    name: "UploadMeasurementsResponse",
    schema: UploadMeasurementsResponseSchema
  },
  path: UPLOAD_MEASUREMENTS_PATH
};

// src/api-definition-paths/measurements-paths/upload-measurements/upload-measurements-data-schema.ts
import { oz as oz339 } from "@vy/utils";
var UploadMeasurementsDataSchema = oz339.object({
  customers: oz339.array(oz339.string()).optional()
}).openapi("UploadMeasurementsData");

// src/api-definition-paths/measurements-paths/upload-measurements-json/upload-measurements-json-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS206 } from "@vy/zapi-types";
var UPLOAD_MEASUREMENTS_JSON_PATH = {
  accessLevel: PATH_ACCESS_LEVELS206.PRIVATE,
  route: "/measurements/upload-json",
  tags: API_TAGS.MEASUREMENTS
};

// src/api-definition-paths/measurements-paths/upload-measurements-json/upload-measurements-json-request-schema.ts
import { oz as oz340 } from "@vy/utils";
var UploadMeasurementsJsonRequestSchema = oz340.object({
  rows: MeasurementRowSchema.array().min(1, "No measurements provided")
}).openapi("UploadMeasurementsJsonRequest");

// src/api-definition-paths/measurements-paths/upload-measurements-json/upload-measurements-json-action.ts
var UPLOAD_MEASUREMENTS_JSON_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "upload-measurements-json"
  },
  response: {
    name: "UploadMeasurementsJsonResponse",
    schema: UploadMeasurementsResponseSchema
  },
  request: {
    name: "UploadMeasurementsJsonRequest",
    schema: UploadMeasurementsJsonRequestSchema
  },
  path: UPLOAD_MEASUREMENTS_JSON_PATH
};

// src/api-definition-paths/measurements-paths/validate-measurement-data/validate-measurement-data-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS207 } from "@vy/zapi-types";
var VALIDATE_MEASUREMENT_DATA_PATH = {
  accessLevel: PATH_ACCESS_LEVELS207.PRIVATE,
  route: "/measurements/validate",
  tags: API_TAGS.MEASUREMENTS
};

// src/api-definition-paths/measurements-paths/validate-measurement-data/validate-measurement-data-response-schema.ts
import { oz as oz341 } from "@vy/utils";
var MergingMeasurementSchema = oz341.object({
  customer: oz341.string(),
  meter: oz341.string(),
  date: oz341.string()
}).openapi("MergingMeasurement");
var ValidateMeasurementDataResponseSchema = oz341.object({
  message: oz341.string().optional(),
  newCustomers: oz341.array(oz341.string()).optional(),
  mergingMeasurements: oz341.array(MergingMeasurementSchema).optional()
}).openapi("ValidateMeasurementDataResponse");

// src/api-definition-paths/measurements-paths/validate-measurement-data/validate-measurement-data-action.ts
var VALIDATE_MEASUREMENT_DATA_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "validate-measurement-data"
  },
  response: {
    name: "ValidateMeasurementDataResponse",
    schema: ValidateMeasurementDataResponseSchema
  },
  path: VALIDATE_MEASUREMENT_DATA_PATH
};

// src/api-definition-paths/measurements-paths/validate-measurements-json/validate-measurements-json-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS208 } from "@vy/zapi-types";
var VALIDATE_MEASUREMENTS_JSON_PATH = {
  accessLevel: PATH_ACCESS_LEVELS208.PRIVATE,
  route: "/measurements/validate-json",
  tags: API_TAGS.MEASUREMENTS
};

// src/api-definition-paths/measurements-paths/validate-measurements-json/validate-measurements-json-request-schema.ts
import { oz as oz342 } from "@vy/utils";
var ValidateMeasurementsJsonRequestSchema = oz342.object({
  rows: MeasurementRowSchema.array().min(1, "No measurements provided")
}).openapi("ValidateMeasurementsJsonRequest");

// src/api-definition-paths/measurements-paths/validate-measurements-json/validate-measurements-json-action.ts
var VALIDATE_MEASUREMENTS_JSON_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "validate-measurements-json"
  },
  response: {
    name: "ValidateMeasurementsJsonResponse",
    schema: ValidateMeasurementDataResponseSchema
  },
  request: {
    name: "ValidateMeasurementsJsonRequest",
    schema: ValidateMeasurementsJsonRequestSchema
  },
  path: VALIDATE_MEASUREMENTS_JSON_PATH
};

// src/api-definition-paths/measurements-paths/measurements-paths.ts
var MEASUREMENTS_PATHS = [
  GENERATE_MEASUREMENTS_PATH,
  MEASUREMENTS_PATH,
  MEASUREMENT_ID_PATH,
  GET_MEASUREMENTS_STATS_PATH,
  VALIDATE_MEASUREMENT_DATA_PATH,
  UPLOAD_MEASUREMENTS_PATH,
  UPLOAD_MEASUREMENTS_JSON_PATH,
  VALIDATE_MEASUREMENTS_JSON_PATH
];

// src/api-definition-paths/measurements-paths/get-measurements/get-measurements-response-schema.ts
import { MeasurementSchema } from "@vy/types";
import { oz as oz343 } from "@vy/utils";
var GetMeasurementsResponseSchema = oz343.object({
  measurements: oz343.array(MeasurementSchema)
}).openapi("GetMeasurementsResponse");

// src/api-definition-paths/measurements-paths/get-measurements/get-measurements-action.ts
var GET_MEASUREMENTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-measurements"
  },
  queryParams: {
    [CUSTOMERS_IDS_QUERY_PARAM.name]: CUSTOMERS_IDS_QUERY_PARAM,
    [METERS_IDS_QUERY_PARAM.name]: METERS_IDS_QUERY_PARAM,
    [START_TIME_QUERY_PARAM.name]: START_TIME_QUERY_PARAM,
    [END_TIME_QUERY_PARAM.name]: END_TIME_QUERY_PARAM
  },
  response: {
    name: "GetMeasurementsResponse",
    schema: GetMeasurementsResponseSchema
  },
  path: MEASUREMENTS_PATH
};

// src/api-definition-paths/measurements-paths/delete-measurement/delete-measurement-action.ts
import { MeasurementSchema as MeasurementSchema2 } from "@vy/types";
var DELETE_MEASUREMENT_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-measurement"
  },
  response: {
    name: "MeasurementDeleteResponse",
    schema: MeasurementSchema2
  },
  path: MEASUREMENT_ID_PATH
};

// src/api-definition-paths/measurements-paths/delete-measurements/delete-measurements-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema49 } from "@vy/types";
import { oz as oz344 } from "@vy/utils";
var DeleteMeasurementsRequestSchema = oz344.object({
  measurementIds: oz344.array(ObjectIdSchema49).openapi("measurementsId")
}).openapi("DeleteMeasurementsRequest");

// src/api-definition-paths/measurements-paths/delete-measurements/delete-measurements-response-schema.ts
import { MeasurementSchema as MeasurementSchema3 } from "@vy/types";
import { oz as oz345 } from "@vy/utils";
var DeleteMeasurementsResponseSchema = oz345.array(MeasurementSchema3).openapi("DeleteMeasurementsRequest");

// src/api-definition-paths/measurements-paths/delete-measurements/delete-measurements-action.ts
var DELETE_MEASUREMENTS_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-measurements"
  },
  request: {
    name: "DeleteMeasurementsRequest",
    schema: DeleteMeasurementsRequestSchema
  },
  response: {
    name: "MeasurementsDeleteResponse",
    schema: DeleteMeasurementsResponseSchema
  },
  path: MEASUREMENTS_PATH
};

// src/api-definition-paths/measurements-paths/update-measurement/update-measurement-action.ts
import { MeasurementSchema as MeasurementSchema4 } from "@vy/types";

// src/api-definition-paths/measurements-paths/update-measurement/update-measurement-request-schema.ts
import { oz as oz346 } from "@vy/utils";
var UpdateMeasurementRequestSchema = oz346.object({
  units: oz346.number()
});

// src/api-definition-paths/measurements-paths/update-measurement/update-measurement-action.ts
var UPDATE_MEASUREMENT_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-measurement"
  },
  response: {
    name: "UpdateMeasurementResponse",
    schema: MeasurementSchema4
  },
  request: {
    name: "UpdateMeasurementRequest",
    schema: UpdateMeasurementRequestSchema
  },
  path: MEASUREMENT_ID_PATH
};

// src/api-definition-paths/measurements-paths/measurements-actions.ts
var MEASUREMENTS_ACTIONS = [
  GENERATE_MEASUREMENTS_ACTION,
  GET_MEASUREMENTS_ACTION,
  GET_MEASUREMENTS_STATS_ACTION,
  VALIDATE_MEASUREMENT_DATA_ACTION,
  UPLOAD_MEASUREMENTS_ACTION,
  UPLOAD_MEASUREMENTS_JSON_ACTION,
  VALIDATE_MEASUREMENTS_JSON_ACTION,
  DELETE_MEASUREMENT_ACTION,
  UPDATE_MEASUREMENT_ACTION,
  DELETE_MEASUREMENTS_ACTION
];

// src/api-definition-paths/meters-paths/get-meter-description/get-meter-description-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS209 } from "@vy/zapi-types";
var GET_METER_DESCRIPTION_PATH = {
  accessLevel: PATH_ACCESS_LEVELS209.PRIVATE,
  route: "/meter/describe",
  tags: API_TAGS.METERS
};

// src/api-definition-paths/meters-paths/get-meter-description/get-meter-description-request-schema.ts
import { MeterInputSchema } from "@vy/types";
import { oz as oz347 } from "@vy/utils";
var GetMeterDescriptionRequestSchema = oz347.object({
  meter: MeterInputSchema
}).openapi("GetMeterDescriptionRequest");

// src/api-definition-paths/meters-paths/get-meter-description/get-meter-description-response-schema.ts
import { oz as oz348 } from "@vy/utils";
var GetMeterDescriptionResponseSchema = oz348.object({
  description: oz348.string()
}).openapi("GetMeterDescriptionResponse");

// src/api-definition-paths/meters-paths/get-meter-description/get-meter-description-action.ts
var GET_METER_DESCRIPTION_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "get-meter-description"
  },
  response: {
    name: "GetMeterDescriptionResponse",
    schema: GetMeterDescriptionResponseSchema
  },
  request: {
    name: "GetMeterDescriptionRequest",
    schema: GetMeterDescriptionRequestSchema
  },
  path: GET_METER_DESCRIPTION_PATH
};

// src/api-definition-paths/meters-paths/get-meter-instance-keys/get-meter-instance-keys-action.ts
import { oz as oz350 } from "@vy/utils";

// src/api-definition-paths/meters-paths/get-meter-instance-keys/get-meter-instance-keys-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS210 } from "@vy/zapi-types";
var GET_METER_INSTANCE_KEYS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS210.PRIVATE,
  route: "/meter/instance-keys",
  tags: API_TAGS.METERS
};

// src/api-definition-paths/meters-paths/get-meter-instance-keys/get-meter-instance-keys-response-schema.ts
import { oz as oz349 } from "@vy/utils";
var GetMeterInstanceKeysResponseSchema = oz349.object({
  instanceKeys: oz349.string().array()
}).openapi("CreateMeterResponse");

// src/api-definition-paths/meters-paths/get-meter-instance-keys/get-meter-instance-keys-action.ts
var CUSTOMER_ID_QUERY_PARAM4 = {
  name: "customerId",
  location: "query",
  schema: oz350.string()
};
var PRODUCT_ID_QUERY_PARAM = {
  name: "productId",
  location: "query",
  schema: oz350.string()
};
var GET_METER_INSTANCE_KEYS_ACTION = {
  method: "get",
  queryParams: {
    [CUSTOMER_ID_QUERY_PARAM4.name]: CUSTOMER_ID_QUERY_PARAM4,
    [PRODUCT_ID_QUERY_PARAM.name]: PRODUCT_ID_QUERY_PARAM
  },
  codeGenerationSettings: {
    actionText: "get-meter-instance-keys"
  },
  response: {
    name: "GetMeterInstanceKeysResponse",
    schema: GetMeterInstanceKeysResponseSchema
  },
  path: GET_METER_INSTANCE_KEYS_PATH
};

// src/api-definition-paths/meters-paths/meter-id-path.ts
import { ObjectIdSchema as ObjectIdSchema50 } from "@vy/types";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS211 } from "@vy/zapi-types";
var METER_ID_PATH_PARAM = {
  name: "meterId",
  location: "path",
  schema: ObjectIdSchema50,
  required: true
};
var METER_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS211.PRIVATE,
  route: "/meter/{meterId}",
  pathParams: {
    [METER_ID_PATH_PARAM.name]: METER_ID_PATH_PARAM
  },
  tags: API_TAGS.METERS
};

// src/api-definition-paths/meters-paths/meter-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS212 } from "@vy/zapi-types";
var METER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS212.PRIVATE,
  route: "/meter",
  tags: API_TAGS.METERS
};

// src/api-definition-paths/meters-paths/meters-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS213 } from "@vy/zapi-types";
var METERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS213.PRIVATE,
  route: "/meters",
  tags: API_TAGS.METERS
};

// src/api-definition-paths/meters-paths/meters-paths.ts
var METERS_PATHS = [
  METERS_PATH,
  METER_PATH,
  GET_METER_INSTANCE_KEYS_PATH,
  METER_ID_PATH,
  GET_METER_DESCRIPTION_PATH
];

// src/api-definition-paths/meters-paths/get-meters/get-meters-response-schema.ts
import { MeterSchema as MeterSchema2 } from "@vy/types";
import { oz as oz351 } from "@vy/utils";
var GetMetersResponseSchema = oz351.object({
  meters: oz351.array(MeterSchema2)
}).openapi("GetMetersResponse");

// src/api-definition-paths/meters-paths/get-meters/get-meters-action.ts
var GET_METERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-meters"
  },
  response: {
    name: "getMetersResponse",
    schema: GetMetersResponseSchema
  },
  path: METERS_PATH
};

// src/api-definition-paths/meters-paths/delete-meter/delete-meter-response-schema.ts
import { oz as oz352 } from "@vy/utils";
var DeleteMeterResponseSchema = oz352.object({
  meterId: oz352.string()
});

// src/api-definition-paths/meters-paths/delete-meter/delete-meter-action.ts
var DELETE_METER_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-meter"
  },
  response: {
    name: "MeterDeleteResponse",
    schema: DeleteMeterResponseSchema
  },
  path: METER_ID_PATH
};

// src/api-definition-paths/meters-paths/create-meter/create-meter-request-schema.ts
import { NewMeterSchema } from "@vy/types";
var CreateMeterRequestSchema = NewMeterSchema.openapi("newMeter");

// src/api-definition-paths/meters-paths/create-meter/create-meter-action.ts
var CREATE_METER_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "create-meter"
  },
  request: {
    name: "CreateMeterRequest",
    schema: CreateMeterRequestSchema
  },
  path: METER_PATH
};

// src/api-definition-paths/meters-paths/update-meter/update-meter-request-schema.ts
import { NewMeterSchema as NewMeterSchema2 } from "@vy/types";
var UpdateMeterRequestSchema = NewMeterSchema2.openapi("UpdateMeterRequest");

// src/api-definition-paths/meters-paths/update-meter/update-meter-action.ts
var UPDATE_METER_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-meter"
  },
  request: {
    name: "UpdateMeterRequest",
    schema: UpdateMeterRequestSchema
  },
  path: METER_ID_PATH
};

// src/api-definition-paths/meters-paths/meters-actions.ts
var METERS_ACTIONS = [
  CREATE_METER_ACTION,
  GET_METER_INSTANCE_KEYS_ACTION,
  GET_METERS_ACTION,
  UPDATE_METER_ACTION,
  GET_METER_DESCRIPTION_ACTION,
  DELETE_METER_ACTION
];

// src/api-definition-paths/notification-alerts-paths/notification-alerts-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS214 } from "@vy/zapi-types";
var NOTIFICATION_ALERTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS214.PRIVATE,
  route: "/notification-alerts",
  tags: API_TAGS.NOTIFICATION_ALERTS
};

// src/api-definition-paths/notification-alerts-paths/update-notification-alert-status/update-notification-alert-status-action.ts
import { NotificationAlertSchema } from "@vy/types";

// src/api-definition-paths/notification-alerts-paths/update-notification-alert-status/update-notification-alert-status-path.ts
import { oz as oz353 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS215 } from "@vy/zapi-types";
var NOTIFICATION_ALERT_ID_PATH_PARAM = {
  name: "notificationAlertId",
  location: "path",
  schema: oz353.string(),
  required: true
};
var UPDATE_NOTIFICATION_ALERT_STATUS_PATH_PARAMS = {
  [NOTIFICATION_ALERT_ID_PATH_PARAM.name]: NOTIFICATION_ALERT_ID_PATH_PARAM
};
var UPDATE_NOTIFICATION_ALERT_STATUS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS215.PRIVATE,
  route: "/notification-alert/{notificationAlertId}/status",
  pathParams: UPDATE_NOTIFICATION_ALERT_STATUS_PATH_PARAMS,
  tags: API_TAGS.NOTIFICATION_ALERTS
};

// src/api-definition-paths/notification-alerts-paths/update-notification-alert-status/update-notification-alert-status-request-schema.ts
import { NotificationAlertStatusSchema } from "@vy/types";
import { oz as oz354 } from "@vy/utils";
var UpdateNotificationAlertRequestSchema = oz354.object({
  status: NotificationAlertStatusSchema
}).openapi("UpdateNotificationAlertRequestSchema");

// src/api-definition-paths/notification-alerts-paths/update-notification-alert-status/update-notification-alert-status-action.ts
var UPDATE_NOTIFICATION_ALERT_STATUS_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-notification-alert-status"
  },
  response: {
    name: "UpdateNotificationAlertStatusResponse",
    schema: NotificationAlertSchema
  },
  request: {
    name: "UpdateNotificationAlertStatusRequest",
    schema: UpdateNotificationAlertRequestSchema
  },
  path: UPDATE_NOTIFICATION_ALERT_STATUS_PATH
};

// src/api-definition-paths/notification-alerts-paths/notification-alerts-paths.ts
var NOTIFICATION_ALERTS_PATHS = [UPDATE_NOTIFICATION_ALERT_STATUS_PATH, NOTIFICATION_ALERTS_PATH];

// src/api-definition-paths/notification-alerts-paths/get-notification-alerts/get-notification-alerts-response-schema.ts
import { ClientNotificationSchema } from "@vy/types";
import { oz as oz355 } from "@vy/utils";
var GetNotificationAlertsResponseSchema = oz355.array(ClientNotificationSchema).openapi("GetNotificationAlertsResponseSchema");

// src/api-definition-paths/notification-alerts-paths/get-notification-alerts/get-notification-alerts-action.ts
var GET_NOTIFICATION_ALERTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-notification-alerts"
  },
  response: {
    name: "GetNotificationAlertsResponse",
    schema: GetNotificationAlertsResponseSchema
  },
  path: NOTIFICATION_ALERTS_PATH
};

// src/api-definition-paths/notification-alerts-paths/notification-alerts-actions.ts
var NOTIFICATION_ALERTS_ACTIONS = [
  GET_NOTIFICATION_ALERTS_ACTION,
  UPDATE_NOTIFICATION_ALERT_STATUS_ACTION
];

// src/api-definition-paths/payments-paths/get-payment-overviews/get-payment-overviews-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS216 } from "@vy/zapi-types";
var GET_PAYMENT_OVERVIEWS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS216.PRIVATE,
  route: "/payments/overviews",
  tags: API_TAGS.PAYMENTS
};

// src/api-definition-paths/payments-paths/get-payment-overviews/get-payments-overviews-response-schema.ts
import { oz as oz357 } from "@vy/utils";

// src/api-definition-paths/payments-paths/get-payment-overviews/payment-overview-schema.ts
import { ApiDateSchema as ApiDateSchema37, ObjectIdSchema as ObjectIdSchema51, CurrencySchema as CurrencySchema15, ExternalPaymentSchema } from "@vy/types";
import { CustomFieldValueSchema as CustomFieldValueSchema4 } from "@vy/custom-fields-types";
import { oz as oz356 } from "@vy/utils";
var PaymentOverviewSchema = oz356.object({
  id: ObjectIdSchema51,
  updatedAt: ApiDateSchema37,
  amount: oz356.number(),
  currency: CurrencySchema15,
  paymentMethod: oz356.string().optional(),
  externalPayment: ExternalPaymentSchema.optional(),
  status: oz356.string(),
  invoiceId: ObjectIdSchema51.optional(),
  invoiceNumber: oz356.string().optional(),
  customerName: oz356.string(),
  customerId: ObjectIdSchema51,
  customFieldValues: CustomFieldValueSchema4.array().optional()
}).openapi("PaymentOverview");

// src/api-definition-paths/payments-paths/get-payment-overviews/get-payments-overviews-response-schema.ts
var GetPaymentsOverviewsResponseSchema = oz357.object({
  paymentsOverviews: oz357.array(PaymentOverviewSchema),
  count: oz357.number()
}).openapi("GetPaymentsOverviewsResponse");

// src/api-definition-paths/payments-paths/get-payment-overviews/get-payment-overviews-action.ts
var GET_PAYMENTS_OVERVIEWS_ACTION = {
  method: "get",
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [START_TIME_QUERY_PARAM.name]: START_TIME_QUERY_PARAM,
    [END_TIME_QUERY_PARAM.name]: END_TIME_QUERY_PARAM
  },
  codeGenerationSettings: {
    actionText: "get-payment-overviews"
  },
  response: {
    name: "GetPaymentOverviewsResponse",
    schema: GetPaymentsOverviewsResponseSchema
  },
  path: GET_PAYMENT_OVERVIEWS_PATH
};

// src/api-definition-paths/payments-paths/get-payments-new/get-payments-new-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS217 } from "@vy/zapi-types";
var GET_PAYMENTS_NEW_PATH = {
  accessLevel: PATH_ACCESS_LEVELS217.PRIVATE,
  route: "/payments/overviews-new",
  tags: API_TAGS.PAYMENTS
};

// src/api-definition-paths/payments-paths/get-payments-new/get-payments-new-response-schema.ts
import { oz as oz358 } from "@vy/utils";
var GetPaymentsNewResponseSchema = oz358.object({
  items: oz358.array(PaymentOverviewSchema),
  count: oz358.number()
}).openapi("GetPaymentsNewResponse");

// src/api-definition-paths/payments-paths/get-payments-new/get-payments-new-action.ts
import { parseJson as parseJson9, oz as oz359 } from "@vy/utils";
import { PaymentFilterSchema } from "@vy/payments-types";
var { param: PAYMENT_SORTING_PARAMETER } = getQuerySortingItemParameterSchemas(
  PaymentOverviewSchema,
  "GetPaymentsNewSorting"
);
var PAYMENT_FILTERS_QUERY_PARAMETER = {
  name: "paymentFilters",
  location: "query",
  schema: oz359.string().transform(parseJson9).pipe(PaymentFilterSchema.array()).optional(),
  required: false
};
var GET_PAYMENTS_NEW_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-payments-new"
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [PAYMENT_FILTERS_QUERY_PARAMETER.name]: PAYMENT_FILTERS_QUERY_PARAMETER,
    [PAYMENT_SORTING_PARAMETER.name]: PAYMENT_SORTING_PARAMETER
  },
  response: {
    name: "GetPaymentsNewResponse",
    schema: GetPaymentsNewResponseSchema
  },
  path: GET_PAYMENTS_NEW_PATH
};

// src/api-definition-paths/payments-paths/get-payment-methods/get-payment-methods-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS218 } from "@vy/zapi-types";
var GET_PAYMENT_METHODS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS218.PRIVATE,
  route: "/payments/payment-methods",
  tags: API_TAGS.PAYMENTS
};

// src/api-definition-paths/payments-paths/get-payment-methods/get-payment-methods-response-schema.ts
import { oz as oz361 } from "@vy/utils";

// src/api-definition-paths/payments-paths/get-payment-methods/payment-method-schema.ts
import { oz as oz360 } from "@vy/utils";
var PaymentMethodSchema = oz360.object({
  id: oz360.string(),
  name: oz360.string()
}).openapi("PaymentMethod");

// src/api-definition-paths/payments-paths/get-payment-methods/get-payment-methods-response-schema.ts
var GetPaymentMethodsResponseSchema = oz361.object({
  paymentMethods: oz361.array(PaymentMethodSchema)
}).openapi("GetPaymentMethodsResponse");

// src/api-definition-paths/payments-paths/get-payment-methods/get-payment-methods-action.ts
var GET_PAYMENT_METHODS_ACTION = {
  method: "get",
  queryParams: {
    [CUSTOMER_ID_QUERY_PARAM.name]: CUSTOMER_ID_QUERY_PARAM
  },
  codeGenerationSettings: {
    actionText: "get-payment-methods"
  },
  response: {
    name: "GetPaymentMethodsResponse",
    schema: GetPaymentMethodsResponseSchema
  },
  path: GET_PAYMENT_METHODS_PATH
};

// src/api-definition-paths/payments-paths/assign-payment-to-invoice/assign-payment-to-invoice-path.ts
import { oz as oz362 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS219 } from "@vy/zapi-types";
var PAYMENT_ID_PATH_PARAM = {
  name: "paymentId",
  location: "path",
  schema: oz362.string(),
  required: true
};
var PAYMENT_ID_PATH_PARAMS = {
  [PAYMENT_ID_PATH_PARAM.name]: PAYMENT_ID_PATH_PARAM
};
var ASSIGN_PAYMENT_TO_INVOICE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS219.PRIVATE,
  route: `/payments/{paymentId}/assign-invoice`,
  pathParams: PAYMENT_ID_PATH_PARAMS,
  tags: API_TAGS.PAYMENTS
};

// src/api-definition-paths/payments-paths/assign-payment-to-invoice/assign-payment-to-invoice-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema52 } from "@vy/types";
import { oz as oz363 } from "@vy/utils";
var AssignPaymentToInvoiceRequestSchema = oz363.object({
  invoiceId: ObjectIdSchema52
}).openapi("AssignPaymentToInvoiceRequest");

// src/api-definition-paths/payments-paths/assign-payment-to-invoice/assign-payment-to-invoice-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema53 } from "@vy/types";
import { oz as oz364 } from "@vy/utils";
var AssignPaymentToInvoiceResponseSchema = oz364.object({
  paymentId: ObjectIdSchema53
}).openapi("AssignPaymentToInvoiceResponse");

// src/api-definition-paths/payments-paths/assign-payment-to-invoice/assign-payment-to-invoice-action.ts
var ASSIGN_PAYMENT_TO_INVOICE_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "assign-payment-to-invoice"
  },
  request: {
    name: "AssignPaymentToInvoiceRequest",
    schema: AssignPaymentToInvoiceRequestSchema
  },
  response: {
    name: "AssignPaymentToInvoiceResponse",
    schema: AssignPaymentToInvoiceResponseSchema
  },
  path: ASSIGN_PAYMENT_TO_INVOICE_PATH
};

// src/api-definition-paths/payments-paths/payments-paths.ts
var PAYMENT_PATHS = [GET_PAYMENT_OVERVIEWS_PATH, GET_PAYMENTS_NEW_PATH, GET_PAYMENT_METHODS_PATH, ASSIGN_PAYMENT_TO_INVOICE_PATH];

// src/api-definition-paths/payments-paths/get-deposit-to/get-deposit-to-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS220 } from "@vy/zapi-types";
var GET_DEPOSIT_TO_PATH = {
  accessLevel: PATH_ACCESS_LEVELS220.PRIVATE,
  route: "/payments/deposit-to",
  tags: API_TAGS.PAYMENTS
};

// src/api-definition-paths/payments-paths/get-deposit-to/get-deposit-to-response-schema.ts
import { oz as oz366 } from "@vy/utils";

// src/api-definition-paths/payments-paths/get-deposit-to/deposit-to-schema.ts
import { oz as oz365 } from "@vy/utils";
var DepositToSchema = oz365.object({
  id: oz365.string().optional(),
  name: oz365.string()
}).openapi("DepositTo");

// src/api-definition-paths/payments-paths/get-deposit-to/get-deposit-to-response-schema.ts
var GetDepositToResponseSchema = oz366.object({
  depositToAccounts: oz366.array(DepositToSchema),
  defaultDepositToAccountId: oz366.string().optional()
}).openapi("GetDepositToResponse");

// src/api-definition-paths/payments-paths/get-deposit-to/get-deposit-to-action.ts
var GET_DEPOSIT_TO_ACTION = {
  method: "get",
  queryParams: {
    [CUSTOMER_ID_QUERY_PARAM.name]: CUSTOMER_ID_QUERY_PARAM
  },
  codeGenerationSettings: {
    actionText: "get-deposit-to"
  },
  response: {
    name: "GetDepositToResponse",
    schema: GetDepositToResponseSchema
  },
  path: GET_DEPOSIT_TO_PATH
};

// src/api-definition-paths/payments-paths/payments-actions.ts
var PAYMENTS_ACTIONS = [GET_PAYMENTS_OVERVIEWS_ACTION, GET_PAYMENTS_NEW_ACTION, GET_PAYMENT_METHODS_ACTION, GET_DEPOSIT_TO_ACTION, ASSIGN_PAYMENT_TO_INVOICE_ACTION];

// src/api-definition-paths/pages-paths/get-billing-cycle-page/get-billing-cycle-page-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS221 } from "@vy/zapi-types";
var GET_BILLING_CYCLE_PAGE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS221.PRIVATE,
  route: "/pages/billing-cycle",
  tags: API_TAGS.PAGES
};

// src/api-definition-paths/pages-paths/get-billing-cycle-page/get-billing-cycle-page-response-schema.ts
import { oz as oz367 } from "@vy/utils";
var GetBillingCyclePageResponseSchema = oz367.object({
  regularBillingCycleInvoicesCount: oz367.number(),
  inspectionBillingCycleInvoicesCount: oz367.number(),
  oldBillingCycleInvoicesCount: oz367.number(),
  overcharges: oz367.number()
}).openapi("GetBillingCyclePageResponse");

// src/api-definition-paths/pages-paths/get-billing-cycle-page/get-billing-cycle-page-action.ts
var GET_BILLING_CYCLE_PAGE_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-billing-cycle-page"
  },
  queryParams: {
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER
  },
  response: {
    name: "GetBillingCyclePageResponse",
    schema: GetBillingCyclePageResponseSchema
  },
  path: GET_BILLING_CYCLE_PAGE_PATH
};

// src/api-definition-paths/pages-paths/get-contract-page-data/get-contract-page-data-path.ts
import { oz as oz368 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS222 } from "@vy/zapi-types";
var CONTRACT_ID_PATH_PARAM3 = {
  name: "contractId",
  location: "path",
  schema: oz368.string(),
  required: true
};
var CONTRACT_ID_PATH_PARAMS = {
  [CONTRACT_ID_PATH_PARAM3.name]: CONTRACT_ID_PATH_PARAM3
};
var GET_CONTRACT_PAGE_DATA_PATH = {
  accessLevel: PATH_ACCESS_LEVELS222.PRIVATE,
  route: "/pages/contract/{contractId}",
  pathParams: CONTRACT_ID_PATH_PARAMS,
  tags: API_TAGS.PAGES
};

// src/api-definition-paths/pages-paths/get-contract-page-data/get-contract-page-data-response-schema.ts
import { oz as oz369 } from "@vy/utils";
import { CustomFieldDefinitionSchema as CustomFieldDefinitionSchema2, CustomFieldValueWithDefinitionSchema as CustomFieldValueWithDefinitionSchema3 } from "@vy/custom-fields-types";
var GetContractPageDataResponseSchema = oz369.object({
  contractPageData: ContractPageDataSchema,
  customFieldsWithDefinitions: CustomFieldValueWithDefinitionSchema3.array().optional(),
  customFieldDefinitions: CustomFieldDefinitionSchema2.array().optional()
}).openapi("GetContractPageDataResponse");

// src/api-definition-paths/pages-paths/get-contract-page-data/get-contract-page-data-action.ts
var GET_CONTRACT_PAGE_DATA_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-contract-page-data"
  },
  response: {
    name: "GetContractPageDataResponse",
    schema: GetContractPageDataResponseSchema
  },
  path: GET_CONTRACT_PAGE_DATA_PATH
};

// src/api-definition-paths/pages-paths/get-customer-contracts-overview-page/get-customer-contracts-overview-page-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS223 } from "@vy/zapi-types";
var GET_CUSTOMER_CONTRACTS_OVERVIEW_PAGE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS223.PRIVATE,
  route: "/pages/customers/{customerId}/contracts",
  tags: API_TAGS.PAGES,
  pathParams: {
    [CUSTOMER_ID_PATH_PARAM.name]: CUSTOMER_ID_PATH_PARAM
  }
};

// src/api-definition-paths/pages-paths/get-customer-contracts-overview-page/get-customer-contracts-overview-page-response.ts
import { FullDayPeriodSchema } from "@vy/types";
import { oz as oz372 } from "@vy/utils";

// src/api-definition-paths/pages-paths/get-customer-contracts-overview-page/customer-contract-overview-schema.ts
import { ContractSchema as ContractSchema9, ApiDateSchema as ApiDateSchema38, PlanSchema as PlanSchema5, ProductSchema as ProductSchema2 } from "@vy/types";
import { oz as oz371 } from "@vy/utils";

// src/api-definition-paths/pages-paths/get-customer-contracts-overview-page/product-consumption-schema.ts
import { oz as oz370 } from "@vy/utils";
var ProductConsumptionSchema = oz370.object({
  id: oz370.string(),
  total: oz370.number(),
  current: oz370.number()
}).optional();

// src/api-definition-paths/pages-paths/get-customer-contracts-overview-page/customer-contract-overview-schema.ts
var CustomerContractOverviewSchema = ContractSchema9.extend({
  isEditable: oz371.boolean(),
  createdAt: ApiDateSchema38,
  revenue: oz371.number(),
  plan: PlanSchema5.extend({
    products: oz371.array(
      ProductSchema2.extend({
        consumption: ProductConsumptionSchema,
        totalUnits: oz371.number().optional()
      })
    )
  })
});

// src/api-definition-paths/pages-paths/get-customer-contracts-overview-page/get-customer-contracts-overview-page-response.ts
var GetCustomerContractsOverviewPageResponseSchema = oz372.object({
  contract: CustomerContractOverviewSchema,
  lastInvoice: oz372.object({
    id: oz372.string(),
    billingCycle: FullDayPeriodSchema
  }).optional()
}).array();

// src/api-definition-paths/pages-paths/get-customer-contracts-overview-page/get-customer-contracts-overview-page-action.ts
var GET_CUSTOMER_CONTRACTS_OVERVIEW_PAGE_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customer-contracts-overview-page"
  },
  response: {
    name: "GetCustomerContractsOverviewPageResponse",
    schema: GetCustomerContractsOverviewPageResponseSchema
  },
  path: GET_CUSTOMER_CONTRACTS_OVERVIEW_PAGE_PATH
};

// src/api-definition-paths/pages-paths/get-customer-invoice-page-data/get-customer-invoice-page-data-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS224 } from "@vy/zapi-types";
var GET_CUSTOMER_INVOICE_PAGE_DATA_PATH = {
  accessLevel: PATH_ACCESS_LEVELS224.PRIVATE,
  route: "/pages/customers/{customerId}/invoice/{invoiceId}",
  tags: API_TAGS.PAGES,
  pathParams: {
    [INVOICE_ID_PATH_PARAM.name]: INVOICE_ID_PATH_PARAM,
    [CUSTOMER_ID_PATH_PARAM.name]: CUSTOMER_ID_PATH_PARAM
  }
};

// src/api-definition-paths/pages-paths/get-home-page-account-summary/get-home-page-account-summary-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS225 } from "@vy/zapi-types";
var GET_HOME_PAGE_ACCOUNT_SUMMARY_PATH = {
  accessLevel: PATH_ACCESS_LEVELS225.PRIVATE,
  route: "/pages/home/account-summary",
  tags: API_TAGS.PAGES
};

// src/api-definition-paths/pages-paths/get-home-page-account-summary/get-home-page-account-summary-response-schema.ts
import { oz as oz373 } from "@vy/utils";
var GetHomePageAccountSummaryResponseSchema = oz373.object({
  customers: oz373.object({
    total: oz373.number(),
    lastMonth: oz373.number(),
    currentMonth: oz373.number()
  }),
  contracts: oz373.object({
    total: oz373.number(),
    lastMonth: oz373.number(),
    currentMonth: oz373.number()
  }),
  overages: oz373.object({
    invoices: oz373.number(),
    amount: oz373.number()
  }),
  invoices: oz373.object({
    total: oz373.number()
  }),
  kpiMetrics: oz373.object({
    acv: oz373.number(),
    previousAcv: oz373.number(),
    activeCustomers: oz373.number(),
    previousActiveCustomers: oz373.number(),
    activeContracts: oz373.number(),
    previousActiveContracts: oz373.number(),
    renewalContracts: oz373.number(),
    inReviewContracts: oz373.number(),
    mrrWaterfall: oz373.object({
      month: oz373.string(),
      beginningMrr: oz373.number(),
      endingMrr: oz373.number(),
      movements: oz373.object({
        newMrr: oz373.number(),
        expansionMrr: oz373.number(),
        reactivationMrr: oz373.number(),
        contractionMrr: oz373.number(),
        churnMrr: oz373.number()
      }),
      nrr: oz373.number(),
      grr: oz373.number()
    })
  })
}).openapi("GetHomePageAccountSummaryResponse");

// src/api-definition-paths/pages-paths/get-home-page-account-summary/get-home-page-account-summary-action.ts
var GET_HOME_PAGE_ACCOUNT_SUMMARY_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-home-page-account-summary"
  },
  response: {
    name: "GetHomePageAccountSummaryResponse",
    schema: GetHomePageAccountSummaryResponseSchema
  },
  path: GET_HOME_PAGE_ACCOUNT_SUMMARY_PATH
};

// src/api-definition-paths/pages-paths/get-products-page-data/get-products-page-data-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS226 } from "@vy/zapi-types";
var GET_PRODUCTS_PAGE_DATA_PATH = {
  accessLevel: PATH_ACCESS_LEVELS226.PRIVATE,
  route: "/pages/products",
  tags: API_TAGS.PAGES
};

// src/api-definition-paths/pages-paths/get-products-page-data/get-products-page-data-response-schema.ts
var GetProductsPageDataResponseSchema = ProductsPageSchema.openapi("GetProductsPageResponse");

// src/api-definition-paths/pages-paths/get-products-page-data/get-products-page-data-action.ts
var GET_PRODUCTS_PAGE_DATA_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-products-page-data"
  },
  queryParams: {
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    ...PAGINATION_QUERY_PARAMETERS
  },
  response: {
    name: "GetProductsPageDataResponse",
    schema: GetProductsPageDataResponseSchema
  },
  path: GET_PRODUCTS_PAGE_DATA_PATH
};

// src/api-definition-paths/pages-paths/pages-paths.ts
var PAGES_PATHS = [
  GET_BILLING_CYCLE_PAGE_PATH,
  GET_PRODUCTS_PAGE_DATA_PATH,
  GET_CONTRACT_PAGE_DATA_PATH,
  GET_CUSTOMER_INVOICE_PAGE_DATA_PATH,
  GET_CUSTOMER_CONTRACTS_OVERVIEW_PAGE_PATH,
  GET_HOME_PAGE_ACCOUNT_SUMMARY_PATH
];

// src/api-definition-paths/pages-paths/get-customer-invoice-page-data/get-customer-invoice-page-data-response-schema.ts
import { CustomerSchema as CustomerSchema11, InvoiceSchema as InvoiceSchema9 } from "@vy/types";
import { oz as oz374 } from "@vy/utils";
var GetCustomerInvoicePageDataResponseSchema = oz374.object({
  customer: CustomerSchema11.pick({
    name: true
  }),
  invoice: InvoiceSchema9.pick({
    name: true,
    billingStatus: true,
    reviewStatus: true
  })
}).openapi("GetCustomerInvoicePageDataResponse");

// src/api-definition-paths/pages-paths/get-customer-invoice-page-data/get-customer-invoice-page-data-action.ts
var GET_CUSTOMER_INVOICE_PAGE_DATA_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-customer-invoice-page-data"
  },
  response: {
    name: "GetCustomerInvoicePageDataResponse",
    schema: GetCustomerInvoicePageDataResponseSchema
  },
  path: GET_CUSTOMER_INVOICE_PAGE_DATA_PATH
};

// src/api-definition-paths/pages-paths/pages-actions.ts
var PAGES_ACTIONS = [
  GET_BILLING_CYCLE_PAGE_ACTION,
  GET_CONTRACT_PAGE_DATA_ACTION,
  GET_PRODUCTS_PAGE_DATA_ACTION,
  GET_CUSTOMER_INVOICE_PAGE_DATA_ACTION,
  GET_CUSTOMER_CONTRACTS_OVERVIEW_PAGE_ACTION,
  GET_HOME_PAGE_ACCOUNT_SUMMARY_ACTION
];

// src/api-definition-paths/accounts-paths/account-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS227 } from "@vy/zapi-types";
var ACCOUNT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS227.PRIVATE,
  route: "/account",
  tags: API_TAGS.ACCOUNTS
};

// src/api-definition-paths/accounts-paths/get-usage-events-report-configuration/get-usage-events-report-configuration-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS228 } from "@vy/zapi-types";
var GET_USAGE_EVENTS_REPORT_CONFIGURATION_PATH = {
  accessLevel: PATH_ACCESS_LEVELS228.PRIVATE,
  route: "/account/usage-events-report-configuration",
  tags: API_TAGS.ACCOUNTS
};

// src/api-definition-paths/accounts-paths/update-account/update-account-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS229 } from "@vy/zapi-types";
var UPDATE_ACCOUNT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS229.PRIVATE,
  route: "/account",
  tags: API_TAGS.ACCOUNTS
};

// src/api-definition-paths/accounts-paths/update-account-logo/update-account-logo-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS230 } from "@vy/zapi-types";
var UPDATE_ACCOUNT_LOGO_PATH = {
  accessLevel: PATH_ACCESS_LEVELS230.PRIVATE,
  route: "/account/logo",
  tags: API_TAGS.ACCOUNTS
};

// src/api-definition-paths/accounts-paths/update-account-logo/update-account-logo-request-schema.ts
import { oz as oz375 } from "@vy/utils";
var UpdateAccountLogoRequestSchema = oz375.object({
  logo: oz375.string().url()
}).openapi("UpdateAccountLogoRequestSchema");

// src/api-definition-paths/accounts-paths/update-account-logo/update-account-logo-action.ts
var UPDATE_ACCOUNT_LOGO_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-account-logo"
  },
  request: {
    name: "UpdateAccountLogoRequest",
    schema: UpdateAccountLogoRequestSchema
  },
  path: UPDATE_ACCOUNT_LOGO_PATH
};

// src/api-definition-paths/accounts-paths/accounts-paths.ts
var ACCOUNTS_PATHS = [
  ACCOUNT_PATH,
  UPDATE_ACCOUNT_PATH,
  UPDATE_ACCOUNT_LOGO_PATH,
  GET_USAGE_EVENTS_REPORT_CONFIGURATION_PATH
];

// src/api-definition-paths/accounts-paths/get-account/get-account-response-schema.ts
import { AccountSchema } from "@vy/types";
import { oz as oz376 } from "@vy/utils";
var GetAccountResponseSchema = oz376.object({
  account: AccountSchema
}).openapi("GetAccountResponse");

// src/api-definition-paths/accounts-paths/get-account/get-account-action.ts
var GET_ACCOUNT_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-account"
  },
  response: {
    name: "GetAccountResponse",
    schema: GetAccountResponseSchema
  },
  path: ACCOUNT_PATH
};

// src/api-definition-paths/accounts-paths/get-usage-events-report-configuration/get-usage-events-report-configuration-response-schema.ts
import { oz as oz377 } from "@vy/utils";
var GetUsageEventsReportConfigurationResponseSchema = oz377.object({
  configured: oz377.boolean()
}).openapi("GetUsageEventsReportConfigurationResponse");

// src/api-definition-paths/accounts-paths/get-usage-events-report-configuration/get-usage-events-report-configuration-action.ts
var GET_USAGE_EVENTS_REPORT_CONFIGURATION_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-usage-events-report-configuration"
  },
  response: {
    name: "GetUsageEventsReportConfigurationResponse",
    schema: GetUsageEventsReportConfigurationResponseSchema
  },
  path: GET_USAGE_EVENTS_REPORT_CONFIGURATION_PATH
};

// src/api-definition-paths/accounts-paths/update-account/update-account-request-schema.ts
import { NewAccountSchema } from "@vy/types";
import { oz as oz378 } from "@vy/utils";
var UpdateAccountRequestSchema = oz378.object({
  account: NewAccountSchema
}).openapi("UpdateAccountRequestSchema");

// src/api-definition-paths/accounts-paths/update-account/update-account-response-schema.ts
import { ObjectIdSchema as ObjectIdSchema54 } from "@vy/types";
import { oz as oz379 } from "@vy/utils";
var UpdateAccountResponseSchema = oz379.object({
  accountId: ObjectIdSchema54
}).openapi("UpdateAccountResponse");

// src/api-definition-paths/accounts-paths/update-account/update-account-action.ts
var UPDATE_ACCOUNT_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-account"
  },
  request: {
    name: "UpdateAccountRequest",
    schema: UpdateAccountRequestSchema
  },
  response: {
    name: "UpdateAccountResponse",
    schema: UpdateAccountResponseSchema
  },
  path: UPDATE_ACCOUNT_PATH
};

// src/api-definition-paths/accounts-paths/accounts-actions.ts
var ACCOUNTS_ACTIONS = [
  GET_ACCOUNT_ACTION,
  UPDATE_ACCOUNT_ACTION,
  UPDATE_ACCOUNT_LOGO_ACTION,
  GET_USAGE_EVENTS_REPORT_CONFIGURATION_ACTION
];

// src/api-definition-paths/auth-paths/nest-auth-paths.ts
var AUTH_PATHS = [
  SIGNUP_PATH,
  SIGNUP_RAW_PATH,
  RESET_PASSWORD_PATH,
  CONFIRM_PASSWORD_RESET_PATH,
  LOGIN_PATH,
  REFRESH_TOKEN_PATH,
  GET_SANDBOX_USER_PATH,
  CONFIRM_PATH
];

// src/api-definition-paths/contact-us-path/contact-us-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS231 } from "@vy/zapi-types";
var CONTACT_US_PATH = {
  accessLevel: PATH_ACCESS_LEVELS231.PUBLIC,
  route: "/contact-us/",
  tags: API_TAGS.CONTACT_US
};

// src/api-definition-paths/contact-us-path/contact-us-request-schema.ts
import { oz as oz380 } from "@vy/utils";
var ContactUsRequestSchema = oz380.object({
  email: oz380.string().min(1).email(),
  message: oz380.string().min(1),
  name: oz380.string().min(1)
}).openapi("ContactUsRequest");

// src/api-definition-paths/contact-us-path/contact-us-action.ts
var CONTACT_US_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "contact-us"
  },
  request: {
    name: "ContactUsRequest",
    schema: ContactUsRequestSchema
  },
  path: CONTACT_US_PATH
};

// src/api-definition-paths/customer-portal-paths/generate-token/generate-token-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS232 } from "@vy/zapi-types";
var GENERATE_TOKEN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS232.PRIVATE,
  route: "/customer-portal/generate-token",
  tags: API_TAGS.CUSTOMER_PORTAL
};

// src/api-definition-paths/customer-portal-paths/generate-token/generate-token-request-schema.ts
import { ApiDateSchema as ApiDateSchema39, CustomerPortalTokenParamsSchema } from "@vy/types";
import { oz as oz381 } from "@vy/utils";
var GenerateTokenRequestSchema = oz381.object({
  params: CustomerPortalTokenParamsSchema,
  expiresAt: ApiDateSchema39.optional()
}).openapi("GenerateTokenRequest");

// src/api-definition-paths/customer-portal-paths/generate-token/generate-token-response-schema.ts
import { oz as oz382 } from "@vy/utils";
var GenerateTokenResponseSchema = oz382.object({
  token: oz382.string()
}).openapi("GenerateTokenResponse");

// src/api-definition-paths/customer-portal-paths/generate-token/generate-token-action.ts
var GENERATE_TOKEN_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "generate-token"
  },
  request: {
    name: "GenerateTokenRequest",
    schema: GenerateTokenRequestSchema
  },
  response: {
    name: "GenerateTokenResponse",
    schema: GenerateTokenResponseSchema
  },
  path: GENERATE_TOKEN_PATH
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-credit-pools/get-customer-portal-credit-pools-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS233 } from "@vy/zapi-types";
var GET_CUSTOMER_PORTAL_CREDIT_POOLS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS233.PUBLIC,
  route: "/customer-portal/credit-pools",
  tags: API_TAGS.CUSTOMER_PORTAL
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-credit-pools/get-customer-portal-credit-pools-response-schema.ts
import { oz as oz383 } from "@vy/utils";
var GetCustomerPortalCreditPoolsResponseSchema = oz383.object({
  creditPools: oz383.array(CreditPoolWithUnitsSchema)
}).openapi("GetCustomerPortalCreditPoolsResponse");

// src/api-definition-paths/customer-portal-paths/get-customer-portal-credit-pools/get-customer-portal-credit-pools-action.ts
var GET_CUSTOMER_PORTAL_CREDIT_POOLS_ACTION = {
  method: "get",
  path: GET_CUSTOMER_PORTAL_CREDIT_POOLS_PATH,
  codeGenerationSettings: {
    actionText: "get-customer-portal-credit-pools"
  },
  queryParams: {
    [TOKEN_QUERY_PARAMETER.name]: TOKEN_QUERY_PARAMETER
  },
  response: {
    name: "GetCustomerPortalCreditPoolsResponse",
    schema: GetCustomerPortalCreditPoolsResponseSchema
  }
};

// src/api-definition-paths/customer-portal-paths/revoke-token/revoke-token-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS234 } from "@vy/zapi-types";
var REVOKE_TOKEN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS234.PRIVATE,
  route: "/customer-portal/revoke-token",
  tags: API_TAGS.CUSTOMER_PORTAL
};

// src/api-definition-paths/customer-portal-paths/revoke-token/revoke-token-request-schema.ts
import { oz as oz384 } from "@vy/utils";
var RevokeTokenRequestSchema = oz384.object({
  token: oz384.string()
}).openapi("RevokeTokenRequest");

// src/api-definition-paths/customer-portal-paths/revoke-token/revoke-token-action.ts
var REVOKE_TOKEN_ACTION = {
  method: "post",
  path: REVOKE_TOKEN_PATH,
  codeGenerationSettings: {
    actionText: "revoke-token"
  },
  request: {
    name: "RevokeTokenRequest",
    schema: RevokeTokenRequestSchema
  }
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-data/get-customer-portal-data-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS235 } from "@vy/zapi-types";
var GET_CUSTOMER_PORTAL_DATA_PATH = {
  accessLevel: PATH_ACCESS_LEVELS235.PUBLIC,
  route: "/customer-portal/get-data",
  tags: API_TAGS.CUSTOMER_PORTAL
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-data/get-customer-portal-data-response-schema.ts
import {
  AccountSchema as AccountSchema2,
  CommitmentTypeSchema,
  CurrencySchema as CurrencySchema16,
  CustomerPortalCustomerSchema,
  CustomerPortalInvoiceSchema,
  INVOICE_BILLING_STATUSES as INVOICE_BILLING_STATUSES2,
  ProductConsumptionSchema as ProductConsumptionSchema2
} from "@vy/types";
import { oz as oz385 } from "@vy/utils";
var CommitmentSummarySchema = oz385.object({
  amount: oz385.number(),
  type: CommitmentTypeSchema
});
var CustomerPortalInvoicesSummarySchema = oz385.record(
  oz385.nativeEnum(INVOICE_BILLING_STATUSES2),
  oz385.number()
);
var GetCustomerPortalDataResponseSchema = oz385.object({
  account: AccountSchema2.pick({
    name: true,
    logoUrl: true
  }),
  customer: CustomerPortalCustomerSchema,
  invoices: oz385.array(CustomerPortalInvoiceSchema),
  totalInvoicesCount: oz385.number(),
  invoicesSummary: CustomerPortalInvoicesSummarySchema.optional(),
  commitmentSummaries: oz385.array(CommitmentSummarySchema).optional(),
  currency: CurrencySchema16.optional(),
  productsConsumption: oz385.array(ProductConsumptionSchema2).optional()
});

// src/api-definition-paths/customer-portal-paths/get-customer-portal-data/get-customer-portal-data-action.ts
var GET_CUSTOMER_PORTAL_DATA_ACTION = {
  method: "get",
  path: GET_CUSTOMER_PORTAL_DATA_PATH,
  codeGenerationSettings: {
    actionText: "get-customer-portal-data"
  },
  queryParams: {
    [TOKEN_QUERY_PARAMETER.name]: TOKEN_QUERY_PARAMETER,
    ...PAGINATION_QUERY_PARAMETERS
  },
  response: {
    name: "GetCustomerPortalDataResponse",
    schema: GetCustomerPortalDataResponseSchema
  }
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-data/get-customer-portal-data-request-schema.ts
import { oz as oz386 } from "@vy/utils";
var GetCustomerPortalDataRequestSchema = oz386.object({
  token: oz386.string()
}).openapi("GetCustomerPortalDataRequest");

// src/api-definition-paths/customer-portal-paths/get-customer-portal-daily-usage-data/get-customer-portal-daily-usage-data-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS236 } from "@vy/zapi-types";
var GET_CUSTOMER_PORTAL_DAILY_USAGE_DATA_PATH = {
  accessLevel: PATH_ACCESS_LEVELS236.PUBLIC,
  route: "/customer-portal/get-daily-usage-data",
  tags: API_TAGS.CUSTOMER_PORTAL
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-daily-usage-data/get-customer-portal-daily-usage-data-response-schema.ts
import { ApiDateSchema as ApiDateSchema40 } from "@vy/types";
import { oz as oz387 } from "@vy/utils";
var GetCustomerPortalDailyUsageDataResponseSchema = oz387.array(
  oz387.object({
    totalValue: oz387.number(),
    date: ApiDateSchema40,
    productName: oz387.string()
  })
);

// src/api-definition-paths/customer-portal-paths/get-customer-portal-daily-usage-data/get-customer-portal-daily-usage-data-action.ts
var GET_CUSTOMER_PORTAL_DAILY_USAGE_DATA_ACTION = {
  method: "get",
  path: GET_CUSTOMER_PORTAL_DAILY_USAGE_DATA_PATH,
  codeGenerationSettings: {
    actionText: "get-customer-portal-daily-usage-data"
  },
  queryParams: {
    [TOKEN_QUERY_PARAMETER.name]: TOKEN_QUERY_PARAMETER,
    [INVOICE_ID_QUERY_PARAMETER.name]: INVOICE_ID_QUERY_PARAMETER
  },
  response: {
    name: "GetCustomerPortalDailyUsageDataResponse",
    schema: GetCustomerPortalDailyUsageDataResponseSchema
  }
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-daily-usage-data/get-customer-portal-daily-usage-data-request-schema.ts
import { oz as oz388 } from "@vy/utils";
var GetCustomerPortalDailyUsageDataRequestSchema = oz388.object({
  token: oz388.string(),
  invoiceId: oz388.string()
}).openapi("GetCustomerPortalDailyUsageDataRequest");

// src/api-definition-paths/customer-portal-paths/get-customer-portal-monthly-usage-data/get-customer-portal-monthly-usage-data-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS237 } from "@vy/zapi-types";
var GET_CUSTOMER_PORTAL_MONTHLY_USAGE_DATA_PATH = {
  accessLevel: PATH_ACCESS_LEVELS237.PUBLIC,
  route: "/customer-portal/get-monthly-usage-data",
  tags: API_TAGS.CUSTOMER_PORTAL
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-monthly-usage-data/get-customer-portal-monthly-usage-data-response-schema.ts
import { ApiDateSchema as ApiDateSchema41 } from "@vy/types";
import { oz as oz389 } from "@vy/utils";
var GetCustomerPortalMonthlyUsageDataResponseSchema = oz389.array(
  oz389.object({
    totalValue: oz389.number(),
    date: ApiDateSchema41,
    productName: oz389.string()
  })
);

// src/api-definition-paths/customer-portal-paths/get-customer-portal-monthly-usage-data/get-customer-portal-monthly-usage-data-action.ts
var GET_CUSTOMER_PORTAL_MONTHLY_USAGE_DATA_ACTION = {
  method: "get",
  path: GET_CUSTOMER_PORTAL_MONTHLY_USAGE_DATA_PATH,
  codeGenerationSettings: {
    actionText: "get-customer-portal-monthly-usage-data"
  },
  queryParams: {
    [TOKEN_QUERY_PARAMETER.name]: TOKEN_QUERY_PARAMETER
  },
  response: {
    name: "GetCustomerPortalMonthlyUsageDataResponse",
    schema: GetCustomerPortalMonthlyUsageDataResponseSchema
  }
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-monthly-usage-data/get-customer-portal-monthly-usage-data-request-schema.ts
import { oz as oz390 } from "@vy/utils";
var GetCustomerPortalMonthlyUsageDataRequestSchema = oz390.object({
  token: oz390.string()
}).openapi("GetCustomerPortalMonthlyUsageDataRequest");

// src/api-definition-paths/customer-portal-paths/get-customer-portal-invoice-pdf/get-customer-portal-invoice-pdf-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS238 } from "@vy/zapi-types";
var GET_CUSTOMER_PORTAL_INVOICE_PDF_PATH = {
  accessLevel: PATH_ACCESS_LEVELS238.PUBLIC,
  route: "/customer-portal/pdf/{invoiceId}",
  pathParams: INVOICE_ID_PATH_PARAMS,
  tags: API_TAGS.CUSTOMER_PORTAL
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-invoice-pdf/get-customer-portal-invoice-pdf-response-schema.ts
import { oz as oz391 } from "@vy/utils";
var GetCustomerPortalInvoicePdfResponseSchema = oz391.object({
  encodedPdf: oz391.string()
}).openapi("GetCustomerPortalInvoicePdfResponse");

// src/api-definition-paths/customer-portal-paths/get-customer-portal-invoice-pdf/get-customer-portal-invoice-pdf-action.ts
var GET_CUSTOMER_PORTAL_INVOICE_PDF_ACTION = {
  method: "get",
  path: GET_CUSTOMER_PORTAL_INVOICE_PDF_PATH,
  codeGenerationSettings: {
    actionText: "get-customer-portal-invoice-pdf"
  },
  queryParams: {
    [TOKEN_QUERY_PARAMETER.name]: TOKEN_QUERY_PARAMETER
  },
  response: {
    name: "GetCustomerPortalInvoicePdfResponse",
    schema: GetCustomerPortalInvoicePdfResponseSchema
  }
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-invoice-pdf/get-customer-portal-invoice-pdf-request-schema.ts
import { oz as oz392 } from "@vy/utils";
var GetCustomerPortalInvoicePdfRequestSchema = oz392.object({
  token: oz392.string()
}).openapi("GetCustomerPortalInvoicePdfRequest");

// src/api-definition-paths/customer-portal-paths/get-customer-portal-invoice-checkout-link/get-customer-portal-invoice-checkout-link-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS239 } from "@vy/zapi-types";
var GET_CUSTOMER_PORTAL_INVOICE_CHECKOUT_LINK_PATH = {
  accessLevel: PATH_ACCESS_LEVELS239.PUBLIC,
  route: "/customer-portal/invoice/stripe/checkout-link",
  tags: API_TAGS.CUSTOMER_PORTAL
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-invoice-checkout-link/get-customer-portal-invoice-checkout-link-request-schema.ts
import { oz as oz393 } from "@vy/utils";
var GetCustomerPortalInvoiceCheckoutLinkRequestSchema = oz393.object({
  token: oz393.string()
}).openapi("GetCustomerPortalInvoiceCheckoutLinkRequest");

// src/api-definition-paths/customer-portal-paths/get-customer-portal-invoice-checkout-link/get-customer-portal-invoice-checkout-link-action.ts
var GET_CUSTOMER_PORTAL_INVOICE_CHECKOUT_LINK_ACTION = {
  method: "get",
  path: GET_CUSTOMER_PORTAL_INVOICE_CHECKOUT_LINK_PATH,
  codeGenerationSettings: {
    actionText: "get-customer-portal-invoice-checkout-link"
  },
  queryParams: {
    [TOKEN_QUERY_PARAMETER.name]: TOKEN_QUERY_PARAMETER
  },
  response: {
    name: "GetCustomerPortalDataResponse",
    schema: GetCustomerPortalInvoiceCheckoutLinkRequestSchema
  }
};

// src/api-definition-paths/customer-portal-paths/get-customer-portal-invoice-checkout-link/get-customer-portal-invoice-checkout-link-response-schema.ts
import { oz as oz394 } from "@vy/utils";
var GetCustomerPortalInvoiceCheckoutLinkResponseSchema = oz394.object({
  checkoutLink: oz394.string()
}).openapi("GetCustomerPortalInvoiceCheckoutLinkResponse");

// src/api-definition-paths/customer-portal-paths/customer-portal-actions.ts
var CUSTOMER_PORTAL_ACTIONS = [
  GENERATE_TOKEN_ACTION,
  GET_CUSTOMER_PORTAL_DATA_ACTION,
  GET_CUSTOMER_PORTAL_DAILY_USAGE_DATA_ACTION,
  GET_CUSTOMER_PORTAL_MONTHLY_USAGE_DATA_ACTION,
  GET_CUSTOMER_PORTAL_INVOICE_PDF_ACTION,
  REVOKE_TOKEN_ACTION,
  GET_CUSTOMER_PORTAL_INVOICE_CHECKOUT_LINK_ACTION,
  GET_CUSTOMER_PORTAL_CREDIT_POOLS_ACTION
];

// src/api-definition-paths/customer-portal-paths/customer-portal-paths.ts
var CUSTOMER_PORTAL_PATHS = [
  GENERATE_TOKEN_PATH,
  GET_CUSTOMER_PORTAL_DATA_PATH,
  GET_CUSTOMER_PORTAL_DAILY_USAGE_DATA_PATH,
  GET_CUSTOMER_PORTAL_MONTHLY_USAGE_DATA_PATH,
  REVOKE_TOKEN_PATH,
  GET_CUSTOMER_PORTAL_INVOICE_PDF_PATH,
  GET_CUSTOMER_PORTAL_INVOICE_CHECKOUT_LINK_PATH,
  GET_CUSTOMER_PORTAL_CREDIT_POOLS_PATH
];

// src/api-definition-paths/email-paths/send-grid/event-handler/event-handler-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS240 } from "@vy/zapi-types";
var SEND_GRID_EVENT_HANDLER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS240.PUBLIC,
  route: "/sendgrid/events",
  tags: API_TAGS.EMAIL
};

// src/api-definition-paths/email-paths/send-grid/event-handler/send-grid-event-handler-request-schema.ts
import { SendGridEventSchema } from "@vy/types";
var SendGridEventHandlerRequestSchema = SendGridEventSchema.array().openapi("sendGridEventHandlerRequest");

// src/api-definition-paths/email-paths/send-grid/event-handler/send-grid-event-handler-response-schema.ts
import { oz as oz395 } from "@vy/utils";
var SendGridEventHandlerResponseSchema = oz395.object({
  response: oz395.string()
}).openapi("sendGridEventHandlerResponse");

// src/api-definition-paths/email-paths/send-grid/event-handler/event-handler-action.ts
var SEND_GRID_EVENT_HANDLER_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "send-grid-event-handler"
  },
  request: {
    name: "SendGridEventHandlerRequestSchema",
    schema: SendGridEventHandlerRequestSchema
  },
  response: {
    name: "SendGridEventHandlerResponse",
    schema: SendGridEventHandlerResponseSchema
  },
  path: SEND_GRID_EVENT_HANDLER_PATH
};

// src/api-definition-paths/email-paths/send-reminder-email/send-reminder-email-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS241 } from "@vy/zapi-types";
var SEND_REMINDER_EMAIL_PATH = {
  accessLevel: PATH_ACCESS_LEVELS241.PRIVATE,
  route: "/email/send-reminder",
  tags: API_TAGS.EMAIL
};

// src/api-definition-paths/email-paths/send-reminder-email/send-reminder-email-request-schema.ts
import { oz as oz396 } from "@vy/utils";
var SendReminderEmailRequestSchema = oz396.object({
  emails: oz396.array(oz396.string()),
  subject: oz396.string(),
  content: oz396.string(),
  invoiceId: oz396.string(),
  customerId: oz396.string()
});

// src/api-definition-paths/email-paths/send-reminder-email/send-reminder-email-action.ts
var SEND_REMINDER_EMAIL_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "send-reminder-email"
  },
  request: {
    name: "SendReminderEmailRequestSchema",
    schema: SendReminderEmailRequestSchema
  },
  path: SEND_REMINDER_EMAIL_PATH
};

// src/api-definition-paths/email-paths/email-paths.ts
var EMAIL_PATHS = [SEND_GRID_EVENT_HANDLER_PATH, SEND_REMINDER_EMAIL_PATH];

// src/api-definition-paths/email-paths/email-actions.ts
var EMAIL_ACTIONS = [SEND_GRID_EVENT_HANDLER_ACTION, SEND_REMINDER_EMAIL_ACTION];

// src/api-definition-paths/phase-labels-paths/get-phase-labels/get-phase-labels-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS242 } from "@vy/zapi-types";
var GET_PHASE_LABELS_PATH = {
  route: "/phase-labels",
  tags: [API_TAGS.PHASE_LABELS],
  accessLevel: PATH_ACCESS_LEVELS242.PRIVATE
};

// src/api-definition-paths/phase-labels-paths/get-phase-labels/get-phase-labels-response-schema.ts
import { PhaseLabelSchema } from "@vy/types";
import { oz as oz397 } from "@vy/utils";
var GetPhaseLabelsResponseSchema = oz397.object({
  phaseLabels: oz397.array(PhaseLabelSchema)
}).openapi("GetPhaseLabelsResponse");

// src/api-definition-paths/phase-labels-paths/get-phase-labels/get-phase-labels-action.ts
var GET_PHASE_LABELS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-phase-labels"
  },
  response: {
    name: "GetPhaseLabelsResponse",
    schema: GetPhaseLabelsResponseSchema
  },
  path: GET_PHASE_LABELS_PATH
};

// src/api-definition-paths/phase-labels-paths/upsert-phase-label/upsert-phase-label-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS243 } from "@vy/zapi-types";
var UPSERT_PHASE_LABEL_PATH = {
  route: "/phase-labels",
  tags: [API_TAGS.PHASE_LABELS],
  accessLevel: PATH_ACCESS_LEVELS243.PRIVATE
};

// src/api-definition-paths/phase-labels-paths/upsert-phase-label/upsert-phase-label-request-schema.ts
import { NewPhaseLabelSchema } from "@vy/types";
var UpsertPhaseLabelRequestSchema = NewPhaseLabelSchema.openapi("UpsertPhaseLabelRequest");

// src/api-definition-paths/phase-labels-paths/upsert-phase-label/upsert-phase-label-response-schema.ts
import { PhaseLabelSchema as PhaseLabelSchema2 } from "@vy/types";
import { oz as oz398 } from "@vy/utils";
var UpsertPhaseLabelResponseSchema = oz398.object({
  phaseLabel: PhaseLabelSchema2
}).openapi("UpsertPhaseLabelResponse");

// src/api-definition-paths/phase-labels-paths/upsert-phase-label/upsert-phase-label-action.ts
var UPSERT_PHASE_LABEL_ACTION = {
  method: "post",
  request: {
    name: "UpsertPhaseLabelRequest",
    schema: UpsertPhaseLabelRequestSchema
  },
  codeGenerationSettings: {
    actionText: "upsert-phase-label"
  },
  response: {
    name: "UpsertPhaseLabelResponse",
    schema: UpsertPhaseLabelResponseSchema
  },
  path: UPSERT_PHASE_LABEL_PATH
};

// src/api-definition-paths/phase-labels-paths/phase-labels-paths.ts
var PHASE_LABELS_PATHS = [GET_PHASE_LABELS_PATH, UPSERT_PHASE_LABEL_PATH];

// src/api-definition-paths/phase-labels-paths/phase-labels-actions.ts
var PHASE_LABELS_ACTIONS = [GET_PHASE_LABELS_ACTION, UPSERT_PHASE_LABEL_ACTION];

// src/api-definition-paths/pricing-paths/get-pricing-templates/get-pricing-templates-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS244 } from "@vy/zapi-types";
var GET_PRICING_TEMPLATES_PATH = {
  route: "/pricing/templates",
  tags: [API_TAGS.PRICING],
  accessLevel: PATH_ACCESS_LEVELS244.PRIVATE
};

// src/api-definition-paths/pricing-paths/get-pricing-templates/get-pricing-templates-response-schema.ts
import { PricingTemplateSchema } from "@vy/types";
import { oz as oz399 } from "@vy/utils";
var GetPricingTemplatesResponseSchema = oz399.object({
  pricingTemplates: oz399.array(PricingTemplateSchema)
}).openapi("GetPricingTemplatesResponse");

// src/api-definition-paths/pricing-paths/get-pricing-templates/get-pricing-templates-action.ts
var GET_PRICING_TEMPLATES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-pricing-templates"
  },
  response: {
    name: "GetPricingTemplatesResponse",
    schema: GetPricingTemplatesResponseSchema
  },
  path: GET_PRICING_TEMPLATES_PATH
};

// src/api-definition-paths/pricing-paths/pricing-paths.ts
var PRICING_PATHS = [GET_PRICING_TEMPLATES_PATH];

// src/api-definition-paths/pricing-paths/pricing-actions.ts
var PRICING_ACTIONS = [GET_PRICING_TEMPLATES_ACTION];

// src/api-definition-paths/revenue-paths/get-recurring-revenue/get-recurring-revenue-action.ts
import { oz as oz401 } from "@vy/utils";

// src/api-definition-paths/revenue-paths/get-recurring-revenue/get-recurring-revenue-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS245 } from "@vy/zapi-types";
var GET_RECURRING_REVENUE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS245.PRIVATE,
  route: "/revenue/recurring",
  tags: API_TAGS.REVENUE
};

// src/api-definition-paths/revenue-paths/get-recurring-revenue/get-recurring-revenue-response.ts
import { ApiDateSchema as ApiDateSchema42 } from "@vy/types";
import { oz as oz400 } from "@vy/utils";
var GetRecurringRevenueResponseSchema = oz400.object({
  monthlyRecurringRevenue: oz400.number(),
  annualRecurringRevenue: oz400.number(),
  recurringRevenueTrend: oz400.array(
    oz400.object({
      month: ApiDateSchema42,
      monthlyRecurringRevenue: oz400.number(),
      annualRecurringRevenue: oz400.number()
    })
  )
}).openapi("GetRecurringRevenueResponse");

// src/api-definition-paths/revenue-paths/get-recurring-revenue/get-recurring-revenue-action.ts
var OPTIONAL_CUSTOMER_ID_QUERY_PARAM = {
  name: "customerId",
  location: "query",
  schema: oz401.string().optional(),
  required: false
};
var OPTIONAL_CONTRACT_ID_QUERY_PARAM = {
  name: "contractId",
  location: "query",
  schema: oz401.string().optional(),
  required: false
};
var GET_RECURRING_REVENUE_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-recurring-revenue"
  },
  response: {
    name: "GetRecurringRevenueResponse",
    schema: GetRecurringRevenueResponseSchema
  },
  queryParams: {
    [OPTIONAL_CUSTOMER_ID_QUERY_PARAM.name]: OPTIONAL_CUSTOMER_ID_QUERY_PARAM,
    [OPTIONAL_CONTRACT_ID_QUERY_PARAM.name]: OPTIONAL_CONTRACT_ID_QUERY_PARAM
  },
  path: GET_RECURRING_REVENUE_PATH
};

// src/api-definition-paths/revenue-paths/get-mrr-waterfall/get-mrr-waterfall-action.ts
import { oz as oz403 } from "@vy/utils";

// src/api-definition-paths/revenue-paths/get-mrr-waterfall/get-mrr-waterfall-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS246 } from "@vy/zapi-types";
var GET_MRR_WATERFALL_PATH = {
  accessLevel: PATH_ACCESS_LEVELS246.PRIVATE,
  route: "/revenue/mrr-waterfall",
  tags: API_TAGS.REVENUE
};

// src/api-definition-paths/revenue-paths/get-mrr-waterfall/get-mrr-waterfall-response.ts
import { oz as oz402 } from "@vy/utils";
var GetMrrWaterfallResponseSchema = oz402.object({
  month: oz402.string(),
  beginningMrr: oz402.number(),
  endingMrr: oz402.number(),
  movements: oz402.object({
    newMrr: oz402.number(),
    expansionMrr: oz402.number(),
    reactivationMrr: oz402.number(),
    contractionMrr: oz402.number(),
    churnMrr: oz402.number()
  }),
  nrr: oz402.number(),
  grr: oz402.number(),
  netChange: oz402.number(),
  netChangePercentage: oz402.number()
}).openapi("GetMrrWaterfallResponse");

// src/api-definition-paths/revenue-paths/get-mrr-waterfall/get-mrr-waterfall-action.ts
var OPTIONAL_MONTH_QUERY_PARAM = {
  name: "month",
  location: "query",
  schema: oz403.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/).optional(),
  required: false
};
var GET_MRR_WATERFALL_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-mrr-waterfall"
  },
  response: {
    name: "GetMrrWaterfallResponse",
    schema: GetMrrWaterfallResponseSchema
  },
  queryParams: {
    [OPTIONAL_MONTH_QUERY_PARAM.name]: OPTIONAL_MONTH_QUERY_PARAM
  },
  path: GET_MRR_WATERFALL_PATH
};

// src/api-definition-paths/revenue-paths/get-ytd-billed-revenue/get-ytd-billed-revenue-action.ts
import { oz as oz405 } from "@vy/utils";

// src/api-definition-paths/revenue-paths/get-ytd-billed-revenue/get-ytd-billed-revenue-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS247 } from "@vy/zapi-types";
var GET_YTD_BILLED_REVENUE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS247.PRIVATE,
  route: "/revenue/ytd-billed",
  tags: API_TAGS.REVENUE
};

// src/api-definition-paths/revenue-paths/get-ytd-billed-revenue/get-ytd-billed-revenue-response-schema.ts
import { oz as oz404 } from "@vy/utils";
var GetYtdBilledRevenueResponseSchema = oz404.object({
  ytdBilledRevenue: oz404.number()
}).openapi("GetYtdBilledRevenueResponse");

// src/api-definition-paths/revenue-paths/get-ytd-billed-revenue/get-ytd-billed-revenue-action.ts
var OPTIONAL_CUSTOMER_ID_QUERY_PARAM2 = {
  name: "customerId",
  location: "query",
  schema: oz405.string().optional(),
  required: false
};
var OPTIONAL_CONTRACT_ID_QUERY_PARAM2 = {
  name: "contractId",
  location: "query",
  schema: oz405.string().optional(),
  required: false
};
var GET_YTD_BILLED_REVENUE_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-ytd-billed-revenue"
  },
  response: {
    name: "GetYtdBilledRevenueResponse",
    schema: GetYtdBilledRevenueResponseSchema
  },
  queryParams: {
    [OPTIONAL_CUSTOMER_ID_QUERY_PARAM2.name]: OPTIONAL_CUSTOMER_ID_QUERY_PARAM2,
    [OPTIONAL_CONTRACT_ID_QUERY_PARAM2.name]: OPTIONAL_CONTRACT_ID_QUERY_PARAM2
  },
  path: GET_YTD_BILLED_REVENUE_PATH
};

// src/api-definition-paths/revenue-paths/get-ytd-revenue-tax/get-ytd-revenue-tax-action.ts
import { oz as oz407 } from "@vy/utils";

// src/api-definition-paths/revenue-paths/get-ytd-revenue-tax/get-ytd-revenue-tax-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS248 } from "@vy/zapi-types";
var GET_YTD_REVENUE_TAX_PATH = {
  accessLevel: PATH_ACCESS_LEVELS248.PRIVATE,
  route: "/revenue/ytd-revenue-tax",
  tags: API_TAGS.REVENUE
};

// src/api-definition-paths/revenue-paths/get-ytd-revenue-tax/get-ytd-revenue-tax-response-schema.ts
import { oz as oz406 } from "@vy/utils";
var GetYtdRevenueTaxResponseSchema = oz406.object({
  ytdRevenueTax: oz406.number()
}).openapi("GetYtdRevenueTaxResponse");

// src/api-definition-paths/revenue-paths/get-ytd-revenue-tax/get-ytd-revenue-tax-action.ts
var OPTIONAL_CUSTOMER_ID_QUERY_PARAM3 = {
  name: "customerId",
  location: "query",
  schema: oz407.string().optional(),
  required: false
};
var OPTIONAL_CONTRACT_ID_QUERY_PARAM3 = {
  name: "contractId",
  location: "query",
  schema: oz407.string().optional(),
  required: false
};
var GET_YTD_REVENUE_TAX_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-ytd-revenue-tax"
  },
  response: {
    name: "GetYtdRevenueTaxResponse",
    schema: GetYtdRevenueTaxResponseSchema
  },
  queryParams: {
    [OPTIONAL_CUSTOMER_ID_QUERY_PARAM3.name]: OPTIONAL_CUSTOMER_ID_QUERY_PARAM3,
    [OPTIONAL_CONTRACT_ID_QUERY_PARAM3.name]: OPTIONAL_CONTRACT_ID_QUERY_PARAM3
  },
  path: GET_YTD_REVENUE_TAX_PATH
};

// src/api-definition-paths/revenue-paths/revenue-actions.ts
var REVENUE_ACTIONS = [
  GET_RECURRING_REVENUE_ACTION,
  GET_MRR_WATERFALL_ACTION,
  GET_YTD_BILLED_REVENUE_ACTION,
  GET_YTD_REVENUE_TAX_ACTION
];

// src/api-definition-paths/revenue-paths/revenue-paths.ts
var REVENUE_PATHS = [
  GET_RECURRING_REVENUE_PATH,
  GET_MRR_WATERFALL_PATH,
  GET_YTD_BILLED_REVENUE_PATH,
  GET_YTD_REVENUE_TAX_PATH
];

// src/api-definition-paths/subsidiaries-paths/subsidiaries-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS249 } from "@vy/zapi-types";
var SUBSIDIARIES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS249.PRIVATE,
  route: "/subsidiaries",
  tags: [API_TAGS.SUBSIDIARIES]
};

// src/api-definition-paths/subsidiaries-paths/update-subsidiary/update-subsidiary-path.ts
import { oz as oz408 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS250 } from "@vy/zapi-types";
var UPDATE_SUBSIDIARY_ID_PATH_PARAM = {
  name: "subsidiaryId",
  location: "path",
  schema: oz408.string(),
  required: true
};
var UPDATE_SUBSIDIARY_PATH = {
  accessLevel: PATH_ACCESS_LEVELS250.PRIVATE,
  route: "/subsidiaries/{subsidiaryId}",
  pathParams: {
    [UPDATE_SUBSIDIARY_ID_PATH_PARAM.name]: UPDATE_SUBSIDIARY_ID_PATH_PARAM
  },
  tags: API_TAGS.SUBSIDIARIES
};

// src/api-definition-paths/subsidiaries-paths/subsidiaries-paths.ts
var SUBSIDIARIES_PATHS = [SUBSIDIARIES_PATH, UPDATE_SUBSIDIARY_PATH];

// src/api-definition-paths/users-paths/get-users/get-users-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS251 } from "@vy/zapi-types";
var GET_USERS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS251.PRIVATE,
  route: "/users",
  tags: API_TAGS.USERS
};

// src/api-definition-paths/users-paths/invite-user/invite-user-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS252 } from "@vy/zapi-types";
var INVITE_USER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS252.PRIVATE,
  route: "/users/invite",
  tags: API_TAGS.USERS
};

// src/api-definition-paths/users-paths/update-user/update-user-path.ts
import { oz as oz409 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS253 } from "@vy/zapi-types";
var USER_ID_PATH_PARAM = {
  name: "userId",
  location: "path",
  schema: oz409.string(),
  required: true
};
var USER_ID_PATH_PARAMS = {
  [USER_ID_PATH_PARAM.name]: USER_ID_PATH_PARAM
};
var UPDATE_USER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS253.PRIVATE,
  route: "/users/{userId}",
  pathParams: USER_ID_PATH_PARAMS,
  tags: API_TAGS.USERS
};

// src/api-definition-paths/users-paths/get-invitations/get-invitations-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS254 } from "@vy/zapi-types";
var GET_INVITATIONS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS254.PRIVATE,
  route: "/users/invitations",
  tags: API_TAGS.USERS
};

// src/api-definition-paths/users-paths/cancel-invitation/cancel-invitation-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS255 } from "@vy/zapi-types";

// src/api-definition-paths/users-paths/cancel-invitation/cancel-invitation-path-params.ts
import { oz as oz410 } from "@vy/utils";
var INVITATION_ID_PATH_PARAM = {
  name: "invitationId",
  location: "path",
  schema: oz410.string(),
  required: true
};
var CANCEL_INVITATION_PATH_PARAMS = {
  [INVITATION_ID_PATH_PARAM.name]: INVITATION_ID_PATH_PARAM
};

// src/api-definition-paths/users-paths/cancel-invitation/cancel-invitation-path.ts
var CANCEL_INVITATION_PATH = {
  accessLevel: PATH_ACCESS_LEVELS255.PRIVATE,
  route: "/users/invitations/{invitationId}",
  pathParams: CANCEL_INVITATION_PATH_PARAMS,
  tags: API_TAGS.USERS
};

// src/api-definition-paths/users-paths/remove-user/remove-user-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS256 } from "@vy/zapi-types";

// src/api-definition-paths/users-paths/remove-user/remove-user-path-params.ts
import { oz as oz411 } from "@vy/utils";
var USER_ID_PATH_PARAM2 = {
  name: "userId",
  location: "path",
  schema: oz411.string(),
  required: true
};
var REMOVE_USER_PATH_PARAMS = {
  [USER_ID_PATH_PARAM2.name]: USER_ID_PATH_PARAM2
};

// src/api-definition-paths/users-paths/remove-user/remove-user-path.ts
var REMOVE_USER_PATH = {
  accessLevel: PATH_ACCESS_LEVELS256.PRIVATE,
  route: "/users/{userId}",
  pathParams: REMOVE_USER_PATH_PARAMS,
  tags: API_TAGS.USERS
};

// src/api-definition-paths/users-paths/users-paths.ts
var USERS_PATHS = [
  GET_USERS_PATH,
  INVITE_USER_PATH,
  UPDATE_USER_PATH,
  GET_INVITATIONS_PATH,
  CANCEL_INVITATION_PATH,
  REMOVE_USER_PATH
];

// src/api-definition-paths/catalog-products-paths/catalog-products-path/catalog-products-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS257 } from "@vy/zapi-types";
var CATALOG_PRODUCTS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS257.PRIVATE,
  route: "/catalog-products",
  tags: API_TAGS.CATALOG_PRODUCTS
};

// src/api-definition-paths/catalog-products-paths/catalog-products-path/create-catalog-products-action.ts
import { oz as oz412 } from "@vy/utils";
import { CatalogProductsSchema, NewCatalogProductSchema } from "@vy/types";
var CreateCatalogProductsResponseSchema = oz412.object({
  catalogProduct: CatalogProductsSchema
}).openapi("CreateCatalogProductsResponse");
var CreateCatalogProductsRequestSchema = NewCatalogProductSchema.openapi("CreateCatalogProductsRequest");
var CREATE_CATALOG_PRODUCTS_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "create-catalog-products"
  },
  request: {
    name: "CreateCatalogProductsRequest",
    schema: CreateCatalogProductsRequestSchema
  },
  response: {
    name: "createCatalogProductsResponse",
    schema: CreateCatalogProductsResponseSchema
  },
  path: CATALOG_PRODUCTS_PATH
};

// src/api-definition-paths/catalog-products-paths/catalog-products-path/get-catalog-products-list-action.ts
import { oz as oz413 } from "@vy/utils";
import { CatalogProductsSchema as CatalogProductsSchema2 } from "@vy/types";
var GetCatalogProductsListResponseSchema = oz413.object({
  catalogProducts: oz413.array(CatalogProductsSchema2)
}).openapi("GetCatalogProductsListResponse");
var GET_CATALOG_PRODUCTS_LIST_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-catalog-products-list"
  },
  response: {
    name: "getCatalogProductsListResponse",
    schema: GetCatalogProductsListResponseSchema
  },
  path: CATALOG_PRODUCTS_PATH
};

// src/api-definition-paths/catalog-products-paths/catalog-products-id-path/catalog-products-id-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS258 } from "@vy/zapi-types";
import { oz as oz414 } from "@vy/utils";
var CATALOG_PRODUCTS_ID_PATH_PARAM_SCHEMA = {
  name: "catalogProductId",
  location: "path",
  schema: oz414.string(),
  required: true
};
var CATALOG_PRODUCTS_ID_PATH_PARAMS = {
  [CATALOG_PRODUCTS_ID_PATH_PARAM_SCHEMA.name]: CATALOG_PRODUCTS_ID_PATH_PARAM_SCHEMA
};
var CATALOG_PRODUCTS_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS258.PRIVATE,
  route: "/catalog-products/{catalogProductId}",
  pathParams: CATALOG_PRODUCTS_ID_PATH_PARAMS,
  tags: API_TAGS.CATALOG_PRODUCTS
};

// src/api-definition-paths/catalog-products-paths/catalog-products-id-path/delete-catalog-products-action.ts
import { oz as oz415 } from "@vy/utils";
var DeleteCatalogProductsResponseSchema = oz415.object({
  catalogProductId: oz415.string()
}).openapi("DeleteCatalogProductsResponse");
var DELETE_CATALOG_PRODUCTS_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-catalog-products"
  },
  response: {
    name: "deleteCatalogProductsResponse",
    schema: DeleteCatalogProductsResponseSchema
  },
  path: CATALOG_PRODUCTS_ID_PATH
};

// src/api-definition-paths/catalog-products-paths/catalog-products-id-path/get-catalog-products-action.ts
import { oz as oz416 } from "@vy/utils";
import { CatalogProductsSchema as CatalogProductsSchema3 } from "@vy/types";
var GetCatalogProductsResponseSchema = oz416.object({
  catalogProduct: CatalogProductsSchema3
}).openapi("GetCatalogProductResponse");
var GET_CATALOG_PRODUCTS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-catalog-products"
  },
  response: {
    name: "getCatalogProductsResponse",
    schema: GetCatalogProductsResponseSchema
  },
  path: CATALOG_PRODUCTS_ID_PATH
};

// src/api-definition-paths/catalog-products-paths/catalog-products-id-path/update-catalog-products-action.ts
import { CatalogProductsSchema as CatalogProductsSchema4, NewCatalogProductSchema as NewCatalogProductSchema2 } from "@vy/types";
import { oz as oz417 } from "@vy/utils";
var UpdateCatalogProductsResponseSchema = oz417.object({
  catalogProduct: CatalogProductsSchema4
}).openapi("UpdateCatalogProductsResponse");
var UpdateCatalogProductsRequestSchema = NewCatalogProductSchema2.openapi("UpdateCatalogProductsRequest");
var UPDATE_CATALOG_PRODUCTS_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-catalog-products"
  },
  request: {
    name: "UpdateCatalogProductsRequest",
    schema: UpdateCatalogProductsRequestSchema
  },
  response: {
    name: "updateCatalogProductsResponse",
    schema: UpdateCatalogProductsResponseSchema
  },
  path: CATALOG_PRODUCTS_ID_PATH
};

// src/api-definition-paths/catalog-products-paths/catalog-products-actions.ts
var CATALOG_PRODUCTS_ACTIONS = [
  CREATE_CATALOG_PRODUCTS_ACTION,
  DELETE_CATALOG_PRODUCTS_ACTION,
  GET_CATALOG_PRODUCTS_ACTION,
  UPDATE_CATALOG_PRODUCTS_ACTION,
  GET_CATALOG_PRODUCTS_LIST_ACTION
];

// src/api-definition-paths/catalog-products-paths/catalog-products-paths.ts
var CATALOG_PRODUCTS_PATHS = [CATALOG_PRODUCTS_PATH, CATALOG_PRODUCTS_ID_PATH];

// src/api-definition-paths/exchange-rates-paths/exchange-rates-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS259 } from "@vy/zapi-types";
var EXCHANGE_RATES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS259.PRIVATE,
  route: "/exchange-rates",
  tags: API_TAGS.EXCHANGE_RATES
};

// src/api-definition-paths/exchange-rates-paths/get-exchange-rates/get-exchange-rates-response-schema.ts
import { CurrencyExchangeRatesSchema } from "@vy/types";
import { oz as oz418 } from "@vy/utils";
var GetExchangeRatesResponseSchema = oz418.object({
  data: CurrencyExchangeRatesSchema
});

// src/api-definition-paths/exchange-rates-paths/get-exchange-rates/get-exchange-rates-action.ts
var GET_EXCHANGE_RATES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-exchange-rates"
  },
  response: {
    name: "GetExchangeRatesResponse",
    schema: GetExchangeRatesResponseSchema
  },
  path: EXCHANGE_RATES_PATH
};

// src/api-definition-paths/exchange-rates-paths/get-exchange-rates-matrix/get-exchange-rates-matrix-response-schema.ts
import { CurrencySchema as CurrencySchema17 } from "@vy/types";
import { oz as oz419 } from "@vy/utils";
var ExchangeRateMatrixRowSchema = oz419.record(CurrencySchema17, oz419.number().positive());
var ExchangeRateMatrixSchema = oz419.record(CurrencySchema17, ExchangeRateMatrixRowSchema);
var GetExchangeRatesMatrixResponseSchema = oz419.object({
  data: ExchangeRateMatrixSchema
});

// src/api-definition-paths/exchange-rates-paths/get-exchange-rates-matrix/get-exchange-rates-matrix-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS260 } from "@vy/zapi-types";
var GET_EXCHANGE_RATES_MATRIX_PATH = {
  accessLevel: PATH_ACCESS_LEVELS260.PRIVATE,
  route: "/exchange-rates/matrix",
  tags: API_TAGS.EXCHANGE_RATES
};

// src/api-definition-paths/exchange-rates-paths/get-exchange-rates-matrix/get-exchange-rates-matrix-action.ts
var GET_EXCHANGE_RATES_MATRIX_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-exchange-rates-matrix"
  },
  response: {
    name: "GetExchangeRatesMatrixResponse",
    schema: GetExchangeRatesMatrixResponseSchema
  },
  path: GET_EXCHANGE_RATES_MATRIX_PATH
};

// src/api-definition-paths/exchange-rates-paths/exchange-rates-actions.ts
var EXCHANGE_RATES_ACTIONS = [GET_EXCHANGE_RATES_ACTION, GET_EXCHANGE_RATES_MATRIX_ACTION];

// src/api-definition-paths/exchange-rates-paths/exchange-rates-paths.ts
var EXCHANGE_RATES_PATHS = [EXCHANGE_RATES_PATH, GET_EXCHANGE_RATES_MATRIX_PATH];

// src/api-definition-paths/custom-field-definition-paths/get-custom-field-definitions/get-custom-field-definitions-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS261 } from "@vy/zapi-types";
var GET_CUSTOM_FIELD_DEFINITIONS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS261.PRIVATE,
  route: "/custom-field-definitions",
  tags: API_TAGS.CUSTOMER
};

// src/api-definition-paths/custom-field-definition-paths/get-custom-field-definitions/get-custom-field-definitions-response-schema.ts
import { oz as oz420 } from "@vy/utils";
import { CustomFieldDefinitionSchema as CustomFieldDefinitionSchema3 } from "@vy/custom-fields-types";
var GetCustomFieldDefinitionsResponseSchema = oz420.object({
  customFieldDefinitions: oz420.array(CustomFieldDefinitionSchema3)
}).openapi("GetCustomFieldDefinitionsResponse");

// src/api-definition-paths/custom-field-definition-paths/get-custom-field-definitions/get-custom-field-definitions-action.ts
var GET_CUSTOM_FIELD_DEFINITIONS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-custom-field-definitions"
  },
  queryParams: {},
  response: {
    name: "GetCustomFieldDefinitionsResponse",
    schema: GetCustomFieldDefinitionsResponseSchema
  },
  path: GET_CUSTOM_FIELD_DEFINITIONS_PATH
};

// src/api-definition-paths/custom-field-definition-paths/custom-field-definition-actions.ts
var CUSTOM_FIELD_DEFINITION_ACTIONS = [GET_CUSTOM_FIELD_DEFINITIONS_ACTION];

// src/api-definition-paths/custom-field-definition-paths/custom-field-definition-paths.ts
var CUSTOM_FIELD_DEFINITION_PATHS = [GET_CUSTOM_FIELD_DEFINITIONS_PATH];

// src/api-definition-paths/customer-note-paths/customer-note-id-path.ts
import { oz as oz421 } from "@vy/utils";
var CUSTOMER_NOTE_ID_PATH_PARAM = {
  name: "noteId",
  location: "path",
  schema: oz421.string(),
  required: true
};
var CUSTOMER_NOTE_ID_PATH_PARAMS = {
  [CUSTOMER_NOTE_ID_PATH_PARAM.name]: CUSTOMER_NOTE_ID_PATH_PARAM
};

// src/api-definition-paths/customer-note-paths/create-customer-note/create-customer-note-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS262 } from "@vy/zapi-types";
var CREATE_CUSTOMER_NOTE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS262.PRIVATE,
  route: "/customer-note/{customerId}",
  pathParams: CUSTOMER_ID_PATH_PARAMS,
  tags: API_TAGS.CUSTOMER_NOTE
};

// src/api-definition-paths/customer-note-paths/create-customer-note/create-customer-note-request-schema.ts
import { oz as oz422 } from "@vy/utils";
var CreateCustomerNoteRequestSchema = oz422.object({
  content: oz422.string().trim().min(1).max(1e3)
}).openapi("CreateCustomerNoteRequest");

// src/api-definition-paths/customer-note-paths/create-customer-note/create-customer-note-response-schema.ts
import { oz as oz423 } from "@vy/utils";
var CreateCustomerNoteResponseSchema = oz423.object({
  id: oz423.string(),
  content: oz423.string(),
  customerId: oz423.string(),
  userEmail: oz423.string(),
  authorFirstName: oz423.string().nullish(),
  authorLastName: oz423.string().nullish(),
  createdAt: oz423.string(),
  updatedAt: oz423.string().nullish()
}).openapi("CreateCustomerNoteResponse");

// src/api-definition-paths/customer-note-paths/create-customer-note/create-customer-note-action.ts
var CREATE_CUSTOMER_NOTE_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "create-customer-note"
  },
  request: {
    name: "CreateCustomerNoteRequest",
    schema: CreateCustomerNoteRequestSchema
  },
  response: {
    name: "CreateCustomerNoteResponse",
    schema: CreateCustomerNoteResponseSchema
  },
  path: CREATE_CUSTOMER_NOTE_PATH
};

// src/api-definition-paths/customer-note-paths/list-customer-notes/list-customer-notes-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS263 } from "@vy/zapi-types";
var LIST_CUSTOMER_NOTES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS263.PRIVATE,
  route: "/customer-notes/{customerId}",
  pathParams: CUSTOMER_ID_PATH_PARAMS,
  tags: API_TAGS.CUSTOMER_NOTES
};

// src/api-definition-paths/customer-note-paths/list-customer-notes/list-customer-notes-response-schema.ts
import { oz as oz424 } from "@vy/utils";
var CustomerNoteItemSchema = oz424.object({
  id: oz424.string(),
  content: oz424.string(),
  authorId: oz424.string(),
  userEmail: oz424.string(),
  authorFirstName: oz424.string().nullish(),
  authorLastName: oz424.string().nullish(),
  createdAt: oz424.string(),
  updatedAt: oz424.string().nullish()
});
var ListCustomerNotesResponseSchema = oz424.object({
  notes: oz424.array(CustomerNoteItemSchema)
}).openapi("ListCustomerNotesResponse");

// src/api-definition-paths/customer-note-paths/list-customer-notes/list-customer-notes-action.ts
var LIST_CUSTOMER_NOTES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "list-customer-notes"
  },
  response: {
    name: "ListCustomerNotesResponse",
    schema: ListCustomerNotesResponseSchema
  },
  path: LIST_CUSTOMER_NOTES_PATH
};

// src/api-definition-paths/customer-note-paths/modify-customer-note/modify-customer-note-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS264 } from "@vy/zapi-types";
var MODIFY_CUSTOMER_NOTE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS264.PRIVATE,
  route: "/customer-note/{noteId}",
  pathParams: CUSTOMER_NOTE_ID_PATH_PARAMS,
  tags: API_TAGS.CUSTOMER_NOTE
};

// src/api-definition-paths/customer-note-paths/modify-customer-note/modify-customer-note-request-schema.ts
import { oz as oz425 } from "@vy/utils";
var ModifyCustomerNoteRequestSchema = oz425.object({
  content: oz425.string().trim().min(1).max(1e3)
}).openapi("ModifyCustomerNoteRequest");

// src/api-definition-paths/customer-note-paths/modify-customer-note/modify-customer-note-response-schema.ts
import { oz as oz426 } from "@vy/utils";
var ModifyCustomerNoteResponseSchema = oz426.object({
  id: oz426.string(),
  content: oz426.string(),
  updatedAt: oz426.string()
}).openapi("ModifyCustomerNoteResponse");

// src/api-definition-paths/customer-note-paths/modify-customer-note/modify-customer-note-action.ts
var MODIFY_CUSTOMER_NOTE_ACTION = {
  method: "patch",
  codeGenerationSettings: {
    actionText: "modify-customer-note"
  },
  request: {
    name: "ModifyCustomerNoteRequest",
    schema: ModifyCustomerNoteRequestSchema
  },
  response: {
    name: "ModifyCustomerNoteResponse",
    schema: ModifyCustomerNoteResponseSchema
  },
  path: MODIFY_CUSTOMER_NOTE_PATH
};

// src/api-definition-paths/customer-note-paths/remove-customer-note/remove-customer-note-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS265 } from "@vy/zapi-types";
var REMOVE_CUSTOMER_NOTE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS265.PRIVATE,
  route: "/customer-note/{noteId}",
  pathParams: CUSTOMER_NOTE_ID_PATH_PARAMS,
  tags: API_TAGS.CUSTOMER_NOTE
};

// src/api-definition-paths/customer-note-paths/remove-customer-note/remove-customer-note-response-schema.ts
import { oz as oz427 } from "@vy/utils";
var RemoveCustomerNoteResponseSchema = oz427.object({
  id: oz427.string()
}).openapi("RemoveCustomerNoteResponse");

// src/api-definition-paths/customer-note-paths/remove-customer-note/remove-customer-note-action.ts
var REMOVE_CUSTOMER_NOTE_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "remove-customer-note"
  },
  response: {
    name: "RemoveCustomerNoteResponse",
    schema: RemoveCustomerNoteResponseSchema
  },
  path: REMOVE_CUSTOMER_NOTE_PATH
};

// src/api-definition-paths/customer-note-paths/customer-note-actions.ts
var CUSTOMER_NOTE_ACTIONS = [
  CREATE_CUSTOMER_NOTE_ACTION,
  LIST_CUSTOMER_NOTES_ACTION,
  MODIFY_CUSTOMER_NOTE_ACTION,
  REMOVE_CUSTOMER_NOTE_ACTION
];

// src/api-definition-paths/customer-note-paths/customer-note-paths.ts
var CUSTOMER_NOTE_PATHS = [
  CREATE_CUSTOMER_NOTE_PATH,
  LIST_CUSTOMER_NOTES_PATH,
  MODIFY_CUSTOMER_NOTE_PATH,
  REMOVE_CUSTOMER_NOTE_PATH
];

// src/api-definition-paths/public-api-keys-paths/public-api-keys-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS266 } from "@vy/zapi-types";
var PUBLIC_API_KEYS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS266.PRIVATE,
  route: "/public-api-keys",
  tags: API_TAGS.PUBLIC_API_KEYS
};

// src/api-definition-paths/public-api-keys-paths/public-api-key-id-path.ts
import { oz as oz428 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS267 } from "@vy/zapi-types";
var PUBLIC_API_KEY_ID_PATH_PARAM = {
  name: "publicApiKeyId",
  location: "path",
  schema: oz428.string(),
  required: true
};
var PUBLIC_API_KEY_ID_PATH_PARAMS = {
  [PUBLIC_API_KEY_ID_PATH_PARAM.name]: PUBLIC_API_KEY_ID_PATH_PARAM
};
var PUBLIC_API_KEY_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS267.PRIVATE,
  route: "/public-api-keys/{publicApiKeyId}",
  pathParams: PUBLIC_API_KEY_ID_PATH_PARAMS,
  tags: API_TAGS.PUBLIC_API_KEYS
};

// src/api-definition-paths/public-api-keys-paths/public-api-keys-paths.ts
var PUBLIC_API_KEYS_PATHS = [PUBLIC_API_KEYS_PATH, PUBLIC_API_KEY_ID_PATH];

// src/api-definition-paths/public-api-keys-paths/create-public-api-key/create-public-api-key-request-schema.ts
import { oz as oz429 } from "@vy/utils";
var CreatePublicApiKeyRequestSchema = oz429.object({
  name: oz429.string().min(1).max(64)
}).openapi("CreatePublicApiKeyRequest");

// src/api-definition-paths/public-api-keys-paths/create-public-api-key/create-public-api-key-response-schema.ts
import { oz as oz430 } from "@vy/utils";
var CreatePublicApiKeyResponseSchema = oz430.object({
  id: oz430.string(),
  name: oz430.string(),
  keyValue: oz430.string(),
  prefix: oz430.string(),
  createdAt: oz430.date()
}).openapi("CreatePublicApiKeyResponse");

// src/api-definition-paths/public-api-keys-paths/create-public-api-key/create-public-api-key-action.ts
var CREATE_PUBLIC_API_KEY_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "create-public-api-key"
  },
  response: {
    name: "CreatePublicApiKeyResponse",
    schema: CreatePublicApiKeyResponseSchema
  },
  request: {
    name: "CreatePublicApiKeyRequest",
    schema: CreatePublicApiKeyRequestSchema
  },
  path: PUBLIC_API_KEYS_PATH
};

// src/api-definition-paths/public-api-keys-paths/delete-public-api-key/delete-public-api-key-response-schema.ts
import { oz as oz431 } from "@vy/utils";
var DeletePublicApiKeyResponseSchema = oz431.object({
  publicApiKeyId: oz431.string()
}).openapi("DeletePublicApiKeyResponse");

// src/api-definition-paths/public-api-keys-paths/delete-public-api-key/delete-public-api-key-action.ts
var DELETE_PUBLIC_API_KEY_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-public-api-key"
  },
  response: {
    name: "DeletePublicApiKeyResponse",
    schema: DeletePublicApiKeyResponseSchema
  },
  path: PUBLIC_API_KEY_ID_PATH
};

// src/api-definition-paths/public-api-keys-paths/get-public-api-keys/get-public-api-keys-response-schema.ts
import { oz as oz432 } from "@vy/utils";
var PublicApiKeySummarySchema = oz432.object({
  id: oz432.string(),
  name: oz432.string(),
  prefix: oz432.string(),
  createdAt: oz432.date()
}).openapi("PublicApiKeySummary");
var GetPublicApiKeysResponseSchema = oz432.object({
  publicApiKeys: oz432.array(PublicApiKeySummarySchema)
}).openapi("GetPublicApiKeysResponse");

// src/api-definition-paths/public-api-keys-paths/get-public-api-keys/get-public-api-keys-action.ts
var GET_PUBLIC_API_KEYS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-public-api-keys"
  },
  response: {
    name: "GetPublicApiKeysResponse",
    schema: GetPublicApiKeysResponseSchema
  },
  path: PUBLIC_API_KEYS_PATH
};

// src/api-definition-paths/public-api-keys-paths/public-api-keys-actions.ts
var PUBLIC_API_KEYS_ACTIONS = [
  CREATE_PUBLIC_API_KEY_ACTION,
  GET_PUBLIC_API_KEYS_ACTION,
  DELETE_PUBLIC_API_KEY_ACTION
];

// src/api-definition-paths/credit-pools-paths/list-credit-pools/list-credit-pools-action.ts
import { oz as oz434 } from "@vy/utils";

// src/api-definition-paths/credit-pools-paths/list-credit-pools/list-credit-pools-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS268 } from "@vy/zapi-types";
var LIST_CREDIT_POOLS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS268.PRIVATE,
  route: "/credit-pools",
  tags: API_TAGS.CREDIT_LEDGER
};

// src/api-definition-paths/credit-pools-paths/list-credit-pools/list-credit-pools-response-schema.ts
import { oz as oz433 } from "@vy/utils";
var ListCreditPoolsResponseSchema = oz433.object({
  creditPools: oz433.array(CreditPoolSchema)
}).openapi("ListCreditPoolsResponse");

// src/api-definition-paths/credit-pools-paths/list-credit-pools/list-credit-pools-action.ts
var CUSTOMER_ID_QUERY_PARAM5 = {
  name: "customerId",
  location: "query",
  schema: oz434.string(),
  required: true
};
var LIST_CREDIT_POOLS_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "list-credit-pools" },
  queryParams: {
    [CUSTOMER_ID_QUERY_PARAM5.name]: CUSTOMER_ID_QUERY_PARAM5
  },
  response: {
    name: "ListCreditPoolsResponse",
    schema: ListCreditPoolsResponseSchema
  },
  path: LIST_CREDIT_POOLS_PATH
};

// src/api-definition-paths/credit-pools-paths/credit-pools-paths.ts
var CREDIT_POOLS_PATHS = [LIST_CREDIT_POOLS_PATH];

// src/api-definition-paths/credit-pools-paths/credit-pools-actions.ts
var CREDIT_POOLS_ACTIONS = [LIST_CREDIT_POOLS_ACTION];

// src/api-definition-paths/credit-types-paths/list-credit-types/list-credit-types-action.ts
import { oz as oz437 } from "@vy/utils";

// src/api-definition-paths/credit-types-paths/list-credit-types/list-credit-types-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS269 } from "@vy/zapi-types";
var LIST_CREDIT_TYPES_PATH = {
  accessLevel: PATH_ACCESS_LEVELS269.PRIVATE,
  route: "/credit-types",
  tags: API_TAGS.CREDIT_LEDGER
};

// src/api-definition-paths/credit-types-paths/list-credit-types/list-credit-types-response-schema.ts
import { oz as oz436 } from "@vy/utils";

// src/api-definition-paths/credit-types-paths/credit-type-schemas.ts
import { oz as oz435 } from "@vy/utils";
import { ApiDateSchema as ApiDateSchema43 } from "@vy/types";
var CreditTypeSchema = oz435.object({
  id: oz435.string(),
  createdAt: ApiDateSchema43,
  updatedAt: ApiDateSchema43,
  name: oz435.string(),
  units: oz435.string().optional(),
  isTaxable: oz435.boolean(),
  isDeletable: oz435.boolean()
}).openapi("CreditType");

// src/api-definition-paths/credit-types-paths/list-credit-types/list-credit-types-response-schema.ts
var ListCreditTypesResponseSchema = oz436.object({
  creditTypes: oz436.array(CreditTypeSchema)
}).openapi("ListCreditTypesResponse");

// src/api-definition-paths/credit-types-paths/list-credit-types/list-credit-types-action.ts
var NAME_SEARCH_QUERY_PARAM = {
  name: "nameSearch",
  location: "query",
  schema: oz437.string().optional(),
  required: false
};
var LIST_CREDIT_TYPES_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "list-credit-types" },
  queryParams: {
    [NAME_SEARCH_QUERY_PARAM.name]: NAME_SEARCH_QUERY_PARAM
  },
  response: {
    name: "ListCreditTypesResponse",
    schema: ListCreditTypesResponseSchema
  },
  path: LIST_CREDIT_TYPES_PATH
};

// src/api-definition-paths/credit-types-paths/get-credit-type/get-credit-type-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS270 } from "@vy/zapi-types";

// src/api-definition-paths/credit-types-paths/credit-type-id-path.ts
import { oz as oz438 } from "@vy/utils";
var CREDIT_TYPE_ID_PATH_PARAM = {
  name: "creditTypeId",
  location: "path",
  schema: oz438.string(),
  required: true
};
var CREDIT_TYPE_ID_PATH_PARAMS = {
  [CREDIT_TYPE_ID_PATH_PARAM.name]: CREDIT_TYPE_ID_PATH_PARAM
};

// src/api-definition-paths/credit-types-paths/get-credit-type/get-credit-type-path.ts
var GET_CREDIT_TYPE_PATH = {
  accessLevel: PATH_ACCESS_LEVELS270.PRIVATE,
  route: `/credit-types/{${CREDIT_TYPE_ID_PATH_PARAM.name}}`,
  tags: API_TAGS.CREDIT_LEDGER,
  pathParams: CREDIT_TYPE_ID_PATH_PARAMS
};

// src/api-definition-paths/credit-types-paths/get-credit-type/get-credit-type-response-schema.ts
import { oz as oz439 } from "@vy/utils";
var GetCreditTypeResponseSchema = oz439.object({
  creditType: CreditTypeSchema
}).openapi("GetCreditTypeResponse");

// src/api-definition-paths/credit-types-paths/get-credit-type/get-credit-type-action.ts
var GET_CREDIT_TYPE_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-credit-type" },
  response: {
    name: "GetCreditTypeResponse",
    schema: GetCreditTypeResponseSchema
  },
  path: GET_CREDIT_TYPE_PATH
};

// src/api-definition-paths/credit-types-paths/credit-types-paths.ts
var CREDIT_TYPES_PATHS = [
  LIST_CREDIT_TYPES_PATH,
  GET_CREDIT_TYPE_PATH
];

// src/api-definition-paths/credit-types-paths/create-credit-type/create-credit-type-request-schema.ts
import { oz as oz440 } from "@vy/utils";
var CreateCreditTypeRequestSchema = oz440.object({
  name: oz440.string(),
  units: oz440.string().optional(),
  isTaxable: oz440.boolean().optional()
}).openapi("CreateCreditTypeRequest");

// src/api-definition-paths/credit-types-paths/create-credit-type/create-credit-type-response-schema.ts
import { oz as oz441 } from "@vy/utils";
var CreateCreditTypeResponseSchema = oz441.object({
  creditType: CreditTypeSchema
}).openapi("CreateCreditTypeResponse");

// src/api-definition-paths/credit-types-paths/create-credit-type/create-credit-type-action.ts
var CREATE_CREDIT_TYPE_ACTION = {
  method: "post",
  codeGenerationSettings: { actionText: "create-credit-type" },
  request: {
    name: "CreateCreditTypeRequest",
    schema: CreateCreditTypeRequestSchema
  },
  response: {
    name: "CreateCreditTypeResponse",
    schema: CreateCreditTypeResponseSchema
  },
  path: LIST_CREDIT_TYPES_PATH
};

// src/api-definition-paths/credit-types-paths/update-credit-type/update-credit-type-request-schema.ts
import { oz as oz442 } from "@vy/utils";
var UpdateCreditTypeRequestSchema = oz442.object({
  name: oz442.string().optional(),
  units: oz442.string().optional(),
  isTaxable: oz442.boolean().optional()
}).openapi("UpdateCreditTypeRequest");

// src/api-definition-paths/credit-types-paths/update-credit-type/update-credit-type-response-schema.ts
import { oz as oz443 } from "@vy/utils";
var UpdateCreditTypeResponseSchema = oz443.object({
  creditType: CreditTypeSchema
}).openapi("UpdateCreditTypeResponse");

// src/api-definition-paths/credit-types-paths/update-credit-type/update-credit-type-action.ts
var UPDATE_CREDIT_TYPE_ACTION = {
  method: "put",
  codeGenerationSettings: { actionText: "update-credit-type" },
  request: {
    name: "UpdateCreditTypeRequest",
    schema: UpdateCreditTypeRequestSchema
  },
  response: {
    name: "UpdateCreditTypeResponse",
    schema: UpdateCreditTypeResponseSchema
  },
  path: GET_CREDIT_TYPE_PATH
};

// src/api-definition-paths/credit-types-paths/delete-credit-type/delete-credit-type-action.ts
var DELETE_CREDIT_TYPE_ACTION = {
  method: "delete",
  codeGenerationSettings: { actionText: "delete-credit-type" },
  path: GET_CREDIT_TYPE_PATH
};

// src/api-definition-paths/credit-types-paths/credit-types-actions.ts
var CREDIT_TYPES_ACTIONS = [
  LIST_CREDIT_TYPES_ACTION,
  GET_CREDIT_TYPE_ACTION,
  CREATE_CREDIT_TYPE_ACTION,
  UPDATE_CREDIT_TYPE_ACTION,
  DELETE_CREDIT_TYPE_ACTION
];

// src/api-definition-paths/webhook-subscriptions-paths/webhook-subscriptions-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS271 } from "@vy/zapi-types";
var WEBHOOK_SUBSCRIPTIONS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS271.PRIVATE,
  route: "/webhook-subscriptions",
  tags: API_TAGS.WEBHOOK_SUBSCRIPTIONS
};

// src/api-definition-paths/webhook-subscriptions-paths/webhook-subscription-id-path.ts
import { oz as oz444 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS272 } from "@vy/zapi-types";
var WEBHOOK_SUBSCRIPTION_ID_PATH_PARAM = {
  name: "webhookSubscriptionId",
  location: "path",
  schema: oz444.string(),
  required: true
};
var WEBHOOK_SUBSCRIPTION_ID_PATH_PARAMS = {
  [WEBHOOK_SUBSCRIPTION_ID_PATH_PARAM.name]: WEBHOOK_SUBSCRIPTION_ID_PATH_PARAM
};
var WEBHOOK_SUBSCRIPTION_ID_PATH = {
  accessLevel: PATH_ACCESS_LEVELS272.PRIVATE,
  route: "/webhook-subscriptions/{webhookSubscriptionId}",
  pathParams: WEBHOOK_SUBSCRIPTION_ID_PATH_PARAMS,
  tags: API_TAGS.WEBHOOK_SUBSCRIPTIONS
};

// src/api-definition-paths/webhook-subscriptions-paths/webhook-subscription-ping-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS273 } from "@vy/zapi-types";
var WEBHOOK_SUBSCRIPTION_PING_PATH = {
  accessLevel: PATH_ACCESS_LEVELS273.PRIVATE,
  route: "/webhook-subscriptions/{webhookSubscriptionId}/ping",
  pathParams: WEBHOOK_SUBSCRIPTION_ID_PATH_PARAMS,
  tags: API_TAGS.WEBHOOK_SUBSCRIPTIONS
};

// src/api-definition-paths/webhook-subscriptions-paths/webhook-subscriptions-paths.ts
var WEBHOOK_SUBSCRIPTIONS_PATHS = [
  WEBHOOK_SUBSCRIPTIONS_PATH,
  WEBHOOK_SUBSCRIPTION_ID_PATH,
  WEBHOOK_SUBSCRIPTION_PING_PATH
];

// src/api-definition-paths/webhook-subscriptions-paths/create-webhook-subscription/create-webhook-subscription-request-schema.ts
import { NOTIFICATION_EVENT_TYPES, NotificationEventTypeSchema } from "@vy/types";
import { oz as oz445 } from "@vy/utils";
var EVENT_TYPES_REQUIRING_THRESHOLD = /* @__PURE__ */ new Set([
  NOTIFICATION_EVENT_TYPES.CommitmentUsageCrossed,
  NOTIFICATION_EVENT_TYPES.CurrencyCommitmentUsageCrossed,
  NOTIFICATION_EVENT_TYPES.CreditPoolThresholdCrossed
]);
var CreateWebhookSubscriptionRequestSchema = oz445.object({
  callbackUrl: oz445.string(),
  eventType: NotificationEventTypeSchema,
  threshold: oz445.number().optional()
}).refine(
  ({ eventType, threshold }) => EVENT_TYPES_REQUIRING_THRESHOLD.has(eventType) ? threshold !== void 0 : threshold === void 0,
  {
    message: "`threshold` is required when eventType is `CommitmentUsageCrossed`, `CurrencyCommitmentUsageCrossed` or `CreditPoolThresholdCrossed` and must be omitted otherwise.",
    path: ["threshold"]
  }
).refine(({ eventType }) => eventType !== NOTIFICATION_EVENT_TYPES.PingTest, {
  message: "`PingTest` is delivered on demand via the ping endpoint and cannot be subscribed to.",
  path: ["eventType"]
}).openapi("CreateWebhookSubscriptionRequest");

// src/api-definition-paths/webhook-subscriptions-paths/create-webhook-subscription/create-webhook-subscription-response-schema.ts
import { oz as oz446 } from "@vy/utils";
import { NotificationEventTypeSchema as NotificationEventTypeSchema2 } from "@vy/types";
var CreateWebhookSubscriptionResponseSchema = oz446.object({
  id: oz446.string(),
  eventType: NotificationEventTypeSchema2,
  callbackUrl: oz446.string(),
  threshold: oz446.number().optional(),
  createdAt: oz446.date()
}).openapi("CreateWebhookSubscriptionResponse");

// src/api-definition-paths/webhook-subscriptions-paths/create-webhook-subscription/create-webhook-subscription-action.ts
var CREATE_WEBHOOK_SUBSCRIPTION_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "create-webhook-subscription"
  },
  response: {
    name: "CreateWebhookSubscriptionResponse",
    schema: CreateWebhookSubscriptionResponseSchema
  },
  request: {
    name: "CreateWebhookSubscriptionRequest",
    schema: CreateWebhookSubscriptionRequestSchema
  },
  path: WEBHOOK_SUBSCRIPTIONS_PATH
};

// src/api-definition-paths/webhook-subscriptions-paths/delete-webhook-subscription/delete-webhook-subscription-response-schema.ts
import { oz as oz447 } from "@vy/utils";
var DeleteWebhookSubscriptionResponseSchema = oz447.object({
  webhookSubscriptionId: oz447.string()
}).openapi("DeleteWebhookSubscriptionResponse");

// src/api-definition-paths/webhook-subscriptions-paths/delete-webhook-subscription/delete-webhook-subscription-action.ts
var DELETE_WEBHOOK_SUBSCRIPTION_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "delete-webhook-subscription"
  },
  response: {
    name: "DeleteWebhookSubscriptionResponse",
    schema: DeleteWebhookSubscriptionResponseSchema
  },
  path: WEBHOOK_SUBSCRIPTION_ID_PATH
};

// src/api-definition-paths/webhook-subscriptions-paths/get-webhook-subscriptions/get-webhook-subscriptions-response-schema.ts
import { oz as oz448 } from "@vy/utils";
import { NotificationEventTypeSchema as NotificationEventTypeSchema3 } from "@vy/types";
var WebhookSubscriptionSummarySchema = oz448.object({
  id: oz448.string(),
  eventType: NotificationEventTypeSchema3,
  callbackUrl: oz448.string(),
  threshold: oz448.number().optional(),
  createdAt: oz448.date()
}).openapi("WebhookSubscriptionSummary");
var GetWebhookSubscriptionsResponseSchema = oz448.object({
  webhookSubscriptions: oz448.array(WebhookSubscriptionSummarySchema)
}).openapi("GetWebhookSubscriptionsResponse");

// src/api-definition-paths/webhook-subscriptions-paths/get-webhook-subscriptions/get-webhook-subscriptions-action.ts
var GET_WEBHOOK_SUBSCRIPTIONS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-webhook-subscriptions"
  },
  response: {
    name: "GetWebhookSubscriptionsResponse",
    schema: GetWebhookSubscriptionsResponseSchema
  },
  path: WEBHOOK_SUBSCRIPTIONS_PATH
};

// src/api-definition-paths/webhook-subscriptions-paths/ping-webhook-subscription/ping-webhook-subscription-response-schema.ts
import { oz as oz449 } from "@vy/utils";
var PingWebhookSubscriptionResponseSchema = oz449.object({
  webhookSubscriptionId: oz449.string(),
  queuedAt: oz449.date()
}).openapi("PingWebhookSubscriptionResponse");

// src/api-definition-paths/webhook-subscriptions-paths/ping-webhook-subscription/ping-webhook-subscription-action.ts
var PING_WEBHOOK_SUBSCRIPTION_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "ping-webhook-subscription"
  },
  response: {
    name: "PingWebhookSubscriptionResponse",
    schema: PingWebhookSubscriptionResponseSchema
  },
  path: WEBHOOK_SUBSCRIPTION_PING_PATH
};

// src/api-definition-paths/webhook-subscriptions-paths/webhook-subscriptions-actions.ts
var WEBHOOK_SUBSCRIPTIONS_ACTIONS = [
  CREATE_WEBHOOK_SUBSCRIPTION_ACTION,
  GET_WEBHOOK_SUBSCRIPTIONS_ACTION,
  DELETE_WEBHOOK_SUBSCRIPTION_ACTION,
  PING_WEBHOOK_SUBSCRIPTION_ACTION
];

// src/api-definition-paths/workflow-executions-paths/get-workflow-execution/get-workflow-execution-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS274 } from "@vy/zapi-types";

// src/api-definition-paths/workflow-executions-paths/workflow-execution-id-path.ts
import { oz as oz450 } from "@vy/utils";
var WORKFLOW_EXECUTION_ID_PATH_PARAM = {
  name: "id",
  location: "path",
  schema: oz450.string(),
  required: true
};
var WORKFLOW_EXECUTION_ID_PATH_PARAMS = {
  [WORKFLOW_EXECUTION_ID_PATH_PARAM.name]: WORKFLOW_EXECUTION_ID_PATH_PARAM
};

// src/api-definition-paths/workflow-executions-paths/get-workflow-execution/get-workflow-execution-path.ts
var GET_WORKFLOW_EXECUTION_PATH = {
  route: "/workflow-executions/{id}",
  pathParams: WORKFLOW_EXECUTION_ID_PATH_PARAMS,
  tags: [API_TAGS.WORKFLOW_EXECUTIONS],
  accessLevel: PATH_ACCESS_LEVELS274.PRIVATE
};

// src/api-definition-paths/workflow-executions-paths/get-workflow-execution/get-workflow-execution-response-schema.ts
import { oz as oz452 } from "@vy/utils";

// src/api-definition-paths/workflow-executions-paths/workflow-execution-schemas.ts
import { oz as oz451 } from "@vy/utils";
var WorkflowExecutionStatusSchema = oz451.enum([
  "pending",
  "running",
  "succeeded",
  "partial",
  "failed"
]);
var WorkflowExecutionStepStatusSchema = oz451.enum(["running", "succeeded", "failed"]);
var WorkflowExecutionErrorSchema = oz451.object({
  message: oz451.string()
});
var WorkflowExecutionStepSchema = oz451.object({
  stepId: oz451.string(),
  type: oz451.string(),
  status: WorkflowExecutionStepStatusSchema,
  userMessage: oz451.string().optional(),
  input: oz451.record(oz451.string(), oz451.unknown()).optional(),
  output: oz451.record(oz451.string(), oz451.unknown()).optional(),
  decision: oz451.string().optional(),
  error: WorkflowExecutionErrorSchema.optional(),
  startedAt: oz451.string(),
  completedAt: oz451.string().optional()
});
var WorkflowExecutionTriggerSchema = oz451.object({
  type: oz451.enum(["cron", "event", "manual"]),
  payload: oz451.record(oz451.string(), oz451.unknown()).optional()
});
var WorkflowExecutionSummarySchema = oz451.object({
  matched: oz451.number(),
  actioned: oz451.number(),
  errors: oz451.array(oz451.string())
});
var WorkflowExecutionSummaryRecordSchema = oz451.object({
  id: oz451.string(),
  workflowId: oz451.string(),
  definitionId: oz451.string(),
  status: WorkflowExecutionStatusSchema,
  trigger: WorkflowExecutionTriggerSchema,
  userMessage: oz451.string().optional(),
  startedAt: oz451.string().optional(),
  completedAt: oz451.string().optional(),
  attempts: oz451.number(),
  createdAt: oz451.string()
}).openapi("WorkflowExecutionSummary");
var WorkflowExecutionRecordSchema = WorkflowExecutionSummaryRecordSchema.extend({
  input: oz451.record(oz451.string(), oz451.unknown()),
  output: oz451.record(oz451.string(), oz451.unknown()).optional(),
  steps: oz451.array(WorkflowExecutionStepSchema),
  executionPath: oz451.array(oz451.string()),
  graphSnapshot: oz451.record(oz451.string(), oz451.unknown()),
  summary: WorkflowExecutionSummarySchema.optional(),
  error: WorkflowExecutionErrorSchema.optional()
}).openapi("WorkflowExecution");

// src/api-definition-paths/workflow-executions-paths/get-workflow-execution/get-workflow-execution-response-schema.ts
var GetWorkflowExecutionResponseSchema = oz452.object({ execution: WorkflowExecutionRecordSchema }).openapi("GetWorkflowExecutionResponse");

// src/api-definition-paths/workflow-executions-paths/get-workflow-execution/get-workflow-execution-action.ts
var GET_WORKFLOW_EXECUTION_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-workflow-execution" },
  response: { name: "GetWorkflowExecutionResponse", schema: GetWorkflowExecutionResponseSchema },
  path: GET_WORKFLOW_EXECUTION_PATH
};

// src/api-definition-paths/workflow-executions-paths/get-workflow-executions/get-workflow-executions-action.ts
import { oz as oz454 } from "@vy/utils";

// src/api-definition-paths/workflow-executions-paths/get-workflow-executions/get-workflow-executions-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS275 } from "@vy/zapi-types";
var GET_WORKFLOW_EXECUTIONS_PATH = {
  route: "/workflow-executions",
  tags: [API_TAGS.WORKFLOW_EXECUTIONS],
  accessLevel: PATH_ACCESS_LEVELS275.PRIVATE
};

// src/api-definition-paths/workflow-executions-paths/get-workflow-executions/get-workflow-executions-response-schema.ts
import { oz as oz453 } from "@vy/utils";
var GetWorkflowExecutionsResponseSchema = oz453.object({
  executions: oz453.array(WorkflowExecutionSummaryRecordSchema)
}).openapi("GetWorkflowExecutionsResponse");

// src/api-definition-paths/workflow-executions-paths/get-workflow-executions/get-workflow-executions-action.ts
var WORKFLOW_ID_QUERY_PARAM = {
  name: "workflowId",
  location: "query",
  schema: oz454.string().optional()
};
var DEFINITION_ID_QUERY_PARAM = {
  name: "definitionId",
  location: "query",
  schema: oz454.string().optional()
};
var STATUS_QUERY_PARAM = {
  name: "status",
  location: "query",
  schema: WorkflowExecutionStatusSchema.optional()
};
var FROM_QUERY_PARAM = {
  name: "from",
  location: "query",
  schema: oz454.string().datetime().optional()
};
var TO_QUERY_PARAM = {
  name: "to",
  location: "query",
  schema: oz454.string().datetime().optional()
};
var LIMIT_QUERY_PARAM = {
  name: "limit",
  location: "query",
  schema: oz454.coerce.number().int().positive().max(200).optional()
};
var SKIP_QUERY_PARAM = {
  name: "skip",
  location: "query",
  schema: oz454.coerce.number().int().nonnegative().optional()
};
var GET_WORKFLOW_EXECUTIONS_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-workflow-executions" },
  queryParams: {
    [WORKFLOW_ID_QUERY_PARAM.name]: WORKFLOW_ID_QUERY_PARAM,
    [DEFINITION_ID_QUERY_PARAM.name]: DEFINITION_ID_QUERY_PARAM,
    [STATUS_QUERY_PARAM.name]: STATUS_QUERY_PARAM,
    [FROM_QUERY_PARAM.name]: FROM_QUERY_PARAM,
    [TO_QUERY_PARAM.name]: TO_QUERY_PARAM,
    [LIMIT_QUERY_PARAM.name]: LIMIT_QUERY_PARAM,
    [SKIP_QUERY_PARAM.name]: SKIP_QUERY_PARAM
  },
  response: { name: "GetWorkflowExecutionsResponse", schema: GetWorkflowExecutionsResponseSchema },
  path: GET_WORKFLOW_EXECUTIONS_PATH
};

// src/api-definition-paths/workflow-executions-paths/workflow-executions-actions.ts
var WORKFLOW_EXECUTIONS_ACTIONS = [
  GET_WORKFLOW_EXECUTIONS_ACTION,
  GET_WORKFLOW_EXECUTION_ACTION
];

// src/api-definition-paths/workflow-executions-paths/workflow-executions-paths.ts
var WORKFLOW_EXECUTIONS_PATHS = [
  GET_WORKFLOW_EXECUTIONS_PATH,
  GET_WORKFLOW_EXECUTION_PATH
];

// src/api-definition-paths/workflows-paths/step-types/get-step-types/get-step-types-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS276 } from "@vy/zapi-types";
var GET_STEP_TYPES_PATH = {
  route: "/step-types",
  tags: [API_TAGS.STEP_TYPES],
  accessLevel: PATH_ACCESS_LEVELS276.PRIVATE
};

// src/api-definition-paths/workflows-paths/step-types/get-step-types/get-step-types-response-schema.ts
import { oz as oz455 } from "@vy/utils";
var StepTypeSummarySchema = oz455.object({
  id: oz455.string(),
  name: oz455.string(),
  description: oz455.string(),
  category: oz455.string()
}).openapi("StepTypeSummary");
var GetStepTypesResponseSchema = oz455.object({ stepTypes: oz455.array(StepTypeSummarySchema) }).openapi("GetStepTypesResponse");

// src/api-definition-paths/workflows-paths/step-types/get-step-types/get-step-types-action.ts
var GET_STEP_TYPES_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-step-types" },
  response: { name: "GetStepTypesResponse", schema: GetStepTypesResponseSchema },
  path: GET_STEP_TYPES_PATH
};

// src/api-definition-paths/workflows-paths/workflow-starters/get-workflow-starter/get-workflow-starter-path.ts
import { oz as oz456 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS277 } from "@vy/zapi-types";
var STARTER_ID_PATH_PARAM = {
  name: "id",
  location: "path",
  schema: oz456.string(),
  required: true
};
var STARTER_ID_PATH_PARAMS = {
  [STARTER_ID_PATH_PARAM.name]: STARTER_ID_PATH_PARAM
};
var STARTER_ACTION_QUERY_PARAM = {
  name: "action",
  location: "query",
  schema: oz456.string().optional(),
  required: false
};
var STARTER_PARAMETERS_QUERY_PARAM = {
  name: "parameters",
  location: "query",
  schema: oz456.string().optional(),
  required: false
};
var GET_WORKFLOW_STARTER_QUERY_PARAMS = {
  [STARTER_ACTION_QUERY_PARAM.name]: STARTER_ACTION_QUERY_PARAM,
  [STARTER_PARAMETERS_QUERY_PARAM.name]: STARTER_PARAMETERS_QUERY_PARAM
};
var GET_WORKFLOW_STARTER_PATH = {
  route: "/workflow-starters/{id}",
  pathParams: STARTER_ID_PATH_PARAMS,
  tags: [API_TAGS.WORKFLOW_STARTERS],
  accessLevel: PATH_ACCESS_LEVELS277.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflow-starters/get-workflow-starter/get-workflow-starter-response-schema.ts
import { oz as oz462 } from "@vy/utils";

// src/api-definition-paths/workflows-paths/workflow-starters/available-action-schema.ts
import { oz as oz457 } from "@vy/utils";
var AvailableActionSchema = oz457.object({
  id: oz457.string(),
  name: oz457.string(),
  description: oz457.string(),
  category: oz457.string()
}).openapi("WorkflowStarterAvailableAction");

// src/api-definition-paths/workflows-paths/workflow-starters/starter-parameter-schema.ts
import { oz as oz458 } from "@vy/utils";
var StarterParameterSchema = oz458.discriminatedUnion("type", [
  oz458.object({
    id: oz458.string(),
    name: oz458.string(),
    description: oz458.string(),
    type: oz458.literal("number"),
    defaultValue: oz458.number(),
    min: oz458.number().optional(),
    max: oz458.number().optional()
  }),
  oz458.object({
    id: oz458.string(),
    name: oz458.string(),
    description: oz458.string(),
    type: oz458.literal("boolean"),
    defaultValue: oz458.boolean()
  }),
  oz458.object({
    id: oz458.string(),
    name: oz458.string(),
    description: oz458.string(),
    type: oz458.literal("string-array"),
    defaultValue: oz458.array(oz458.string())
  })
]).openapi("WorkflowStarterParameter");

// src/api-definition-paths/workflows-paths/workflow-starters/starter-trigger-schema.ts
import { oz as oz459 } from "@vy/utils";
var StarterTriggerSchema = oz459.discriminatedUnion("type", [
  oz459.object({
    type: oz459.literal("cron"),
    defaultSchedule: oz459.string(),
    configurableSchedule: oz459.boolean().optional()
  }),
  oz459.object({
    type: oz459.literal("event"),
    topic: oz459.string(),
    filterPolicy: oz459.record(oz459.string(), oz459.array(oz459.string())).optional()
  }),
  oz459.object({ type: oz459.literal("manual") })
]);

// src/api-definition-paths/workflows-paths/workflows/workflow-schemas.ts
import { oz as oz460 } from "@vy/utils";
var WorkflowTriggerSchema = oz460.discriminatedUnion("type", [
  oz460.object({
    type: oz460.literal("cron"),
    schedule: oz460.string(),
    configurableSchedule: oz460.boolean().optional()
  }),
  oz460.object({
    type: oz460.literal("event"),
    topic: oz460.string(),
    filterPolicy: oz460.record(oz460.string(), oz460.array(oz460.string())).optional()
  }),
  oz460.object({ type: oz460.literal("manual") })
]);
var WorkflowStatusSchema = oz460.enum(["draft", "published", "obsolete"]);
var WorkflowGraphSchema = oz460.object({
  startStepId: oz460.string(),
  steps: oz460.record(oz460.string(), oz460.unknown())
});
var WorkflowSummarySchema = oz460.object({
  id: oz460.string(),
  definitionId: oz460.string(),
  version: oz460.number(),
  status: WorkflowStatusSchema,
  name: oz460.string(),
  description: oz460.string().optional(),
  starterTemplateId: oz460.string().optional(),
  trigger: WorkflowTriggerSchema,
  createdAt: oz460.string(),
  updatedAt: oz460.string(),
  lastExecutionAt: oz460.string().optional(),
  lastExecutionStatus: oz460.string().optional()
}).openapi("WorkflowSummary");
var WorkflowSchema = WorkflowSummarySchema.extend({
  previousVersionId: oz460.string().optional(),
  graph: WorkflowGraphSchema,
  createdBy: oz460.string(),
  publishedAt: oz460.string().optional(),
  publishedBy: oz460.string().optional(),
  obsoletedAt: oz460.string().optional()
}).openapi("Workflow");

// src/api-definition-paths/workflows-paths/workflow-starters/workflow-starter-summary-schema.ts
import { oz as oz461 } from "@vy/utils";
var WorkflowStarterSummarySchema = oz461.object({
  id: oz461.string(),
  name: oz461.string(),
  description: oz461.string(),
  category: oz461.string(),
  trigger: StarterTriggerSchema,
  availableActions: oz461.array(AvailableActionSchema).optional(),
  parameters: oz461.array(StarterParameterSchema).optional()
}).openapi("WorkflowStarterSummary");

// src/api-definition-paths/workflows-paths/workflow-starters/workflow-starter-schema.ts
var WorkflowStarterSchema = WorkflowStarterSummarySchema.extend({
  graph: WorkflowGraphSchema
}).openapi("WorkflowStarter");

// src/api-definition-paths/workflows-paths/workflow-starters/get-workflow-starter/get-workflow-starter-response-schema.ts
var GetWorkflowStarterResponseSchema = oz462.object({ starter: WorkflowStarterSchema }).openapi("GetWorkflowStarterResponse");

// src/api-definition-paths/workflows-paths/workflow-starters/get-workflow-starter/get-workflow-starter-action.ts
var GET_WORKFLOW_STARTER_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-workflow-starter" },
  queryParams: GET_WORKFLOW_STARTER_QUERY_PARAMS,
  response: { name: "GetWorkflowStarterResponse", schema: GetWorkflowStarterResponseSchema },
  path: GET_WORKFLOW_STARTER_PATH
};

// src/api-definition-paths/workflows-paths/workflow-starters/get-workflow-starters/get-workflow-starters-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS278 } from "@vy/zapi-types";
var GET_WORKFLOW_STARTERS_PATH = {
  route: "/workflow-starters",
  tags: [API_TAGS.WORKFLOW_STARTERS],
  accessLevel: PATH_ACCESS_LEVELS278.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflow-starters/get-workflow-starters/get-workflow-starters-response-schema.ts
import { oz as oz463 } from "@vy/utils";
var GetWorkflowStartersResponseSchema = oz463.object({ starters: oz463.array(WorkflowStarterSummarySchema) }).openapi("GetWorkflowStartersResponse");

// src/api-definition-paths/workflows-paths/workflow-starters/get-workflow-starters/get-workflow-starters-action.ts
var GET_WORKFLOW_STARTERS_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-workflow-starters" },
  response: { name: "GetWorkflowStartersResponse", schema: GetWorkflowStartersResponseSchema },
  path: GET_WORKFLOW_STARTERS_PATH
};

// src/api-definition-paths/workflows-paths/workflows/create-workflow/create-workflow-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS279 } from "@vy/zapi-types";
var CREATE_WORKFLOW_PATH = {
  route: "/workflows",
  tags: [API_TAGS.WORKFLOWS],
  accessLevel: PATH_ACCESS_LEVELS279.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflows/create-workflow/create-workflow-request-schema.ts
import { oz as oz464 } from "@vy/utils";
var CreateWorkflowRequestSchema = oz464.object({
  name: oz464.string().min(1),
  description: oz464.string().optional(),
  starterTemplateId: oz464.string().optional(),
  trigger: WorkflowTriggerSchema,
  graph: WorkflowGraphSchema
}).openapi("CreateWorkflowRequest");

// src/api-definition-paths/workflows-paths/workflows/create-workflow/create-workflow-response-schema.ts
import { oz as oz465 } from "@vy/utils";
var CreateWorkflowResponseSchema = oz465.object({ workflow: WorkflowSchema }).openapi("CreateWorkflowResponse");

// src/api-definition-paths/workflows-paths/workflows/create-workflow/create-workflow-action.ts
var CREATE_WORKFLOW_ACTION = {
  method: "post",
  codeGenerationSettings: { actionText: "create-workflow" },
  request: { name: "CreateWorkflowRequest", schema: CreateWorkflowRequestSchema },
  response: { name: "CreateWorkflowResponse", schema: CreateWorkflowResponseSchema },
  path: CREATE_WORKFLOW_PATH
};

// src/api-definition-paths/workflows-paths/workflows/create-workflow-version/create-workflow-version-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS280 } from "@vy/zapi-types";

// src/api-definition-paths/workflows-paths/workflows/published-workflow-id-path.ts
import { oz as oz466 } from "@vy/utils";
var PUBLISHED_WORKFLOW_ID_PATH_PARAM = {
  name: "publishedWorkflowId",
  location: "path",
  schema: oz466.string(),
  required: true
};
var PUBLISHED_WORKFLOW_ID_PATH_PARAMS = {
  [PUBLISHED_WORKFLOW_ID_PATH_PARAM.name]: PUBLISHED_WORKFLOW_ID_PATH_PARAM
};

// src/api-definition-paths/workflows-paths/workflows/create-workflow-version/create-workflow-version-path.ts
var CREATE_WORKFLOW_VERSION_PATH = {
  route: "/workflows/from/{publishedWorkflowId}",
  pathParams: PUBLISHED_WORKFLOW_ID_PATH_PARAMS,
  tags: [API_TAGS.WORKFLOWS],
  accessLevel: PATH_ACCESS_LEVELS280.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflows/create-workflow-version/create-workflow-version-request-schema.ts
import { oz as oz467 } from "@vy/utils";
var CreateWorkflowVersionRequestSchema = oz467.object({
  name: oz467.string().min(1).optional(),
  description: oz467.string().optional(),
  trigger: WorkflowTriggerSchema.optional(),
  graph: WorkflowGraphSchema.optional()
}).openapi("CreateWorkflowVersionRequest");

// src/api-definition-paths/workflows-paths/workflows/create-workflow-version/create-workflow-version-response-schema.ts
import { oz as oz468 } from "@vy/utils";
var CreateWorkflowVersionResponseSchema = oz468.object({ workflow: WorkflowSchema }).openapi("CreateWorkflowVersionResponse");

// src/api-definition-paths/workflows-paths/workflows/create-workflow-version/create-workflow-version-action.ts
var CREATE_WORKFLOW_VERSION_ACTION = {
  method: "post",
  codeGenerationSettings: { actionText: "create-workflow-version" },
  request: { name: "CreateWorkflowVersionRequest", schema: CreateWorkflowVersionRequestSchema },
  response: { name: "CreateWorkflowVersionResponse", schema: CreateWorkflowVersionResponseSchema },
  path: CREATE_WORKFLOW_VERSION_PATH
};

// src/api-definition-paths/workflows-paths/workflows/definition-id-path.ts
import { oz as oz469 } from "@vy/utils";
var DEFINITION_ID_PATH_PARAM = {
  name: "id",
  location: "path",
  schema: oz469.string(),
  required: true
};
var DEFINITION_ID_PATH_PARAMS = {
  [DEFINITION_ID_PATH_PARAM.name]: DEFINITION_ID_PATH_PARAM
};

// src/api-definition-paths/workflows-paths/workflows/disable-workflow/disable-workflow-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS281 } from "@vy/zapi-types";

// src/api-definition-paths/workflows-paths/workflows/workflow-id-path.ts
import { oz as oz470 } from "@vy/utils";
var WORKFLOW_ID_PATH_PARAM = {
  name: "id",
  location: "path",
  schema: oz470.string(),
  required: true
};
var WORKFLOW_ID_PATH_PARAMS = {
  [WORKFLOW_ID_PATH_PARAM.name]: WORKFLOW_ID_PATH_PARAM
};

// src/api-definition-paths/workflows-paths/workflows/disable-workflow/disable-workflow-path.ts
var DISABLE_WORKFLOW_PATH = {
  route: "/workflows/{id}/disable",
  pathParams: WORKFLOW_ID_PATH_PARAMS,
  tags: [API_TAGS.WORKFLOWS],
  accessLevel: PATH_ACCESS_LEVELS281.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflows/disable-workflow/disable-workflow-response-schema.ts
import { oz as oz471 } from "@vy/utils";
var DisableWorkflowResponseSchema = oz471.object({ workflow: WorkflowSchema }).openapi("DisableWorkflowResponse");

// src/api-definition-paths/workflows-paths/workflows/disable-workflow/disable-workflow-action.ts
var DISABLE_WORKFLOW_ACTION = {
  method: "post",
  codeGenerationSettings: { actionText: "disable-workflow" },
  response: { name: "DisableWorkflowResponse", schema: DisableWorkflowResponseSchema },
  path: DISABLE_WORKFLOW_PATH
};

// src/api-definition-paths/workflows-paths/workflows/execute-workflow/execute-workflow-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS282 } from "@vy/zapi-types";
var EXECUTE_WORKFLOW_PATH = {
  route: "/workflows/{id}/execute",
  pathParams: WORKFLOW_ID_PATH_PARAMS,
  tags: [API_TAGS.WORKFLOWS],
  accessLevel: PATH_ACCESS_LEVELS282.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflows/execute-workflow/execute-workflow-request-schema.ts
import { oz as oz472 } from "@vy/utils";
var ExecuteWorkflowRequestSchema = oz472.object({}).openapi("ExecuteWorkflowRequest");

// src/api-definition-paths/workflows-paths/workflows/execute-workflow/execute-workflow-response-schema.ts
import { oz as oz473 } from "@vy/utils";
var ExecuteWorkflowResponseSchema = oz473.object({ execution: WorkflowExecutionRecordSchema }).openapi("ExecuteWorkflowResponse");

// src/api-definition-paths/workflows-paths/workflows/execute-workflow/execute-workflow-action.ts
var EXECUTE_WORKFLOW_ACTION = {
  method: "post",
  codeGenerationSettings: { actionText: "execute-workflow" },
  request: { name: "ExecuteWorkflowRequest", schema: ExecuteWorkflowRequestSchema },
  response: { name: "ExecuteWorkflowResponse", schema: ExecuteWorkflowResponseSchema },
  path: EXECUTE_WORKFLOW_PATH
};

// src/api-definition-paths/workflows-paths/workflows/get-workflow/get-workflow-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS283 } from "@vy/zapi-types";
var GET_WORKFLOW_PATH = {
  route: "/workflows/{id}",
  pathParams: WORKFLOW_ID_PATH_PARAMS,
  tags: [API_TAGS.WORKFLOWS],
  accessLevel: PATH_ACCESS_LEVELS283.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflows/get-workflow/get-workflow-response-schema.ts
import { oz as oz474 } from "@vy/utils";
var GetWorkflowResponseSchema = oz474.object({ workflow: WorkflowSchema }).openapi("GetWorkflowResponse");

// src/api-definition-paths/workflows-paths/workflows/get-workflow/get-workflow-action.ts
var GET_WORKFLOW_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-workflow" },
  response: { name: "GetWorkflowResponse", schema: GetWorkflowResponseSchema },
  path: GET_WORKFLOW_PATH
};

// src/api-definition-paths/workflows-paths/workflows/get-workflow-versions/get-workflow-versions-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS284 } from "@vy/zapi-types";
var GET_WORKFLOW_VERSIONS_PATH = {
  route: "/workflows/definitions/{id}/versions",
  pathParams: DEFINITION_ID_PATH_PARAMS,
  tags: [API_TAGS.WORKFLOWS],
  accessLevel: PATH_ACCESS_LEVELS284.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflows/get-workflow-versions/get-workflow-versions-response-schema.ts
import { oz as oz475 } from "@vy/utils";
var GetWorkflowVersionsResponseSchema = oz475.object({ versions: oz475.array(WorkflowSummarySchema) }).openapi("GetWorkflowVersionsResponse");

// src/api-definition-paths/workflows-paths/workflows/get-workflow-versions/get-workflow-versions-action.ts
var GET_WORKFLOW_VERSIONS_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-workflow-versions" },
  response: { name: "GetWorkflowVersionsResponse", schema: GetWorkflowVersionsResponseSchema },
  path: GET_WORKFLOW_VERSIONS_PATH
};

// src/api-definition-paths/workflows-paths/workflows/get-workflows/get-workflows-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS285 } from "@vy/zapi-types";
var GET_WORKFLOWS_PATH = {
  route: "/workflows",
  tags: [API_TAGS.WORKFLOWS],
  accessLevel: PATH_ACCESS_LEVELS285.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflows/get-workflows/get-workflows-response-schema.ts
import { oz as oz476 } from "@vy/utils";
var GetWorkflowsResponseSchema = oz476.object({ workflows: oz476.array(WorkflowSummarySchema) }).openapi("GetWorkflowsResponse");

// src/api-definition-paths/workflows-paths/workflows/get-workflows/get-workflows-action.ts
var STATUS_QUERY_PARAM2 = {
  name: "status",
  location: "query",
  schema: WorkflowStatusSchema.optional()
};
var GET_WORKFLOWS_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-workflows" },
  queryParams: { [STATUS_QUERY_PARAM2.name]: STATUS_QUERY_PARAM2 },
  response: { name: "GetWorkflowsResponse", schema: GetWorkflowsResponseSchema },
  path: GET_WORKFLOWS_PATH
};

// src/api-definition-paths/workflows-paths/workflows/modify-workflow/modify-workflow-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS286 } from "@vy/zapi-types";
var MODIFY_WORKFLOW_PATH = {
  route: "/workflows/{id}",
  pathParams: WORKFLOW_ID_PATH_PARAMS,
  tags: [API_TAGS.WORKFLOWS],
  accessLevel: PATH_ACCESS_LEVELS286.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflows/modify-workflow/modify-workflow-request-schema.ts
import { oz as oz477 } from "@vy/utils";
var ModifyWorkflowRequestSchema = oz477.object({
  name: oz477.string().min(1).optional(),
  description: oz477.string().optional(),
  trigger: WorkflowTriggerSchema.optional(),
  graph: WorkflowGraphSchema.optional()
}).openapi("ModifyWorkflowRequest");

// src/api-definition-paths/workflows-paths/workflows/modify-workflow/modify-workflow-response-schema.ts
import { oz as oz478 } from "@vy/utils";
var ModifyWorkflowResponseSchema = oz478.object({ workflow: WorkflowSchema }).openapi("ModifyWorkflowResponse");

// src/api-definition-paths/workflows-paths/workflows/modify-workflow/modify-workflow-action.ts
var MODIFY_WORKFLOW_ACTION = {
  method: "patch",
  codeGenerationSettings: { actionText: "modify-workflow" },
  request: { name: "ModifyWorkflowRequest", schema: ModifyWorkflowRequestSchema },
  response: { name: "ModifyWorkflowResponse", schema: ModifyWorkflowResponseSchema },
  path: MODIFY_WORKFLOW_PATH
};

// src/api-definition-paths/workflows-paths/workflows/publish-workflow/publish-workflow-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS287 } from "@vy/zapi-types";
var PUBLISH_WORKFLOW_PATH = {
  route: "/workflows/{id}/publish",
  pathParams: WORKFLOW_ID_PATH_PARAMS,
  tags: [API_TAGS.WORKFLOWS],
  accessLevel: PATH_ACCESS_LEVELS287.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflows/publish-workflow/publish-workflow-response-schema.ts
import { oz as oz479 } from "@vy/utils";
var PublishWorkflowResponseSchema = oz479.object({ workflow: WorkflowSchema }).openapi("PublishWorkflowResponse");

// src/api-definition-paths/workflows-paths/workflows/publish-workflow/publish-workflow-action.ts
var PUBLISH_WORKFLOW_ACTION = {
  method: "post",
  codeGenerationSettings: { actionText: "publish-workflow" },
  response: { name: "PublishWorkflowResponse", schema: PublishWorkflowResponseSchema },
  path: PUBLISH_WORKFLOW_PATH
};

// src/api-definition-paths/workflows-paths/workflows/remove-workflow/remove-workflow-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS288 } from "@vy/zapi-types";
var REMOVE_WORKFLOW_PATH = {
  route: "/workflows/{id}",
  pathParams: WORKFLOW_ID_PATH_PARAMS,
  tags: [API_TAGS.WORKFLOWS],
  accessLevel: PATH_ACCESS_LEVELS288.PRIVATE
};

// src/api-definition-paths/workflows-paths/workflows/remove-workflow/remove-workflow-response-schema.ts
import { oz as oz480 } from "@vy/utils";
var RemoveWorkflowResponseSchema = oz480.object({}).openapi("RemoveWorkflowResponse");

// src/api-definition-paths/workflows-paths/workflows/remove-workflow/remove-workflow-action.ts
var REMOVE_WORKFLOW_ACTION = {
  method: "delete",
  codeGenerationSettings: { actionText: "remove-workflow" },
  response: { name: "RemoveWorkflowResponse", schema: RemoveWorkflowResponseSchema },
  path: REMOVE_WORKFLOW_PATH
};

// src/api-definition-paths/workflows-paths/workflows-actions.ts
var WORKFLOWS_ACTIONS = [
  GET_STEP_TYPES_ACTION,
  GET_WORKFLOW_STARTER_ACTION,
  GET_WORKFLOW_STARTERS_ACTION,
  GET_WORKFLOWS_ACTION,
  GET_WORKFLOW_ACTION,
  CREATE_WORKFLOW_ACTION,
  MODIFY_WORKFLOW_ACTION,
  REMOVE_WORKFLOW_ACTION,
  PUBLISH_WORKFLOW_ACTION,
  DISABLE_WORKFLOW_ACTION,
  CREATE_WORKFLOW_VERSION_ACTION,
  GET_WORKFLOW_VERSIONS_ACTION,
  EXECUTE_WORKFLOW_ACTION
];

// src/api-definition-paths/workflows-paths/workflows-paths.ts
var WORKFLOWS_PATHS = [
  GET_STEP_TYPES_PATH,
  GET_WORKFLOW_STARTER_PATH,
  GET_WORKFLOW_STARTERS_PATH,
  GET_WORKFLOWS_PATH,
  GET_WORKFLOW_PATH,
  CREATE_WORKFLOW_PATH,
  MODIFY_WORKFLOW_PATH,
  REMOVE_WORKFLOW_PATH,
  PUBLISH_WORKFLOW_PATH,
  DISABLE_WORKFLOW_PATH,
  CREATE_WORKFLOW_VERSION_PATH,
  GET_WORKFLOW_VERSIONS_PATH
];

// src/api-definition-paths/api-paths.ts
var API_PATHS = [
  ACCOUNTS_PATHS,
  BILLING_CYCLES_PATHS,
  CONTRACT_PATHS,
  CONTRACTS_PATHS,
  CREDIT_LEDGER_PATHS,
  CUSTOMER_PATHS,
  CUSTOMER_PORTAL_PATHS,
  DATA_DASHBOARDS_PATHS,
  EVENT_FIELDS_PATHS,
  EVENTS_PATHS,
  INTEGRATIONS_PATHS,
  INVOICES_PATHS,
  LINE_ITEMS_PATHS,
  MEASUREMENTS_PATHS,
  METERS_PATHS,
  AUTH_PATHS,
  NOTIFICATION_ALERTS_PATHS,
  PAGES_PATHS,
  PAYMENT_PATHS,
  PLAN_PATHS,
  PHASE_LABELS_PATHS,
  PRICING_PATHS,
  REPORTS_PATHS,
  [CONTACT_US_PATH],
  USERS_PATHS,
  SUBSIDIARIES_PATHS,
  REVENUE_PATHS,
  EMAIL_PATHS,
  CATALOG_PRODUCTS_PATHS,
  EXCHANGE_RATES_PATHS,
  CUSTOMER_NOTE_PATHS,
  CUSTOM_FIELD_DEFINITION_PATHS,
  PUBLIC_API_KEYS_PATHS,
  WORKFLOWS_PATHS,
  WORKFLOW_EXECUTIONS_PATHS,
  WEBHOOK_SUBSCRIPTIONS_PATHS,
  CREDIT_TYPES_PATHS,
  CREDIT_POOLS_PATHS
];

// src/api-definition-paths/labels-paths/label-id-path.ts
import { oz as oz481 } from "@vy/utils";
var LABEL_ID_PATH_PARAM = {
  name: "labelId",
  location: "path",
  schema: oz481.string(),
  required: true
};
var LABEL_ID_PATH_PARAMS = {
  [LABEL_ID_PATH_PARAM.name]: LABEL_ID_PATH_PARAM
};

// src/api-definition-paths/labels-paths/get-labels/get-labels-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS289 } from "@vy/zapi-types";
var GET_LABELS_PATH = {
  route: "/labels",
  tags: [API_TAGS.LABELS],
  accessLevel: PATH_ACCESS_LEVELS289.PRIVATE
};

// src/api-definition-paths/labels-paths/get-labels/get-labels-response-schema.ts
import { LabelSchema as LabelSchema2 } from "@vy/types";
import { oz as oz482 } from "@vy/utils";
var GetLabelsResponseSchema = oz482.object({ labels: oz482.array(LabelSchema2) }).openapi("GetLabelsResponse");

// src/api-definition-paths/labels-paths/get-labels/get-labels-action.ts
var GET_LABELS_ACTION = {
  method: "get",
  codeGenerationSettings: { actionText: "get-labels" },
  response: { name: "GetLabelsResponse", schema: GetLabelsResponseSchema },
  path: GET_LABELS_PATH
};

// src/api-definition-paths/labels-paths/create-label/create-label-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS290 } from "@vy/zapi-types";
var CREATE_LABEL_PATH = {
  route: "/labels",
  tags: [API_TAGS.LABELS],
  accessLevel: PATH_ACCESS_LEVELS290.PRIVATE
};

// src/api-definition-paths/labels-paths/create-label/create-label-request-schema.ts
import { NewLabelSchema } from "@vy/types";
var CreateLabelRequestSchema = NewLabelSchema.openapi("CreateLabelRequest");

// src/api-definition-paths/labels-paths/create-label/create-label-response-schema.ts
import { LabelSchema as LabelSchema3 } from "@vy/types";
import { oz as oz483 } from "@vy/utils";
var CreateLabelResponseSchema = oz483.object({ label: LabelSchema3 }).openapi("CreateLabelResponse");

// src/api-definition-paths/labels-paths/create-label/create-label-action.ts
var CREATE_LABEL_ACTION = {
  method: "post",
  codeGenerationSettings: { actionText: "create-label" },
  response: { name: "CreateLabelResponse", schema: CreateLabelResponseSchema },
  request: { name: "CreateLabelRequest", schema: CreateLabelRequestSchema },
  path: CREATE_LABEL_PATH
};

// src/api-definition-paths/labels-paths/update-label/update-label-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS291 } from "@vy/zapi-types";
var UPDATE_LABEL_PATH = {
  route: "/labels/{labelId}",
  pathParams: LABEL_ID_PATH_PARAMS,
  tags: [API_TAGS.LABELS],
  accessLevel: PATH_ACCESS_LEVELS291.PRIVATE
};

// src/api-definition-paths/labels-paths/update-label/update-label-request-schema.ts
import { UpdateLabelSchema } from "@vy/types";
var UpdateLabelRequestSchema = UpdateLabelSchema.openapi("UpdateLabelRequest");

// src/api-definition-paths/labels-paths/update-label/update-label-response-schema.ts
import { LabelSchema as LabelSchema4 } from "@vy/types";
import { oz as oz484 } from "@vy/utils";
var UpdateLabelResponseSchema = oz484.object({ label: LabelSchema4 }).openapi("UpdateLabelResponse");

// src/api-definition-paths/labels-paths/update-label/update-label-action.ts
var UPDATE_LABEL_ACTION = {
  method: "put",
  codeGenerationSettings: { actionText: "update-label" },
  response: { name: "UpdateLabelResponse", schema: UpdateLabelResponseSchema },
  request: { name: "UpdateLabelRequest", schema: UpdateLabelRequestSchema },
  path: UPDATE_LABEL_PATH
};

// src/api-definition-paths/labels-paths/delete-label/delete-label-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS292 } from "@vy/zapi-types";
var DELETE_LABEL_PATH = {
  route: "/labels/{labelId}",
  pathParams: LABEL_ID_PATH_PARAMS,
  tags: [API_TAGS.LABELS],
  accessLevel: PATH_ACCESS_LEVELS292.PRIVATE
};

// src/api-definition-paths/labels-paths/delete-label/delete-label-response-schema.ts
import { oz as oz485 } from "@vy/utils";
var DeleteLabelResponseSchema = oz485.object({}).openapi("DeleteLabelResponse");

// src/api-definition-paths/labels-paths/delete-label/delete-label-action.ts
var DELETE_LABEL_ACTION = {
  method: "delete",
  codeGenerationSettings: { actionText: "delete-label" },
  response: { name: "DeleteLabelResponse", schema: DeleteLabelResponseSchema },
  path: DELETE_LABEL_PATH
};

// src/api-definition-paths/labels-paths/labels-actions-list.ts
var LABELS_ACTIONS = [GET_LABELS_ACTION, CREATE_LABEL_ACTION, UPDATE_LABEL_ACTION, DELETE_LABEL_ACTION];

// src/api-definition-paths/labels-paths/labels-paths.ts
var LABELS_PATHS = [GET_LABELS_PATH, CREATE_LABEL_PATH, UPDATE_LABEL_PATH, DELETE_LABEL_PATH];

// src/api-definition-paths/subsidiaries-paths/create-subsidiary/create-subsidiary-request-schema.ts
import { NewSubsidiarySchema } from "@vy/types";
import { oz as oz486 } from "@vy/utils";
var CreateSubsidiaryRequestSchema = oz486.object({
  subsidiary: NewSubsidiarySchema
}).openapi("CreateSubsidiaryRequestPayload");

// src/api-definition-paths/subsidiaries-paths/create-subsidiary/create-subsidiary-response-schema.ts
import { SubsidiarySchema } from "@vy/types";
import { oz as oz487 } from "@vy/utils";
var CreateSubsidiaryResponseSchema = oz487.object({
  subsidiary: SubsidiarySchema
}).openapi("CreateSubsidiaryResponse");

// src/api-definition-paths/subsidiaries-paths/create-subsidiary/create-subsidiary-action.ts
var CREATE_SUBSIDIARY_ACTION = {
  method: "post",
  codeGenerationSettings: {
    actionText: "create-subsidiary"
  },
  request: {
    name: "CreateSubsidiaryRequest",
    schema: CreateSubsidiaryRequestSchema
  },
  response: {
    name: "CreateSubsidiaryResponse",
    schema: CreateSubsidiaryResponseSchema
  },
  path: SUBSIDIARIES_PATH
};

// src/api-definition-paths/subsidiaries-paths/get-subsidiaries/get-subsidiaries-response-schema.ts
import { SubsidiarySchema as SubsidiarySchema2 } from "@vy/types";
import { oz as oz488 } from "@vy/utils";
var GetSubsidiariesResponseSchema = oz488.object({
  subsidiaries: SubsidiarySchema2.array()
}).openapi("GetSubsidiariesResponse");

// src/api-definition-paths/subsidiaries-paths/get-subsidiaries/get-subsidiaries-action.ts
var GET_SUBSIDIARIES_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-subsidiaries"
  },
  response: {
    name: "GetSubsidiariesResponse",
    schema: GetSubsidiariesResponseSchema
  },
  path: SUBSIDIARIES_PATH
};

// src/api-definition-paths/subsidiaries-paths/update-subsidiary/update-subsidiary-request-schema.ts
import { NewSubsidiarySchema as NewSubsidiarySchema2 } from "@vy/types";
import { oz as oz489 } from "@vy/utils";
var UpdateSubsidiaryRequestSchema = oz489.object({
  subsidiary: NewSubsidiarySchema2
}).openapi("UpdateSubsidiaryRequestPayload");

// src/api-definition-paths/subsidiaries-paths/update-subsidiary/update-subsidiary-response-schema.ts
import { SubsidiarySchema as SubsidiarySchema3 } from "@vy/types";
import { oz as oz490 } from "@vy/utils";
var UpdateSubsidiaryResponseSchema = oz490.object({
  subsidiary: SubsidiarySchema3
}).openapi("UpdateSubsidiaryResponse");

// src/api-definition-paths/subsidiaries-paths/update-subsidiary/update-subsidiary-action.ts
var UPDATE_SUBSIDIARY_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-subsidiary"
  },
  request: {
    name: "UpdateSubsidiaryRequest",
    schema: UpdateSubsidiaryRequestSchema
  },
  response: {
    name: "UpdateSubsidiaryResponse",
    schema: UpdateSubsidiaryResponseSchema
  },
  path: UPDATE_SUBSIDIARY_PATH
};

// src/api-definition-paths/subsidiaries-paths/subsidiaries-actions.ts
var SUBSIDIARIES_ACTIONS = [
  CREATE_SUBSIDIARY_ACTION,
  GET_SUBSIDIARIES_ACTION,
  UPDATE_SUBSIDIARY_ACTION
];

// src/api-definition-paths/users-paths/get-users/get-users-response-schema.ts
import { UserSchema as UserSchema2 } from "@vy/types";
import { oz as oz491 } from "@vy/utils";
var GetUsersResponseSchema = oz491.object({
  users: UserSchema2.array()
}).openapi("GetUsersResponse");

// src/api-definition-paths/users-paths/get-users/get-users-action.ts
var GET_USERS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "get-users"
  },
  response: {
    name: "GetUsersResponse",
    schema: GetUsersResponseSchema
  },
  path: GET_USERS_PATH
};

// src/api-definition-paths/users-paths/invite-user/invite-user-request-schema.ts
import { ObjectIdSchema as ObjectIdSchema55, RolesSchema, UsernameSchema as UsernameSchema5 } from "@vy/types";
import { oz as oz492 } from "@vy/utils";
var InviteUserRequestSchema = oz492.object({
  username: UsernameSchema5,
  role: RolesSchema,
  invitedBy: ObjectIdSchema55,
  firstName: oz492.string().optional(),
  lastName: oz492.string().optional()
}).openapi("inviteUserRequestSchema");

// src/api-definition-paths/users-paths/invite-user/invite-user-action.ts
var INVITE_USER_ACTION = {
  method: "post",
  request: {
    name: "InviteUserRequest",
    schema: InviteUserRequestSchema
  },
  codeGenerationSettings: {
    actionText: "inviteUser"
  },
  path: INVITE_USER_PATH
};

// src/api-definition-paths/users-paths/update-user/update-user-request-schema.ts
import { RolesSchema as RolesSchema2 } from "@vy/types";
import { oz as oz493 } from "@vy/utils";
var UpdateUserRequestSchema = oz493.object({
  role: RolesSchema2.optional(),
  firstName: oz493.string().optional(),
  lastName: oz493.string().optional()
}).openapi("UpdateUserRequest");

// src/api-definition-paths/users-paths/update-user/update-user-response-schema.ts
import { UserSchema as UserSchema3 } from "@vy/types";
import { oz as oz494 } from "@vy/utils";
var UpdateUserResponseSchema = oz494.object({
  user: UserSchema3
}).openapi("UpdateUserResponse");

// src/api-definition-paths/users-paths/update-user/update-user-action.ts
var UPDATE_USER_ACTION = {
  method: "put",
  codeGenerationSettings: {
    actionText: "update-user"
  },
  request: {
    name: "UpdateUserRequest",
    schema: UpdateUserRequestSchema
  },
  response: {
    name: "UpdateUserResponse",
    schema: UpdateUserResponseSchema
  },
  path: UPDATE_USER_PATH
};

// src/api-definition-paths/users-paths/get-invitations/get-invitations-response-schema.ts
import { oz as oz495 } from "@vy/utils";
import { UserInvitationSchema } from "@vy/types";
var GetInvitationsResponseSchema = oz495.object({
  invitations: oz495.array(UserInvitationSchema)
}).openapi("getInvitationsResponseSchema");

// src/api-definition-paths/users-paths/get-invitations/get-invitations-action.ts
var GET_INVITATIONS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "getInvitations"
  },
  response: {
    name: "GetInvitationsResponse",
    schema: GetInvitationsResponseSchema
  },
  path: GET_INVITATIONS_PATH
};

// src/api-definition-paths/users-paths/cancel-invitation/cancel-invitation-action.ts
var CANCEL_INVITATION_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "cancelInvitation"
  },
  path: CANCEL_INVITATION_PATH
};

// src/api-definition-paths/users-paths/remove-user/remove-user-action.ts
var REMOVE_USER_ACTION = {
  method: "delete",
  codeGenerationSettings: {
    actionText: "removeUser"
  },
  path: REMOVE_USER_PATH
};

// src/api-definition-paths/users-paths/users-actions.ts
var USERS_ACTIONS = [
  GET_USERS_ACTION,
  INVITE_USER_ACTION,
  UPDATE_USER_ACTION,
  GET_INVITATIONS_ACTION,
  CANCEL_INVITATION_ACTION,
  REMOVE_USER_ACTION
];

// src/api-definition-paths/jobs-paths/list-jobs/list-jobs-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS293 } from "@vy/zapi-types";
var LIST_JOBS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS293.PRIVATE,
  route: "/jobs",
  tags: API_TAGS.JOBS
};

// src/api-definition-paths/jobs-paths/list-jobs/list-jobs-response-schema.ts
import { oz as oz496 } from "@vy/utils";
import { JOB_TASK_STATUSES as JOB_TASK_STATUSES2, JOB_TYPES, JOB_STATUSES } from "@vy/jobs-types";
import { ApiDateSchema as ApiDateSchema44 } from "@vy/types";
var JobStatusSchema = oz496.nativeEnum(JOB_STATUSES);
var JobTypeSchema = oz496.nativeEnum(JOB_TYPES);
var JobTaskStatusSchema = oz496.nativeEnum(JOB_TASK_STATUSES2);
var JobTaskSchema = oz496.object({
  id: oz496.string(),
  createdAt: ApiDateSchema44,
  updatedAt: ApiDateSchema44,
  jobId: oz496.string(),
  status: JobTaskStatusSchema,
  metadata: oz496.record(oz496.unknown()),
  result: oz496.record(oz496.unknown()).optional(),
  errorMessage: oz496.string().optional(),
  startedAt: ApiDateSchema44.optional(),
  completedAt: ApiDateSchema44.optional()
});
var JobNotificationSchema = oz496.object({
  id: oz496.string(),
  createdAt: ApiDateSchema44,
  updatedAt: ApiDateSchema44,
  accountId: oz496.string(),
  userId: oz496.string().optional(),
  jobId: oz496.string(),
  title: oz496.string(),
  description: oz496.string().optional(),
  readAt: ApiDateSchema44.optional(),
  metadata: oz496.record(oz496.unknown()),
  dismissedAt: ApiDateSchema44.optional()
});
var JobWithDerivedPropertiesSchema = oz496.object({
  id: oz496.string(),
  createdAt: ApiDateSchema44,
  updatedAt: ApiDateSchema44,
  accountId: oz496.string(),
  userId: oz496.string().optional(),
  type: JobTypeSchema,
  tasks: oz496.array(JobTaskSchema),
  status: JobStatusSchema,
  progress: oz496.number().min(0).max(100),
  startedAt: ApiDateSchema44.optional(),
  completedAt: ApiDateSchema44.optional(),
  hasErrors: oz496.boolean(),
  errorCount: oz496.number().int().min(0),
  totalTasks: oz496.number().int().min(0),
  completedTasks: oz496.number().int().min(0),
  notification: JobNotificationSchema.optional()
});
var ListJobsResponseSchema = oz496.array(JobWithDerivedPropertiesSchema);

// src/api-definition-paths/jobs-paths/list-jobs/list-jobs-action.ts
var LIST_JOBS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "list-jobs"
  },
  response: {
    name: "ListJobsResponse",
    schema: ListJobsResponseSchema
  },
  path: LIST_JOBS_PATH
};

// src/api-definition-paths/jobs-paths/list-job-tasks/list-job-tasks-path.ts
import { oz as oz497 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS294 } from "@vy/zapi-types";
var JOB_ID_PATH_PARAM = {
  name: "jobId",
  location: "path",
  schema: oz497.string(),
  required: true
};
var LIST_JOB_TASKS_PATH_PARAMS = {
  [JOB_ID_PATH_PARAM.name]: JOB_ID_PATH_PARAM
};
var LIST_JOB_TASKS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS294.PRIVATE,
  route: "/jobs/{jobId}/tasks",
  pathParams: LIST_JOB_TASKS_PATH_PARAMS,
  tags: API_TAGS.JOBS
};

// src/api-definition-paths/jobs-paths/list-job-tasks/list-job-tasks-response-schema.ts
import { oz as oz498 } from "@vy/utils";
import { JobTaskStatusSchema as JobTaskStatusSchema2, JobTaskTypeSchema } from "@vy/jobs-types";
import { ApiDateSchema as ApiDateSchema45 } from "@vy/types";
var JobTaskSchema2 = oz498.object({
  id: oz498.string(),
  createdAt: ApiDateSchema45,
  updatedAt: ApiDateSchema45,
  jobId: oz498.string(),
  type: JobTaskTypeSchema,
  status: JobTaskStatusSchema2,
  metadata: oz498.record(oz498.unknown()),
  result: oz498.record(oz498.unknown()).optional(),
  errorMessage: oz498.string().optional(),
  startedAt: ApiDateSchema45.optional(),
  completedAt: ApiDateSchema45.optional()
});
var ListJobTasksResponseSchema = oz498.array(JobTaskSchema2);

// src/api-definition-paths/jobs-paths/list-job-tasks/list-job-tasks-action.ts
var LIST_JOB_TASKS_ACTION = {
  method: "get",
  codeGenerationSettings: {
    actionText: "list-job-tasks"
  },
  response: {
    name: "ListJobTasksResponse",
    schema: ListJobTasksResponseSchema
  },
  path: LIST_JOB_TASKS_PATH
};

// src/api-definition-paths/jobs-paths/update-job-notifications-read-status/update-job-notifications-read-status-path.ts
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS295 } from "@vy/zapi-types";
var UPDATE_JOB_NOTIFICATIONS_READ_STATUS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS295.PRIVATE,
  route: "/jobs/notifications/read-status",
  tags: API_TAGS.JOBS
};

// src/api-definition-paths/jobs-paths/update-job-notifications-read-status/update-job-notifications-read-status-request-schema.ts
import { oz as oz499 } from "@vy/utils";
var NotificationReadStatusSchema = oz499.enum(["READ", "UNREAD"]);
var UpdateJobNotificationsReadStatusRequestSchema = oz499.object({
  ids: oz499.array(oz499.string()).min(1),
  status: NotificationReadStatusSchema
}).openapi("UpdateJobNotificationsReadStatusRequest");

// src/api-definition-paths/jobs-paths/update-job-notifications-read-status/update-job-notifications-read-status-response-schema.ts
import { oz as oz500 } from "@vy/utils";
import { ApiDateSchema as ApiDateSchema46 } from "@vy/types";
var JobNotificationSchema2 = oz500.object({
  id: oz500.string(),
  createdAt: ApiDateSchema46,
  updatedAt: ApiDateSchema46,
  accountId: oz500.string(),
  userId: oz500.string().optional(),
  jobId: oz500.string(),
  title: oz500.string(),
  description: oz500.string().optional(),
  readAt: ApiDateSchema46.optional(),
  metadata: oz500.record(oz500.unknown()),
  dismissedAt: ApiDateSchema46.optional()
});
var UpdateJobNotificationsReadStatusResponseSchema = oz500.array(JobNotificationSchema2);

// src/api-definition-paths/jobs-paths/update-job-notifications-read-status/update-job-notifications-read-status-action.ts
var UPDATE_JOB_NOTIFICATIONS_READ_STATUS_ACTION = {
  method: "patch",
  codeGenerationSettings: {
    actionText: "update-job-notifications-read-status"
  },
  response: {
    name: "UpdateJobNotificationsReadStatusResponse",
    schema: UpdateJobNotificationsReadStatusResponseSchema
  },
  request: {
    name: "UpdateJobNotificationsReadStatusRequest",
    schema: UpdateJobNotificationsReadStatusRequestSchema
  },
  path: UPDATE_JOB_NOTIFICATIONS_READ_STATUS_PATH
};

// src/api-definition-paths/jobs-paths/dismiss-job-notification/dismiss-job-notification-path.ts
import { oz as oz501 } from "@vy/utils";
import { PATH_ACCESS_LEVELS as PATH_ACCESS_LEVELS296 } from "@vy/zapi-types";
var DISMISS_JOB_NOTIFICATION_JOB_ID_PARAM = {
  name: "jobId",
  location: "path",
  schema: oz501.string(),
  required: true
};
var DISMISS_JOB_NOTIFICATION_PATH_PARAMS = {
  [DISMISS_JOB_NOTIFICATION_JOB_ID_PARAM.name]: DISMISS_JOB_NOTIFICATION_JOB_ID_PARAM
};
var DISMISS_JOB_NOTIFICATION_PATH = {
  accessLevel: PATH_ACCESS_LEVELS296.PRIVATE,
  route: "/jobs/{jobId}/notifications/dismiss",
  pathParams: DISMISS_JOB_NOTIFICATION_PATH_PARAMS,
  tags: API_TAGS.JOBS
};

// src/api-definition-paths/jobs-paths/dismiss-job-notification/dismiss-job-notification-response-schema.ts
import { oz as oz502 } from "@vy/utils";
import { ApiDateSchema as ApiDateSchema47 } from "@vy/types";
var DismissJobNotificationResponseSchema = oz502.object({
  id: oz502.string(),
  createdAt: ApiDateSchema47,
  updatedAt: ApiDateSchema47,
  accountId: oz502.string(),
  userId: oz502.string().optional(),
  jobId: oz502.string(),
  title: oz502.string(),
  description: oz502.string().optional(),
  readAt: ApiDateSchema47.optional(),
  metadata: oz502.record(oz502.unknown()),
  dismissedAt: ApiDateSchema47.optional()
}).openapi("DismissJobNotificationResponse");

// src/api-definition-paths/jobs-paths/dismiss-job-notification/dismiss-job-notification-action.ts
var DISMISS_JOB_NOTIFICATION_ACTION = {
  method: "patch",
  codeGenerationSettings: {
    actionText: "dismiss-job-notification"
  },
  response: {
    name: "DismissJobNotificationResponse",
    schema: DismissJobNotificationResponseSchema
  },
  path: DISMISS_JOB_NOTIFICATION_PATH
};

// src/api-definition-paths/jobs-paths/dismiss-job-notification/dismiss-job-notification-request-schema.ts
import { oz as oz503 } from "@vy/utils";
var DismissJobNotificationRequestPathParamsSchema = oz503.object({
  jobId: oz503.string()
}).openapi("DismissJobNotificationRequestPathParams");

// src/api-definition-paths/jobs-paths/jobs-actions.ts
var JOBS_ACTIONS = [
  LIST_JOBS_ACTION,
  LIST_JOB_TASKS_ACTION,
  UPDATE_JOB_NOTIFICATIONS_READ_STATUS_ACTION,
  DISMISS_JOB_NOTIFICATION_ACTION
];

// src/api-definition-paths/jobs-paths/jobs-paths.ts
var JOBS_PATHS = [
  LIST_JOBS_PATH,
  LIST_JOB_TASKS_PATH,
  UPDATE_JOB_NOTIFICATIONS_READ_STATUS_PATH,
  DISMISS_JOB_NOTIFICATION_PATH
];

// src/api-definition-paths/api-actions.ts
var API_ACTIONS = [
  ACCOUNTS_ACTIONS,
  BILLING_CYCLES_ACTIONS,
  CONTRACT_ACTIONS,
  CONTRACTS_ACTIONS,
  CREDIT_LEDGER_ACTIONS,
  CUSTOMERS_ACTIONS,
  CUSTOMER_PORTAL_ACTIONS,
  DATA_DASHBOARDS_ACTIONS,
  EVENT_FIELDS_ACTIONS,
  EVENTS_ACTIONS,
  INTEGRATIONS_ACTIONS,
  INVOICES_ACTIONS,
  LINE_ITEMS_ACTIONS,
  MEASUREMENTS_ACTIONS,
  METERS_ACTIONS,
  AUTH_ACTIONS,
  NOTIFICATION_ALERTS_ACTIONS,
  PAGES_ACTIONS,
  PAYMENTS_ACTIONS,
  PLANS_ACTIONS,
  LABELS_ACTIONS,
  PHASE_LABELS_ACTIONS,
  REPORTS_ACTIONS,
  [CONTACT_US_ACTION],
  USERS_ACTIONS,
  SUBSIDIARIES_ACTIONS,
  REVENUE_ACTIONS,
  EMAIL_ACTIONS,
  PRODUCTS_ACTIONS,
  PRICING_ACTIONS,
  CATALOG_PRODUCTS_ACTIONS,
  EXCHANGE_RATES_ACTIONS,
  JOBS_ACTIONS,
  CUSTOMER_NOTE_ACTIONS,
  CUSTOM_FIELD_DEFINITION_ACTIONS,
  PUBLIC_API_KEYS_ACTIONS,
  WORKFLOWS_ACTIONS,
  WORKFLOW_EXECUTIONS_ACTIONS,
  WEBHOOK_SUBSCRIPTIONS_ACTIONS,
  CREDIT_TYPES_ACTIONS,
  CREDIT_POOLS_ACTIONS
];
export {
  ACCOUNTS_ACTIONS,
  ACCOUNTS_PATHS,
  ANROK_BACKFILL_TRANSACTIONS_ACTION,
  ANROK_BACKFILL_TRANSACTIONS_PATH,
  ANROK_CONNECT_ACTION,
  ANROK_CONNECT_PATH,
  API_ACTIONS,
  API_PATHS,
  APPLY_CREDITS_ACTION,
  APPLY_CREDITS_PATH,
  APPROVAL_FLOW_INVOICE_TYPES,
  ASSIGN_PAYMENT_TO_INVOICE_ACTION,
  ASSIGN_PAYMENT_TO_INVOICE_PATH,
  AUTH_ACTIONS,
  AnrokAuthConnectRequestSchema,
  AnrokBackfillTransactionsRequestSchema,
  ApplyCreditsRequestSchema,
  ApprovalFlowInvoiceTypesParamSchema,
  AssignPaymentToInvoiceRequestSchema,
  AssignPaymentToInvoiceResponseSchema,
  AvailableActionSchema,
  BILLING_CYCLES_ACTIONS,
  BILLING_CYCLES_ID_PATH,
  BILLING_CYCLES_PATHS,
  BILLING_CYCLE_ID_PATH_PARAM,
  BILLING_CYCLE_INVOICE_TYPES,
  BillingCycleInvoiceSchema,
  BillingCycleInvoiceTypeSchema,
  BooleanQueryParamSchema,
  CANCEL_INVITATION_ACTION,
  CANCEL_INVITATION_PATH,
  CANCEL_INVITATION_PATH_PARAMS,
  CATALOG_PRODUCTS_ACTIONS,
  CATALOG_PRODUCTS_ID_PATH,
  CATALOG_PRODUCTS_ID_PATH_PARAMS,
  CATALOG_PRODUCTS_ID_PATH_PARAM_SCHEMA,
  CATALOG_PRODUCTS_PATH,
  CATALOG_PRODUCTS_PATHS,
  CONFIRM_ACTION,
  CONFIRM_PASSWORD_RESET_ACTION,
  CONFIRM_PASSWORD_RESET_PATH,
  CONFIRM_PATH,
  CONNACT_CONNECT_ACTION,
  CONNACT_CONNECT_PATH,
  CONTACT_US_ACTION,
  CONTACT_US_PATH,
  CONTRACTS_ACTIONS,
  CONTRACTS_PATH,
  CONTRACTS_PATHS,
  CONTRACT_ACTIONS,
  CONTRACT_ID_PATH,
  CONTRACT_ID_PATH_PARAM,
  CONTRACT_PATH,
  CONTRACT_PATHS,
  CONTRACT_TERMINATION_OPTIONS,
  CREATE_BILLING_CYCLE_ACTION,
  CREATE_BILLING_CYCLE_PATH,
  CREATE_CATALOG_PRODUCTS_ACTION,
  CREATE_CONTRACTS_ACTION,
  CREATE_CREDIT_NOTE_ACTION,
  CREATE_CREDIT_TYPE_ACTION,
  CREATE_CUSTOMER_ACTION,
  CREATE_CUSTOMER_NOTE_ACTION,
  CREATE_CUSTOMER_NOTE_PATH,
  CREATE_INVOICE_ACTION,
  CREATE_LABEL_ACTION,
  CREATE_LABEL_PATH,
  CREATE_LINE_ITEM_ACTION,
  CREATE_LINE_ITEM_PATH,
  CREATE_METER_ACTION,
  CREATE_PLAN_ACTION,
  CREATE_PLAN_PATH,
  CREATE_PUBLIC_API_KEY_ACTION,
  CREATE_SUBSIDIARY_ACTION,
  CREATE_WEBHOOK_SUBSCRIPTION_ACTION,
  CREATE_WORKFLOW_ACTION,
  CREATE_WORKFLOW_PATH,
  CREATE_WORKFLOW_VERSION_ACTION,
  CREATE_WORKFLOW_VERSION_PATH,
  CREDIT_LEDGER_ACTIONS,
  CREDIT_LEDGER_ENTRY_ID_PATH_PARAM,
  CREDIT_LEDGER_ENTRY_ID_PATH_PARAMS,
  CREDIT_LEDGER_ID_PATH_PARAM,
  CREDIT_LEDGER_ID_PATH_PARAMS,
  CREDIT_LEDGER_PATHS,
  CREDIT_POOLS_ACTIONS,
  CREDIT_POOLS_PATHS,
  CREDIT_POOL_ENTRY_TYPES,
  CREDIT_TYPES_ACTIONS,
  CREDIT_TYPES_PATHS,
  CREDIT_TYPE_ID_PATH_PARAM,
  CREDIT_TYPE_ID_PATH_PARAMS,
  CUSTOMERS_ACTIONS,
  CUSTOMERS_IDS_QUERY_PARAM,
  CUSTOMER_FILTERS_QUERY_PARAMETER,
  CUSTOMER_ID_PATH,
  CUSTOMER_ID_PATH_PARAM,
  CUSTOMER_ID_PATH_PARAMS,
  CUSTOMER_ID_QUERY_PARAM,
  CUSTOMER_NOTE_ACTIONS,
  CUSTOMER_NOTE_ID_PATH_PARAM,
  CUSTOMER_NOTE_ID_PATH_PARAMS,
  CUSTOMER_NOTE_PATHS,
  CUSTOMER_PATH,
  CUSTOMER_PATHS,
  CUSTOMER_PORTAL_ACTIONS,
  CUSTOMER_PORTAL_PATHS,
  CUSTOM_FIELD_DEFINITION_ACTIONS,
  CUSTOM_FIELD_DEFINITION_ID_PATH_PARAM,
  CUSTOM_FIELD_DEFINITION_PATHS,
  CacheSignatureSchema,
  CommitmentSummarySchema,
  ConfirmPasswordResetRequestSchema,
  ConfirmPasswordResetResponseSchema,
  ConfirmRequestSchema,
  ConnactAuthConnectRequestSchema,
  ContactUsRequestSchema,
  ContractDeleteResponseSchema,
  ContractPageDataSchema,
  ContractPageVersionSchema,
  ContractProductOverviewSchema,
  ContractRenewalRequestSchema,
  ContractRenewalResponseSchema,
  ContractTerminationRequestSchema,
  ContractUsageByDateBreakdownSchema,
  CreateBillingCycleRequestSchema,
  CreateBillingCycleResponseSchema,
  CreateCatalogProductsRequestSchema,
  CreateCatalogProductsResponseSchema,
  CreateContractsRequestSchema,
  CreateContractsResponseSchema,
  CreateCreditTypeRequestSchema,
  CreateCreditTypeResponseSchema,
  CreateCustomerNoteRequestSchema,
  CreateCustomerNoteResponseSchema,
  CreateCustomerRequestSchema,
  CreateCustomerResponseSchema,
  CreateInvoiceRequestSchema,
  CreateInvoiceResponseSchema,
  CreateInvoiceSettingsSchema,
  CreateInvoiceSettingsWithValidationSchema,
  CreateLabelRequestSchema,
  CreateLabelResponseSchema,
  CreateLineItemRequestSchema,
  CreateLineItemResponseSchema,
  CreateMeterRequestSchema,
  CreatePlanRequestSchema,
  CreatePlanResponseSchema,
  CreatePublicApiKeyRequestSchema,
  CreatePublicApiKeyResponseSchema,
  CreateSubsidiaryRequestSchema,
  CreateSubsidiaryResponseSchema,
  CreateWebhookSubscriptionRequestSchema,
  CreateWebhookSubscriptionResponseSchema,
  CreateWorkflowRequestSchema,
  CreateWorkflowResponseSchema,
  CreateWorkflowVersionRequestSchema,
  CreateWorkflowVersionResponseSchema,
  CreditPoolEntrySchema,
  CreditPoolEntryTypeSchema,
  CreditPoolProjectionSchema,
  CreditPoolSchema,
  CreditPoolWithUnitsSchema,
  CreditPoolsProjectionMapSchema,
  CreditTypeSchema,
  CustomerContractOverviewSchema,
  CustomerNoteItemSchema,
  CustomerOverviewSchema,
  CustomerPortalInvoicesSummarySchema,
  DATA_DASHBOARDS_ACTIONS,
  DATA_DASHBOARDS_PATHS,
  DATE_FORMATS,
  DEFINITION_ID_PATH_PARAM,
  DEFINITION_ID_PATH_PARAMS,
  DELETE_CATALOG_PRODUCTS_ACTION,
  DELETE_CONTRACT_ACTION,
  DELETE_CREDIT_NOTE_ACTION,
  DELETE_CREDIT_NOTE_PATH,
  DELETE_CREDIT_TYPE_ACTION,
  DELETE_CUSTOMER_ACTION,
  DELETE_CUSTOMER_PATH,
  DELETE_INVOICE_ACTION,
  DELETE_INVOICE_PATH,
  DELETE_LABEL_ACTION,
  DELETE_LABEL_PATH,
  DELETE_LINE_ITEM_ACTION,
  DELETE_MEASUREMENTS_ACTION,
  DELETE_MEASUREMENT_ACTION,
  DELETE_METER_ACTION,
  DELETE_PLAN_ACTION,
  DELETE_PUBLIC_API_KEY_ACTION,
  DELETE_REPORT_ACTION,
  DELETE_REVENUE_RECOGNITION_OVERRIDE_ACTION,
  DELETE_REVISION_ACTION,
  DELETE_REVISION_ID_PATH_PARAM,
  DELETE_REVISION_PATH,
  DELETE_REVISION_PATH_PARAMS,
  DELETE_WEBHOOK_SUBSCRIPTION_ACTION,
  DISABLE_PLAN_ACTION,
  DISABLE_PLAN_PATH,
  DISABLE_WORKFLOW_ACTION,
  DISABLE_WORKFLOW_PATH,
  DISCONNECT_INTEGRATION_ACTION,
  DISCONNECT_INTEGRATION_PATH,
  DISMISS_JOB_NOTIFICATION_ACTION,
  DISMISS_JOB_NOTIFICATION_PATH,
  DISMISS_JOB_NOTIFICATION_PATH_PARAMS,
  DYNAMIC_INVOICE_ID_TYPES,
  DeleteCatalogProductsResponseSchema,
  DeleteCustomerResponseSchema,
  DeleteInvoiceResponseSchema,
  DeleteLabelResponseSchema,
  DeleteLineItemResponseSchema,
  DeleteMeasurementsRequestSchema,
  DeleteMeasurementsResponseSchema,
  DeleteMeterResponseSchema,
  DeletePublicApiKeyResponseSchema,
  DeleteReportResponseSchema,
  DeleteRevenueRecognitionOverrideResponseSchema,
  DeleteRevisionResponseSchema,
  DeleteWebhookSubscriptionResponseSchema,
  DepositToSchema,
  DisablePlanResponseSchema,
  DisableWorkflowResponseSchema,
  DismissJobNotificationRequestPathParamsSchema,
  DismissJobNotificationResponseSchema,
  DynamicInvoiceDataSchema,
  DynamicInvoiceIdTypeSchema,
  DynamicInvoiceMeasurementChartDataSchema,
  DynamicInvoiceMeasurementChartMeterSchema,
  DynamicInvoiceMeasurementChartMeterUsageSchema,
  DynamicInvoiceMeterUsageSchema,
  DynamicInvoicePageContractSchema,
  DynamicInvoicePageCustomerSchema,
  DynamicInvoicePageInvoiceSchema,
  DynamicInvoicePageMeasuredPriceBreakdownMapSchema,
  EMAIL_ACTIONS,
  EMAIL_PATHS,
  END_TIME_QUERY_PARAM,
  ERP_ID_QUERY_PARAM,
  EVENTS_ACTIONS,
  EVENTS_PATHS,
  EVENT_FIELDS_ACTIONS,
  EVENT_FIELDS_PATHS,
  EVENT_FIELDS_QUERY_EVENT_NAME_PARAMETER,
  EVENT_FIELD_VALUES_EVENT_NAME_QUERY_PARAMETER,
  EVENT_FIELD_VALUES_FIELD_NAME_QUERY_PARAMETER,
  EVENT_REF_QUERY_PARAM,
  EXCHANGE_RATES_ACTIONS,
  EXCHANGE_RATES_PATHS,
  EXECUTE_WORKFLOW_ACTION,
  EXECUTE_WORKFLOW_PATH,
  EXPORT_NET_SUITE_SALES_ORDER_ACTION,
  EXPORT_USAGE_TO_MARKETPLACE_ACTION,
  EXPORT_USAGE_TO_MARKETPLACE_PATH,
  EXTERNAL_ID_QUERY_PARAMETER,
  EXTRACT_CONTRACT_ACTION,
  EXTRACT_CONTRACT_PATH,
  EXTRACT_PLAN_ACTION,
  EXTRACT_PLAN_PATH,
  ExecuteWorkflowRequestSchema,
  ExecuteWorkflowResponseSchema,
  ExportUsageToMarketplaceRequestSchema,
  ExtractContractResponseSchema,
  ExtractPlanResponseSchema,
  FILTER_SAMPLE_EVENTS_ACTION,
  FILTER_SAMPLE_EVENTS_PATH,
  FilterSampleEventsRequestSchema,
  FilterSampleEventsResponseSchema,
  GENERATE_MEASUREMENTS_ACTION,
  GENERATE_MEASUREMENTS_PATH,
  GENERATE_TOKEN_ACTION,
  GENERATE_TOKEN_PATH,
  GET_ACCOUNT_ACTION,
  GET_AFFECTED_METERED_EVENTS_ACTION,
  GET_AFFECTED_METERED_EVENTS_PATH,
  GET_ANONYMOUS_CUSTOMERS_REPORT_ACTION,
  GET_ANONYMOUS_CUSTOMERS_REPORT_PATH,
  GET_APPROVAL_FLOW_INVOICES_LIST_ACTION,
  GET_APPROVAL_FLOW_INVOICES_LIST_PATH,
  GET_AR_AGING_REPORT_ACTION,
  GET_AR_AGING_REPORT_PATH,
  GET_BILLING_CYCLES_OVERVIEWS_ACTION,
  GET_BILLING_CYCLES_OVERVIEWS_PATH,
  GET_BILLING_CYCLE_INVOICES_ACTION,
  GET_BILLING_CYCLE_INVOICES_PATH,
  GET_BILLING_CYCLE_PAGE_ACTION,
  GET_BILLING_CYCLE_PAGE_PATH,
  GET_CATALOG_PRODUCTS_ACTION,
  GET_CATALOG_PRODUCTS_LIST_ACTION,
  GET_COMMITMENT_REPORT_ACTION,
  GET_COMMITMENT_REPORT_PATH,
  GET_COMMITMENT_VS_USAGE_ACTION,
  GET_COMMITMENT_VS_USAGE_PATH,
  GET_CONNECTED_INTEGRATIONS_ACTION,
  GET_CONNECTED_INTEGRATIONS_PATH,
  GET_CONTRACTS_ACTION,
  GET_CONTRACTS_OVERVIEWS_ACTION,
  GET_CONTRACTS_OVERVIEWS_PATH,
  GET_CONTRACTS_REPORT_ACTION,
  GET_CONTRACTS_REPORT_PATH,
  GET_CONTRACT_ACTION,
  GET_CONTRACT_BILLING_SCHEDULE_ACTION,
  GET_CONTRACT_BILLING_SCHEDULE_PATH,
  GET_CONTRACT_CUSTOM_FIELDS_ACTION,
  GET_CONTRACT_CUSTOM_FIELDS_PATH,
  GET_CONTRACT_PAGE_DATA_ACTION,
  GET_CONTRACT_PAGE_DATA_PATH,
  GET_CONTRACT_PDF_ACTION,
  GET_CONTRACT_PDF_PATH,
  GET_CONTRACT_PRODUCTS_CONSUMPTION_ACTION,
  GET_CONTRACT_PRODUCTS_CONSUMPTION_PATH,
  GET_CONTRACT_PRODUCTS_OVERVIEWS_ACTION,
  GET_CONTRACT_PRODUCTS_OVERVIEWS_PATH,
  GET_CONTRACT_REVENUE_SCHEDULE_REPORT_ACTION,
  GET_CONTRACT_REVENUE_SCHEDULE_REPORT_PATH,
  GET_CONTRACT_USAGE_BREAKDOWN_ACTION,
  GET_CONTRACT_USAGE_BREAKDOWN_PATH,
  GET_CONTRACT_VERSION_ACTION,
  GET_CONTRACT_VERSION_PATH,
  GET_CONTRACT_VERSION_PATH_PARAMS,
  GET_CREDIT_LEDGER_OVERVIEW_ACTION,
  GET_CREDIT_LEDGER_OVERVIEW_PATH,
  GET_CREDIT_LEDGER_PDF_ACTION,
  GET_CREDIT_LEDGER_PDF_PATH,
  GET_CREDIT_NOTES_ACTION,
  GET_CREDIT_NOTES_PATH,
  GET_CREDIT_TYPE_ACTION,
  GET_CREDIT_TYPE_PATH,
  GET_CUSTOMERS_ACTION,
  GET_CUSTOMERS_NAMES_ACTION,
  GET_CUSTOMERS_NAMES_PATH,
  GET_CUSTOMERS_OVERVIEWS_ACTION,
  GET_CUSTOMERS_OVERVIEWS_NEW_ACTION,
  GET_CUSTOMERS_OVERVIEWS_NEW_PATH,
  GET_CUSTOMERS_PATH,
  GET_CUSTOMERS_REPORT_ACTION,
  GET_CUSTOMERS_REPORT_PATH,
  GET_CUSTOMER_ACTION,
  GET_CUSTOMER_COMMITMENT_USAGE_ACTION,
  GET_CUSTOMER_COMMITMENT_USAGE_PATH,
  GET_CUSTOMER_CONTRACTS_OVERVIEW_PAGE_ACTION,
  GET_CUSTOMER_CONTRACTS_OVERVIEW_PAGE_PATH,
  GET_CUSTOMER_INVOICE_PAGE_DATA_ACTION,
  GET_CUSTOMER_INVOICE_PAGE_DATA_PATH,
  GET_CUSTOMER_MASTER_REPORT_ACTION,
  GET_CUSTOMER_MASTER_REPORT_PATH,
  GET_CUSTOMER_OVERVIEWS_PATH,
  GET_CUSTOMER_PORTAL_CREDIT_POOLS_ACTION,
  GET_CUSTOMER_PORTAL_CREDIT_POOLS_PATH,
  GET_CUSTOMER_PORTAL_DAILY_USAGE_DATA_ACTION,
  GET_CUSTOMER_PORTAL_DAILY_USAGE_DATA_PATH,
  GET_CUSTOMER_PORTAL_DATA_ACTION,
  GET_CUSTOMER_PORTAL_DATA_PATH,
  GET_CUSTOMER_PORTAL_INVOICE_CHECKOUT_LINK_ACTION,
  GET_CUSTOMER_PORTAL_INVOICE_CHECKOUT_LINK_PATH,
  GET_CUSTOMER_PORTAL_INVOICE_PDF_ACTION,
  GET_CUSTOMER_PORTAL_INVOICE_PDF_PATH,
  GET_CUSTOMER_PORTAL_MONTHLY_USAGE_DATA_ACTION,
  GET_CUSTOMER_PORTAL_MONTHLY_USAGE_DATA_PATH,
  GET_CUSTOMER_REVENUE_REPORT_ACTION,
  GET_CUSTOMER_REVENUE_REPORT_PATH,
  GET_CUSTOMER_STATUS_COUNTS_ACTION,
  GET_CUSTOMER_STATUS_COUNTS_PATH,
  GET_CUSTOM_FIELD_DEFINITIONS_ACTION,
  GET_CUSTOM_FIELD_DEFINITIONS_PATH,
  GET_DAILY_EVENTS_DIGESTED_ACTION,
  GET_DAILY_EVENTS_DIGESTED_PATH,
  GET_DEPOSIT_TO_ACTION,
  GET_DEPOSIT_TO_PATH,
  GET_DYNAMIC_INVOICE_ACTION,
  GET_DYNAMIC_INVOICE_BY_DISCRIMINATOR_ACTION,
  GET_DYNAMIC_INVOICE_BY_DISCRIMINATOR_PATH,
  GET_DYNAMIC_INVOICE_PATH,
  GET_EVENT_FIELDS_ACTION,
  GET_EVENT_FIELDS_PATH,
  GET_EVENT_FIELD_VALUES_ACTION,
  GET_EVENT_FIELD_VALUES_PATH,
  GET_EVENT_NAMES_ACTION,
  GET_EVENT_NAMES_PATH,
  GET_EXCHANGE_RATES_ACTION,
  GET_EXCHANGE_RATES_MATRIX_ACTION,
  GET_EXCHANGE_RATES_MATRIX_PATH,
  GET_EXPORTED_INTEGRATIONS_ACTION,
  GET_EXPORTED_INTEGRATIONS_PATH,
  GET_EXTERNAL_API_TOKEN_ACTION,
  GET_EXTERNAL_API_TOKEN_PATH,
  GET_EXTERNAL_LINK_ACTION,
  GET_EXTERNAL_LINK_PATH,
  GET_FAILED_INVOICE_DELIVERIES_REPORT_ACTION,
  GET_FAILED_INVOICE_DELIVERIES_REPORT_PATH,
  GET_HOME_PAGE_ACCOUNT_SUMMARY_ACTION,
  GET_HOME_PAGE_ACCOUNT_SUMMARY_PATH,
  GET_INTEGRATION_SETTINGS_ACTION,
  GET_INTEGRATION_SETTINGS_PATH,
  GET_INVITATIONS_ACTION,
  GET_INVITATIONS_PATH,
  GET_INVOICES_AR_HEALTH_ACTION,
  GET_INVOICES_AR_HEALTH_PATH,
  GET_INVOICES_BREAKDOWN_STATS_ACTION,
  GET_INVOICES_BREAKDOWN_STATS_PATH,
  GET_INVOICES_HIGHLIGHTS_STATISTICS_ACTION,
  GET_INVOICES_HIGHLIGHTS_STATISTICS_PATH,
  GET_INVOICES_OVERVIEWS_ACTION,
  GET_INVOICES_OVERVIEWS_NEW_ACTION,
  GET_INVOICES_OVERVIEWS_NEW_PATH,
  GET_INVOICES_OVERVIEWS_PATH,
  GET_INVOICES_STATISTICS_ACTION,
  GET_INVOICES_STATISTICS_PATH,
  GET_INVOICES_SUMMARY_ACTION,
  GET_INVOICES_SUMMARY_PATH,
  GET_INVOICES_SUMMARY_REPORT_ACTION,
  GET_INVOICES_SUMMARY_REPORT_PATH,
  GET_INVOICE_ACTION,
  GET_INVOICE_PDF_ACTION,
  GET_INVOICE_PDF_PATH,
  GET_INVOICE_PRODUCTS_INTEGRATIONS_ACTION,
  GET_INVOICE_PRODUCTS_INTEGRATIONS_PATH,
  GET_INVOICE_PRODUCTS_INTEGRATION_ENTITIES_ACTION,
  GET_INVOICE_PRODUCTS_INTEGRATION_ENTITIES_PATH,
  GET_INVOICE_USAGE_EVENTS_REPORT_ACTION,
  GET_INVOICE_USAGE_EVENTS_REPORT_PATH,
  GET_JOURNAL_ENTRIES_REPORT_ACTION,
  GET_JOURNAL_ENTRIES_REPORT_PATH,
  GET_LABELS_ACTION,
  GET_LABELS_PATH,
  GET_LATEST_CONTRACT_RENEWAL_ACTION,
  GET_LATEST_CONTRACT_RENEWAL_PATH,
  GET_LATEST_EVENTS_ACTION,
  GET_LATEST_EVENTS_PATH,
  GET_LIGHT_INVOICES_ACTION,
  GET_LIGHT_INVOICES_PATH,
  GET_MEASUREMENTS_ACTION,
  GET_MEASUREMENTS_STATS_ACTION,
  GET_MEASUREMENTS_STATS_PATH,
  GET_METERS_ACTION,
  GET_METER_DESCRIPTION_ACTION,
  GET_METER_DESCRIPTION_PATH,
  GET_METER_INSTANCE_KEYS_ACTION,
  GET_METER_INSTANCE_KEYS_PATH,
  GET_MONTHLY_CLOUSER_REPORT_ACTION,
  GET_MONTHLY_CLOUSER_REPORT_PATH,
  GET_MRR_WATERFALL_ACTION,
  GET_MRR_WATERFALL_PATH,
  GET_NET_SUITE_SUBSIDIARIES_ACTION,
  GET_NET_SUITE_SUBSIDIARIES_PATH,
  GET_NOTIFICATION_ALERTS_ACTION,
  GET_PAYMENTS_NEW_ACTION,
  GET_PAYMENTS_NEW_PATH,
  GET_PAYMENTS_OVERVIEWS_ACTION,
  GET_PAYMENT_METHODS_ACTION,
  GET_PAYMENT_METHODS_PATH,
  GET_PAYMENT_OVERVIEWS_PATH,
  GET_PHASE_LABELS_ACTION,
  GET_PHASE_LABELS_PATH,
  GET_PLANS_OVERVIEWS_ACTION,
  GET_PLANS_OVERVIEWS_PATH,
  GET_PLAN_ACTION,
  GET_PLAN_OVERVIEW_ACTION,
  GET_PLAN_OVERVIEW_PATH,
  GET_POTENTIAL_CHILD_CUSTOMERS_ACTION,
  GET_POTENTIAL_CHILD_CUSTOMERS_PATH,
  GET_PRICING_TEMPLATES_ACTION,
  GET_PRICING_TEMPLATES_PATH,
  GET_PRODUCTS_PAGE_DATA_ACTION,
  GET_PRODUCTS_PAGE_DATA_PATH,
  GET_PRODUCTS_USAGE_REPORT_ACTION,
  GET_PRODUCTS_USAGE_REPORT_PATH,
  GET_PRODUCT_USAGE_BY_DATE_BREAKDOWN_ACTION,
  GET_PRODUCT_USAGE_BY_DATE_BREAKDOWN_PATH,
  GET_PRODUCT_USAGE_CHART_DATA_ACTION,
  GET_PRODUCT_USAGE_CHART_DATA_PATH,
  GET_PUBLIC_API_KEYS_ACTION,
  GET_RECURRING_REVENUE_ACTION,
  GET_RECURRING_REVENUE_PATH,
  GET_RECURRING_REVENUE_REPORT_ACTION,
  GET_RECURRING_REVENUE_REPORT_PATH,
  GET_REPORTS_ACTION,
  GET_REVENUE_BY_CURRENCY_ACTION,
  GET_REVENUE_BY_CURRENCY_PATH,
  GET_SANDBOX_USER_ACTION,
  GET_SANDBOX_USER_PATH,
  GET_SLACK_CHANNELS_ACTION,
  GET_SLACK_CHANNELS_PATH,
  GET_SLACK_USERS_ACTION,
  GET_SLACK_USERS_PATH,
  GET_STEP_TYPES_ACTION,
  GET_STEP_TYPES_PATH,
  GET_SUBSIDIARIES_ACTION,
  GET_TOP_OVERDUE_CUSTOMERS_ACTION,
  GET_TOP_OVERDUE_CUSTOMERS_PATH,
  GET_UNAPPROVED_INVOICES_REPORT_ACTION,
  GET_UNAPPROVED_INVOICES_REPORT_PATH,
  GET_UNCHARGED_USAGE_REPORT_ACTION,
  GET_UNCHARGED_USAGE_REPORT_PATH,
  GET_UNMETERED_EVENTS_REPORT_ACTION,
  GET_UNMETERED_EVENTS_REPORT_PATH,
  GET_UPCOMING_INVOICES_REPORT_ACTION,
  GET_UPCOMING_INVOICES_REPORT_PATH,
  GET_USAGE_BY_METER_ACTION,
  GET_USAGE_BY_METER_PATH,
  GET_USAGE_EVENTS_REPORT_CONFIGURATION_ACTION,
  GET_USAGE_EVENTS_REPORT_CONFIGURATION_PATH,
  GET_USAGE_REPORT_ACTION,
  GET_USAGE_REPORT_PATH,
  GET_USAGE_REPORT_V2_ACTION,
  GET_USAGE_REPORT_V2_PATH,
  GET_USERS_ACTION,
  GET_USERS_PATH,
  GET_WEBHOOK_SUBSCRIPTIONS_ACTION,
  GET_WORKFLOWS_ACTION,
  GET_WORKFLOWS_PATH,
  GET_WORKFLOW_ACTION,
  GET_WORKFLOW_EXECUTIONS_ACTION,
  GET_WORKFLOW_EXECUTIONS_PATH,
  GET_WORKFLOW_EXECUTION_ACTION,
  GET_WORKFLOW_EXECUTION_PATH,
  GET_WORKFLOW_PATH,
  GET_WORKFLOW_STARTERS_ACTION,
  GET_WORKFLOW_STARTERS_PATH,
  GET_WORKFLOW_STARTER_ACTION,
  GET_WORKFLOW_STARTER_PATH,
  GET_WORKFLOW_STARTER_QUERY_PARAMS,
  GET_WORKFLOW_VERSIONS_ACTION,
  GET_WORKFLOW_VERSIONS_PATH,
  GET_YTD_BILLED_REVENUE_ACTION,
  GET_YTD_BILLED_REVENUE_PATH,
  GET_YTD_REVENUE_TAX_ACTION,
  GET_YTD_REVENUE_TAX_PATH,
  GenerateMeasurementsDataSchema,
  GenerateMeasurementsRequestSchema,
  GenerateMeasurementsResponseSchema,
  GenerateTokenRequestSchema,
  GenerateTokenResponseSchema,
  GetAccountResponseSchema,
  GetAffectedMeteredEventsResponseSchema,
  GetAnonymousCustomersReportResponseSchema,
  GetApprovalFlowInvoicesListResponseSchema,
  GetArAgingReportResponseSchema,
  GetBillingCycleInvoicesResponseSchema,
  GetBillingCyclePageResponseSchema,
  GetBillingCyclesResponseSchema,
  GetCatalogProductsListResponseSchema,
  GetCatalogProductsResponseSchema,
  GetCommitmentReportResponseSchema,
  GetCommitmentVsUsageResponseSchema,
  GetConnectedIntegrationsResponseSchema,
  GetContractBillingScheduleResponseSchema,
  GetContractCustomFieldsResponseSchema,
  GetContractPageDataResponseSchema,
  GetContractPdfResponseSchema,
  GetContractProductsConsumptionResponseSchema,
  GetContractProductsOverviewsResponseSchema,
  GetContractResponseSchema,
  GetContractRevenueScheduleReportResponseSchema,
  GetContractUsageBreakdownResponseSchema,
  GetContractVersionResponseSchema,
  GetContractsOverviewsResponseSchema,
  GetContractsOverviewsSortingSchema,
  GetContractsReportResponseSchema,
  GetContractsResponseSchema,
  GetContractsSortingSchema,
  GetCreditLedgerOverviewResponseSchema,
  GetCreditLedgerPdfResponseSchema,
  GetCreditNotesResponseSchema,
  GetCreditTypeResponseSchema,
  GetCustomFieldDefinitionsResponseSchema,
  GetCustomerCommitmentUsageResponseSchema,
  GetCustomerContractsOverviewPageResponseSchema,
  GetCustomerInvoicePageDataResponseSchema,
  GetCustomerMasterReportResponseSchema,
  GetCustomerPortalCreditPoolsResponseSchema,
  GetCustomerPortalDailyUsageDataRequestSchema,
  GetCustomerPortalDailyUsageDataResponseSchema,
  GetCustomerPortalDataRequestSchema,
  GetCustomerPortalDataResponseSchema,
  GetCustomerPortalInvoiceCheckoutLinkRequestSchema,
  GetCustomerPortalInvoiceCheckoutLinkResponseSchema,
  GetCustomerPortalInvoicePdfRequestSchema,
  GetCustomerPortalInvoicePdfResponseSchema,
  GetCustomerPortalMonthlyUsageDataRequestSchema,
  GetCustomerPortalMonthlyUsageDataResponseSchema,
  GetCustomerResponseSchema,
  GetCustomerRevenueReportResponseSchema,
  GetCustomerStatusCountsResponseSchema,
  GetCustomersNamesResponseSchema,
  GetCustomersOverviewsNewResponseSchema,
  GetCustomersOverviewsResponseSchema,
  GetCustomersOverviewsSortingSchema,
  GetCustomersReportResponseSchema,
  GetCustomersResponseSchema,
  GetDailyEventsDigestedResponseSchema,
  GetDepositToResponseSchema,
  GetDynamicInvoiceDataResponseSchema,
  GetEventFieldValuesResponseSchema,
  GetEventFieldsResponseSchema,
  GetEventNamesResponseSchema,
  GetExchangeRatesMatrixResponseSchema,
  GetExchangeRatesResponseSchema,
  GetExportedIntegrationsResponseSchema,
  GetExternalApiTokenResponseSchema,
  GetExternalLinkResponseSchema,
  GetFailedInvoiceDeliveriesReportResponseSchema,
  GetHomePageAccountSummaryResponseSchema,
  GetIntegrationSettingsResponseSchema,
  GetInvitationsResponseSchema,
  GetInvoicePdfResponseSchema,
  GetInvoiceProductsIntegrationEntitiesPath,
  GetInvoiceProductsIntegrationEntitiesResponseSchema,
  GetInvoiceProductsIntegrationsResponseSchema,
  GetInvoiceResponseSchema,
  GetInvoicesArHealthResponseSchema,
  GetInvoicesBreakdownStatsResponseSchema,
  GetInvoicesHighlightsStatisticsResponseSchema,
  GetInvoicesOverviewsNewResponseSchema,
  GetInvoicesOverviewsResponseSchema,
  GetInvoicesOverviewsSortingSchema,
  GetInvoicesStatisticsResponseSchema,
  GetInvoicesSummaryReportResponseSchema,
  GetInvoicesSummaryResponseSchema,
  GetJournalEntriesReportResponseSchema,
  GetLabelsResponseSchema,
  GetLatestContractRenewalResponseSchema,
  GetLatestEventsResponseSchema,
  GetLightInvoicesResponseSchema,
  GetMeasurementsResponseSchema,
  GetMeasurementsStatsExportResponseSchema,
  GetMeasurementsStatsQueryResponseSchema,
  GetMeasurementsStatsResponseSchema,
  GetMeasurementsStatsSortingSchema,
  GetMeterDescriptionRequestSchema,
  GetMeterDescriptionResponseSchema,
  GetMeterInstanceKeysResponseSchema,
  GetMetersResponseSchema,
  GetMonthlyClouserReportResponseSchema,
  GetMrrWaterfallResponseSchema,
  GetNotificationAlertsResponseSchema,
  GetPaymentMethodsResponseSchema,
  GetPaymentsNewResponseSchema,
  GetPaymentsOverviewsResponseSchema,
  GetPhaseLabelsResponseSchema,
  GetPlanOverviewResponseSchema,
  GetPlanResponseSchema,
  GetPlansOverviewsResponseSchema,
  GetPlansOverviewsSortingSchema,
  GetPricingTemplatesResponseSchema,
  GetProductUsageByDateBreakdownResponseSchema,
  GetProductUsageChartDataResponseSchema,
  GetProductsPageDataResponseSchema,
  GetProductsUsageReportResponseSchema,
  GetPublicApiKeysResponseSchema,
  GetRecurringRevenueReportResponseSchema,
  GetRecurringRevenueResponseSchema,
  GetReportsResponseSchema,
  GetRevenueByCurrencyResponseSchema,
  GetStepTypesResponseSchema,
  GetSubsidiariesResponseSchema,
  GetTopOverdueCustomersResponseSchema,
  GetUnapprovedInvoicesReportResponseSchema,
  GetUnchargedUsageReportResponseSchema,
  GetUnmeteredEventsReportResponseSchema,
  GetUpcomingInvoicesReportResponseSchema,
  GetUsageByMeterResponseSchema,
  GetUsageEventsReportConfigurationResponseSchema,
  GetUsageReportResponseSchema,
  GetUsageReportV2ResponseSchema,
  GetUsersResponseSchema,
  GetWebhookSubscriptionsResponseSchema,
  GetWorkflowExecutionResponseSchema,
  GetWorkflowExecutionsResponseSchema,
  GetWorkflowResponseSchema,
  GetWorkflowStarterResponseSchema,
  GetWorkflowStartersResponseSchema,
  GetWorkflowVersionsResponseSchema,
  GetWorkflowsResponseSchema,
  GetYtdBilledRevenueResponseSchema,
  GetYtdRevenueTaxResponseSchema,
  HUBSPOT_AUTH_CALLBACK_ACTION,
  HUBSPOT_AUTH_CALLBACK_CODE_QUERY_PARAMETER,
  HUBSPOT_AUTH_CALLBACK_PATH,
  HUBSPOT_AUTH_CALLBACK_STATE_QUERY_PARAMETER,
  HUBSPOT_AUTH_CONNECT_ACTION,
  HUBSPOT_AUTH_CONNECT_PATH,
  HUBSPOT_SYNC_CUSTOMERS_ACTION,
  HUBSPOT_SYNC_CUSTOMERS_PATH,
  HomePageTopGrossingSchema,
  HubspotAuthConnectRedirectResponseSchema,
  INTEGRATIONS_ACTIONS,
  INTEGRATIONS_PATHS,
  INTEGRATION_ID_PATH_PARAM,
  INTEGRATION_ID_PATH_PARAMS,
  INTEGRATION_QUERY_PARAMETER,
  INVALIDATE_EXTERNAL_API_TOKEN_ACTION,
  INVALIDATE_EXTERNAL_API_TOKEN_PATH,
  INVITE_USER_ACTION,
  INVITE_USER_PATH,
  INVOICES_ACTIONS,
  INVOICES_PATHS,
  INVOICE_ID_PATH,
  INVOICE_ID_PATH_PARAM,
  INVOICE_ID_PATH_PARAMS,
  INVOICE_ID_QUERY_PARAMETER,
  INVOICE_PATH,
  InviteUserRequestSchema,
  InvoiceOverviewSchema,
  InvoicePaymentSchema,
  InvoiceSyncAttemptErrorReasonSchema,
  InvoiceSyncAttemptResultSchema,
  InvoicesHighlightsSummarySchema,
  InvoicesOverviewsSummarySchema,
  IssueCreditNoteRequestSchema,
  IssueCreditNoteResponseSchema,
  JOBS_ACTIONS,
  JOBS_PATHS,
  JOB_ID_PATH_PARAM,
  LABELS_ACTIONS,
  LABELS_PATHS,
  LABEL_ID_PATH_PARAM,
  LABEL_ID_PATH_PARAMS,
  LINE_ITEMS_ACTIONS,
  LINE_ITEMS_PATHS,
  LIST_CONTRACT_CREDIT_POOLS_ACTION,
  LIST_CONTRACT_CREDIT_POOLS_PATH,
  LIST_CREDIT_POOLS_ACTION,
  LIST_CREDIT_POOLS_PATH,
  LIST_CREDIT_TYPES_ACTION,
  LIST_CREDIT_TYPES_PATH,
  LIST_CUSTOMER_NOTES_ACTION,
  LIST_CUSTOMER_NOTES_PATH,
  LIST_JOBS_ACTION,
  LIST_JOBS_PATH,
  LIST_JOB_TASKS_ACTION,
  LIST_JOB_TASKS_PATH,
  LIST_JOB_TASKS_PATH_PARAMS,
  LOGIN_ACTION,
  LOGIN_PATH,
  LightInvoiceCommitmentLineItemSchema,
  LightInvoiceFixedLineItemSchema,
  LightInvoiceUsageLineItemSchema,
  ListContractCreditPoolsResponseSchema,
  ListCreditPoolsResponseSchema,
  ListCreditTypesResponseSchema,
  ListCustomerNotesResponseSchema,
  ListJobTasksResponseSchema,
  ListJobsResponseSchema,
  LoginRequestSchema,
  LoginResponseSchema,
  MEASUREMENTS_ACTIONS,
  MEASUREMENTS_PATHS,
  MEASUREMENTS_STATS_MODES,
  MEASUREMENT_ID_PATH,
  METERS_ACTIONS,
  METERS_IDS_QUERY_PARAM,
  METERS_PATH,
  METERS_PATHS,
  METER_ID_PATH,
  METER_PATH,
  MIGRATE_TO_AUTOMATIC_TAX_ACTION,
  MIGRATE_TO_AUTOMATIC_TAX_PATH,
  MODIFY_CUSTOMER_NOTE_ACTION,
  MODIFY_CUSTOMER_NOTE_PATH,
  MODIFY_EXTERNAL_PRODUCT_ACTION,
  MODIFY_EXTERNAL_PRODUCT_PATH,
  MODIFY_EXTERNAL_PRODUCT_QUERY_PARAMS,
  MODIFY_WORKFLOW_ACTION,
  MODIFY_WORKFLOW_PATH,
  MORNING_CONNECT_ACTION,
  MORNING_CONNECT_PATH,
  MORNING_EXPORT_INVOICES_ACTION,
  MORNING_EXPORT_INVOICES_PATH,
  MORNING_GET_CUSTOMERS_ACTION,
  MORNING_GET_CUSTOMERS_PATH,
  MarketplaceSyncStatusSchema,
  MeasurementRowSchema,
  MeasurementsStatsSchema,
  MergingMeasurementSchema,
  MeterForProductPageResponseSchema,
  MeterWithTotalMeasurementsResultSchema,
  MetersForProductPageResponseSchema,
  MigrateToAutomaticTaxRequestSchema,
  MigrateToAutomaticTaxResponseSchema,
  ModifyCustomerNoteRequestSchema,
  ModifyCustomerNoteResponseSchema,
  ModifyWorkflowRequestSchema,
  ModifyWorkflowResponseSchema,
  MorningAuthConnectRequestSchema,
  MorningCustomerPayloadSchema,
  MorningExportInvoicesRequestSchema,
  MorningGetCustomersResponseSchema,
  NET_SUITE_CONNECT_ACTION,
  NET_SUITE_CONNECT_PATH,
  NET_SUITE_EXPORT_CREDIT_MEMO_ACTION,
  NET_SUITE_EXPORT_CREDIT_MEMO_PATH,
  NET_SUITE_EXPORT_SALES_ORDER_PATH,
  NET_SUITE_GET_CLASSES_ACTION,
  NET_SUITE_GET_CLASSES_PATH,
  NET_SUITE_GET_CREDIT_ITEMS_ACTION,
  NET_SUITE_GET_CREDIT_ITEMS_PATH,
  NET_SUITE_GET_CUSTOMERS_ACTION,
  NET_SUITE_GET_CUSTOMERS_PATH,
  NET_SUITE_GET_CUSTOMER_ACTION,
  NET_SUITE_GET_CUSTOMER_PATH,
  NET_SUITE_GET_DEPOSIT_TO_ACCOUNTS_ACTION,
  NET_SUITE_GET_DEPOSIT_TO_ACCOUNTS_PATH,
  NET_SUITE_GET_INVOICE_DASHBOARD_URL_ACTION,
  NET_SUITE_GET_INVOICE_DASHBOARD_URL_PATH,
  NET_SUITE_GET_PRODUCTS_ACTION,
  NET_SUITE_GET_PRODUCTS_PATH,
  NET_SUITE_SYNC_INVOICES_ACTION,
  NET_SUITE_SYNC_INVOICES_PATH,
  NET_SUITE_SYNC_INVOICES_SALES_ORDER_ACTION,
  NET_SUITE_SYNC_INVOICES_SALES_ORDER_PATH,
  NET_SUITE_UPDATE_SALES_ORDER_ACTION,
  NET_SUITE_UPDATE_SALES_ORDER_PATH,
  NOTIFICATION_ALERTS_ACTIONS,
  NOTIFICATION_ALERTS_PATHS,
  NetSuiteConnectRequestSchema,
  NetSuiteDepositToAccountSchema,
  NetSuiteExportCreditMemoRequestSchema,
  NetSuiteExportSalesOrderRequestSchema,
  NetSuiteGetClassesResponseSchema,
  NetSuiteGetCreditItemsResponseSchema,
  NetSuiteGetCustomerResponseSchema,
  NetSuiteGetCustomersResponseSchema,
  NetSuiteGetDepositToAccountsResponseSchema,
  NetSuiteGetInvoiceDashboardUrlResponseSchema,
  NetSuiteGetProductsResponseSchema,
  NetSuiteGetSubsidiariesResponseSchema,
  NetSuiteSyncInvoicesRequestSchema,
  NetSuiteSyncInvoicesSalesOrderRequestSchema,
  NetSuiteUpdateSalesOrderRequestSchema,
  OPTIONAL_CUSTOMER_ALIAS_QUERY_PARAM,
  OPTIONAL_END_TIME_QUERY_PARAM,
  OPTIONAL_EVENT_NAMES_QUERY_PARAM,
  OPTIONAL_EVENT_REF_QUERY_PARAM,
  OPTIONAL_REPORT_ID_QUERY_PARAM,
  OPTIONAL_START_TIME_QUERY_PARAM,
  OUTSTANDING_BREAKDOWN_OPTIONS,
  OverdueBucketDataSchema,
  OverdueBucketRange,
  OverdueBucketRangeSchema,
  PADDLE_CONNECT_ACTION,
  PADDLE_CONNECT_PATH,
  PADDLE_EVENT_ACTION,
  PADDLE_EVENT_PATH,
  PADDLE_EXPORT_INVOICES_ACTION,
  PADDLE_EXPORT_INVOICES_PATH,
  PADDLE_GET_CUSTOMERS_ACTION,
  PADDLE_GET_CUSTOMERS_PATH,
  PADDLE_GET_PRODUCTS_ACTION,
  PADDLE_GET_PRODUCTS_PATH,
  PADDLE_GET_TRANSACTION_URL_ACTION,
  PADDLE_GET_TRANSACTION_URL_PATH,
  PAGES_ACTIONS,
  PAGES_PATHS,
  PAGINATION_QUERY_PARAMETERS,
  PAYMENTS_ACTIONS,
  PAYMENT_ID_PATH_PARAM,
  PAYMENT_ID_PATH_PARAMS,
  PAYMENT_PATHS,
  PHASE_LABELS_ACTIONS,
  PHASE_LABELS_PATHS,
  PING_WEBHOOK_SUBSCRIPTION_ACTION,
  PLANS_ACTIONS,
  PLANS_ID_PATH_PARAM,
  PLAN_ID_PATH,
  PLAN_ID_PATH_PARAMS,
  PLAN_PATHS,
  PLAN_STATUSES_QUERY_PARAMETER,
  POST_CREDIT_NOTE_PATH,
  PRICING_ACTIONS,
  PRICING_PATHS,
  PRODUCTS_ACTIONS,
  PRODUCT_ID_PATH_PARAM,
  PRODUCT_ID_PATH_PARAMS,
  PRODUCT_PATHS,
  PUBLIC_API_KEYS_ACTIONS,
  PUBLIC_API_KEYS_PATH,
  PUBLIC_API_KEYS_PATHS,
  PUBLIC_API_KEY_ID_PATH,
  PUBLIC_API_KEY_ID_PATH_PARAM,
  PUBLIC_API_KEY_ID_PATH_PARAMS,
  PUBLISHED_WORKFLOW_ID_PATH_PARAM,
  PUBLISHED_WORKFLOW_ID_PATH_PARAMS,
  PUBLISH_WORKFLOW_ACTION,
  PUBLISH_WORKFLOW_PATH,
  PaddleAuthConnectRequestSchema,
  PaddleCustomerPayloadSchema,
  PaddleEnvironmentSchema,
  PaddleEventRequestSchema,
  PaddleEventResponseSchema,
  PaddleExportInvoicesRequestSchema,
  PaddleGetCustomersResponseSchema,
  PaddleGetProductsResponseSchema,
  PaddleGetTransactionUrlResponseSchema,
  PaddleProductPayloadSchema,
  PaymentMethodSchema,
  PaymentOverviewSchema,
  PingWebhookSubscriptionResponseSchema,
  PlanOverviewSchema,
  PotentialChildCustomersResponseSchema,
  ProductConsumptionBreakdownSchema,
  ProductConsumptionSchema,
  ProductIntegrationSchema,
  ProductUsageBreakdownItemSchema,
  ProductsPageSchema,
  PublicApiKeySummarySchema,
  PublishWorkflowResponseSchema,
  QUICKBOOKS_AUTH_CALLBACK_ACTION,
  QUICKBOOKS_AUTH_CALLBACK_PATH,
  QUICKBOOKS_CONNECT_ACTION,
  QUICKBOOKS_CONNECT_PATH,
  QUICKBOOKS_EXPORT_CREDIT_MEMO_ACTION,
  QUICKBOOKS_EXPORT_CREDIT_MEMO_PATH,
  QUICKBOOKS_EXPORT_INVOICES_ACTION,
  QUICKBOOKS_EXPORT_INVOICES_PATH,
  QUICKBOOKS_GET_CUSTOMERS_ACTION,
  QUICKBOOKS_GET_CUSTOMERS_PATH,
  QUICKBOOKS_GET_DEPOSIT_TO_ACCOUNTS_ACTION,
  QUICKBOOKS_GET_DEPOSIT_TO_ACCOUNTS_PATH,
  QUICKBOOKS_GET_PRODUCTS_ACTION,
  QUICKBOOKS_GET_PRODUCTS_PATH,
  QueryableIntegrationTypesV3Schema,
  QuickBooksConnectResponseSchema,
  QuickBooksDepositToAccountSchema,
  QuickBooksExportCreditMemoRequestSchema,
  QuickBooksExportInvoicesRequestSchema,
  QuickBooksGetCustomersResponseSchema,
  QuickBooksGetDepositToAccountsResponseSchema,
  QuickBooksGetProductsResponseSchema,
  RECEIVE_PAYMENT_ACTION,
  RECEIVE_PAYMENT_PATH,
  REFRESH_TOKEN_ACTION,
  REFRESH_TOKEN_PATH,
  REFUND_INVOICE_ACTION,
  REFUND_INVOICE_PATH,
  REMOVE_CUSTOMER_NOTE_ACTION,
  REMOVE_CUSTOMER_NOTE_PATH,
  REMOVE_USER_ACTION,
  REMOVE_USER_PATH,
  REMOVE_USER_PATH_PARAMS,
  REMOVE_WORKFLOW_ACTION,
  REMOVE_WORKFLOW_PATH,
  RENEW_CONTRACT_ACTION,
  RENEW_CONTRACT_PATH,
  REPORTS_ACTIONS,
  REPORTS_PATH,
  REPORTS_PATHS,
  REPORT_ID_PATH,
  REPORT_ID_PATH_PARAM,
  REPORT_ID_PATH_PARAMS,
  RESET_PASSWORD_ACTION,
  RESET_PASSWORD_PATH,
  REVENUE_ACTIONS,
  REVENUE_PATHS,
  REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PARAM,
  REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PARAMS,
  REVENUE_RECOGNITION_OVERRIDE_VARIANT_ID_PATH,
  REVISE_CONTRACT_ACTION,
  REVISE_CONTRACT_PATH,
  REVOKE_TOKEN_ACTION,
  REVOKE_TOKEN_PATH,
  RawTotalMeasurementResultSchema,
  ReceivePaymentRequestSchema,
  RefreshTokenResponseSchema,
  RefundInvoiceResponseSchema,
  RemoveCustomerNoteResponseSchema,
  RemoveWorkflowResponseSchema,
  ReportCountsByBillingStatusSchema,
  ReportInvoiceSummaryComparisonsSchema,
  ReportInvoicesSummarySchema,
  ReportRevenueByBillingStatusSchema,
  ResetPasswordRequestSchema,
  ResetPasswordResponseSchema,
  RevenueRecognitionRecordSchema,
  ReviseContractRequestSchema,
  RevokeTokenRequestSchema,
  S3ConnectRequestSchema,
  S3_CONNECT_ACTION,
  S3_CONNECT_PATH,
  SALESFORCE_CONNECT_ACTION,
  SALESFORCE_CONNECT_PATH,
  SALESFORCE_GET_CONTRACT_CUSTOM_FIELDS_ACTION,
  SALESFORCE_GET_CONTRACT_CUSTOM_FIELDS_PATH,
  SALESFORCE_IMPORT_CUSTOMERS_ACTION,
  SALESFORCE_IMPORT_CUSTOMERS_PATH,
  SANDBOX_ENVIRONMENT_QUERY_PARAMETER,
  SEARCH_QUERY_PARAMETER,
  SEARCH_TERM_QUERY_PARAMETER,
  SEND_GRID_EVENT_HANDLER_ACTION,
  SEND_GRID_EVENT_HANDLER_PATH,
  SEND_REMINDER_EMAIL_ACTION,
  SEND_REMINDER_EMAIL_PATH,
  SEND_SLACK_CREDIT_NOTE_NOTIFICATION_ACTION,
  SEND_SLACK_CREDIT_NOTE_NOTIFICATION_PATH,
  SEND_SLACK_INVOICE_APPROVAL_MESSAGE_ACTION,
  SEND_SLACK_INVOICE_APPROVAL_MESSAGE_PATH,
  SET_CONTRACT_AUTO_RENEWAL_ACTION,
  SET_CONTRACT_AUTO_RENEWAL_PATH,
  SET_LINE_ITEM_CALCULATION_STATE_ACTION,
  SET_LINE_ITEM_CALCULATION_STATE_PATH,
  SHARE_CREDIT_NOTES_ACTION,
  SHARE_CREDIT_NOTES_PATH,
  SHARE_INVOICES_ACTION,
  SHARE_INVOICES_PATH,
  SIGNUP_ACTION,
  SIGNUP_PATH,
  SIGNUP_RAW_ACTION,
  SIGNUP_RAW_PATH,
  SLACK_CALLBACK_ACTION,
  SLACK_CALLBACK_PATH,
  SLACK_CONNECT_ACTION,
  SLACK_CONNECT_PATH,
  SLACK_EVENT_HANDLER_ACTION,
  SLACK_EVENT_HANDLER_PATH,
  SOFT_UPDATE_PLAN_ACTION,
  SOFT_UPDATE_PLAN_PATH,
  STARTER_ACTION_QUERY_PARAM,
  STARTER_ID_PATH_PARAM,
  STARTER_ID_PATH_PARAMS,
  STARTER_PARAMETERS_QUERY_PARAM,
  START_TIME_QUERY_PARAM,
  STRIPE_CONNECT_ACTION,
  STRIPE_CONNECT_PATH,
  STRIPE_CREATE_CUSTOMER_ACTION,
  STRIPE_CREATE_CUSTOMER_PATH,
  STRIPE_CREATE_INVOICE_ACTION,
  STRIPE_CREATE_INVOICE_PATH,
  STRIPE_EVENT_ACTION,
  STRIPE_EVENT_PATH,
  STRIPE_GET_CUSTOMERS_ACTION,
  STRIPE_GET_CUSTOMERS_PATH,
  SUBSIDIARIES_ACTIONS,
  SUBSIDIARIES_PATH,
  SUBSIDIARIES_PATHS,
  SUPPORTED_DAYS,
  SUPPORTED_DELIMITERS,
  SUPPORTED_MONTHS,
  SUPPORTED_YEARS,
  SalesforceConnectRequestSchema,
  SalesforceGetContractCustomFieldsResponseSchema,
  SalesforceImportCustomersResponseSchema,
  SendGridEventHandlerRequestSchema,
  SendGridEventHandlerResponseSchema,
  SendReminderEmailRequestSchema,
  SetContractAutoRenewalRequestSchema,
  SetLineItemCalculationStateRequestSchema,
  SetLineItemCalculationStateResponseSchema,
  ShareCreditNotesRequestSchema,
  ShareInvoicesRequestSchema,
  SignupRawRequestSchema,
  SignupRawResponseSchema,
  SignupRequestSchema,
  SignupResponseSchema,
  SlackActionSchema,
  SlackAuthConnectRedirectResponseSchema,
  SlackEventHandlerParsedRequestSchema,
  SlackEventHandlerRequestSchema,
  SlackEventHandlerResponseSchema,
  SlackGetChannelsResponseSchema,
  SlackGetUsersResponseSchema,
  SlackSendCreditNoteNotificationRequestSchema,
  SlackSendCreditNoteNotificationResponseSchema,
  SlackSendInvoiceApprovalMessageRequestSchema,
  SlackSendInvoiceApprovalMessageResponseSchema,
  SoftUpdatePlanRequestSchema,
  SoftUpdatePlanResponseSchema,
  StarterParameterSchema,
  StarterTriggerSchema,
  StepTypeSummarySchema,
  StringArrayParamSchema,
  StripeAuthConnectRequestSchema,
  StripeCreateCustomerResponseSchema,
  StripeCreateInvoiceRequestSchema,
  StripeCreateInvoiceResponseSchema,
  StripeEventRequestSchema,
  StripeEventResponseSchema,
  StripeGetCustomersResponseSchema,
  TERMINATE_CONTRACT_ACTION,
  TERMINATE_CONTRACT_PATH,
  TOKEN_QUERY_PARAMETER,
  TRIGGER_LINE_ITEMS_CALCULATOR_ACTION,
  TRIGGER_LINE_ITEM_CALCULATOR_PATH,
  TRIGGER_REPORT_JOB_ACTION,
  TRIGGER_REPORT_JOB_PATH,
  TotalRevenueSchema,
  TriggerAnonymousCustomersReportJobParametersSchema,
  TriggerCommitmentUsageReportJobParametersSchema,
  TriggerContractsReportJobParametersSchema,
  TriggerCustomersReportJobParametersSchema,
  TriggerFailedInvoiceDeliveriesReportJobParametersSchema,
  TriggerMonthlyClosureReportJobParametersSchema,
  TriggerProductsUsageReportJobParametersSchema,
  TriggerRecurringRevenueReportJobParametersSchema,
  TriggerReportJobRequestSchema,
  TriggerUnchargedUsageReportJobParametersSchema,
  UNDO_LINE_ITEM_PRICE_OVERRIDE_ACTION,
  UPDATE_ACCOUNT_ACTION,
  UPDATE_ACCOUNT_LOGO_ACTION,
  UPDATE_ACCOUNT_LOGO_PATH,
  UPDATE_ACCOUNT_PATH,
  UPDATE_BILLING_CYCLE_ACTION,
  UPDATE_BILLING_CYCLE_PATH_PARAMS,
  UPDATE_CATALOG_PRODUCTS_ACTION,
  UPDATE_CONTRACT_ACTION,
  UPDATE_CONTRACT_CUSTOM_FIELD_VALUE_ACTION,
  UPDATE_CONTRACT_CUSTOM_FIELD_VALUE_PATH,
  UPDATE_CONTRACT_CUSTOM_FIELD_VALUE_PATH_PARAMS,
  UPDATE_CONTRACT_END_DATE_ACTION,
  UPDATE_CONTRACT_LABELS_ACTION,
  UPDATE_CONTRACT_LABELS_PATH,
  UPDATE_CONTRACT_MEMO_ACTION,
  UPDATE_CONTRACT_MEMO_PATH,
  UPDATE_CONTRACT_PATH_PARAMS,
  UPDATE_CONTRACT_STATUS_ACTION,
  UPDATE_CONTRACT_STATUS_PATH,
  UPDATE_CREDIT_TYPE_ACTION,
  UPDATE_CUSTOMER_ACTION,
  UPDATE_CUSTOMER_LABELS_ACTION,
  UPDATE_CUSTOMER_LABELS_PATH,
  UPDATE_INTEGRATION_CONFIGURATION_ACTION,
  UPDATE_INTEGRATION_CONFIGURATION_PATH,
  UPDATE_INVOICES_ADDITIONAL_DETAILS_ACTION,
  UPDATE_INVOICES_ADDITIONAL_DETAILS_BULK_PATH,
  UPDATE_INVOICES_ADDITIONAL_DETAILS_PATH,
  UPDATE_INVOICES_BILLING_STATUSES_ACTION,
  UPDATE_INVOICES_BILLING_STATUSES_PATH,
  UPDATE_INVOICES_REVIEW_STATUSES_ACTION,
  UPDATE_INVOICES_REVIEW_STATUSES_PATH,
  UPDATE_INVOICE_ADDITIONAL_DETAILS_ACTION,
  UPDATE_INVOICE_CURRENCY_ACTION,
  UPDATE_INVOICE_CURRENCY_PATH,
  UPDATE_INVOICE_ISSUE_DATE_ACTION,
  UPDATE_INVOICE_ISSUE_DATE_PATH,
  UPDATE_JOB_NOTIFICATIONS_READ_STATUS_ACTION,
  UPDATE_JOB_NOTIFICATIONS_READ_STATUS_PATH,
  UPDATE_LABEL_ACTION,
  UPDATE_LABEL_PATH,
  UPDATE_LINE_ITEMS_ACTION,
  UPDATE_LINE_ITEM_ACTION,
  UPDATE_LINE_ITEM_INTEGRATION_ENTITIES_ACTION,
  UPDATE_LINE_ITEM_INTEGRATION_ENTITIES_PATH,
  UPDATE_MEASUREMENT_ACTION,
  UPDATE_METER_ACTION,
  UPDATE_NOTIFICATION_ALERT_STATUS_ACTION,
  UPDATE_NOTIFICATION_ALERT_STATUS_PATH,
  UPDATE_PLAN_ACTION,
  UPDATE_PRODUCT_INTEGRATION_ENTITIES_ACTION,
  UPDATE_PRODUCT_INTEGRATION_ENTITIES_PATH,
  UPDATE_SUBSIDIARY_ACTION,
  UPDATE_SUBSIDIARY_PATH,
  UPDATE_USER_ACTION,
  UPDATE_USER_PATH,
  UPLOAD_MEASUREMENTS_ACTION,
  UPLOAD_MEASUREMENTS_JSON_ACTION,
  UPLOAD_MEASUREMENTS_JSON_PATH,
  UPLOAD_MEASUREMENTS_PATH,
  UPSERT_PHASE_LABEL_ACTION,
  UPSERT_PHASE_LABEL_PATH,
  UPSERT_REVENUE_RECOGNITION_OVERRIDE_ACTION,
  USERS_ACTIONS,
  USERS_PATHS,
  USER_ID_PATH_PARAM,
  USER_ID_PATH_PARAMS,
  UndoLineItemPriceOverrideResponseSchema,
  UpdateAccountLogoRequestSchema,
  UpdateAccountRequestSchema,
  UpdateAccountResponseSchema,
  UpdateBillingCycleRequestSchema,
  UpdateBillingCycleResponseSchema,
  UpdateCatalogProductsRequestSchema,
  UpdateCatalogProductsResponseSchema,
  UpdateContractCustomFieldValueRequestSchema,
  UpdateContractCustomFieldValueResponseSchema,
  UpdateContractLabelsRequestSchema,
  UpdateContractLabelsResponseSchema,
  UpdateContractMemoRequestSchema,
  UpdateContractMemoResponseSchema,
  UpdateContractRequestSchema,
  UpdateContractResponseSchema,
  UpdateContractStatusRequestSchema,
  UpdateContractStatusResponseSchema,
  UpdateCreditTypeRequestSchema,
  UpdateCreditTypeResponseSchema,
  UpdateCustomerLabelsRequestSchema,
  UpdateCustomerLabelsResponseSchema,
  UpdateCustomerRequestSchema,
  UpdateCustomerResponseSchema,
  UpdateIntegrationConfigurationRequestSchema,
  UpdateIntegrationConfigurationResponseSchema,
  UpdateInvoiceAdditionalDetailsRequestSchema,
  UpdateInvoiceCurrencyRequestSchema,
  UpdateInvoiceIssueDateRequestSchema,
  UpdateInvoicesAdditionalDetailsRequestSchema,
  UpdateInvoicesBillingStatusRequestSchema,
  UpdateInvoicesBillingStatusResponseSchema,
  UpdateInvoicesReviewStatusRequestSchema,
  UpdateInvoicesReviewStatusResponseSchema,
  UpdateJobNotificationsReadStatusRequestSchema,
  UpdateJobNotificationsReadStatusResponseSchema,
  UpdateLabelRequestSchema,
  UpdateLabelResponseSchema,
  UpdateLineItemIntegrationEntitiesRequestSchema,
  UpdateLineItemRequestSchema,
  UpdateLineItemResponseSchema,
  UpdateLineItemsRequestSchema,
  UpdateLineItemsResponseSchema,
  UpdateMeasurementRequestSchema,
  UpdateMeterRequestSchema,
  UpdateNotificationAlertRequestSchema,
  UpdatePlanRequestSchema,
  UpdatePlanResponseSchema,
  UpdateProductIntegrationEntitiesRequestSchema,
  UpdateProductIntegrationEntitiesResponseSchema,
  UpdateSubsidiaryRequestSchema,
  UpdateSubsidiaryResponseSchema,
  UpdateUserRequestSchema,
  UpdateUserResponseSchema,
  UploadMeasurementsDataSchema,
  UploadMeasurementsJsonRequestSchema,
  UploadMeasurementsResponseSchema as UploadMeasurementsJsonResponseSchema,
  UploadMeasurementsResponseSchema,
  UpsertPhaseLabelRequestSchema,
  UpsertPhaseLabelResponseSchema,
  UpsertRevenueRecognitionOverrideRequestSchema,
  UpsertRevenueRecognitionOverrideResponseSchema,
  UsageByMeterSchema,
  VALIDATE_MEASUREMENTS_JSON_ACTION,
  VALIDATE_MEASUREMENTS_JSON_PATH,
  VALIDATE_MEASUREMENT_DATA_ACTION,
  VALIDATE_MEASUREMENT_DATA_PATH,
  VARIANT_ID_PATH_PARAM,
  VARIANT_ID_PATH_PARAMS,
  ValidateMeasurementDataResponseSchema,
  ValidateMeasurementsJsonRequestSchema,
  ValidateMeasurementDataResponseSchema as ValidateMeasurementsJsonResponseSchema,
  WEBHOOK_SUBSCRIPTIONS_ACTIONS,
  WEBHOOK_SUBSCRIPTIONS_PATH,
  WEBHOOK_SUBSCRIPTIONS_PATHS,
  WEBHOOK_SUBSCRIPTION_ID_PATH,
  WEBHOOK_SUBSCRIPTION_ID_PATH_PARAM,
  WEBHOOK_SUBSCRIPTION_ID_PATH_PARAMS,
  WEBHOOK_SUBSCRIPTION_PING_PATH,
  WORKFLOWS_ACTIONS,
  WORKFLOWS_PATHS,
  WORKFLOW_EXECUTIONS_ACTIONS,
  WORKFLOW_EXECUTIONS_PATHS,
  WORKFLOW_EXECUTION_ID_PATH_PARAM,
  WORKFLOW_EXECUTION_ID_PATH_PARAMS,
  WORKFLOW_ID_PATH_PARAM,
  WORKFLOW_ID_PATH_PARAMS,
  WebhookSubscriptionSummarySchema,
  WorkflowExecutionRecordSchema,
  WorkflowExecutionStatusSchema,
  WorkflowExecutionSummaryRecordSchema,
  WorkflowGraphSchema,
  WorkflowSchema,
  WorkflowStarterSchema,
  WorkflowStarterSummarySchema,
  WorkflowStatusSchema,
  WorkflowSummarySchema,
  WorkflowTriggerSchema,
  XERO_AUTH_CALLBACK_ACTION,
  XERO_AUTH_CALLBACK_PATH,
  XERO_AUTH_CONNECT_ACTION,
  XERO_AUTH_CONNECT_PATH,
  XERO_EXPORT_CREDIT_MEMO_ACTION,
  XERO_EXPORT_CREDIT_MEMO_PATH,
  XERO_EXPORT_INVOICES_ACTION,
  XERO_EXPORT_INVOICES_PATH,
  XERO_GET_CUSTOMERS_ACTION,
  XERO_GET_CUSTOMERS_PATH,
  XERO_GET_DEPOSIT_TO_ACCOUNTS_ACTION,
  XERO_GET_DEPOSIT_TO_ACCOUNTS_PATH,
  XERO_GET_PRODUCTS_ACTION,
  XERO_GET_PRODUCTS_PATH,
  XeroAuthConnectRequestSchema,
  XeroAuthConnectResponseSchema,
  XeroCustomerPayloadSchema,
  XeroDepositToAccountSchema,
  XeroExportCreditMemoRequestSchema,
  XeroExportInvoicesRequestSchema,
  XeroGetCustomersResponseSchema,
  XeroGetDepositToAccountsResponseSchema,
  XeroGetProductsResponseSchema,
  XeroProductPayloadSchema,
  invoicesByBillingStatusSchema,
  invoicesByReviewStatusSchema,
  isStringNumber,
  isValidMeasurementDate,
  updateInvoiceAdditionalDetailsResponseSchema,
  updateInvoiceCurrencyResponseSchema,
  updateInvoiceIssueDateResponseSchema,
  updateInvoicesAdditionalDetailsResponseSchema
};
